function wasTouched() {
  (window.theme.isTouch = !0),
    document.removeEventListener("touchstart", wasTouched, { passive: !0 }),
    (document.documentElement.className =
      document.documentElement.className.replace("no-touch", "touch")),
    document.dispatchEvent(new CustomEvent("theme:touch", { bubbles: !0 }));
}
console.log("fired shop js"),
  /* ==== 2026-07-04 FAZ2: kaldırıldı ====
   1) shopify-payment-button global preventDefault — Buy Now'ı site genelinde
      kilitliyordu; interceptor kalktığı için native davranışa dönüldü.
   2) localStorage.EngraveLocal temizliği — localStorage fee mekanizması söküldü. */
  (function (e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e.document
          ? t(e, !0)
          : function (e) {
              if (!e.document)
                throw new Error("jQuery requires a window with a document");
              return t(e);
            })
      : t(e);
  })("undefined" != typeof window ? window : this, function (e, t) {
    "use strict";
    var i = [],
      n = Object.getPrototypeOf,
      o = i.slice,
      r = i.flat
        ? function (e) {
            return i.flat.call(e);
          }
        : function (e) {
            return i.concat.apply([], e);
          },
      s = i.push,
      a = i.indexOf,
      l = {},
      c = l.toString,
      d = l.hasOwnProperty,
      u = d.toString,
      p = u.call(Object),
      h = {},
      f = function (e) {
        return "function" == typeof e && "number" != typeof e.nodeType;
      },
      m = function (e) {
        return null != e && e === e.window;
      },
      g = e.document,
      v = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function y(e, t, i) {
      var n,
        o,
        r = (i = i || g).createElement("script");
      if (((r.text = e), t))
        for (n in v)
          (o = t[n] || (t.getAttribute && t.getAttribute(n))) &&
            r.setAttribute(n, o);
      i.head.appendChild(r).parentNode.removeChild(r);
    }
    function b(e) {
      return null == e
        ? e + ""
        : "object" == typeof e || "function" == typeof e
        ? l[c.call(e)] || "object"
        : typeof e;
    }
    var w = "3.5.1",
      k = function (e, t) {
        return new k.fn.init(e, t);
      };
    function x(e) {
      var t = !!e && "length" in e && e.length,
        i = b(e);
      return (
        !f(e) &&
        !m(e) &&
        ("array" === i ||
          0 === t ||
          ("number" == typeof t && 0 < t && t - 1 in e))
      );
    }
    (k.fn = k.prototype =
      {
        jquery: w,
        constructor: k,
        length: 0,
        toArray: function () {
          return o.call(this);
        },
        get: function (e) {
          return null == e
            ? o.call(this)
            : e < 0
            ? this[e + this.length]
            : this[e];
        },
        pushStack: function (e) {
          var t = k.merge(this.constructor(), e);
          return (t.prevObject = this), t;
        },
        each: function (e) {
          return k.each(this, e);
        },
        map: function (e) {
          return this.pushStack(
            k.map(this, function (t, i) {
              return e.call(t, i, t);
            })
          );
        },
        slice: function () {
          return this.pushStack(o.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        even: function () {
          return this.pushStack(
            k.grep(this, function (e, t) {
              return (t + 1) % 2;
            })
          );
        },
        odd: function () {
          return this.pushStack(
            k.grep(this, function (e, t) {
              return t % 2;
            })
          );
        },
        eq: function (e) {
          var t = this.length,
            i = +e + (e < 0 ? t : 0);
          return this.pushStack(0 <= i && i < t ? [this[i]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: s,
        sort: i.sort,
        splice: i.splice,
      }),
      (k.extend = k.fn.extend =
        function () {
          var e,
            t,
            i,
            n,
            o,
            r,
            s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
          for (
            "boolean" == typeof s && ((c = s), (s = arguments[a] || {}), a++),
              "object" == typeof s || f(s) || (s = {}),
              a === l && ((s = this), a--);
            a < l;
            a++
          )
            if (null != (e = arguments[a]))
              for (t in e)
                (n = e[t]),
                  "__proto__" !== t &&
                    s !== n &&
                    (c && n && (k.isPlainObject(n) || (o = Array.isArray(n)))
                      ? ((i = s[t]),
                        (r =
                          o && !Array.isArray(i)
                            ? []
                            : o || k.isPlainObject(i)
                            ? i
                            : {}),
                        (o = !1),
                        (s[t] = k.extend(c, r, n)))
                      : void 0 !== n && (s[t] = n));
          return s;
        }),
      k.extend({
        expando: "jQuery" + (w + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (e) {
          throw new Error(e);
        },
        noop: function () {},
        isPlainObject: function (e) {
          var t, i;
          return !(
            !e ||
            "[object Object]" !== c.call(e) ||
            ((t = n(e)) &&
              ("function" !=
                typeof (i = d.call(t, "constructor") && t.constructor) ||
                u.call(i) !== p))
          );
        },
        isEmptyObject: function (e) {
          var t;
          for (t in e) return !1;
          return !0;
        },
        globalEval: function (e, t, i) {
          y(e, { nonce: t && t.nonce }, i);
        },
        each: function (e, t) {
          var i,
            n = 0;
          if (x(e))
            for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
          else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
          return e;
        },
        makeArray: function (e, t) {
          var i = t || [];
          return (
            null != e &&
              (x(Object(e))
                ? k.merge(i, "string" == typeof e ? [e] : e)
                : s.call(i, e)),
            i
          );
        },
        inArray: function (e, t, i) {
          return null == t ? -1 : a.call(t, e, i);
        },
        merge: function (e, t) {
          for (var i = +t.length, n = 0, o = e.length; n < i; n++)
            e[o++] = t[n];
          return (e.length = o), e;
        },
        grep: function (e, t, i) {
          for (var n = [], o = 0, r = e.length, s = !i; o < r; o++)
            !t(e[o], o) !== s && n.push(e[o]);
          return n;
        },
        map: function (e, t, i) {
          var n,
            o,
            s = 0,
            a = [];
          if (x(e))
            for (n = e.length; s < n; s++)
              null != (o = t(e[s], s, i)) && a.push(o);
          else for (s in e) null != (o = t(e[s], s, i)) && a.push(o);
          return r(a);
        },
        guid: 1,
        support: h,
      }),
      "function" == typeof Symbol &&
        (k.fn[Symbol.iterator] = i[Symbol.iterator]),
      k.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (e, t) {
          l["[object " + t + "]"] = t.toLowerCase();
        }
      );
    var S = (function (e) {
      var t,
        i,
        n,
        o,
        r,
        s,
        a,
        l,
        c,
        d,
        u,
        p,
        h,
        f,
        m,
        g,
        v,
        y,
        b,
        w = "sizzle" + 1 * new Date(),
        k = e.document,
        x = 0,
        S = 0,
        C = le(),
        T = le(),
        $ = le(),
        _ = le(),
        E = function (e, t) {
          return e === t && (u = !0), 0;
        },
        A = {}.hasOwnProperty,
        P = [],
        L = P.pop,
        j = P.push,
        I = P.push,
        M = P.slice,
        q = function (e, t) {
          for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
          return -1;
        },
        D =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        z = "[\\x20\\t\\r\\n\\f]",
        F =
          "(?:\\\\[\\da-fA-F]{1,6}" +
          z +
          "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        O =
          "\\[" +
          z +
          "*(" +
          F +
          ")(?:" +
          z +
          "*([*^$|!~]?=)" +
          z +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          F +
          "))|)" +
          z +
          "*\\]",
        N =
          ":(" +
          F +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          O +
          ")*)|.*)\\)|)",
        B = new RegExp(z + "+", "g"),
        H = new RegExp("^" + z + "+|((?:^|[^\\\\])(?:\\\\.)*)" + z + "+$", "g"),
        W = new RegExp("^" + z + "*," + z + "*"),
        R = new RegExp("^" + z + "*([>+~]|" + z + ")" + z + "*"),
        U = new RegExp(z + "|>"),
        V = new RegExp(N),
        G = new RegExp("^" + F + "$"),
        X = {
          ID: new RegExp("^#(" + F + ")"),
          CLASS: new RegExp("^\\.(" + F + ")"),
          TAG: new RegExp("^(" + F + "|[*])"),
          ATTR: new RegExp("^" + O),
          PSEUDO: new RegExp("^" + N),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              z +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              z +
              "*(?:([+-]|)" +
              z +
              "*(\\d+)|))" +
              z +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + D + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              z +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              z +
              "*((?:-\\d)?\\d*)" +
              z +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        Y = /HTML$/i,
        Q = /^(?:input|select|textarea|button)$/i,
        K = /^h\d$/i,
        J = /^[^{]+\{\s*\[native \w/,
        Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ee = /[+~]/,
        te = new RegExp(
          "\\\\[\\da-fA-F]{1,6}" + z + "?|\\\\([^\\r\\n\\f])",
          "g"
        ),
        ie = function (e, t) {
          var i = "0x" + e.slice(1) - 65536;
          return (
            t ||
            (i < 0
              ? String.fromCharCode(i + 65536)
              : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320))
          );
        },
        ne = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        oe = function (e, t) {
          return t
            ? "\0" === e
              ? "ï¿½"
              : e.slice(0, -1) +
                "\\" +
                e.charCodeAt(e.length - 1).toString(16) +
                " "
            : "\\" + e;
        },
        re = function () {
          p();
        },
        se = we(
          function (e) {
            return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
          },
          { dir: "parentNode", next: "legend" }
        );
      try {
        I.apply((P = M.call(k.childNodes)), k.childNodes),
          P[k.childNodes.length].nodeType;
      } catch (t) {
        I = {
          apply: P.length
            ? function (e, t) {
                j.apply(e, M.call(t));
              }
            : function (e, t) {
                for (var i = e.length, n = 0; (e[i++] = t[n++]); );
                e.length = i - 1;
              },
        };
      }
      function ae(e, t, n, o) {
        var r,
          a,
          c,
          d,
          u,
          f,
          v,
          y = t && t.ownerDocument,
          k = t ? t.nodeType : 9;
        if (
          ((n = n || []),
          "string" != typeof e || !e || (1 !== k && 9 !== k && 11 !== k))
        )
          return n;
        if (!o && (p(t), (t = t || h), m)) {
          if (11 !== k && (u = Z.exec(e)))
            if ((r = u[1])) {
              if (9 === k) {
                if (!(c = t.getElementById(r))) return n;
                if (c.id === r) return n.push(c), n;
              } else if (
                y &&
                (c = y.getElementById(r)) &&
                b(t, c) &&
                c.id === r
              )
                return n.push(c), n;
            } else {
              if (u[2]) return I.apply(n, t.getElementsByTagName(e)), n;
              if (
                (r = u[3]) &&
                i.getElementsByClassName &&
                t.getElementsByClassName
              )
                return I.apply(n, t.getElementsByClassName(r)), n;
            }
          if (
            i.qsa &&
            !_[e + " "] &&
            (!g || !g.test(e)) &&
            (1 !== k || "object" !== t.nodeName.toLowerCase())
          ) {
            if (((v = e), (y = t), 1 === k && (U.test(e) || R.test(e)))) {
              for (
                ((y = (ee.test(e) && ve(t.parentNode)) || t) === t &&
                  i.scope) ||
                  ((d = t.getAttribute("id"))
                    ? (d = d.replace(ne, oe))
                    : t.setAttribute("id", (d = w))),
                  a = (f = s(e)).length;
                a--;

              )
                f[a] = (d ? "#" + d : ":scope") + " " + be(f[a]);
              v = f.join(",");
            }
            try {
              return I.apply(n, y.querySelectorAll(v)), n;
            } catch (t) {
              _(e, !0);
            } finally {
              d === w && t.removeAttribute("id");
            }
          }
        }
        return l(e.replace(H, "$1"), t, n, o);
      }
      function le() {
        var e = [];
        return function t(i, o) {
          return (
            e.push(i + " ") > n.cacheLength && delete t[e.shift()],
            (t[i + " "] = o)
          );
        };
      }
      function ce(e) {
        return (e[w] = !0), e;
      }
      function de(e) {
        var t = h.createElement("fieldset");
        try {
          return !!e(t);
        } catch (e) {
          return !1;
        } finally {
          t.parentNode && t.parentNode.removeChild(t), (t = null);
        }
      }
      function ue(e, t) {
        for (var i = e.split("|"), o = i.length; o--; ) n.attrHandle[i[o]] = t;
      }
      function pe(e, t) {
        var i = t && e,
          n =
            i &&
            1 === e.nodeType &&
            1 === t.nodeType &&
            e.sourceIndex - t.sourceIndex;
        if (n) return n;
        if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
        return e ? 1 : -1;
      }
      function he(e) {
        return function (t) {
          return "input" === t.nodeName.toLowerCase() && t.type === e;
        };
      }
      function fe(e) {
        return function (t) {
          var i = t.nodeName.toLowerCase();
          return ("input" === i || "button" === i) && t.type === e;
        };
      }
      function me(e) {
        return function (t) {
          return "form" in t
            ? t.parentNode && !1 === t.disabled
              ? "label" in t
                ? "label" in t.parentNode
                  ? t.parentNode.disabled === e
                  : t.disabled === e
                : t.isDisabled === e || (t.isDisabled !== !e && se(t) === e)
              : t.disabled === e
            : "label" in t && t.disabled === e;
        };
      }
      function ge(e) {
        return ce(function (t) {
          return (
            (t = +t),
            ce(function (i, n) {
              for (var o, r = e([], i.length, t), s = r.length; s--; )
                i[(o = r[s])] && (i[o] = !(n[o] = i[o]));
            })
          );
        });
      }
      function ve(e) {
        return e && void 0 !== e.getElementsByTagName && e;
      }
      for (t in ((i = ae.support = {}),
      (r = ae.isXML =
        function (e) {
          var t = e.namespaceURI,
            i = (e.ownerDocument || e).documentElement;
          return !Y.test(t || (i && i.nodeName) || "HTML");
        }),
      (p = ae.setDocument =
        function (e) {
          var t,
            o,
            s = e ? e.ownerDocument || e : k;
          return (
            s != h &&
              9 === s.nodeType &&
              s.documentElement &&
              ((f = (h = s).documentElement),
              (m = !r(h)),
              k != h &&
                (o = h.defaultView) &&
                o.top !== o &&
                (o.addEventListener
                  ? o.addEventListener("unload", re, !1)
                  : o.attachEvent && o.attachEvent("onunload", re)),
              (i.scope = de(function (e) {
                return (
                  f.appendChild(e).appendChild(h.createElement("div")),
                  void 0 !== e.querySelectorAll &&
                    !e.querySelectorAll(":scope fieldset div").length
                );
              })),
              (i.attributes = de(function (e) {
                return (e.className = "i"), !e.getAttribute("className");
              })),
              (i.getElementsByTagName = de(function (e) {
                return (
                  e.appendChild(h.createComment("")),
                  !e.getElementsByTagName("*").length
                );
              })),
              (i.getElementsByClassName = J.test(h.getElementsByClassName)),
              (i.getById = de(function (e) {
                return (
                  (f.appendChild(e).id = w),
                  !h.getElementsByName || !h.getElementsByName(w).length
                );
              })),
              i.getById
                ? ((n.filter.ID = function (e) {
                    var t = e.replace(te, ie);
                    return function (e) {
                      return e.getAttribute("id") === t;
                    };
                  }),
                  (n.find.ID = function (e, t) {
                    if (void 0 !== t.getElementById && m) {
                      var i = t.getElementById(e);
                      return i ? [i] : [];
                    }
                  }))
                : ((n.filter.ID = function (e) {
                    var t = e.replace(te, ie);
                    return function (e) {
                      var i =
                        void 0 !== e.getAttributeNode &&
                        e.getAttributeNode("id");
                      return i && i.value === t;
                    };
                  }),
                  (n.find.ID = function (e, t) {
                    if (void 0 !== t.getElementById && m) {
                      var i,
                        n,
                        o,
                        r = t.getElementById(e);
                      if (r) {
                        if ((i = r.getAttributeNode("id")) && i.value === e)
                          return [r];
                        for (o = t.getElementsByName(e), n = 0; (r = o[n++]); )
                          if ((i = r.getAttributeNode("id")) && i.value === e)
                            return [r];
                      }
                      return [];
                    }
                  })),
              (n.find.TAG = i.getElementsByTagName
                ? function (e, t) {
                    return void 0 !== t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : i.qsa
                      ? t.querySelectorAll(e)
                      : void 0;
                  }
                : function (e, t) {
                    var i,
                      n = [],
                      o = 0,
                      r = t.getElementsByTagName(e);
                    if ("*" === e) {
                      for (; (i = r[o++]); ) 1 === i.nodeType && n.push(i);
                      return n;
                    }
                    return r;
                  }),
              (n.find.CLASS =
                i.getElementsByClassName &&
                function (e, t) {
                  if (void 0 !== t.getElementsByClassName && m)
                    return t.getElementsByClassName(e);
                }),
              (v = []),
              (g = []),
              (i.qsa = J.test(h.querySelectorAll)) &&
                (de(function (e) {
                  var t;
                  (f.appendChild(e).innerHTML =
                    "<a id='" +
                    w +
                    "'></a><select id='" +
                    w +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      g.push("[*^$]=" + z + "*(?:''|\"\")"),
                    e.querySelectorAll("[selected]").length ||
                      g.push("\\[" + z + "*(?:value|" + D + ")"),
                    e.querySelectorAll("[id~=" + w + "-]").length ||
                      g.push("~="),
                    (t = h.createElement("input")).setAttribute("name", ""),
                    e.appendChild(t),
                    e.querySelectorAll("[name='']").length ||
                      g.push(
                        "\\[" + z + "*name" + z + "*=" + z + "*(?:''|\"\")"
                      ),
                    e.querySelectorAll(":checked").length || g.push(":checked"),
                    e.querySelectorAll("a#" + w + "+*").length ||
                      g.push(".#.+[+~]"),
                    e.querySelectorAll("\\\f"),
                    g.push("[\\r\\n\\f]");
                }),
                de(function (e) {
                  e.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var t = h.createElement("input");
                  t.setAttribute("type", "hidden"),
                    e.appendChild(t).setAttribute("name", "D"),
                    e.querySelectorAll("[name=d]").length &&
                      g.push("name" + z + "*[*^$|!~]?="),
                    2 !== e.querySelectorAll(":enabled").length &&
                      g.push(":enabled", ":disabled"),
                    (f.appendChild(e).disabled = !0),
                    2 !== e.querySelectorAll(":disabled").length &&
                      g.push(":enabled", ":disabled"),
                    e.querySelectorAll("*,:x"),
                    g.push(",.*:");
                })),
              (i.matchesSelector = J.test(
                (y =
                  f.matches ||
                  f.webkitMatchesSelector ||
                  f.mozMatchesSelector ||
                  f.oMatchesSelector ||
                  f.msMatchesSelector)
              )) &&
                de(function (e) {
                  (i.disconnectedMatch = y.call(e, "*")),
                    y.call(e, "[s!='']:x"),
                    v.push("!=", N);
                }),
              (g = g.length && new RegExp(g.join("|"))),
              (v = v.length && new RegExp(v.join("|"))),
              (t = J.test(f.compareDocumentPosition)),
              (b =
                t || J.test(f.contains)
                  ? function (e, t) {
                      var i = 9 === e.nodeType ? e.documentElement : e,
                        n = t && t.parentNode;
                      return (
                        e === n ||
                        !(
                          !n ||
                          1 !== n.nodeType ||
                          !(i.contains
                            ? i.contains(n)
                            : e.compareDocumentPosition &&
                              16 & e.compareDocumentPosition(n))
                        )
                      );
                    }
                  : function (e, t) {
                      if (t)
                        for (; (t = t.parentNode); ) if (t === e) return !0;
                      return !1;
                    }),
              (E = t
                ? function (e, t) {
                    if (e === t) return (u = !0), 0;
                    var n =
                      !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      n ||
                      (1 &
                        (n =
                          (e.ownerDocument || e) == (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!i.sortDetached && t.compareDocumentPosition(e) === n)
                        ? e == h || (e.ownerDocument == k && b(k, e))
                          ? -1
                          : t == h || (t.ownerDocument == k && b(k, t))
                          ? 1
                          : d
                          ? q(d, e) - q(d, t)
                          : 0
                        : 4 & n
                        ? -1
                        : 1)
                    );
                  }
                : function (e, t) {
                    if (e === t) return (u = !0), 0;
                    var i,
                      n = 0,
                      o = e.parentNode,
                      r = t.parentNode,
                      s = [e],
                      a = [t];
                    if (!o || !r)
                      return e == h
                        ? -1
                        : t == h
                        ? 1
                        : o
                        ? -1
                        : r
                        ? 1
                        : d
                        ? q(d, e) - q(d, t)
                        : 0;
                    if (o === r) return pe(e, t);
                    for (i = e; (i = i.parentNode); ) s.unshift(i);
                    for (i = t; (i = i.parentNode); ) a.unshift(i);
                    for (; s[n] === a[n]; ) n++;
                    return n
                      ? pe(s[n], a[n])
                      : s[n] == k
                      ? -1
                      : a[n] == k
                      ? 1
                      : 0;
                  })),
            h
          );
        }),
      (ae.matches = function (e, t) {
        return ae(e, null, null, t);
      }),
      (ae.matchesSelector = function (e, t) {
        if (
          (p(e),
          i.matchesSelector &&
            m &&
            !_[t + " "] &&
            (!v || !v.test(t)) &&
            (!g || !g.test(t)))
        )
          try {
            var n = y.call(e, t);
            if (
              n ||
              i.disconnectedMatch ||
              (e.document && 11 !== e.document.nodeType)
            )
              return n;
          } catch (e) {
            _(t, !0);
          }
        return 0 < ae(t, h, null, [e]).length;
      }),
      (ae.contains = function (e, t) {
        return (e.ownerDocument || e) != h && p(e), b(e, t);
      }),
      (ae.attr = function (e, t) {
        (e.ownerDocument || e) != h && p(e);
        var o = n.attrHandle[t.toLowerCase()],
          r = o && A.call(n.attrHandle, t.toLowerCase()) ? o(e, t, !m) : void 0;
        return void 0 !== r
          ? r
          : i.attributes || !m
          ? e.getAttribute(t)
          : (r = e.getAttributeNode(t)) && r.specified
          ? r.value
          : null;
      }),
      (ae.escape = function (e) {
        return (e + "").replace(ne, oe);
      }),
      (ae.error = function (e) {
        throw new Error("Syntax error, unrecognized expression: " + e);
      }),
      (ae.uniqueSort = function (e) {
        var t,
          n = [],
          o = 0,
          r = 0;
        if (
          ((u = !i.detectDuplicates),
          (d = !i.sortStable && e.slice(0)),
          e.sort(E),
          u)
        ) {
          for (; (t = e[r++]); ) t === e[r] && (o = n.push(r));
          for (; o--; ) e.splice(n[o], 1);
        }
        return (d = null), e;
      }),
      (o = ae.getText =
        function (e) {
          var t,
            i = "",
            n = 0,
            r = e.nodeType;
          if (r) {
            if (1 === r || 9 === r || 11 === r) {
              if ("string" == typeof e.textContent) return e.textContent;
              for (e = e.firstChild; e; e = e.nextSibling) i += o(e);
            } else if (3 === r || 4 === r) return e.nodeValue;
          } else for (; (t = e[n++]); ) i += o(t);
          return i;
        }),
      ((n = ae.selectors =
        {
          cacheLength: 50,
          createPseudo: ce,
          match: X,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(te, ie)),
                (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ie)),
                "~=" === e[2] && (e[3] = " " + e[3] + " "),
                e.slice(0, 4)
              );
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                "nth" === e[1].slice(0, 3)
                  ? (e[3] || ae.error(e[0]),
                    (e[4] = +(e[4]
                      ? e[5] + (e[6] || 1)
                      : 2 * ("even" === e[3] || "odd" === e[3]))),
                    (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                  : e[3] && ae.error(e[0]),
                e
              );
            },
            PSEUDO: function (e) {
              var t,
                i = !e[6] && e[2];
              return X.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || "")
                    : i &&
                      V.test(i) &&
                      (t = s(i, !0)) &&
                      (t = i.indexOf(")", i.length - t) - i.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
                  e.slice(0, 3));
            },
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(te, ie).toLowerCase();
              return "*" === e
                ? function () {
                    return !0;
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t;
                  };
            },
            CLASS: function (e) {
              var t = C[e + " "];
              return (
                t ||
                ((t = new RegExp("(^|" + z + ")" + e + "(" + z + "|$)")) &&
                  C(e, function (e) {
                    return t.test(
                      ("string" == typeof e.className && e.className) ||
                        (void 0 !== e.getAttribute &&
                          e.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (e, t, i) {
              return function (n) {
                var o = ae.attr(n, e);
                return null == o
                  ? "!=" === t
                  : !t ||
                      ((o += ""),
                      "=" === t
                        ? o === i
                        : "!=" === t
                        ? o !== i
                        : "^=" === t
                        ? i && 0 === o.indexOf(i)
                        : "*=" === t
                        ? i && -1 < o.indexOf(i)
                        : "$=" === t
                        ? i && o.slice(-i.length) === i
                        : "~=" === t
                        ? -1 < (" " + o.replace(B, " ") + " ").indexOf(i)
                        : "|=" === t &&
                          (o === i || o.slice(0, i.length + 1) === i + "-"));
              };
            },
            CHILD: function (e, t, i, n, o) {
              var r = "nth" !== e.slice(0, 3),
                s = "last" !== e.slice(-4),
                a = "of-type" === t;
              return 1 === n && 0 === o
                ? function (e) {
                    return !!e.parentNode;
                  }
                : function (t, i, l) {
                    var c,
                      d,
                      u,
                      p,
                      h,
                      f,
                      m = r !== s ? "nextSibling" : "previousSibling",
                      g = t.parentNode,
                      v = a && t.nodeName.toLowerCase(),
                      y = !l && !a,
                      b = !1;
                    if (g) {
                      if (r) {
                        for (; m; ) {
                          for (p = t; (p = p[m]); )
                            if (
                              a
                                ? p.nodeName.toLowerCase() === v
                                : 1 === p.nodeType
                            )
                              return !1;
                          f = m = "only" === e && !f && "nextSibling";
                        }
                        return !0;
                      }
                      if (((f = [s ? g.firstChild : g.lastChild]), s && y)) {
                        for (
                          b =
                            (h =
                              (c =
                                (d =
                                  (u = (p = g)[w] || (p[w] = {}))[p.uniqueID] ||
                                  (u[p.uniqueID] = {}))[e] || [])[0] === x &&
                              c[1]) && c[2],
                            p = h && g.childNodes[h];
                          (p = (++h && p && p[m]) || (b = h = 0) || f.pop());

                        )
                          if (1 === p.nodeType && ++b && p === t) {
                            d[e] = [x, h, b];
                            break;
                          }
                      } else if (
                        (y &&
                          (b = h =
                            (c =
                              (d =
                                (u = (p = t)[w] || (p[w] = {}))[p.uniqueID] ||
                                (u[p.uniqueID] = {}))[e] || [])[0] === x &&
                            c[1]),
                        !1 === b)
                      )
                        for (
                          ;
                          (p = (++h && p && p[m]) || (b = h = 0) || f.pop()) &&
                          ((a
                            ? p.nodeName.toLowerCase() !== v
                            : 1 !== p.nodeType) ||
                            !++b ||
                            (y &&
                              ((d =
                                (u = p[w] || (p[w] = {}))[p.uniqueID] ||
                                (u[p.uniqueID] = {}))[e] = [x, b]),
                            p !== t));

                        );
                      return (b -= o) === n || (b % n == 0 && 0 <= b / n);
                    }
                  };
            },
            PSEUDO: function (e, t) {
              var i,
                o =
                  n.pseudos[e] ||
                  n.setFilters[e.toLowerCase()] ||
                  ae.error("unsupported pseudo: " + e);
              return o[w]
                ? o(t)
                : 1 < o.length
                ? ((i = [e, e, "", t]),
                  n.setFilters.hasOwnProperty(e.toLowerCase())
                    ? ce(function (e, i) {
                        for (var n, r = o(e, t), s = r.length; s--; )
                          e[(n = q(e, r[s]))] = !(i[n] = r[s]);
                      })
                    : function (e) {
                        return o(e, 0, i);
                      })
                : o;
            },
          },
          pseudos: {
            not: ce(function (e) {
              var t = [],
                i = [],
                n = a(e.replace(H, "$1"));
              return n[w]
                ? ce(function (e, t, i, o) {
                    for (var r, s = n(e, null, o, []), a = e.length; a--; )
                      (r = s[a]) && (e[a] = !(t[a] = r));
                  })
                : function (e, o, r) {
                    return (
                      (t[0] = e), n(t, null, r, i), (t[0] = null), !i.pop()
                    );
                  };
            }),
            has: ce(function (e) {
              return function (t) {
                return 0 < ae(e, t).length;
              };
            }),
            contains: ce(function (e) {
              return (
                (e = e.replace(te, ie)),
                function (t) {
                  return -1 < (t.textContent || o(t)).indexOf(e);
                }
              );
            }),
            lang: ce(function (e) {
              return (
                G.test(e || "") || ae.error("unsupported lang: " + e),
                (e = e.replace(te, ie).toLowerCase()),
                function (t) {
                  var i;
                  do {
                    if (
                      (i = m
                        ? t.lang
                        : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                    )
                      return (
                        (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                      );
                  } while ((t = t.parentNode) && 1 === t.nodeType);
                  return !1;
                }
              );
            }),
            target: function (t) {
              var i = e.location && e.location.hash;
              return i && i.slice(1) === t.id;
            },
            root: function (e) {
              return e === f;
            },
            focus: function (e) {
              return (
                e === h.activeElement &&
                (!h.hasFocus || h.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              );
            },
            enabled: me(!1),
            disabled: me(!0),
            checked: function (e) {
              var t = e.nodeName.toLowerCase();
              return (
                ("input" === t && !!e.checked) ||
                ("option" === t && !!e.selected)
              );
            },
            selected: function (e) {
              return (
                e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
              );
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling)
                if (e.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e) {
              return !n.pseudos.empty(e);
            },
            header: function (e) {
              return K.test(e.nodeName);
            },
            input: function (e) {
              return Q.test(e.nodeName);
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return ("input" === t && "button" === e.type) || "button" === t;
            },
            text: function (e) {
              var t;
              return (
                "input" === e.nodeName.toLowerCase() &&
                "text" === e.type &&
                (null == (t = e.getAttribute("type")) ||
                  "text" === t.toLowerCase())
              );
            },
            first: ge(function () {
              return [0];
            }),
            last: ge(function (e, t) {
              return [t - 1];
            }),
            eq: ge(function (e, t, i) {
              return [i < 0 ? i + t : i];
            }),
            even: ge(function (e, t) {
              for (var i = 0; i < t; i += 2) e.push(i);
              return e;
            }),
            odd: ge(function (e, t) {
              for (var i = 1; i < t; i += 2) e.push(i);
              return e;
            }),
            lt: ge(function (e, t, i) {
              for (var n = i < 0 ? i + t : t < i ? t : i; 0 <= --n; ) e.push(n);
              return e;
            }),
            gt: ge(function (e, t, i) {
              for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
              return e;
            }),
          },
        }).pseudos.nth = n.pseudos.eq),
      { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
        n.pseudos[t] = he(t);
      for (t in { submit: !0, reset: !0 }) n.pseudos[t] = fe(t);
      function ye() {}
      function be(e) {
        for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
        return n;
      }
      function we(e, t, i) {
        var n = t.dir,
          o = t.next,
          r = o || n,
          s = i && "parentNode" === r,
          a = S++;
        return t.first
          ? function (t, i, o) {
              for (; (t = t[n]); ) if (1 === t.nodeType || s) return e(t, i, o);
              return !1;
            }
          : function (t, i, l) {
              var c,
                d,
                u,
                p = [x, a];
              if (l) {
                for (; (t = t[n]); )
                  if ((1 === t.nodeType || s) && e(t, i, l)) return !0;
              } else
                for (; (t = t[n]); )
                  if (1 === t.nodeType || s)
                    if (
                      ((d =
                        (u = t[w] || (t[w] = {}))[t.uniqueID] ||
                        (u[t.uniqueID] = {})),
                      o && o === t.nodeName.toLowerCase())
                    )
                      t = t[n] || t;
                    else {
                      if ((c = d[r]) && c[0] === x && c[1] === a)
                        return (p[2] = c[2]);
                      if (((d[r] = p)[2] = e(t, i, l))) return !0;
                    }
              return !1;
            };
      }
      function ke(e) {
        return 1 < e.length
          ? function (t, i, n) {
              for (var o = e.length; o--; ) if (!e[o](t, i, n)) return !1;
              return !0;
            }
          : e[0];
      }
      function xe(e, t, i, n, o) {
        for (var r, s = [], a = 0, l = e.length, c = null != t; a < l; a++)
          (r = e[a]) && ((i && !i(r, n, o)) || (s.push(r), c && t.push(a)));
        return s;
      }
      function Se(e, t, i, n, o, r) {
        return (
          n && !n[w] && (n = Se(n)),
          o && !o[w] && (o = Se(o, r)),
          ce(function (r, s, a, l) {
            var c,
              d,
              u,
              p = [],
              h = [],
              f = s.length,
              m =
                r ||
                (function (e, t, i) {
                  for (var n = 0, o = t.length; n < o; n++) ae(e, t[n], i);
                  return i;
                })(t || "*", a.nodeType ? [a] : a, []),
              g = !e || (!r && t) ? m : xe(m, p, e, a, l),
              v = i ? (o || (r ? e : f || n) ? [] : s) : g;
            if ((i && i(g, v, a, l), n))
              for (c = xe(v, h), n(c, [], a, l), d = c.length; d--; )
                (u = c[d]) && (v[h[d]] = !(g[h[d]] = u));
            if (r) {
              if (o || e) {
                if (o) {
                  for (c = [], d = v.length; d--; )
                    (u = v[d]) && c.push((g[d] = u));
                  o(null, (v = []), c, l);
                }
                for (d = v.length; d--; )
                  (u = v[d]) &&
                    -1 < (c = o ? q(r, u) : p[d]) &&
                    (r[c] = !(s[c] = u));
              }
            } else (v = xe(v === s ? v.splice(f, v.length) : v)), o ? o(null, s, v, l) : I.apply(s, v);
          })
        );
      }
      function Ce(e) {
        for (
          var t,
            i,
            o,
            r = e.length,
            s = n.relative[e[0].type],
            a = s || n.relative[" "],
            l = s ? 1 : 0,
            d = we(
              function (e) {
                return e === t;
              },
              a,
              !0
            ),
            u = we(
              function (e) {
                return -1 < q(t, e);
              },
              a,
              !0
            ),
            p = [
              function (e, i, n) {
                var o =
                  (!s && (n || i !== c)) ||
                  ((t = i).nodeType ? d(e, i, n) : u(e, i, n));
                return (t = null), o;
              },
            ];
          l < r;
          l++
        )
          if ((i = n.relative[e[l].type])) p = [we(ke(p), i)];
          else {
            if ((i = n.filter[e[l].type].apply(null, e[l].matches))[w]) {
              for (o = ++l; o < r && !n.relative[e[o].type]; o++);
              return Se(
                1 < l && ke(p),
                1 < l &&
                  be(
                    e
                      .slice(0, l - 1)
                      .concat({ value: " " === e[l - 2].type ? "*" : "" })
                  ).replace(H, "$1"),
                i,
                l < o && Ce(e.slice(l, o)),
                o < r && Ce((e = e.slice(o))),
                o < r && be(e)
              );
            }
            p.push(i);
          }
        return ke(p);
      }
      return (
        (ye.prototype = n.filters = n.pseudos),
        (n.setFilters = new ye()),
        (s = ae.tokenize =
          function (e, t) {
            var i,
              o,
              r,
              s,
              a,
              l,
              c,
              d = T[e + " "];
            if (d) return t ? 0 : d.slice(0);
            for (a = e, l = [], c = n.preFilter; a; ) {
              for (s in ((i && !(o = W.exec(a))) ||
                (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
              (i = !1),
              (o = R.exec(a)) &&
                ((i = o.shift()),
                r.push({ value: i, type: o[0].replace(H, " ") }),
                (a = a.slice(i.length))),
              n.filter))
                !(o = X[s].exec(a)) ||
                  (c[s] && !(o = c[s](o))) ||
                  ((i = o.shift()),
                  r.push({ value: i, type: s, matches: o }),
                  (a = a.slice(i.length)));
              if (!i) break;
            }
            return t ? a.length : a ? ae.error(e) : T(e, l).slice(0);
          }),
        (a = ae.compile =
          function (e, t) {
            var i,
              o,
              r,
              a,
              l,
              d,
              u = [],
              f = [],
              g = $[e + " "];
            if (!g) {
              for (t || (t = s(e)), i = t.length; i--; )
                (g = Ce(t[i]))[w] ? u.push(g) : f.push(g);
              (g = $(
                e,
                ((o = f),
                (a = 0 < (r = u).length),
                (l = 0 < o.length),
                (d = function (e, t, i, s, d) {
                  var u,
                    f,
                    g,
                    v = 0,
                    y = "0",
                    b = e && [],
                    w = [],
                    k = c,
                    S = e || (l && n.find.TAG("*", d)),
                    C = (x += null == k ? 1 : Math.random() || 0.1),
                    T = S.length;
                  for (
                    d && (c = t == h || t || d);
                    y !== T && null != (u = S[y]);
                    y++
                  ) {
                    if (l && u) {
                      for (
                        f = 0, t || u.ownerDocument == h || (p(u), (i = !m));
                        (g = o[f++]);

                      )
                        if (g(u, t || h, i)) {
                          s.push(u);
                          break;
                        }
                      d && (x = C);
                    }
                    a && ((u = !g && u) && v--, e && b.push(u));
                  }
                  if (((v += y), a && y !== v)) {
                    for (f = 0; (g = r[f++]); ) g(b, w, t, i);
                    if (e) {
                      if (0 < v)
                        for (; y--; ) b[y] || w[y] || (w[y] = L.call(s));
                      w = xe(w);
                    }
                    I.apply(s, w),
                      d &&
                        !e &&
                        0 < w.length &&
                        1 < v + r.length &&
                        ae.uniqueSort(s);
                  }
                  return d && ((x = C), (c = k)), b;
                }),
                a ? ce(d) : d)
              )).selector = e;
            }
            return g;
          }),
        (l = ae.select =
          function (e, t, i, o) {
            var r,
              l,
              c,
              d,
              u,
              p = "function" == typeof e && e,
              h = !o && s((e = p.selector || e));
            if (((i = i || []), 1 === h.length)) {
              if (
                2 < (l = h[0] = h[0].slice(0)).length &&
                "ID" === (c = l[0]).type &&
                9 === t.nodeType &&
                m &&
                n.relative[l[1].type]
              ) {
                if (
                  !(t = (n.find.ID(c.matches[0].replace(te, ie), t) || [])[0])
                )
                  return i;
                p && (t = t.parentNode), (e = e.slice(l.shift().value.length));
              }
              for (
                r = X.needsContext.test(e) ? 0 : l.length;
                r-- && ((c = l[r]), !n.relative[(d = c.type)]);

              )
                if (
                  (u = n.find[d]) &&
                  (o = u(
                    c.matches[0].replace(te, ie),
                    (ee.test(l[0].type) && ve(t.parentNode)) || t
                  ))
                ) {
                  if ((l.splice(r, 1), !(e = o.length && be(l))))
                    return I.apply(i, o), i;
                  break;
                }
            }
            return (
              (p || a(e, h))(
                o,
                t,
                !m,
                i,
                !t || (ee.test(e) && ve(t.parentNode)) || t
              ),
              i
            );
          }),
        (i.sortStable = w.split("").sort(E).join("") === w),
        (i.detectDuplicates = !!u),
        p(),
        (i.sortDetached = de(function (e) {
          return 1 & e.compareDocumentPosition(h.createElement("fieldset"));
        })),
        de(function (e) {
          return (
            (e.innerHTML = "<a href='#'></a>"),
            "#" === e.firstChild.getAttribute("href")
          );
        }) ||
          ue("type|href|height|width", function (e, t, i) {
            if (!i)
              return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
          }),
        (i.attributes &&
          de(function (e) {
            return (
              (e.innerHTML = "<input/>"),
              e.firstChild.setAttribute("value", ""),
              "" === e.firstChild.getAttribute("value")
            );
          })) ||
          ue("value", function (e, t, i) {
            if (!i && "input" === e.nodeName.toLowerCase())
              return e.defaultValue;
          }),
        de(function (e) {
          return null == e.getAttribute("disabled");
        }) ||
          ue(D, function (e, t, i) {
            var n;
            if (!i)
              return !0 === e[t]
                ? t.toLowerCase()
                : (n = e.getAttributeNode(t)) && n.specified
                ? n.value
                : null;
          }),
        ae
      );
    })(e);
    (k.find = S),
      (k.expr = S.selectors),
      (k.expr[":"] = k.expr.pseudos),
      (k.uniqueSort = k.unique = S.uniqueSort),
      (k.text = S.getText),
      (k.isXMLDoc = S.isXML),
      (k.contains = S.contains),
      (k.escapeSelector = S.escape);
    var C = function (e, t, i) {
        for (var n = [], o = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
          if (1 === e.nodeType) {
            if (o && k(e).is(i)) break;
            n.push(e);
          }
        return n;
      },
      T = function (e, t) {
        for (var i = []; e; e = e.nextSibling)
          1 === e.nodeType && e !== t && i.push(e);
        return i;
      },
      $ = k.expr.match.needsContext;
    function _(e, t) {
      return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    var E = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function A(e, t, i) {
      return f(t)
        ? k.grep(e, function (e, n) {
            return !!t.call(e, n, e) !== i;
          })
        : t.nodeType
        ? k.grep(e, function (e) {
            return (e === t) !== i;
          })
        : "string" != typeof t
        ? k.grep(e, function (e) {
            return -1 < a.call(t, e) !== i;
          })
        : k.filter(t, e, i);
    }
    (k.filter = function (e, t, i) {
      var n = t[0];
      return (
        i && (e = ":not(" + e + ")"),
        1 === t.length && 1 === n.nodeType
          ? k.find.matchesSelector(n, e)
            ? [n]
            : []
          : k.find.matches(
              e,
              k.grep(t, function (e) {
                return 1 === e.nodeType;
              })
            )
      );
    }),
      k.fn.extend({
        find: function (e) {
          var t,
            i,
            n = this.length,
            o = this;
          if ("string" != typeof e)
            return this.pushStack(
              k(e).filter(function () {
                for (t = 0; t < n; t++) if (k.contains(o[t], this)) return !0;
              })
            );
          for (i = this.pushStack([]), t = 0; t < n; t++) k.find(e, o[t], i);
          return 1 < n ? k.uniqueSort(i) : i;
        },
        filter: function (e) {
          return this.pushStack(A(this, e || [], !1));
        },
        not: function (e) {
          return this.pushStack(A(this, e || [], !0));
        },
        is: function (e) {
          return !!A(
            this,
            "string" == typeof e && $.test(e) ? k(e) : e || [],
            !1
          ).length;
        },
      });
    var P,
      L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((k.fn.init = function (e, t, i) {
      var n, o;
      if (!e) return this;
      if (((i = i || P), "string" == typeof e)) {
        if (
          !(n =
            "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
              ? [null, e, null]
              : L.exec(e)) ||
          (!n[1] && t)
        )
          return !t || t.jquery
            ? (t || i).find(e)
            : this.constructor(t).find(e);
        if (n[1]) {
          if (
            ((t = t instanceof k ? t[0] : t),
            k.merge(
              this,
              k.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : g, !0)
            ),
            E.test(n[1]) && k.isPlainObject(t))
          )
            for (n in t) f(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
          return this;
        }
        return (
          (o = g.getElementById(n[2])) && ((this[0] = o), (this.length = 1)),
          this
        );
      }
      return e.nodeType
        ? ((this[0] = e), (this.length = 1), this)
        : f(e)
        ? void 0 !== i.ready
          ? i.ready(e)
          : e(k)
        : k.makeArray(e, this);
    }).prototype = k.fn),
      (P = k(g));
    var j = /^(?:parents|prev(?:Until|All))/,
      I = { children: !0, contents: !0, next: !0, prev: !0 };
    function M(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType; );
      return e;
    }
    k.fn.extend({
      has: function (e) {
        var t = k(e, this),
          i = t.length;
        return this.filter(function () {
          for (var e = 0; e < i; e++) if (k.contains(this, t[e])) return !0;
        });
      },
      closest: function (e, t) {
        var i,
          n = 0,
          o = this.length,
          r = [],
          s = "string" != typeof e && k(e);
        if (!$.test(e))
          for (; n < o; n++)
            for (i = this[n]; i && i !== t; i = i.parentNode)
              if (
                i.nodeType < 11 &&
                (s
                  ? -1 < s.index(i)
                  : 1 === i.nodeType && k.find.matchesSelector(i, e))
              ) {
                r.push(i);
                break;
              }
        return this.pushStack(1 < r.length ? k.uniqueSort(r) : r);
      },
      index: function (e) {
        return e
          ? "string" == typeof e
            ? a.call(k(e), this[0])
            : a.call(this, e.jquery ? e[0] : e)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (e, t) {
        return this.pushStack(k.uniqueSort(k.merge(this.get(), k(e, t))));
      },
      addBack: function (e) {
        return this.add(
          null == e ? this.prevObject : this.prevObject.filter(e)
        );
      },
    }),
      k.each(
        {
          parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
          },
          parents: function (e) {
            return C(e, "parentNode");
          },
          parentsUntil: function (e, t, i) {
            return C(e, "parentNode", i);
          },
          next: function (e) {
            return M(e, "nextSibling");
          },
          prev: function (e) {
            return M(e, "previousSibling");
          },
          nextAll: function (e) {
            return C(e, "nextSibling");
          },
          prevAll: function (e) {
            return C(e, "previousSibling");
          },
          nextUntil: function (e, t, i) {
            return C(e, "nextSibling", i);
          },
          prevUntil: function (e, t, i) {
            return C(e, "previousSibling", i);
          },
          siblings: function (e) {
            return T((e.parentNode || {}).firstChild, e);
          },
          children: function (e) {
            return T(e.firstChild);
          },
          contents: function (e) {
            return null != e.contentDocument && n(e.contentDocument)
              ? e.contentDocument
              : (_(e, "template") && (e = e.content || e),
                k.merge([], e.childNodes));
          },
        },
        function (e, t) {
          k.fn[e] = function (i, n) {
            var o = k.map(this, t, i);
            return (
              "Until" !== e.slice(-5) && (n = i),
              n && "string" == typeof n && (o = k.filter(n, o)),
              1 < this.length &&
                (I[e] || k.uniqueSort(o), j.test(e) && o.reverse()),
              this.pushStack(o)
            );
          };
        }
      );
    var q = /[^\x20\t\r\n\f]+/g;
    function D(e) {
      return e;
    }
    function z(e) {
      throw e;
    }
    function F(e, t, i, n) {
      var o;
      try {
        e && f((o = e.promise))
          ? o.call(e).done(t).fail(i)
          : e && f((o = e.then))
          ? o.call(e, t, i)
          : t.apply(void 0, [e].slice(n));
      } catch (e) {
        i.apply(void 0, [e]);
      }
    }
    (k.Callbacks = function (e) {
      var t, i;
      e =
        "string" == typeof e
          ? ((t = e),
            (i = {}),
            k.each(t.match(q) || [], function (e, t) {
              i[t] = !0;
            }),
            i)
          : k.extend({}, e);
      var n,
        o,
        r,
        s,
        a = [],
        l = [],
        c = -1,
        d = function () {
          for (s = s || e.once, r = n = !0; l.length; c = -1)
            for (o = l.shift(); ++c < a.length; )
              !1 === a[c].apply(o[0], o[1]) &&
                e.stopOnFalse &&
                ((c = a.length), (o = !1));
          e.memory || (o = !1), (n = !1), s && (a = o ? [] : "");
        },
        u = {
          add: function () {
            return (
              a &&
                (o && !n && ((c = a.length - 1), l.push(o)),
                (function t(i) {
                  k.each(i, function (i, n) {
                    f(n)
                      ? (e.unique && u.has(n)) || a.push(n)
                      : n && n.length && "string" !== b(n) && t(n);
                  });
                })(arguments),
                o && !n && d()),
              this
            );
          },
          remove: function () {
            return (
              k.each(arguments, function (e, t) {
                for (var i; -1 < (i = k.inArray(t, a, i)); )
                  a.splice(i, 1), i <= c && c--;
              }),
              this
            );
          },
          has: function (e) {
            return e ? -1 < k.inArray(e, a) : 0 < a.length;
          },
          empty: function () {
            return a && (a = []), this;
          },
          disable: function () {
            return (s = l = []), (a = o = ""), this;
          },
          disabled: function () {
            return !a;
          },
          lock: function () {
            return (s = l = []), o || n || (a = o = ""), this;
          },
          locked: function () {
            return !!s;
          },
          fireWith: function (e, t) {
            return (
              s ||
                ((t = [e, (t = t || []).slice ? t.slice() : t]),
                l.push(t),
                n || d()),
              this
            );
          },
          fire: function () {
            return u.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!r;
          },
        };
      return u;
    }),
      k.extend({
        Deferred: function (t) {
          var i = [
              [
                "notify",
                "progress",
                k.Callbacks("memory"),
                k.Callbacks("memory"),
                2,
              ],
              [
                "resolve",
                "done",
                k.Callbacks("once memory"),
                k.Callbacks("once memory"),
                0,
                "resolved",
              ],
              [
                "reject",
                "fail",
                k.Callbacks("once memory"),
                k.Callbacks("once memory"),
                1,
                "rejected",
              ],
            ],
            n = "pending",
            o = {
              state: function () {
                return n;
              },
              always: function () {
                return r.done(arguments).fail(arguments), this;
              },
              catch: function (e) {
                return o.then(null, e);
              },
              pipe: function () {
                var e = arguments;
                return k
                  .Deferred(function (t) {
                    k.each(i, function (i, n) {
                      var o = f(e[n[4]]) && e[n[4]];
                      r[n[1]](function () {
                        var e = o && o.apply(this, arguments);
                        e && f(e.promise)
                          ? e
                              .promise()
                              .progress(t.notify)
                              .done(t.resolve)
                              .fail(t.reject)
                          : t[n[0] + "With"](this, o ? [e] : arguments);
                      });
                    }),
                      (e = null);
                  })
                  .promise();
              },
              then: function (t, n, o) {
                var r = 0;
                function s(t, i, n, o) {
                  return function () {
                    var a = this,
                      l = arguments,
                      c = function () {
                        var e, c;
                        if (!(t < r)) {
                          if ((e = n.apply(a, l)) === i.promise())
                            throw new TypeError("Thenable self-resolution");
                          (c =
                            e &&
                            ("object" == typeof e || "function" == typeof e) &&
                            e.then),
                            f(c)
                              ? o
                                ? c.call(e, s(r, i, D, o), s(r, i, z, o))
                                : (r++,
                                  c.call(
                                    e,
                                    s(r, i, D, o),
                                    s(r, i, z, o),
                                    s(r, i, D, i.notifyWith)
                                  ))
                              : (n !== D && ((a = void 0), (l = [e])),
                                (o || i.resolveWith)(a, l));
                        }
                      },
                      d = o
                        ? c
                        : function () {
                            try {
                              c();
                            } catch (e) {
                              k.Deferred.exceptionHook &&
                                k.Deferred.exceptionHook(e, d.stackTrace),
                                r <= t + 1 &&
                                  (n !== z && ((a = void 0), (l = [e])),
                                  i.rejectWith(a, l));
                            }
                          };
                    t
                      ? d()
                      : (k.Deferred.getStackHook &&
                          (d.stackTrace = k.Deferred.getStackHook()),
                        e.setTimeout(d));
                  };
                }
                return k
                  .Deferred(function (e) {
                    i[0][3].add(s(0, e, f(o) ? o : D, e.notifyWith)),
                      i[1][3].add(s(0, e, f(t) ? t : D)),
                      i[2][3].add(s(0, e, f(n) ? n : z));
                  })
                  .promise();
              },
              promise: function (e) {
                return null != e ? k.extend(e, o) : o;
              },
            },
            r = {};
          return (
            k.each(i, function (e, t) {
              var s = t[2],
                a = t[5];
              (o[t[1]] = s.add),
                a &&
                  s.add(
                    function () {
                      n = a;
                    },
                    i[3 - e][2].disable,
                    i[3 - e][3].disable,
                    i[0][2].lock,
                    i[0][3].lock
                  ),
                s.add(t[3].fire),
                (r[t[0]] = function () {
                  return (
                    r[t[0] + "With"](this === r ? void 0 : this, arguments),
                    this
                  );
                }),
                (r[t[0] + "With"] = s.fireWith);
            }),
            o.promise(r),
            t && t.call(r, r),
            r
          );
        },
        when: function (e) {
          var t = arguments.length,
            i = t,
            n = Array(i),
            r = o.call(arguments),
            s = k.Deferred(),
            a = function (e) {
              return function (i) {
                (n[e] = this),
                  (r[e] = 1 < arguments.length ? o.call(arguments) : i),
                  --t || s.resolveWith(n, r);
              };
            };
          if (
            t <= 1 &&
            (F(e, s.done(a(i)).resolve, s.reject, !t),
            "pending" === s.state() || f(r[i] && r[i].then))
          )
            return s.then();
          for (; i--; ) F(r[i], a(i), s.reject);
          return s.promise();
        },
      });
    var O = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (k.Deferred.exceptionHook = function (t, i) {
      e.console &&
        e.console.warn &&
        t &&
        O.test(t.name) &&
        e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, i);
    }),
      (k.readyException = function (t) {
        e.setTimeout(function () {
          throw t;
        });
      });
    var N = k.Deferred();
    function B() {
      g.removeEventListener("DOMContentLoaded", B),
        e.removeEventListener("load", B),
        k.ready();
    }
    (k.fn.ready = function (e) {
      return (
        N.then(e).catch(function (e) {
          k.readyException(e);
        }),
        this
      );
    }),
      k.extend({
        isReady: !1,
        readyWait: 1,
        ready: function (e) {
          (!0 === e ? --k.readyWait : k.isReady) ||
            ((k.isReady = !0) !== e && 0 < --k.readyWait) ||
            N.resolveWith(g, [k]);
        },
      }),
      (k.ready.then = N.then),
      "complete" === g.readyState ||
      ("loading" !== g.readyState && !g.documentElement.doScroll)
        ? e.setTimeout(k.ready)
        : (g.addEventListener("DOMContentLoaded", B),
          e.addEventListener("load", B));
    var H = function (e, t, i, n, o, r, s) {
        var a = 0,
          l = e.length,
          c = null == i;
        if ("object" === b(i))
          for (a in ((o = !0), i)) H(e, t, a, i[a], !0, r, s);
        else if (
          void 0 !== n &&
          ((o = !0),
          f(n) || (s = !0),
          c &&
            (s
              ? (t.call(e, n), (t = null))
              : ((c = t),
                (t = function (e, t, i) {
                  return c.call(k(e), i);
                }))),
          t)
        )
          for (; a < l; a++) t(e[a], i, s ? n : n.call(e[a], a, t(e[a], i)));
        return o ? e : c ? t.call(e) : l ? t(e[0], i) : r;
      },
      W = /^-ms-/,
      R = /-([a-z])/g;
    function U(e, t) {
      return t.toUpperCase();
    }
    function V(e) {
      return e.replace(W, "ms-").replace(R, U);
    }
    var G = function (e) {
      return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
    function X() {
      this.expando = k.expando + X.uid++;
    }
    (X.uid = 1),
      (X.prototype = {
        cache: function (e) {
          var t = e[this.expando];
          return (
            t ||
              ((t = {}),
              G(e) &&
                (e.nodeType
                  ? (e[this.expando] = t)
                  : Object.defineProperty(e, this.expando, {
                      value: t,
                      configurable: !0,
                    }))),
            t
          );
        },
        set: function (e, t, i) {
          var n,
            o = this.cache(e);
          if ("string" == typeof t) o[V(t)] = i;
          else for (n in t) o[V(n)] = t[n];
          return o;
        },
        get: function (e, t) {
          return void 0 === t
            ? this.cache(e)
            : e[this.expando] && e[this.expando][V(t)];
        },
        access: function (e, t, i) {
          return void 0 === t || (t && "string" == typeof t && void 0 === i)
            ? this.get(e, t)
            : (this.set(e, t, i), void 0 !== i ? i : t);
        },
        remove: function (e, t) {
          var i,
            n = e[this.expando];
          if (void 0 !== n) {
            if (void 0 !== t) {
              i = (t = Array.isArray(t)
                ? t.map(V)
                : (t = V(t)) in n
                ? [t]
                : t.match(q) || []).length;
              for (; i--; ) delete n[t[i]];
            }
            (void 0 === t || k.isEmptyObject(n)) &&
              (e.nodeType
                ? (e[this.expando] = void 0)
                : delete e[this.expando]);
          }
        },
        hasData: function (e) {
          var t = e[this.expando];
          return void 0 !== t && !k.isEmptyObject(t);
        },
      });
    var Y = new X(),
      Q = new X(),
      K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      J = /[A-Z]/g;
    function Z(e, t, i) {
      var n, o;
      if (void 0 === i && 1 === e.nodeType)
        if (
          ((n = "data-" + t.replace(J, "-$&").toLowerCase()),
          "string" == typeof (i = e.getAttribute(n)))
        ) {
          try {
            i =
              "true" === (o = i) ||
              ("false" !== o &&
                ("null" === o
                  ? null
                  : o === +o + ""
                  ? +o
                  : K.test(o)
                  ? JSON.parse(o)
                  : o));
          } catch (e) {}
          Q.set(e, t, i);
        } else i = void 0;
      return i;
    }
    k.extend({
      hasData: function (e) {
        return Q.hasData(e) || Y.hasData(e);
      },
      data: function (e, t, i) {
        return Q.access(e, t, i);
      },
      removeData: function (e, t) {
        Q.remove(e, t);
      },
      _data: function (e, t, i) {
        return Y.access(e, t, i);
      },
      _removeData: function (e, t) {
        Y.remove(e, t);
      },
    }),
      k.fn.extend({
        data: function (e, t) {
          var i,
            n,
            o,
            r = this[0],
            s = r && r.attributes;
          if (void 0 === e) {
            if (
              this.length &&
              ((o = Q.get(r)), 1 === r.nodeType && !Y.get(r, "hasDataAttrs"))
            ) {
              for (i = s.length; i--; )
                s[i] &&
                  0 === (n = s[i].name).indexOf("data-") &&
                  ((n = V(n.slice(5))), Z(r, n, o[n]));
              Y.set(r, "hasDataAttrs", !0);
            }
            return o;
          }
          return "object" == typeof e
            ? this.each(function () {
                Q.set(this, e);
              })
            : H(
                this,
                function (t) {
                  var i;
                  if (r && void 0 === t)
                    return void 0 !== (i = Q.get(r, e)) ||
                      void 0 !== (i = Z(r, e))
                      ? i
                      : void 0;
                  this.each(function () {
                    Q.set(this, e, t);
                  });
                },
                null,
                t,
                1 < arguments.length,
                null,
                !0
              );
        },
        removeData: function (e) {
          return this.each(function () {
            Q.remove(this, e);
          });
        },
      }),
      k.extend({
        queue: function (e, t, i) {
          var n;
          if (e)
            return (
              (t = (t || "fx") + "queue"),
              (n = Y.get(e, t)),
              i &&
                (!n || Array.isArray(i)
                  ? (n = Y.access(e, t, k.makeArray(i)))
                  : n.push(i)),
              n || []
            );
        },
        dequeue: function (e, t) {
          t = t || "fx";
          var i = k.queue(e, t),
            n = i.length,
            o = i.shift(),
            r = k._queueHooks(e, t);
          "inprogress" === o && ((o = i.shift()), n--),
            o &&
              ("fx" === t && i.unshift("inprogress"),
              delete r.stop,
              o.call(
                e,
                function () {
                  k.dequeue(e, t);
                },
                r
              )),
            !n && r && r.empty.fire();
        },
        _queueHooks: function (e, t) {
          var i = t + "queueHooks";
          return (
            Y.get(e, i) ||
            Y.access(e, i, {
              empty: k.Callbacks("once memory").add(function () {
                Y.remove(e, [t + "queue", i]);
              }),
            })
          );
        },
      }),
      k.fn.extend({
        queue: function (e, t) {
          var i = 2;
          return (
            "string" != typeof e && ((t = e), (e = "fx"), i--),
            arguments.length < i
              ? k.queue(this[0], e)
              : void 0 === t
              ? this
              : this.each(function () {
                  var i = k.queue(this, e, t);
                  k._queueHooks(this, e),
                    "fx" === e && "inprogress" !== i[0] && k.dequeue(this, e);
                })
          );
        },
        dequeue: function (e) {
          return this.each(function () {
            k.dequeue(this, e);
          });
        },
        clearQueue: function (e) {
          return this.queue(e || "fx", []);
        },
        promise: function (e, t) {
          var i,
            n = 1,
            o = k.Deferred(),
            r = this,
            s = this.length,
            a = function () {
              --n || o.resolveWith(r, [r]);
            };
          for (
            "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
            s--;

          )
            (i = Y.get(r[s], e + "queueHooks")) &&
              i.empty &&
              (n++, i.empty.add(a));
          return a(), o.promise(t);
        },
      });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
      ie = ["Top", "Right", "Bottom", "Left"],
      ne = g.documentElement,
      oe = function (e) {
        return k.contains(e.ownerDocument, e);
      },
      re = { composed: !0 };
    ne.getRootNode &&
      (oe = function (e) {
        return (
          k.contains(e.ownerDocument, e) ||
          e.getRootNode(re) === e.ownerDocument
        );
      });
    var se = function (e, t) {
      return (
        "none" === (e = t || e).style.display ||
        ("" === e.style.display && oe(e) && "none" === k.css(e, "display"))
      );
    };
    function ae(e, t, i, n) {
      var o,
        r,
        s = 20,
        a = n
          ? function () {
              return n.cur();
            }
          : function () {
              return k.css(e, t, "");
            },
        l = a(),
        c = (i && i[3]) || (k.cssNumber[t] ? "" : "px"),
        d =
          e.nodeType &&
          (k.cssNumber[t] || ("px" !== c && +l)) &&
          te.exec(k.css(e, t));
      if (d && d[3] !== c) {
        for (l /= 2, c = c || d[3], d = +l || 1; s--; )
          k.style(e, t, d + c),
            (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0),
            (d /= r);
        (d *= 2), k.style(e, t, d + c), (i = i || []);
      }
      return (
        i &&
          ((d = +d || +l || 0),
          (o = i[1] ? d + (i[1] + 1) * i[2] : +i[2]),
          n && ((n.unit = c), (n.start = d), (n.end = o))),
        o
      );
    }
    var le = {};
    function ce(e, t) {
      for (var i, n, o, r, s, a, l, c = [], d = 0, u = e.length; d < u; d++)
        (n = e[d]).style &&
          ((i = n.style.display),
          t
            ? ("none" === i &&
                ((c[d] = Y.get(n, "display") || null),
                c[d] || (n.style.display = "")),
              "" === n.style.display &&
                se(n) &&
                (c[d] =
                  ((l = s = r = void 0),
                  (s = (o = n).ownerDocument),
                  (a = o.nodeName),
                  (l = le[a]) ||
                    ((r = s.body.appendChild(s.createElement(a))),
                    (l = k.css(r, "display")),
                    r.parentNode.removeChild(r),
                    "none" === l && (l = "block"),
                    (le[a] = l)))))
            : "none" !== i && ((c[d] = "none"), Y.set(n, "display", i)));
      for (d = 0; d < u; d++) null != c[d] && (e[d].style.display = c[d]);
      return e;
    }
    k.fn.extend({
      show: function () {
        return ce(this, !0);
      },
      hide: function () {
        return ce(this);
      },
      toggle: function (e) {
        return "boolean" == typeof e
          ? e
            ? this.show()
            : this.hide()
          : this.each(function () {
              se(this) ? k(this).show() : k(this).hide();
            });
      },
    });
    var de,
      ue,
      pe = /^(?:checkbox|radio)$/i,
      he = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
      fe = /^$|^module$|\/(?:java|ecma)script/i;
    (de = g.createDocumentFragment().appendChild(g.createElement("div"))),
      (ue = g.createElement("input")).setAttribute("type", "radio"),
      ue.setAttribute("checked", "checked"),
      ue.setAttribute("name", "t"),
      de.appendChild(ue),
      (h.checkClone = de.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (de.innerHTML = "<textarea>x</textarea>"),
      (h.noCloneChecked = !!de.cloneNode(!0).lastChild.defaultValue),
      (de.innerHTML = "<option></option>"),
      (h.option = !!de.lastChild);
    var me = {
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
    function ge(e, t) {
      var i;
      return (
        (i =
          void 0 !== e.getElementsByTagName
            ? e.getElementsByTagName(t || "*")
            : void 0 !== e.querySelectorAll
            ? e.querySelectorAll(t || "*")
            : []),
        void 0 === t || (t && _(e, t)) ? k.merge([e], i) : i
      );
    }
    function ve(e, t) {
      for (var i = 0, n = e.length; i < n; i++)
        Y.set(e[i], "globalEval", !t || Y.get(t[i], "globalEval"));
    }
    (me.tbody = me.tfoot = me.colgroup = me.caption = me.thead),
      (me.th = me.td),
      h.option ||
        (me.optgroup = me.option =
          [1, "<select multiple='multiple'>", "</select>"]);
    var ye = /<|&#?\w+;/;
    function be(e, t, i, n, o) {
      for (
        var r,
          s,
          a,
          l,
          c,
          d,
          u = t.createDocumentFragment(),
          p = [],
          h = 0,
          f = e.length;
        h < f;
        h++
      )
        if ((r = e[h]) || 0 === r)
          if ("object" === b(r)) k.merge(p, r.nodeType ? [r] : r);
          else if (ye.test(r)) {
            for (
              s = s || u.appendChild(t.createElement("div")),
                a = (he.exec(r) || ["", ""])[1].toLowerCase(),
                l = me[a] || me._default,
                s.innerHTML = l[1] + k.htmlPrefilter(r) + l[2],
                d = l[0];
              d--;

            )
              s = s.lastChild;
            k.merge(p, s.childNodes), ((s = u.firstChild).textContent = "");
          } else p.push(t.createTextNode(r));
      for (u.textContent = "", h = 0; (r = p[h++]); )
        if (n && -1 < k.inArray(r, n)) o && o.push(r);
        else if (
          ((c = oe(r)), (s = ge(u.appendChild(r), "script")), c && ve(s), i)
        )
          for (d = 0; (r = s[d++]); ) fe.test(r.type || "") && i.push(r);
      return u;
    }
    var we = /^key/,
      ke = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      xe = /^([^.]*)(?:\.(.+)|)/;
    function Se() {
      return !0;
    }
    function Ce() {
      return !1;
    }
    function Te(e, t) {
      return (
        (e ===
          (function () {
            try {
              return g.activeElement;
            } catch (e) {}
          })()) ==
        ("focus" === t)
      );
    }
    function $e(e, t, i, n, o, r) {
      var s, a;
      if ("object" == typeof t) {
        for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), t))
          $e(e, a, i, n, t[a], r);
        return e;
      }
      if (
        (null == n && null == o
          ? ((o = i), (n = i = void 0))
          : null == o &&
            ("string" == typeof i
              ? ((o = n), (n = void 0))
              : ((o = n), (n = i), (i = void 0))),
        !1 === o)
      )
        o = Ce;
      else if (!o) return e;
      return (
        1 === r &&
          ((s = o),
          ((o = function (e) {
            return k().off(e), s.apply(this, arguments);
          }).guid = s.guid || (s.guid = k.guid++))),
        e.each(function () {
          k.event.add(this, t, o, n, i);
        })
      );
    }
    function _e(e, t, i) {
      i
        ? (Y.set(e, t, !1),
          k.event.add(e, t, {
            namespace: !1,
            handler: function (e) {
              var n,
                r,
                s = Y.get(this, t);
              if (1 & e.isTrigger && this[t]) {
                if (s.length)
                  (k.event.special[t] || {}).delegateType &&
                    e.stopPropagation();
                else if (
                  ((s = o.call(arguments)),
                  Y.set(this, t, s),
                  (n = i(this, t)),
                  this[t](),
                  s !== (r = Y.get(this, t)) || n
                    ? Y.set(this, t, !1)
                    : (r = {}),
                  s !== r)
                )
                  return (
                    e.stopImmediatePropagation(), e.preventDefault(), r.value
                  );
              } else
                s.length &&
                  (Y.set(this, t, {
                    value: k.event.trigger(
                      k.extend(s[0], k.Event.prototype),
                      s.slice(1),
                      this
                    ),
                  }),
                  e.stopImmediatePropagation());
            },
          }))
        : void 0 === Y.get(e, t) && k.event.add(e, t, Se);
    }
    (k.event = {
      global: {},
      add: function (e, t, i, n, o) {
        var r,
          s,
          a,
          l,
          c,
          d,
          u,
          p,
          h,
          f,
          m,
          g = Y.get(e);
        if (G(e))
          for (
            i.handler && ((i = (r = i).handler), (o = r.selector)),
              o && k.find.matchesSelector(ne, o),
              i.guid || (i.guid = k.guid++),
              (l = g.events) || (l = g.events = Object.create(null)),
              (s = g.handle) ||
                (s = g.handle =
                  function (t) {
                    return void 0 !== k && k.event.triggered !== t.type
                      ? k.event.dispatch.apply(e, arguments)
                      : void 0;
                  }),
              c = (t = (t || "").match(q) || [""]).length;
            c--;

          )
            (h = m = (a = xe.exec(t[c]) || [])[1]),
              (f = (a[2] || "").split(".").sort()),
              h &&
                ((u = k.event.special[h] || {}),
                (h = (o ? u.delegateType : u.bindType) || h),
                (u = k.event.special[h] || {}),
                (d = k.extend(
                  {
                    type: h,
                    origType: m,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: o,
                    needsContext: o && k.expr.match.needsContext.test(o),
                    namespace: f.join("."),
                  },
                  r
                )),
                (p = l[h]) ||
                  (((p = l[h] = []).delegateCount = 0),
                  (u.setup && !1 !== u.setup.call(e, n, f, s)) ||
                    (e.addEventListener && e.addEventListener(h, s))),
                u.add &&
                  (u.add.call(e, d),
                  d.handler.guid || (d.handler.guid = i.guid)),
                o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                (k.event.global[h] = !0));
      },
      remove: function (e, t, i, n, o) {
        var r,
          s,
          a,
          l,
          c,
          d,
          u,
          p,
          h,
          f,
          m,
          g = Y.hasData(e) && Y.get(e);
        if (g && (l = g.events)) {
          for (c = (t = (t || "").match(q) || [""]).length; c--; )
            if (
              ((h = m = (a = xe.exec(t[c]) || [])[1]),
              (f = (a[2] || "").split(".").sort()),
              h)
            ) {
              for (
                u = k.event.special[h] || {},
                  p = l[(h = (n ? u.delegateType : u.bindType) || h)] || [],
                  a =
                    a[2] &&
                    new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  s = r = p.length;
                r--;

              )
                (d = p[r]),
                  (!o && m !== d.origType) ||
                    (i && i.guid !== d.guid) ||
                    (a && !a.test(d.namespace)) ||
                    (n && n !== d.selector && ("**" !== n || !d.selector)) ||
                    (p.splice(r, 1),
                    d.selector && p.delegateCount--,
                    u.remove && u.remove.call(e, d));
              s &&
                !p.length &&
                ((u.teardown && !1 !== u.teardown.call(e, f, g.handle)) ||
                  k.removeEvent(e, h, g.handle),
                delete l[h]);
            } else for (h in l) k.event.remove(e, h + t[c], i, n, !0);
          k.isEmptyObject(l) && Y.remove(e, "handle events");
        }
      },
      dispatch: function (e) {
        var t,
          i,
          n,
          o,
          r,
          s,
          a = new Array(arguments.length),
          l = k.event.fix(e),
          c = (Y.get(this, "events") || Object.create(null))[l.type] || [],
          d = k.event.special[l.type] || {};
        for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
        if (
          ((l.delegateTarget = this),
          !d.preDispatch || !1 !== d.preDispatch.call(this, l))
        ) {
          for (
            s = k.event.handlers.call(this, l, c), t = 0;
            (o = s[t++]) && !l.isPropagationStopped();

          )
            for (
              l.currentTarget = o.elem, i = 0;
              (r = o.handlers[i++]) && !l.isImmediatePropagationStopped();

            )
              (l.rnamespace &&
                !1 !== r.namespace &&
                !l.rnamespace.test(r.namespace)) ||
                ((l.handleObj = r),
                (l.data = r.data),
                void 0 !==
                  (n = (
                    (k.event.special[r.origType] || {}).handle || r.handler
                  ).apply(o.elem, a)) &&
                  !1 === (l.result = n) &&
                  (l.preventDefault(), l.stopPropagation()));
          return d.postDispatch && d.postDispatch.call(this, l), l.result;
        }
      },
      handlers: function (e, t) {
        var i,
          n,
          o,
          r,
          s,
          a = [],
          l = t.delegateCount,
          c = e.target;
        if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
          for (; c !== this; c = c.parentNode || this)
            if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
              for (r = [], s = {}, i = 0; i < l; i++)
                void 0 === s[(o = (n = t[i]).selector + " ")] &&
                  (s[o] = n.needsContext
                    ? -1 < k(o, this).index(c)
                    : k.find(o, this, null, [c]).length),
                  s[o] && r.push(n);
              r.length && a.push({ elem: c, handlers: r });
            }
        return (
          (c = this),
          l < t.length && a.push({ elem: c, handlers: t.slice(l) }),
          a
        );
      },
      addProp: function (e, t) {
        Object.defineProperty(k.Event.prototype, e, {
          enumerable: !0,
          configurable: !0,
          get: f(t)
            ? function () {
                if (this.originalEvent) return t(this.originalEvent);
              }
            : function () {
                if (this.originalEvent) return this.originalEvent[e];
              },
          set: function (t) {
            Object.defineProperty(this, e, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: t,
            });
          },
        });
      },
      fix: function (e) {
        return e[k.expando] ? e : new k.Event(e);
      },
      special: {
        load: { noBubble: !0 },
        click: {
          setup: function (e) {
            var t = this || e;
            return (
              pe.test(t.type) && t.click && _(t, "input") && _e(t, "click", Se),
              !1
            );
          },
          trigger: function (e) {
            var t = this || e;
            return (
              pe.test(t.type) && t.click && _(t, "input") && _e(t, "click"), !0
            );
          },
          _default: function (e) {
            var t = e.target;
            return (
              (pe.test(t.type) &&
                t.click &&
                _(t, "input") &&
                Y.get(t, "click")) ||
              _(t, "a")
            );
          },
        },
        beforeunload: {
          postDispatch: function (e) {
            void 0 !== e.result &&
              e.originalEvent &&
              (e.originalEvent.returnValue = e.result);
          },
        },
      },
    }),
      (k.removeEvent = function (e, t, i) {
        e.removeEventListener && e.removeEventListener(t, i);
      }),
      (k.Event = function (e, t) {
        if (!(this instanceof k.Event)) return new k.Event(e, t);
        e && e.type
          ? ((this.originalEvent = e),
            (this.type = e.type),
            (this.isDefaultPrevented =
              e.defaultPrevented ||
              (void 0 === e.defaultPrevented && !1 === e.returnValue)
                ? Se
                : Ce),
            (this.target =
              e.target && 3 === e.target.nodeType
                ? e.target.parentNode
                : e.target),
            (this.currentTarget = e.currentTarget),
            (this.relatedTarget = e.relatedTarget))
          : (this.type = e),
          t && k.extend(this, t),
          (this.timeStamp = (e && e.timeStamp) || Date.now()),
          (this[k.expando] = !0);
      }),
      (k.Event.prototype = {
        constructor: k.Event,
        isDefaultPrevented: Ce,
        isPropagationStopped: Ce,
        isImmediatePropagationStopped: Ce,
        isSimulated: !1,
        preventDefault: function () {
          var e = this.originalEvent;
          (this.isDefaultPrevented = Se),
            e && !this.isSimulated && e.preventDefault();
        },
        stopPropagation: function () {
          var e = this.originalEvent;
          (this.isPropagationStopped = Se),
            e && !this.isSimulated && e.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var e = this.originalEvent;
          (this.isImmediatePropagationStopped = Se),
            e && !this.isSimulated && e.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      k.each(
        {
          altKey: !0,
          bubbles: !0,
          cancelable: !0,
          changedTouches: !0,
          ctrlKey: !0,
          detail: !0,
          eventPhase: !0,
          metaKey: !0,
          pageX: !0,
          pageY: !0,
          shiftKey: !0,
          view: !0,
          char: !0,
          code: !0,
          charCode: !0,
          key: !0,
          keyCode: !0,
          button: !0,
          buttons: !0,
          clientX: !0,
          clientY: !0,
          offsetX: !0,
          offsetY: !0,
          pointerId: !0,
          pointerType: !0,
          screenX: !0,
          screenY: !0,
          targetTouches: !0,
          toElement: !0,
          touches: !0,
          which: function (e) {
            var t = e.button;
            return null == e.which && we.test(e.type)
              ? null != e.charCode
                ? e.charCode
                : e.keyCode
              : !e.which && void 0 !== t && ke.test(e.type)
              ? 1 & t
                ? 1
                : 2 & t
                ? 3
                : 4 & t
                ? 2
                : 0
              : e.which;
          },
        },
        k.event.addProp
      ),
      k.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
        k.event.special[e] = {
          setup: function () {
            return _e(this, e, Te), !1;
          },
          trigger: function () {
            return _e(this, e), !0;
          },
          delegateType: t,
        };
      }),
      k.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (e, t) {
          k.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function (e) {
              var i,
                n = e.relatedTarget,
                o = e.handleObj;
              return (
                (n && (n === this || k.contains(this, n))) ||
                  ((e.type = o.origType),
                  (i = o.handler.apply(this, arguments)),
                  (e.type = t)),
                i
              );
            },
          };
        }
      ),
      k.fn.extend({
        on: function (e, t, i, n) {
          return $e(this, e, t, i, n);
        },
        one: function (e, t, i, n) {
          return $e(this, e, t, i, n, 1);
        },
        off: function (e, t, i) {
          var n, o;
          if (e && e.preventDefault && e.handleObj)
            return (
              (n = e.handleObj),
              k(e.delegateTarget).off(
                n.namespace ? n.origType + "." + n.namespace : n.origType,
                n.selector,
                n.handler
              ),
              this
            );
          if ("object" == typeof e) {
            for (o in e) this.off(o, t, e[o]);
            return this;
          }
          return (
            (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
            !1 === i && (i = Ce),
            this.each(function () {
              k.event.remove(this, e, i, t);
            })
          );
        },
      });
    var Ee = /<script|<style|<link/i,
      Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Pe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function Le(e, t) {
      return (
        (_(e, "table") &&
          _(11 !== t.nodeType ? t : t.firstChild, "tr") &&
          k(e).children("tbody")[0]) ||
        e
      );
    }
    function je(e) {
      return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function Ie(e) {
      return (
        "true/" === (e.type || "").slice(0, 5)
          ? (e.type = e.type.slice(5))
          : e.removeAttribute("type"),
        e
      );
    }
    function Me(e, t) {
      var i, n, o, r, s, a;
      if (1 === t.nodeType) {
        if (Y.hasData(e) && (a = Y.get(e).events))
          for (o in (Y.remove(t, "handle events"), a))
            for (i = 0, n = a[o].length; i < n; i++) k.event.add(t, o, a[o][i]);
        Q.hasData(e) && ((r = Q.access(e)), (s = k.extend({}, r)), Q.set(t, s));
      }
    }
    function qe(e, t, i, n) {
      t = r(t);
      var o,
        s,
        a,
        l,
        c,
        d,
        u = 0,
        p = e.length,
        m = p - 1,
        g = t[0],
        v = f(g);
      if (v || (1 < p && "string" == typeof g && !h.checkClone && Ae.test(g)))
        return e.each(function (o) {
          var r = e.eq(o);
          v && (t[0] = g.call(this, o, r.html())), qe(r, t, i, n);
        });
      if (
        p &&
        ((s = (o = be(t, e[0].ownerDocument, !1, e, n)).firstChild),
        1 === o.childNodes.length && (o = s),
        s || n)
      ) {
        for (l = (a = k.map(ge(o, "script"), je)).length; u < p; u++)
          (c = o),
            u !== m &&
              ((c = k.clone(c, !0, !0)), l && k.merge(a, ge(c, "script"))),
            i.call(e[u], c, u);
        if (l)
          for (
            d = a[a.length - 1].ownerDocument, k.map(a, Ie), u = 0;
            u < l;
            u++
          )
            (c = a[u]),
              fe.test(c.type || "") &&
                !Y.access(c, "globalEval") &&
                k.contains(d, c) &&
                (c.src && "module" !== (c.type || "").toLowerCase()
                  ? k._evalUrl &&
                    !c.noModule &&
                    k._evalUrl(
                      c.src,
                      { nonce: c.nonce || c.getAttribute("nonce") },
                      d
                    )
                  : y(c.textContent.replace(Pe, ""), c, d));
      }
      return e;
    }
    function De(e, t, i) {
      for (var n, o = t ? k.filter(t, e) : e, r = 0; null != (n = o[r]); r++)
        i || 1 !== n.nodeType || k.cleanData(ge(n)),
          n.parentNode &&
            (i && oe(n) && ve(ge(n, "script")), n.parentNode.removeChild(n));
      return e;
    }
    k.extend({
      htmlPrefilter: function (e) {
        return e;
      },
      clone: function (e, t, i) {
        var n,
          o,
          r,
          s,
          a,
          l,
          c,
          d = e.cloneNode(!0),
          u = oe(e);
        if (
          !(
            h.noCloneChecked ||
            (1 !== e.nodeType && 11 !== e.nodeType) ||
            k.isXMLDoc(e)
          )
        )
          for (s = ge(d), n = 0, o = (r = ge(e)).length; n < o; n++)
            (a = r[n]),
              "input" === (c = (l = s[n]).nodeName.toLowerCase()) &&
              pe.test(a.type)
                ? (l.checked = a.checked)
                : ("input" !== c && "textarea" !== c) ||
                  (l.defaultValue = a.defaultValue);
        if (t)
          if (i)
            for (
              r = r || ge(e), s = s || ge(d), n = 0, o = r.length;
              n < o;
              n++
            )
              Me(r[n], s[n]);
          else Me(e, d);
        return (
          0 < (s = ge(d, "script")).length && ve(s, !u && ge(e, "script")), d
        );
      },
      cleanData: function (e) {
        for (
          var t, i, n, o = k.event.special, r = 0;
          void 0 !== (i = e[r]);
          r++
        )
          if (G(i)) {
            if ((t = i[Y.expando])) {
              if (t.events)
                for (n in t.events)
                  o[n] ? k.event.remove(i, n) : k.removeEvent(i, n, t.handle);
              i[Y.expando] = void 0;
            }
            i[Q.expando] && (i[Q.expando] = void 0);
          }
      },
    }),
      k.fn.extend({
        detach: function (e) {
          return De(this, e, !0);
        },
        remove: function (e) {
          return De(this, e);
        },
        text: function (e) {
          return H(
            this,
            function (e) {
              return void 0 === e
                ? k.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = e);
                  });
            },
            null,
            e,
            arguments.length
          );
        },
        append: function () {
          return qe(this, arguments, function (e) {
            (1 !== this.nodeType &&
              11 !== this.nodeType &&
              9 !== this.nodeType) ||
              Le(this, e).appendChild(e);
          });
        },
        prepend: function () {
          return qe(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = Le(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function () {
          return qe(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function () {
          return qe(this, arguments, function (e) {
            this.parentNode &&
              this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function () {
          for (var e, t = 0; null != (e = this[t]); t++)
            1 === e.nodeType && (k.cleanData(ge(e, !1)), (e.textContent = ""));
          return this;
        },
        clone: function (e, t) {
          return (
            (e = null != e && e),
            (t = null == t ? e : t),
            this.map(function () {
              return k.clone(this, e, t);
            })
          );
        },
        html: function (e) {
          return H(
            this,
            function (e) {
              var t = this[0] || {},
                i = 0,
                n = this.length;
              if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
              if (
                "string" == typeof e &&
                !Ee.test(e) &&
                !me[(he.exec(e) || ["", ""])[1].toLowerCase()]
              ) {
                e = k.htmlPrefilter(e);
                try {
                  for (; i < n; i++)
                    1 === (t = this[i] || {}).nodeType &&
                      (k.cleanData(ge(t, !1)), (t.innerHTML = e));
                  t = 0;
                } catch (e) {}
              }
              t && this.empty().append(e);
            },
            null,
            e,
            arguments.length
          );
        },
        replaceWith: function () {
          var e = [];
          return qe(
            this,
            arguments,
            function (t) {
              var i = this.parentNode;
              k.inArray(this, e) < 0 &&
                (k.cleanData(ge(this)), i && i.replaceChild(t, this));
            },
            e
          );
        },
      }),
      k.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e, t) {
          k.fn[e] = function (e) {
            for (var i, n = [], o = k(e), r = o.length - 1, a = 0; a <= r; a++)
              (i = a === r ? this : this.clone(!0)),
                k(o[a])[t](i),
                s.apply(n, i.get());
            return this.pushStack(n);
          };
        }
      );
    var ze = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
      Fe = function (t) {
        var i = t.ownerDocument.defaultView;
        return (i && i.opener) || (i = e), i.getComputedStyle(t);
      },
      Oe = function (e, t, i) {
        var n,
          o,
          r = {};
        for (o in t) (r[o] = e.style[o]), (e.style[o] = t[o]);
        for (o in ((n = i.call(e)), t)) e.style[o] = r[o];
        return n;
      },
      Ne = new RegExp(ie.join("|"), "i");
    function Be(e, t, i) {
      var n,
        o,
        r,
        s,
        a = e.style;
      return (
        (i = i || Fe(e)) &&
          ("" !== (s = i.getPropertyValue(t) || i[t]) ||
            oe(e) ||
            (s = k.style(e, t)),
          !h.pixelBoxStyles() &&
            ze.test(s) &&
            Ne.test(t) &&
            ((n = a.width),
            (o = a.minWidth),
            (r = a.maxWidth),
            (a.minWidth = a.maxWidth = a.width = s),
            (s = i.width),
            (a.width = n),
            (a.minWidth = o),
            (a.maxWidth = r))),
        void 0 !== s ? s + "" : s
      );
    }
    function He(e, t) {
      return {
        get: function () {
          if (!e()) return (this.get = t).apply(this, arguments);
          delete this.get;
        },
      };
    }
    !(function () {
      function t() {
        if (d) {
          (c.style.cssText =
            "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
            (d.style.cssText =
              "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
            ne.appendChild(c).appendChild(d);
          var t = e.getComputedStyle(d);
          (n = "1%" !== t.top),
            (l = 12 === i(t.marginLeft)),
            (d.style.right = "60%"),
            (s = 36 === i(t.right)),
            (o = 36 === i(t.width)),
            (d.style.position = "absolute"),
            (r = 12 === i(d.offsetWidth / 3)),
            ne.removeChild(c),
            (d = null);
        }
      }
      function i(e) {
        return Math.round(parseFloat(e));
      }
      var n,
        o,
        r,
        s,
        a,
        l,
        c = g.createElement("div"),
        d = g.createElement("div");
      d.style &&
        ((d.style.backgroundClip = "content-box"),
        (d.cloneNode(!0).style.backgroundClip = ""),
        (h.clearCloneStyle = "content-box" === d.style.backgroundClip),
        k.extend(h, {
          boxSizingReliable: function () {
            return t(), o;
          },
          pixelBoxStyles: function () {
            return t(), s;
          },
          pixelPosition: function () {
            return t(), n;
          },
          reliableMarginLeft: function () {
            return t(), l;
          },
          scrollboxSize: function () {
            return t(), r;
          },
          reliableTrDimensions: function () {
            var t, i, n, o;
            return (
              null == a &&
                ((t = g.createElement("table")),
                (i = g.createElement("tr")),
                (n = g.createElement("div")),
                (t.style.cssText = "position:absolute;left:-11111px"),
                (i.style.height = "1px"),
                (n.style.height = "9px"),
                ne.appendChild(t).appendChild(i).appendChild(n),
                (o = e.getComputedStyle(i)),
                (a = 3 < parseInt(o.height)),
                ne.removeChild(t)),
              a
            );
          },
        }));
    })();
    var We = ["Webkit", "Moz", "ms"],
      Re = g.createElement("div").style,
      Ue = {};
    function Ve(e) {
      return (
        k.cssProps[e] ||
        Ue[e] ||
        (e in Re
          ? e
          : (Ue[e] =
              (function (e) {
                for (
                  var t = e[0].toUpperCase() + e.slice(1), i = We.length;
                  i--;

                )
                  if ((e = We[i] + t) in Re) return e;
              })(e) || e))
      );
    }
    var Ge = /^(none|table(?!-c[ea]).+)/,
      Xe = /^--/,
      Ye = { position: "absolute", visibility: "hidden", display: "block" },
      Qe = { letterSpacing: "0", fontWeight: "400" };
    function Ke(e, t, i) {
      var n = te.exec(t);
      return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
    }
    function Je(e, t, i, n, o, r) {
      var s = "width" === t ? 1 : 0,
        a = 0,
        l = 0;
      if (i === (n ? "border" : "content")) return 0;
      for (; s < 4; s += 2)
        "margin" === i && (l += k.css(e, i + ie[s], !0, o)),
          n
            ? ("content" === i && (l -= k.css(e, "padding" + ie[s], !0, o)),
              "margin" !== i &&
                (l -= k.css(e, "border" + ie[s] + "Width", !0, o)))
            : ((l += k.css(e, "padding" + ie[s], !0, o)),
              "padding" !== i
                ? (l += k.css(e, "border" + ie[s] + "Width", !0, o))
                : (a += k.css(e, "border" + ie[s] + "Width", !0, o)));
      return (
        !n &&
          0 <= r &&
          (l +=
            Math.max(
              0,
              Math.ceil(
                e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5
              )
            ) || 0),
        l
      );
    }
    function Ze(e, t, i) {
      var n = Fe(e),
        o =
          (!h.boxSizingReliable() || i) &&
          "border-box" === k.css(e, "boxSizing", !1, n),
        r = o,
        s = Be(e, t, n),
        a = "offset" + t[0].toUpperCase() + t.slice(1);
      if (ze.test(s)) {
        if (!i) return s;
        s = "auto";
      }
      return (
        ((!h.boxSizingReliable() && o) ||
          (!h.reliableTrDimensions() && _(e, "tr")) ||
          "auto" === s ||
          (!parseFloat(s) && "inline" === k.css(e, "display", !1, n))) &&
          e.getClientRects().length &&
          ((o = "border-box" === k.css(e, "boxSizing", !1, n)),
          (r = a in e) && (s = e[a])),
        (s = parseFloat(s) || 0) +
          Je(e, t, i || (o ? "border" : "content"), r, n, s) +
          "px"
      );
    }
    function et(e, t, i, n, o) {
      return new et.prototype.init(e, t, i, n, o);
    }
    k.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var i = Be(e, "opacity");
              return "" === i ? "1" : i;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: {},
      style: function (e, t, i, n) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var o,
            r,
            s,
            a = V(t),
            l = Xe.test(t),
            c = e.style;
          if (
            (l || (t = Ve(a)),
            (s = k.cssHooks[t] || k.cssHooks[a]),
            void 0 === i)
          )
            return s && "get" in s && void 0 !== (o = s.get(e, !1, n))
              ? o
              : c[t];
          "string" == (r = typeof i) &&
            (o = te.exec(i)) &&
            o[1] &&
            ((i = ae(e, t, o)), (r = "number")),
            null != i &&
              i == i &&
              ("number" !== r ||
                l ||
                (i += (o && o[3]) || (k.cssNumber[a] ? "" : "px")),
              h.clearCloneStyle ||
                "" !== i ||
                0 !== t.indexOf("background") ||
                (c[t] = "inherit"),
              (s && "set" in s && void 0 === (i = s.set(e, i, n))) ||
                (l ? c.setProperty(t, i) : (c[t] = i)));
        }
      },
      css: function (e, t, i, n) {
        var o,
          r,
          s,
          a = V(t);
        return (
          Xe.test(t) || (t = Ve(a)),
          (s = k.cssHooks[t] || k.cssHooks[a]) &&
            "get" in s &&
            (o = s.get(e, !0, i)),
          void 0 === o && (o = Be(e, t, n)),
          "normal" === o && t in Qe && (o = Qe[t]),
          "" === i || i
            ? ((r = parseFloat(o)), !0 === i || isFinite(r) ? r || 0 : o)
            : o
        );
      },
    }),
      k.each(["height", "width"], function (e, t) {
        k.cssHooks[t] = {
          get: function (e, i, n) {
            if (i)
              return !Ge.test(k.css(e, "display")) ||
                (e.getClientRects().length && e.getBoundingClientRect().width)
                ? Ze(e, t, n)
                : Oe(e, Ye, function () {
                    return Ze(e, t, n);
                  });
          },
          set: function (e, i, n) {
            var o,
              r = Fe(e),
              s = !h.scrollboxSize() && "absolute" === r.position,
              a = (s || n) && "border-box" === k.css(e, "boxSizing", !1, r),
              l = n ? Je(e, t, n, a, r) : 0;
            return (
              a &&
                s &&
                (l -= Math.ceil(
                  e["offset" + t[0].toUpperCase() + t.slice(1)] -
                    parseFloat(r[t]) -
                    Je(e, t, "border", !1, r) -
                    0.5
                )),
              l &&
                (o = te.exec(i)) &&
                "px" !== (o[3] || "px") &&
                ((e.style[t] = i), (i = k.css(e, t))),
              Ke(0, i, l)
            );
          },
        };
      }),
      (k.cssHooks.marginLeft = He(h.reliableMarginLeft, function (e, t) {
        if (t)
          return (
            (parseFloat(Be(e, "marginLeft")) ||
              e.getBoundingClientRect().left -
                Oe(e, { marginLeft: 0 }, function () {
                  return e.getBoundingClientRect().left;
                })) + "px"
          );
      })),
      k.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
        (k.cssHooks[e + t] = {
          expand: function (i) {
            for (
              var n = 0, o = {}, r = "string" == typeof i ? i.split(" ") : [i];
              n < 4;
              n++
            )
              o[e + ie[n] + t] = r[n] || r[n - 2] || r[0];
            return o;
          },
        }),
          "margin" !== e && (k.cssHooks[e + t].set = Ke);
      }),
      k.fn.extend({
        css: function (e, t) {
          return H(
            this,
            function (e, t, i) {
              var n,
                o,
                r = {},
                s = 0;
              if (Array.isArray(t)) {
                for (n = Fe(e), o = t.length; s < o; s++)
                  r[t[s]] = k.css(e, t[s], !1, n);
                return r;
              }
              return void 0 !== i ? k.style(e, t, i) : k.css(e, t);
            },
            e,
            t,
            1 < arguments.length
          );
        },
      }),
      (((k.Tween = et).prototype = {
        constructor: et,
        init: function (e, t, i, n, o, r) {
          (this.elem = e),
            (this.prop = i),
            (this.easing = o || k.easing._default),
            (this.options = t),
            (this.start = this.now = this.cur()),
            (this.end = n),
            (this.unit = r || (k.cssNumber[i] ? "" : "px"));
        },
        cur: function () {
          var e = et.propHooks[this.prop];
          return e && e.get ? e.get(this) : et.propHooks._default.get(this);
        },
        run: function (e) {
          var t,
            i = et.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = t =
                  k.easing[this.easing](
                    e,
                    this.options.duration * e,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = t = e),
            (this.now = (this.end - this.start) * t + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            i && i.set ? i.set(this) : et.propHooks._default.set(this),
            this
          );
        },
      }).init.prototype = et.prototype),
      ((et.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return 1 !== e.elem.nodeType ||
              (null != e.elem[e.prop] && null == e.elem.style[e.prop])
              ? e.elem[e.prop]
              : (t = k.css(e.elem, e.prop, "")) && "auto" !== t
              ? t
              : 0;
          },
          set: function (e) {
            k.fx.step[e.prop]
              ? k.fx.step[e.prop](e)
              : 1 !== e.elem.nodeType ||
                (!k.cssHooks[e.prop] && null == e.elem.style[Ve(e.prop)])
              ? (e.elem[e.prop] = e.now)
              : k.style(e.elem, e.prop, e.now + e.unit);
          },
        },
      }).scrollTop = et.propHooks.scrollLeft =
        {
          set: function (e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
          },
        }),
      (k.easing = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (k.fx = et.prototype.init),
      (k.fx.step = {});
    var tt,
      it,
      nt,
      ot,
      rt = /^(?:toggle|show|hide)$/,
      st = /queueHooks$/;
    function at() {
      it &&
        (!1 === g.hidden && e.requestAnimationFrame
          ? e.requestAnimationFrame(at)
          : e.setTimeout(at, k.fx.interval),
        k.fx.tick());
    }
    function lt() {
      return (
        e.setTimeout(function () {
          tt = void 0;
        }),
        (tt = Date.now())
      );
    }
    function ct(e, t) {
      var i,
        n = 0,
        o = { height: e };
      for (t = t ? 1 : 0; n < 4; n += 2 - t)
        o["margin" + (i = ie[n])] = o["padding" + i] = e;
      return t && (o.opacity = o.width = e), o;
    }
    function dt(e, t, i) {
      for (
        var n,
          o = (ut.tweeners[t] || []).concat(ut.tweeners["*"]),
          r = 0,
          s = o.length;
        r < s;
        r++
      )
        if ((n = o[r].call(i, t, e))) return n;
    }
    function ut(e, t, i) {
      var n,
        o,
        r = 0,
        s = ut.prefilters.length,
        a = k.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (o) return !1;
          for (
            var t = tt || lt(),
              i = Math.max(0, c.startTime + c.duration - t),
              n = 1 - (i / c.duration || 0),
              r = 0,
              s = c.tweens.length;
            r < s;
            r++
          )
            c.tweens[r].run(n);
          return (
            a.notifyWith(e, [c, n, i]),
            n < 1 && s
              ? i
              : (s || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1)
          );
        },
        c = a.promise({
          elem: e,
          props: k.extend({}, t),
          opts: k.extend(
            !0,
            { specialEasing: {}, easing: k.easing._default },
            i
          ),
          originalProperties: t,
          originalOptions: i,
          startTime: tt || lt(),
          duration: i.duration,
          tweens: [],
          createTween: function (t, i) {
            var n = k.Tween(
              e,
              c.opts,
              t,
              i,
              c.opts.specialEasing[t] || c.opts.easing
            );
            return c.tweens.push(n), n;
          },
          stop: function (t) {
            var i = 0,
              n = t ? c.tweens.length : 0;
            if (o) return this;
            for (o = !0; i < n; i++) c.tweens[i].run(1);
            return (
              t
                ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t]))
                : a.rejectWith(e, [c, t]),
              this
            );
          },
        }),
        d = c.props;
      for (
        (function (e, t) {
          var i, n, o, r, s;
          for (i in e)
            if (
              ((o = t[(n = V(i))]),
              (r = e[i]),
              Array.isArray(r) && ((o = r[1]), (r = e[i] = r[0])),
              i !== n && ((e[n] = r), delete e[i]),
              (s = k.cssHooks[n]) && ("expand" in s))
            )
              for (i in ((r = s.expand(r)), delete e[n], r))
                (i in e) || ((e[i] = r[i]), (t[i] = o));
            else t[n] = o;
        })(d, c.opts.specialEasing);
        r < s;
        r++
      )
        if ((n = ut.prefilters[r].call(c, e, d, c.opts)))
          return (
            f(n.stop) &&
              (k._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)),
            n
          );
      return (
        k.map(d, dt, c),
        f(c.opts.start) && c.opts.start.call(e, c),
        c
          .progress(c.opts.progress)
          .done(c.opts.done, c.opts.complete)
          .fail(c.opts.fail)
          .always(c.opts.always),
        k.fx.timer(k.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
        c
      );
    }
    (k.Animation = k.extend(ut, {
      tweeners: {
        "*": [
          function (e, t) {
            var i = this.createTween(e, t);
            return ae(i.elem, e, te.exec(t), i), i;
          },
        ],
      },
      tweener: function (e, t) {
        f(e) ? ((t = e), (e = ["*"])) : (e = e.match(q));
        for (var i, n = 0, o = e.length; n < o; n++)
          (i = e[n]),
            (ut.tweeners[i] = ut.tweeners[i] || []),
            ut.tweeners[i].unshift(t);
      },
      prefilters: [
        function (e, t, i) {
          var n,
            o,
            r,
            s,
            a,
            l,
            c,
            d,
            u = "width" in t || "height" in t,
            p = this,
            h = {},
            f = e.style,
            m = e.nodeType && se(e),
            g = Y.get(e, "fxshow");
          for (n in (i.queue ||
            (null == (s = k._queueHooks(e, "fx")).unqueued &&
              ((s.unqueued = 0),
              (a = s.empty.fire),
              (s.empty.fire = function () {
                s.unqueued || a();
              })),
            s.unqueued++,
            p.always(function () {
              p.always(function () {
                s.unqueued--, k.queue(e, "fx").length || s.empty.fire();
              });
            })),
          t))
            if (((o = t[n]), rt.test(o))) {
              if (
                (delete t[n],
                (r = r || "toggle" === o),
                o === (m ? "hide" : "show"))
              ) {
                if ("show" !== o || !g || void 0 === g[n]) continue;
                m = !0;
              }
              h[n] = (g && g[n]) || k.style(e, n);
            }
          if ((l = !k.isEmptyObject(t)) || !k.isEmptyObject(h))
            for (n in (u &&
              1 === e.nodeType &&
              ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
              null == (c = g && g.display) && (c = Y.get(e, "display")),
              "none" === (d = k.css(e, "display")) &&
                (c
                  ? (d = c)
                  : (ce([e], !0),
                    (c = e.style.display || c),
                    (d = k.css(e, "display")),
                    ce([e]))),
              ("inline" === d || ("inline-block" === d && null != c)) &&
                "none" === k.css(e, "float") &&
                (l ||
                  (p.done(function () {
                    f.display = c;
                  }),
                  null == c && ((d = f.display), (c = "none" === d ? "" : d))),
                (f.display = "inline-block"))),
            i.overflow &&
              ((f.overflow = "hidden"),
              p.always(function () {
                (f.overflow = i.overflow[0]),
                  (f.overflowX = i.overflow[1]),
                  (f.overflowY = i.overflow[2]);
              })),
            (l = !1),
            h))
              l ||
                (g
                  ? "hidden" in g && (m = g.hidden)
                  : (g = Y.access(e, "fxshow", { display: c })),
                r && (g.hidden = !m),
                m && ce([e], !0),
                p.done(function () {
                  for (n in (m || ce([e]), Y.remove(e, "fxshow"), h))
                    k.style(e, n, h[n]);
                })),
                (l = dt(m ? g[n] : 0, n, p)),
                n in g ||
                  ((g[n] = l.start), m && ((l.end = l.start), (l.start = 0)));
        },
      ],
      prefilter: function (e, t) {
        t ? ut.prefilters.unshift(e) : ut.prefilters.push(e);
      },
    })),
      (k.speed = function (e, t, i) {
        var n =
          e && "object" == typeof e
            ? k.extend({}, e)
            : {
                complete: i || (!i && t) || (f(e) && e),
                duration: e,
                easing: (i && t) || (t && !f(t) && t),
              };
        return (
          k.fx.off
            ? (n.duration = 0)
            : "number" != typeof n.duration &&
              (n.duration in k.fx.speeds
                ? (n.duration = k.fx.speeds[n.duration])
                : (n.duration = k.fx.speeds._default)),
          (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
          (n.old = n.complete),
          (n.complete = function () {
            f(n.old) && n.old.call(this), n.queue && k.dequeue(this, n.queue);
          }),
          n
        );
      }),
      k.fn.extend({
        fadeTo: function (e, t, i, n) {
          return this.filter(se)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: t }, e, i, n);
        },
        animate: function (e, t, i, n) {
          var o = k.isEmptyObject(e),
            r = k.speed(t, i, n),
            s = function () {
              var t = ut(this, k.extend({}, e), r);
              (o || Y.get(this, "finish")) && t.stop(!0);
            };
          return (
            (s.finish = s),
            o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
          );
        },
        stop: function (e, t, i) {
          var n = function (e) {
            var t = e.stop;
            delete e.stop, t(i);
          };
          return (
            "string" != typeof e && ((i = t), (t = e), (e = void 0)),
            t && this.queue(e || "fx", []),
            this.each(function () {
              var t = !0,
                o = null != e && e + "queueHooks",
                r = k.timers,
                s = Y.get(this);
              if (o) s[o] && s[o].stop && n(s[o]);
              else for (o in s) s[o] && s[o].stop && st.test(o) && n(s[o]);
              for (o = r.length; o--; )
                r[o].elem !== this ||
                  (null != e && r[o].queue !== e) ||
                  (r[o].anim.stop(i), (t = !1), r.splice(o, 1));
              (!t && i) || k.dequeue(this, e);
            })
          );
        },
        finish: function (e) {
          return (
            !1 !== e && (e = e || "fx"),
            this.each(function () {
              var t,
                i = Y.get(this),
                n = i[e + "queue"],
                o = i[e + "queueHooks"],
                r = k.timers,
                s = n ? n.length : 0;
              for (
                i.finish = !0,
                  k.queue(this, e, []),
                  o && o.stop && o.stop.call(this, !0),
                  t = r.length;
                t--;

              )
                r[t].elem === this &&
                  r[t].queue === e &&
                  (r[t].anim.stop(!0), r.splice(t, 1));
              for (t = 0; t < s; t++)
                n[t] && n[t].finish && n[t].finish.call(this);
              delete i.finish;
            })
          );
        },
      }),
      k.each(["toggle", "show", "hide"], function (e, t) {
        var i = k.fn[t];
        k.fn[t] = function (e, n, o) {
          return null == e || "boolean" == typeof e
            ? i.apply(this, arguments)
            : this.animate(ct(t, !0), e, n, o);
        };
      }),
      k.each(
        {
          slideDown: ct("show"),
          slideUp: ct("hide"),
          slideToggle: ct("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (e, t) {
          k.fn[e] = function (e, i, n) {
            return this.animate(t, e, i, n);
          };
        }
      ),
      (k.timers = []),
      (k.fx.tick = function () {
        var e,
          t = 0,
          i = k.timers;
        for (tt = Date.now(); t < i.length; t++)
          (e = i[t])() || i[t] !== e || i.splice(t--, 1);
        i.length || k.fx.stop(), (tt = void 0);
      }),
      (k.fx.timer = function (e) {
        k.timers.push(e), k.fx.start();
      }),
      (k.fx.interval = 13),
      (k.fx.start = function () {
        it || ((it = !0), at());
      }),
      (k.fx.stop = function () {
        it = null;
      }),
      (k.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (k.fn.delay = function (t, i) {
        return (
          (t = (k.fx && k.fx.speeds[t]) || t),
          (i = i || "fx"),
          this.queue(i, function (i, n) {
            var o = e.setTimeout(i, t);
            n.stop = function () {
              e.clearTimeout(o);
            };
          })
        );
      }),
      (nt = g.createElement("input")),
      (ot = g.createElement("select").appendChild(g.createElement("option"))),
      (nt.type = "checkbox"),
      (h.checkOn = "" !== nt.value),
      (h.optSelected = ot.selected),
      ((nt = g.createElement("input")).value = "t"),
      (nt.type = "radio"),
      (h.radioValue = "t" === nt.value);
    var pt,
      ht = k.expr.attrHandle;
    k.fn.extend({
      attr: function (e, t) {
        return H(this, k.attr, e, t, 1 < arguments.length);
      },
      removeAttr: function (e) {
        return this.each(function () {
          k.removeAttr(this, e);
        });
      },
    }),
      k.extend({
        attr: function (e, t, i) {
          var n,
            o,
            r = e.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return void 0 === e.getAttribute
              ? k.prop(e, t, i)
              : ((1 === r && k.isXMLDoc(e)) ||
                  (o =
                    k.attrHooks[t.toLowerCase()] ||
                    (k.expr.match.bool.test(t) ? pt : void 0)),
                void 0 !== i
                  ? null === i
                    ? void k.removeAttr(e, t)
                    : o && "set" in o && void 0 !== (n = o.set(e, i, t))
                    ? n
                    : (e.setAttribute(t, i + ""), i)
                  : o && "get" in o && null !== (n = o.get(e, t))
                  ? n
                  : null == (n = k.find.attr(e, t))
                  ? void 0
                  : n);
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              if (!h.radioValue && "radio" === t && _(e, "input")) {
                var i = e.value;
                return e.setAttribute("type", t), i && (e.value = i), t;
              }
            },
          },
        },
        removeAttr: function (e, t) {
          var i,
            n = 0,
            o = t && t.match(q);
          if (o && 1 === e.nodeType)
            for (; (i = o[n++]); ) e.removeAttribute(i);
        },
      }),
      (pt = {
        set: function (e, t, i) {
          return !1 === t ? k.removeAttr(e, i) : e.setAttribute(i, i), i;
        },
      }),
      k.each(k.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var i = ht[t] || k.find.attr;
        ht[t] = function (e, t, n) {
          var o,
            r,
            s = t.toLowerCase();
          return (
            n ||
              ((r = ht[s]),
              (ht[s] = o),
              (o = null != i(e, t, n) ? s : null),
              (ht[s] = r)),
            o
          );
        };
      });
    var ft = /^(?:input|select|textarea|button)$/i,
      mt = /^(?:a|area)$/i;
    function gt(e) {
      return (e.match(q) || []).join(" ");
    }
    function vt(e) {
      return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function yt(e) {
      return Array.isArray(e) ? e : ("string" == typeof e && e.match(q)) || [];
    }
    k.fn.extend({
      prop: function (e, t) {
        return H(this, k.prop, e, t, 1 < arguments.length);
      },
      removeProp: function (e) {
        return this.each(function () {
          delete this[k.propFix[e] || e];
        });
      },
    }),
      k.extend({
        prop: function (e, t, i) {
          var n,
            o,
            r = e.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return (
              (1 === r && k.isXMLDoc(e)) ||
                ((t = k.propFix[t] || t), (o = k.propHooks[t])),
              void 0 !== i
                ? o && "set" in o && void 0 !== (n = o.set(e, i, t))
                  ? n
                  : (e[t] = i)
                : o && "get" in o && null !== (n = o.get(e, t))
                ? n
                : e[t]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e) {
              var t = k.find.attr(e, "tabindex");
              return t
                ? parseInt(t, 10)
                : ft.test(e.nodeName) || (mt.test(e.nodeName) && e.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      h.optSelected ||
        (k.propHooks.selected = {
          get: function (e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null;
          },
          set: function (e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
          },
        }),
      k.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          k.propFix[this.toLowerCase()] = this;
        }
      ),
      k.fn.extend({
        addClass: function (e) {
          var t,
            i,
            n,
            o,
            r,
            s,
            a,
            l = 0;
          if (f(e))
            return this.each(function (t) {
              k(this).addClass(e.call(this, t, vt(this)));
            });
          if ((t = yt(e)).length)
            for (; (i = this[l++]); )
              if (((o = vt(i)), (n = 1 === i.nodeType && " " + gt(o) + " "))) {
                for (s = 0; (r = t[s++]); )
                  n.indexOf(" " + r + " ") < 0 && (n += r + " ");
                o !== (a = gt(n)) && i.setAttribute("class", a);
              }
          return this;
        },
        removeClass: function (e) {
          var t,
            i,
            n,
            o,
            r,
            s,
            a,
            l = 0;
          if (f(e))
            return this.each(function (t) {
              k(this).removeClass(e.call(this, t, vt(this)));
            });
          if (!arguments.length) return this.attr("class", "");
          if ((t = yt(e)).length)
            for (; (i = this[l++]); )
              if (((o = vt(i)), (n = 1 === i.nodeType && " " + gt(o) + " "))) {
                for (s = 0; (r = t[s++]); )
                  for (; -1 < n.indexOf(" " + r + " "); )
                    n = n.replace(" " + r + " ", " ");
                o !== (a = gt(n)) && i.setAttribute("class", a);
              }
          return this;
        },
        toggleClass: function (e, t) {
          var i = typeof e,
            n = "string" === i || Array.isArray(e);
          return "boolean" == typeof t && n
            ? t
              ? this.addClass(e)
              : this.removeClass(e)
            : f(e)
            ? this.each(function (i) {
                k(this).toggleClass(e.call(this, i, vt(this), t), t);
              })
            : this.each(function () {
                var t, o, r, s;
                if (n)
                  for (o = 0, r = k(this), s = yt(e); (t = s[o++]); )
                    r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
                else
                  (void 0 !== e && "boolean" !== i) ||
                    ((t = vt(this)) && Y.set(this, "__className__", t),
                    this.setAttribute &&
                      this.setAttribute(
                        "class",
                        t || !1 === e ? "" : Y.get(this, "__className__") || ""
                      ));
              });
        },
        hasClass: function (e) {
          var t,
            i,
            n = 0;
          for (t = " " + e + " "; (i = this[n++]); )
            if (1 === i.nodeType && -1 < (" " + gt(vt(i)) + " ").indexOf(t))
              return !0;
          return !1;
        },
      });
    var bt = /\r/g;
    k.fn.extend({
      val: function (e) {
        var t,
          i,
          n,
          o = this[0];
        return arguments.length
          ? ((n = f(e)),
            this.each(function (i) {
              var o;
              1 === this.nodeType &&
                (null == (o = n ? e.call(this, i, k(this).val()) : e)
                  ? (o = "")
                  : "number" == typeof o
                  ? (o += "")
                  : Array.isArray(o) &&
                    (o = k.map(o, function (e) {
                      return null == e ? "" : e + "";
                    })),
                ((t =
                  k.valHooks[this.type] ||
                  k.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in t &&
                  void 0 !== t.set(this, o, "value")) ||
                  (this.value = o));
            }))
          : o
          ? (t = k.valHooks[o.type] || k.valHooks[o.nodeName.toLowerCase()]) &&
            "get" in t &&
            void 0 !== (i = t.get(o, "value"))
            ? i
            : "string" == typeof (i = o.value)
            ? i.replace(bt, "")
            : null == i
            ? ""
            : i
          : void 0;
      },
    }),
      k.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = k.find.attr(e, "value");
              return null != t ? t : gt(k.text(e));
            },
          },
          select: {
            get: function (e) {
              var t,
                i,
                n,
                o = e.options,
                r = e.selectedIndex,
                s = "select-one" === e.type,
                a = s ? null : [],
                l = s ? r + 1 : o.length;
              for (n = r < 0 ? l : s ? r : 0; n < l; n++)
                if (
                  ((i = o[n]).selected || n === r) &&
                  !i.disabled &&
                  (!i.parentNode.disabled || !_(i.parentNode, "optgroup"))
                ) {
                  if (((t = k(i).val()), s)) return t;
                  a.push(t);
                }
              return a;
            },
            set: function (e, t) {
              for (
                var i, n, o = e.options, r = k.makeArray(t), s = o.length;
                s--;

              )
                ((n = o[s]).selected =
                  -1 < k.inArray(k.valHooks.option.get(n), r)) && (i = !0);
              return i || (e.selectedIndex = -1), r;
            },
          },
        },
      }),
      k.each(["radio", "checkbox"], function () {
        (k.valHooks[this] = {
          set: function (e, t) {
            if (Array.isArray(t))
              return (e.checked = -1 < k.inArray(k(e).val(), t));
          },
        }),
          h.checkOn ||
            (k.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
      }),
      (h.focusin = "onfocusin" in e);
    var wt = /^(?:focusinfocus|focusoutblur)$/,
      kt = function (e) {
        e.stopPropagation();
      };
    k.extend(k.event, {
      trigger: function (t, i, n, o) {
        var r,
          s,
          a,
          l,
          c,
          u,
          p,
          h,
          v = [n || g],
          y = d.call(t, "type") ? t.type : t,
          b = d.call(t, "namespace") ? t.namespace.split(".") : [];
        if (
          ((s = h = a = n = n || g),
          3 !== n.nodeType &&
            8 !== n.nodeType &&
            !wt.test(y + k.event.triggered) &&
            (-1 < y.indexOf(".") &&
              ((y = (b = y.split(".")).shift()), b.sort()),
            (c = y.indexOf(":") < 0 && "on" + y),
            ((t = t[k.expando]
              ? t
              : new k.Event(y, "object" == typeof t && t)).isTrigger = o
              ? 2
              : 3),
            (t.namespace = b.join(".")),
            (t.rnamespace = t.namespace
              ? new RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (t.result = void 0),
            t.target || (t.target = n),
            (i = null == i ? [t] : k.makeArray(i, [t])),
            (p = k.event.special[y] || {}),
            o || !p.trigger || !1 !== p.trigger.apply(n, i)))
        ) {
          if (!o && !p.noBubble && !m(n)) {
            for (
              l = p.delegateType || y, wt.test(l + y) || (s = s.parentNode);
              s;
              s = s.parentNode
            )
              v.push(s), (a = s);
            a === (n.ownerDocument || g) &&
              v.push(a.defaultView || a.parentWindow || e);
          }
          for (r = 0; (s = v[r++]) && !t.isPropagationStopped(); )
            (h = s),
              (t.type = 1 < r ? l : p.bindType || y),
              (u =
                (Y.get(s, "events") || Object.create(null))[t.type] &&
                Y.get(s, "handle")) && u.apply(s, i),
              (u = c && s[c]) &&
                u.apply &&
                G(s) &&
                ((t.result = u.apply(s, i)),
                !1 === t.result && t.preventDefault());
          return (
            (t.type = y),
            o ||
              t.isDefaultPrevented() ||
              (p._default && !1 !== p._default.apply(v.pop(), i)) ||
              !G(n) ||
              (c &&
                f(n[y]) &&
                !m(n) &&
                ((a = n[c]) && (n[c] = null),
                (k.event.triggered = y),
                t.isPropagationStopped() && h.addEventListener(y, kt),
                n[y](),
                t.isPropagationStopped() && h.removeEventListener(y, kt),
                (k.event.triggered = void 0),
                a && (n[c] = a))),
            t.result
          );
        }
      },
      simulate: function (e, t, i) {
        var n = k.extend(new k.Event(), i, { type: e, isSimulated: !0 });
        k.event.trigger(n, null, t);
      },
    }),
      k.fn.extend({
        trigger: function (e, t) {
          return this.each(function () {
            k.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, t) {
          var i = this[0];
          if (i) return k.event.trigger(e, t, i, !0);
        },
      }),
      h.focusin ||
        k.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
          var i = function (e) {
            k.event.simulate(t, e.target, k.event.fix(e));
          };
          k.event.special[t] = {
            setup: function () {
              var n = this.ownerDocument || this.document || this,
                o = Y.access(n, t);
              o || n.addEventListener(e, i, !0), Y.access(n, t, (o || 0) + 1);
            },
            teardown: function () {
              var n = this.ownerDocument || this.document || this,
                o = Y.access(n, t) - 1;
              o
                ? Y.access(n, t, o)
                : (n.removeEventListener(e, i, !0), Y.remove(n, t));
            },
          };
        });
    var xt = e.location,
      St = { guid: Date.now() },
      Ct = /\?/;
    k.parseXML = function (t) {
      var i;
      if (!t || "string" != typeof t) return null;
      try {
        i = new e.DOMParser().parseFromString(t, "text/xml");
      } catch (t) {
        i = void 0;
      }
      return (
        (i && !i.getElementsByTagName("parsererror").length) ||
          k.error("Invalid XML: " + t),
        i
      );
    };
    var Tt = /\[\]$/,
      $t = /\r?\n/g,
      _t = /^(?:submit|button|image|reset|file)$/i,
      Et = /^(?:input|select|textarea|keygen)/i;
    function At(e, t, i, n) {
      var o;
      if (Array.isArray(t))
        k.each(t, function (t, o) {
          i || Tt.test(e)
            ? n(e, o)
            : At(
                e + "[" + ("object" == typeof o && null != o ? t : "") + "]",
                o,
                i,
                n
              );
        });
      else if (i || "object" !== b(t)) n(e, t);
      else for (o in t) At(e + "[" + o + "]", t[o], i, n);
    }
    (k.param = function (e, t) {
      var i,
        n = [],
        o = function (e, t) {
          var i = f(t) ? t() : t;
          n[n.length] =
            encodeURIComponent(e) +
            "=" +
            encodeURIComponent(null == i ? "" : i);
        };
      if (null == e) return "";
      if (Array.isArray(e) || (e.jquery && !k.isPlainObject(e)))
        k.each(e, function () {
          o(this.name, this.value);
        });
      else for (i in e) At(i, e[i], t, o);
      return n.join("&");
    }),
      k.fn.extend({
        serialize: function () {
          return k.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var e = k.prop(this, "elements");
            return e ? k.makeArray(e) : this;
          })
            .filter(function () {
              var e = this.type;
              return (
                this.name &&
                !k(this).is(":disabled") &&
                Et.test(this.nodeName) &&
                !_t.test(e) &&
                (this.checked || !pe.test(e))
              );
            })
            .map(function (e, t) {
              var i = k(this).val();
              return null == i
                ? null
                : Array.isArray(i)
                ? k.map(i, function (e) {
                    return { name: t.name, value: e.replace($t, "\r\n") };
                  })
                : { name: t.name, value: i.replace($t, "\r\n") };
            })
            .get();
        },
      });
    var Pt = /%20/g,
      Lt = /#.*$/,
      jt = /([?&])_=[^&]*/,
      It = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      Mt = /^(?:GET|HEAD)$/,
      qt = /^\/\//,
      Dt = {},
      zt = {},
      Ft = "*/".concat("*"),
      Ot = g.createElement("a");
    function Nt(e) {
      return function (t, i) {
        "string" != typeof t && ((i = t), (t = "*"));
        var n,
          o = 0,
          r = t.toLowerCase().match(q) || [];
        if (f(i))
          for (; (n = r[o++]); )
            "+" === n[0]
              ? ((n = n.slice(1) || "*"), (e[n] = e[n] || []).unshift(i))
              : (e[n] = e[n] || []).push(i);
      };
    }
    function Bt(e, t, i, n) {
      var o = {},
        r = e === zt;
      function s(a) {
        var l;
        return (
          (o[a] = !0),
          k.each(e[a] || [], function (e, a) {
            var c = a(t, i, n);
            return "string" != typeof c || r || o[c]
              ? r
                ? !(l = c)
                : void 0
              : (t.dataTypes.unshift(c), s(c), !1);
          }),
          l
        );
      }
      return s(t.dataTypes[0]) || (!o["*"] && s("*"));
    }
    function Ht(e, t) {
      var i,
        n,
        o = k.ajaxSettings.flatOptions || {};
      for (i in t) void 0 !== t[i] && ((o[i] ? e : n || (n = {}))[i] = t[i]);
      return n && k.extend(!0, e, n), e;
    }
    (Ot.href = xt.href),
      k.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: xt.href,
          type: "GET",
          isLocal:
            /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
              xt.protocol
            ),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": Ft,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON",
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": JSON.parse,
            "text xml": k.parseXML,
          },
          flatOptions: { url: !0, context: !0 },
        },
        ajaxSetup: function (e, t) {
          return t ? Ht(Ht(e, k.ajaxSettings), t) : Ht(k.ajaxSettings, e);
        },
        ajaxPrefilter: Nt(Dt),
        ajaxTransport: Nt(zt),
        ajax: function (t, i) {
          "object" == typeof t && ((i = t), (t = void 0)), (i = i || {});
          var n,
            o,
            r,
            s,
            a,
            l,
            c,
            d,
            u,
            p,
            h = k.ajaxSetup({}, i),
            f = h.context || h,
            m = h.context && (f.nodeType || f.jquery) ? k(f) : k.event,
            v = k.Deferred(),
            y = k.Callbacks("once memory"),
            b = h.statusCode || {},
            w = {},
            x = {},
            S = "canceled",
            C = {
              readyState: 0,
              getResponseHeader: function (e) {
                var t;
                if (c) {
                  if (!s)
                    for (s = {}; (t = It.exec(r)); )
                      s[t[1].toLowerCase() + " "] = (
                        s[t[1].toLowerCase() + " "] || []
                      ).concat(t[2]);
                  t = s[e.toLowerCase() + " "];
                }
                return null == t ? null : t.join(", ");
              },
              getAllResponseHeaders: function () {
                return c ? r : null;
              },
              setRequestHeader: function (e, t) {
                return (
                  null == c &&
                    ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e),
                    (w[e] = t)),
                  this
                );
              },
              overrideMimeType: function (e) {
                return null == c && (h.mimeType = e), this;
              },
              statusCode: function (e) {
                var t;
                if (e)
                  if (c) C.always(e[C.status]);
                  else for (t in e) b[t] = [b[t], e[t]];
                return this;
              },
              abort: function (e) {
                var t = e || S;
                return n && n.abort(t), T(0, t), this;
              },
            };
          if (
            (v.promise(C),
            (h.url = ((t || h.url || xt.href) + "").replace(
              qt,
              xt.protocol + "//"
            )),
            (h.type = i.method || i.type || h.method || h.type),
            (h.dataTypes = (h.dataType || "*").toLowerCase().match(q) || [""]),
            null == h.crossDomain)
          ) {
            l = g.createElement("a");
            try {
              (l.href = h.url),
                (l.href = l.href),
                (h.crossDomain =
                  Ot.protocol + "//" + Ot.host != l.protocol + "//" + l.host);
            } catch (t) {
              h.crossDomain = !0;
            }
          }
          if (
            (h.data &&
              h.processData &&
              "string" != typeof h.data &&
              (h.data = k.param(h.data, h.traditional)),
            Bt(Dt, h, i, C),
            c)
          )
            return C;
          for (u in ((d = k.event && h.global) &&
            0 == k.active++ &&
            k.event.trigger("ajaxStart"),
          (h.type = h.type.toUpperCase()),
          (h.hasContent = !Mt.test(h.type)),
          (o = h.url.replace(Lt, "")),
          h.hasContent
            ? h.data &&
              h.processData &&
              0 ===
                (h.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              (h.data = h.data.replace(Pt, "+"))
            : ((p = h.url.slice(o.length)),
              h.data &&
                (h.processData || "string" == typeof h.data) &&
                ((o += (Ct.test(o) ? "&" : "?") + h.data), delete h.data),
              !1 === h.cache &&
                ((o = o.replace(jt, "$1")),
                (p = (Ct.test(o) ? "&" : "?") + "_=" + St.guid++ + p)),
              (h.url = o + p)),
          h.ifModified &&
            (k.lastModified[o] &&
              C.setRequestHeader("If-Modified-Since", k.lastModified[o]),
            k.etag[o] && C.setRequestHeader("If-None-Match", k.etag[o])),
          ((h.data && h.hasContent && !1 !== h.contentType) || i.contentType) &&
            C.setRequestHeader("Content-Type", h.contentType),
          C.setRequestHeader(
            "Accept",
            h.dataTypes[0] && h.accepts[h.dataTypes[0]]
              ? h.accepts[h.dataTypes[0]] +
                  ("*" !== h.dataTypes[0] ? ", " + Ft + "; q=0.01" : "")
              : h.accepts["*"]
          ),
          h.headers))
            C.setRequestHeader(u, h.headers[u]);
          if (h.beforeSend && (!1 === h.beforeSend.call(f, C, h) || c))
            return C.abort();
          if (
            ((S = "abort"),
            y.add(h.complete),
            C.done(h.success),
            C.fail(h.error),
            (n = Bt(zt, h, i, C)))
          ) {
            if (((C.readyState = 1), d && m.trigger("ajaxSend", [C, h]), c))
              return C;
            h.async &&
              0 < h.timeout &&
              (a = e.setTimeout(function () {
                C.abort("timeout");
              }, h.timeout));
            try {
              (c = !1), n.send(w, T);
            } catch (t) {
              if (c) throw t;
              T(-1, t);
            }
          } else T(-1, "No Transport");
          function T(t, i, s, l) {
            var u,
              p,
              g,
              w,
              x,
              S = i;
            c ||
              ((c = !0),
              a && e.clearTimeout(a),
              (n = void 0),
              (r = l || ""),
              (C.readyState = 0 < t ? 4 : 0),
              (u = (200 <= t && t < 300) || 304 === t),
              s &&
                (w = (function (e, t, i) {
                  for (
                    var n, o, r, s, a = e.contents, l = e.dataTypes;
                    "*" === l[0];

                  )
                    l.shift(),
                      void 0 === n &&
                        (n = e.mimeType || t.getResponseHeader("Content-Type"));
                  if (n)
                    for (o in a)
                      if (a[o] && a[o].test(n)) {
                        l.unshift(o);
                        break;
                      }
                  if (l[0] in i) r = l[0];
                  else {
                    for (o in i) {
                      if (!l[0] || e.converters[o + " " + l[0]]) {
                        r = o;
                        break;
                      }
                      s || (s = o);
                    }
                    r = r || s;
                  }
                  if (r) return r !== l[0] && l.unshift(r), i[r];
                })(h, C, s)),
              !u &&
                -1 < k.inArray("script", h.dataTypes) &&
                (h.converters["text script"] = function () {}),
              (w = (function (e, t, i, n) {
                var o,
                  r,
                  s,
                  a,
                  l,
                  c = {},
                  d = e.dataTypes.slice();
                if (d[1])
                  for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
                for (r = d.shift(); r; )
                  if (
                    (e.responseFields[r] && (i[e.responseFields[r]] = t),
                    !l &&
                      n &&
                      e.dataFilter &&
                      (t = e.dataFilter(t, e.dataType)),
                    (l = r),
                    (r = d.shift()))
                  )
                    if ("*" === r) r = l;
                    else if ("*" !== l && l !== r) {
                      if (!(s = c[l + " " + r] || c["* " + r]))
                        for (o in c)
                          if (
                            (a = o.split(" "))[1] === r &&
                            (s = c[l + " " + a[0]] || c["* " + a[0]])
                          ) {
                            !0 === s
                              ? (s = c[o])
                              : !0 !== c[o] && ((r = a[0]), d.unshift(a[1]));
                            break;
                          }
                      if (!0 !== s)
                        if (s && e.throws) t = s(t);
                        else
                          try {
                            t = s(t);
                          } catch (e) {
                            return {
                              state: "parsererror",
                              error: s
                                ? e
                                : "No conversion from " + l + " to " + r,
                            };
                          }
                    }
                return { state: "success", data: t };
              })(h, w, C, u)),
              u
                ? (h.ifModified &&
                    ((x = C.getResponseHeader("Last-Modified")) &&
                      (k.lastModified[o] = x),
                    (x = C.getResponseHeader("etag")) && (k.etag[o] = x)),
                  204 === t || "HEAD" === h.type
                    ? (S = "nocontent")
                    : 304 === t
                    ? (S = "notmodified")
                    : ((S = w.state), (p = w.data), (u = !(g = w.error))))
                : ((g = S), (!t && S) || ((S = "error"), t < 0 && (t = 0))),
              (C.status = t),
              (C.statusText = (i || S) + ""),
              u ? v.resolveWith(f, [p, S, C]) : v.rejectWith(f, [C, S, g]),
              C.statusCode(b),
              (b = void 0),
              d &&
                m.trigger(u ? "ajaxSuccess" : "ajaxError", [C, h, u ? p : g]),
              y.fireWith(f, [C, S]),
              d &&
                (m.trigger("ajaxComplete", [C, h]),
                --k.active || k.event.trigger("ajaxStop")));
          }
          return C;
        },
        getJSON: function (e, t, i) {
          return k.get(e, t, i, "json");
        },
        getScript: function (e, t) {
          return k.get(e, void 0, t, "script");
        },
      }),
      k.each(["get", "post"], function (e, t) {
        k[t] = function (e, i, n, o) {
          return (
            f(i) && ((o = o || n), (n = i), (i = void 0)),
            k.ajax(
              k.extend(
                { url: e, type: t, dataType: o, data: i, success: n },
                k.isPlainObject(e) && e
              )
            )
          );
        };
      }),
      k.ajaxPrefilter(function (e) {
        var t;
        for (t in e.headers)
          "content-type" === t.toLowerCase() &&
            (e.contentType = e.headers[t] || "");
      }),
      (k._evalUrl = function (e, t, i) {
        return k.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          converters: { "text script": function () {} },
          dataFilter: function (e) {
            k.globalEval(e, t, i);
          },
        });
      }),
      k.fn.extend({
        wrapAll: function (e) {
          var t;
          return (
            this[0] &&
              (f(e) && (e = e.call(this[0])),
              (t = k(e, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && t.insertBefore(this[0]),
              t
                .map(function () {
                  for (var e = this; e.firstElementChild; )
                    e = e.firstElementChild;
                  return e;
                })
                .append(this)),
            this
          );
        },
        wrapInner: function (e) {
          return f(e)
            ? this.each(function (t) {
                k(this).wrapInner(e.call(this, t));
              })
            : this.each(function () {
                var t = k(this),
                  i = t.contents();
                i.length ? i.wrapAll(e) : t.append(e);
              });
        },
        wrap: function (e) {
          var t = f(e);
          return this.each(function (i) {
            k(this).wrapAll(t ? e.call(this, i) : e);
          });
        },
        unwrap: function (e) {
          return (
            this.parent(e)
              .not("body")
              .each(function () {
                k(this).replaceWith(this.childNodes);
              }),
            this
          );
        },
      }),
      (k.expr.pseudos.hidden = function (e) {
        return !k.expr.pseudos.visible(e);
      }),
      (k.expr.pseudos.visible = function (e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
      }),
      (k.ajaxSettings.xhr = function () {
        try {
          return new e.XMLHttpRequest();
        } catch (e) {}
      });
    var Wt = { 0: 200, 1223: 204 },
      Rt = k.ajaxSettings.xhr();
    (h.cors = !!Rt && "withCredentials" in Rt),
      (h.ajax = Rt = !!Rt),
      k.ajaxTransport(function (t) {
        var i, n;
        if (h.cors || (Rt && !t.crossDomain))
          return {
            send: function (o, r) {
              var s,
                a = t.xhr();
              if (
                (a.open(t.type, t.url, t.async, t.username, t.password),
                t.xhrFields)
              )
                for (s in t.xhrFields) a[s] = t.xhrFields[s];
              for (s in (t.mimeType &&
                a.overrideMimeType &&
                a.overrideMimeType(t.mimeType),
              t.crossDomain ||
                o["X-Requested-With"] ||
                (o["X-Requested-With"] = "XMLHttpRequest"),
              o))
                a.setRequestHeader(s, o[s]);
              (i = function (e) {
                return function () {
                  i &&
                    ((i =
                      n =
                      a.onload =
                      a.onerror =
                      a.onabort =
                      a.ontimeout =
                      a.onreadystatechange =
                        null),
                    "abort" === e
                      ? a.abort()
                      : "error" === e
                      ? "number" != typeof a.status
                        ? r(0, "error")
                        : r(a.status, a.statusText)
                      : r(
                          Wt[a.status] || a.status,
                          a.statusText,
                          "text" !== (a.responseType || "text") ||
                            "string" != typeof a.responseText
                            ? { binary: a.response }
                            : { text: a.responseText },
                          a.getAllResponseHeaders()
                        ));
                };
              }),
                (a.onload = i()),
                (n = a.onerror = a.ontimeout = i("error")),
                void 0 !== a.onabort
                  ? (a.onabort = n)
                  : (a.onreadystatechange = function () {
                      4 === a.readyState &&
                        e.setTimeout(function () {
                          i && n();
                        });
                    }),
                (i = i("abort"));
              try {
                a.send((t.hasContent && t.data) || null),
                  window?.swatch_hover_func();
              } catch (o) {
                if (i) throw o;
              }
            },
            abort: function () {
              i && i();
            },
          };
      }),
      k.ajaxPrefilter(function (e) {
        e.crossDomain && (e.contents.script = !1);
      }),
      k.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (e) {
            return k.globalEval(e), e;
          },
        },
      }),
      k.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }),
      k.ajaxTransport("script", function (e) {
        var t, i;
        if (e.crossDomain || e.scriptAttrs)
          return {
            send: function (n, o) {
              (t = k("<script>")
                .attr(e.scriptAttrs || {})
                .prop({ charset: e.scriptCharset, src: e.url })
                .on(
                  "load error",
                  (i = function (e) {
                    t.remove(),
                      (i = null),
                      e && o("error" === e.type ? 404 : 200, e.type);
                  })
                )),
                g.head.appendChild(t[0]);
            },
            abort: function () {
              i && i();
            },
          };
      });
    var Ut,
      Vt = [],
      Gt = /(=)\?(?=&|$)|\?\?/;
    k.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = Vt.pop() || k.expando + "_" + St.guid++;
        return (this[e] = !0), e;
      },
    }),
      k.ajaxPrefilter("json jsonp", function (t, i, n) {
        var o,
          r,
          s,
          a =
            !1 !== t.jsonp &&
            (Gt.test(t.url)
              ? "url"
              : "string" == typeof t.data &&
                0 ===
                  (t.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                Gt.test(t.data) &&
                "data");
        if (a || "jsonp" === t.dataTypes[0])
          return (
            (o = t.jsonpCallback =
              f(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
            a
              ? (t[a] = t[a].replace(Gt, "$1" + o))
              : !1 !== t.jsonp &&
                (t.url += (Ct.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
            (t.converters["script json"] = function () {
              return s || k.error(o + " was not called"), s[0];
            }),
            (t.dataTypes[0] = "json"),
            (r = e[o]),
            (e[o] = function () {
              s = arguments;
            }),
            n.always(function () {
              void 0 === r ? k(e).removeProp(o) : (e[o] = r),
                t[o] && ((t.jsonpCallback = i.jsonpCallback), Vt.push(o)),
                s && f(r) && r(s[0]),
                (s = r = void 0);
            }),
            "script"
          );
      }),
      (h.createHTMLDocument =
        (((Ut = g.implementation.createHTMLDocument("").body).innerHTML =
          "<form></form><form></form>"),
        2 === Ut.childNodes.length)),
      (k.parseHTML = function (e, t, i) {
        return "string" != typeof e
          ? []
          : ("boolean" == typeof t && ((i = t), (t = !1)),
            t ||
              (h.createHTMLDocument
                ? (((n = (t =
                    g.implementation.createHTMLDocument("")).createElement(
                    "base"
                  )).href = g.location.href),
                  t.head.appendChild(n))
                : (t = g)),
            (r = !i && []),
            (o = E.exec(e))
              ? [t.createElement(o[1])]
              : ((o = be([e], t, r)),
                r && r.length && k(r).remove(),
                k.merge([], o.childNodes)));
        var n, o, r;
      }),
      (k.fn.load = function (e, t, i) {
        var n,
          o,
          r,
          s = this,
          a = e.indexOf(" ");
        return (
          -1 < a && ((n = gt(e.slice(a))), (e = e.slice(0, a))),
          f(t)
            ? ((i = t), (t = void 0))
            : t && "object" == typeof t && (o = "POST"),
          0 < s.length &&
            k
              .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
              .done(function (e) {
                (r = arguments),
                  s.html(n ? k("<div>").append(k.parseHTML(e)).find(n) : e);
              })
              .always(
                i &&
                  function (e, t) {
                    s.each(function () {
                      i.apply(this, r || [e.responseText, t, e]);
                    });
                  }
              ),
          this
        );
      }),
      (k.expr.pseudos.animated = function (e) {
        return k.grep(k.timers, function (t) {
          return e === t.elem;
        }).length;
      }),
      (k.offset = {
        setOffset: function (e, t, i) {
          var n,
            o,
            r,
            s,
            a,
            l,
            c = k.css(e, "position"),
            d = k(e),
            u = {};
          "static" === c && (e.style.position = "relative"),
            (a = d.offset()),
            (r = k.css(e, "top")),
            (l = k.css(e, "left")),
            ("absolute" === c || "fixed" === c) && -1 < (r + l).indexOf("auto")
              ? ((s = (n = d.position()).top), (o = n.left))
              : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
            f(t) && (t = t.call(e, i, k.extend({}, a))),
            null != t.top && (u.top = t.top - a.top + s),
            null != t.left && (u.left = t.left - a.left + o),
            "using" in t
              ? t.using.call(e, u)
              : ("number" == typeof u.top && (u.top += "px"),
                "number" == typeof u.left && (u.left += "px"),
                d.css(u));
        },
      }),
      k.fn.extend({
        offset: function (e) {
          if (arguments.length)
            return void 0 === e
              ? this
              : this.each(function (t) {
                  k.offset.setOffset(this, e, t);
                });
          var t,
            i,
            n = this[0];
          return n
            ? n.getClientRects().length
              ? ((t = n.getBoundingClientRect()),
                (i = n.ownerDocument.defaultView),
                { top: t.top + i.pageYOffset, left: t.left + i.pageXOffset })
              : { top: 0, left: 0 }
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e,
              t,
              i,
              n = this[0],
              o = { top: 0, left: 0 };
            if ("fixed" === k.css(n, "position")) t = n.getBoundingClientRect();
            else {
              for (
                t = this.offset(),
                  i = n.ownerDocument,
                  e = n.offsetParent || i.documentElement;
                e &&
                (e === i.body || e === i.documentElement) &&
                "static" === k.css(e, "position");

              )
                e = e.parentNode;
              e &&
                e !== n &&
                1 === e.nodeType &&
                (((o = k(e).offset()).top += k.css(e, "borderTopWidth", !0)),
                (o.left += k.css(e, "borderLeftWidth", !0)));
            }
            return {
              top: t.top - o.top - k.css(n, "marginTop", !0),
              left: t.left - o.left - k.css(n, "marginLeft", !0),
            };
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent;
              e && "static" === k.css(e, "position");

            )
              e = e.offsetParent;
            return e || ne;
          });
        },
      }),
      k.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (e, t) {
          var i = "pageYOffset" === t;
          k.fn[e] = function (n) {
            return H(
              this,
              function (e, n, o) {
                var r;
                if (
                  (m(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView),
                  void 0 === o)
                )
                  return r ? r[t] : e[n];
                r
                  ? r.scrollTo(i ? r.pageXOffset : o, i ? o : r.pageYOffset)
                  : (e[n] = o);
              },
              e,
              n,
              arguments.length
            );
          };
        }
      ),
      k.each(["top", "left"], function (e, t) {
        k.cssHooks[t] = He(h.pixelPosition, function (e, i) {
          if (i)
            return (i = Be(e, t)), ze.test(i) ? k(e).position()[t] + "px" : i;
        });
      }),
      k.each({ Height: "height", Width: "width" }, function (e, t) {
        k.each(
          { padding: "inner" + e, content: t, "": "outer" + e },
          function (i, n) {
            k.fn[n] = function (o, r) {
              var s = arguments.length && (i || "boolean" != typeof o),
                a = i || (!0 === o || !0 === r ? "margin" : "border");
              return H(
                this,
                function (t, i, o) {
                  var r;
                  return m(t)
                    ? 0 === n.indexOf("outer")
                      ? t["inner" + e]
                      : t.document.documentElement["client" + e]
                    : 9 === t.nodeType
                    ? ((r = t.documentElement),
                      Math.max(
                        t.body["scroll" + e],
                        r["scroll" + e],
                        t.body["offset" + e],
                        r["offset" + e],
                        r["client" + e]
                      ))
                    : void 0 === o
                    ? k.css(t, i, a)
                    : k.style(t, i, o, a);
                },
                t,
                s ? o : void 0,
                s
              );
            };
          }
        );
      }),
      k.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e, t) {
          k.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      k.fn.extend({
        bind: function (e, t, i) {
          return this.on(e, null, t, i);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, i, n) {
          return this.on(t, e, i, n);
        },
        undelegate: function (e, t, i) {
          return 1 === arguments.length
            ? this.off(e, "**")
            : this.off(t, e || "**", i);
        },
        hover: function (e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        },
      }),
      k.each(
        "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
          " "
        ),
        function (e, t) {
          k.fn[t] = function (e, i) {
            return 0 < arguments.length
              ? this.on(t, null, e, i)
              : this.trigger(t);
          };
        }
      );
    var Xt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (k.proxy = function (e, t) {
      var i, n, r;
      if (("string" == typeof t && ((i = e[t]), (t = e), (e = i)), f(e)))
        return (
          (n = o.call(arguments, 2)),
          ((r = function () {
            return e.apply(t || this, n.concat(o.call(arguments)));
          }).guid = e.guid =
            e.guid || k.guid++),
          r
        );
    }),
      (k.holdReady = function (e) {
        e ? k.readyWait++ : k.ready(!0);
      }),
      (k.isArray = Array.isArray),
      (k.parseJSON = JSON.parse),
      (k.nodeName = _),
      (k.isFunction = f),
      (k.isWindow = m),
      (k.camelCase = V),
      (k.type = b),
      (k.now = Date.now),
      (k.isNumeric = function (e) {
        var t = k.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
      }),
      (k.trim = function (e) {
        return null == e ? "" : (e + "").replace(Xt, "");
      }),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return k;
        });
    var Yt = e.jQuery,
      Qt = e.$;
    return (
      (k.noConflict = function (t) {
        return (
          e.$ === k && (e.$ = Qt), t && e.jQuery === k && (e.jQuery = Yt), k
        );
      }),
      void 0 === t && (e.jQuery = e.$ = k),
      k
    );
  }),
  document.addEventListener("touchstart", wasTouched, { passive: !0 }),
  (function (e, t) {
    "object" == typeof exports && "undefined" != typeof module
      ? t(exports)
      : "function" == typeof define && define.amd
      ? define(["exports"], t)
      : t(
          ((e =
            "undefined" != typeof globalThis ? globalThis : e || self).Sqrl =
            {})
        );
  })(this, function (e) {
    "use strict";
    function t(e) {
      var i,
        n,
        o = new Error(e);
      return (
        (i = o),
        (n = t.prototype),
        Object.setPrototypeOf ? Object.setPrototypeOf(i, n) : (i.__proto__ = n),
        o
      );
    }
    function i(e, i, n) {
      var o = i.slice(0, n).split(/\n/),
        r = o.length,
        s = o[r - 1].length + 1;
      throw t(
        (e +=
          " at line " +
          r +
          " col " +
          s +
          ":\n\n  " +
          i.split(/\n/)[r - 1] +
          "\n  " +
          Array(s).join(" ") +
          "^")
      );
    }
    t.prototype = Object.create(Error.prototype, {
      name: { value: "Squirrelly Error", enumerable: !1 },
    });
    var n = new Function("return this")().Promise,
      o = !1;
    try {
      o = new Function("return (async function(){}).constructor")();
    } catch (e) {
      if (!(e instanceof SyntaxError)) throw e;
    }
    function r(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    function s(e, t, i) {
      for (var n in t)
        r(t, n) &&
          (null == t[n] ||
          "object" != typeof t[n] ||
          ("storage" !== n && "prefixes" !== n) ||
          i
            ? (e[n] = t[n])
            : (e[n] = s({}, t[n])));
      return e;
    }
    var a = /^async +/,
      l = /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})*}|(?!\${)[^\\`])*`/g,
      c = /'(?:\\[\s\w"'\\`]|[^\n\r'\\])*?'/g,
      d = /"(?:\\[\s\w"'\\`]|[^\n\r"\\])*?"/g,
      u = /[.*+\-?^${}()|[\]\\]/g;
    function p(e) {
      return u.test(e) ? e.replace(u, "\\$&") : e;
    }
    function h(e, n) {
      n.rmWhitespace &&
        (e = e.replace(/[\r\n]+/g, "\n").replace(/^\s+|\s+$/gm, "")),
        (l.lastIndex = 0),
        (c.lastIndex = 0),
        (d.lastIndex = 0);
      var o = n.prefixes,
        r = [o.h, o.b, o.i, o.r, o.c, o.e].reduce(function (e, t) {
          return e && t ? e + "|" + p(t) : t ? p(t) : e;
        }, ""),
        s = new RegExp(
          "([|()]|=>)|('|\"|`|\\/\\*)|\\s*((\\/)?(-|_)?" + p(n.tags[1]) + ")",
          "g"
        ),
        u = new RegExp(
          "([^]*?)" + p(n.tags[0]) + "(-|_)?\\s*(" + r + ")?\\s*",
          "g"
        ),
        h = 0,
        f = !1;
      function m(t, o) {
        var r,
          p = { f: [] },
          m = 0,
          g = "c";
        function v(t) {
          var o = e.slice(h, t),
            r = o.trim();
          if ("f" === g)
            "safe" === r
              ? (p.raw = !0)
              : n.async && a.test(r)
              ? ((r = r.replace(a, "")), p.f.push([r, "", !0]))
              : p.f.push([r, ""]);
          else if ("fp" === g) p.f[p.f.length - 1][1] += r;
          else if ("err" === g) {
            if (r) {
              var s = o.search(/\S/);
              i("invalid syntax", e, h + s);
            }
          } else p[g] = r;
          h = t + 1;
        }
        for (
          "h" === o || "b" === o || "c" === o
            ? (g = "n")
            : "r" === o && ((p.raw = !0), (o = "i")),
            s.lastIndex = h;
          null !== (r = s.exec(e));

        ) {
          var y = r[1],
            b = r[2],
            w = r[3],
            k = r[4],
            x = r[5],
            S = r.index;
          if (y)
            "(" === y
              ? (0 === m &&
                  ("n" === g
                    ? (v(S), (g = "p"))
                    : "f" === g && (v(S), (g = "fp"))),
                m++)
              : ")" === y
              ? 0 == --m && "c" !== g && (v(S), (g = "err"))
              : 0 === m && "|" === y
              ? (v(S), (g = "f"))
              : "=>" === y && (v(S), (h += 1), (g = "res"));
          else if (b)
            if ("/*" === b) {
              var C = e.indexOf("*/", s.lastIndex);
              -1 === C && i("unclosed comment", e, r.index),
                (s.lastIndex = C + 2);
            } else
              "'" === b
                ? ((c.lastIndex = r.index),
                  c.exec(e)
                    ? (s.lastIndex = c.lastIndex)
                    : i("unclosed string", e, r.index))
                : '"' === b
                ? ((d.lastIndex = r.index),
                  d.exec(e)
                    ? (s.lastIndex = d.lastIndex)
                    : i("unclosed string", e, r.index))
                : "`" === b &&
                  ((l.lastIndex = r.index),
                  l.exec(e)
                    ? (s.lastIndex = l.lastIndex)
                    : i("unclosed string", e, r.index));
          else if (w)
            return (
              v(S),
              (h = S + r[0].length),
              (u.lastIndex = h),
              (f = x),
              k && "h" === o && (o = "s"),
              (p.t = o),
              p
            );
        }
        return i("unclosed tag", e, t), p;
      }
      var g = (function r(s, l) {
        (s.b = []), (s.d = []);
        var c,
          d = !1,
          p = [];
        function g(e, t) {
          e &&
            (e = (function (e, t, i, n) {
              var o, r;
              return (
                "string" == typeof t.autoTrim
                  ? (o = r = t.autoTrim)
                  : Array.isArray(t.autoTrim) &&
                    ((o = t.autoTrim[1]), (r = t.autoTrim[0])),
                (i || !1 === i) && (o = i),
                (n || !1 === n) && (r = n),
                "slurp" === o && "slurp" === r
                  ? e.trim()
                  : ("_" === o || "slurp" === o
                      ? (e = String.prototype.trimLeft
                          ? e.trimLeft()
                          : e.replace(/^[\s\uFEFF\xA0]+/, ""))
                      : ("-" !== o && "nl" !== o) ||
                        (e = e.replace(/^(?:\n|\r|\r\n)/, "")),
                    "_" === r || "slurp" === r
                      ? (e = String.prototype.trimRight
                          ? e.trimRight()
                          : e.replace(/[\s\uFEFF\xA0]+$/, ""))
                      : ("-" !== r && "nl" !== r) ||
                        (e = e.replace(/(?:\n|\r|\r\n)$/, "")),
                    e)
              );
            })(e, n, f, t)) &&
            ((e = e.replace(/\\|'/g, "\\$&").replace(/\r\n|\n|\r/g, "\\n")),
            p.push(e));
        }
        for (; null !== (c = u.exec(e)); ) {
          var v,
            y = c[1],
            b = c[2],
            w = c[3] || "";
          for (var k in o)
            if (o[k] === w) {
              v = k;
              break;
            }
          g(y, b),
            (h = c.index + c[0].length),
            v || i("unrecognized tag type: " + w, e, h);
          var x = m(c.index, v),
            S = x.t;
          if ("h" === S) {
            var C = x.n || "";
            n.async && a.test(C) && ((x.a = !0), (x.n = C.replace(a, ""))),
              (x = r(x)),
              p.push(x);
          } else if ("c" === S) {
            if (s.n === x.n) return d ? ((d.d = p), s.b.push(d)) : (s.d = p), s;
            i("Helper start and end don't match", e, c.index + c[0].length);
          } else if ("b" === S) {
            d ? ((d.d = p), s.b.push(d)) : (s.d = p);
            var T = x.n || "";
            n.async && a.test(T) && ((x.a = !0), (x.n = T.replace(a, ""))),
              (d = x),
              (p = []);
          } else if ("s" === S) {
            var $ = x.n || "";
            n.async && a.test($) && ((x.a = !0), (x.n = $.replace(a, ""))),
              p.push(x);
          } else p.push(x);
        }
        if (!l) throw t('unclosed helper "' + s.n + '"');
        return g(e.slice(h, e.length), !1), (s.d = p), s;
      })({ f: [] }, !0);
      if (n.plugins)
        for (var v = 0; v < n.plugins.length; v++) {
          var y = n.plugins[v];
          y.processAST && (g.d = y.processAST(g.d, n));
        }
      return g.d;
    }
    function f(e, t) {
      var i = h(e, t),
        n =
          "var tR='';" +
          (t.useWith ? "with(" + t.varName + "||{}){" : "") +
          b(i, t) +
          "if(cb){cb(null,tR)} return tR" +
          (t.useWith ? "}" : "");
      if (t.plugins)
        for (var o = 0; o < t.plugins.length; o++) {
          var r = t.plugins[o];
          r.processFnString && (n = r.processFnString(n, t));
        }
      return n;
    }
    function m(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i][0],
          o = t[i][1];
        (e = (t[i][2] ? "await " : "") + "c.l('F','" + n + "')(" + e),
          o && (e += "," + o),
          (e += ")");
      }
      return e;
    }
    function g(e, t, i, n, o, r) {
      var s =
        "{exec:" + (o ? "async " : "") + y(i, t, e) + ",params:[" + n + "]";
      return (
        r && (s += ",name:'" + r + "'"), o && (s += ",async:true"), s + "}"
      );
    }
    function v(e, t) {
      for (var i = "[", n = 0; n < e.length; n++) {
        var o = e[n];
        (i += g(t, o.res || "", o.d, o.p || "", o.a, o.n)),
          n < e.length && (i += ",");
      }
      return i + "]";
    }
    function y(e, t, i) {
      return "function(" + t + "){var tR='';" + b(e, i) + "return tR}";
    }
    function b(e, t) {
      for (var i = 0, n = e.length, o = ""; i < n; i++) {
        var r = e[i];
        if ("string" == typeof r) o += "tR+='" + r + "';";
        else {
          var s = r.t,
            a = r.c || "",
            l = r.f,
            c = r.n || "",
            d = r.p || "",
            u = r.res || "",
            p = r.b,
            h = !!r.a;
          if ("i" === s) {
            t.defaultFilter &&
              (a = "c.l('F','" + t.defaultFilter + "')(" + a + ")");
            var f = m(a, l);
            !r.raw && t.autoEscape && (f = "c.l('F','e')(" + f + ")"),
              (o += "tR+=" + f + ";");
          } else if ("h" === s)
            if (t.storage.nativeHelpers.get(c))
              o += t.storage.nativeHelpers.get(c)(r, t);
            else {
              var y =
                (h ? "await " : "") +
                "c.l('H','" +
                c +
                "')(" +
                g(t, u, r.d, d, h);
              (y += p ? "," + v(p, t) : ",[]"),
                (o += "tR+=" + m((y += ",c)"), l) + ";");
            }
          else
            "s" === s
              ? (o +=
                  "tR+=" +
                  m(
                    (h ? "await " : "") +
                      "c.l('H','" +
                      c +
                      "')({params:[" +
                      d +
                      "]},[],c)",
                    l
                  ) +
                  ";")
              : "e" === s && (o += a + "\n");
        }
      }
      return o;
    }
    var w = (function () {
        function e(e) {
          this.cache = e;
        }
        return (
          (e.prototype.define = function (e, t) {
            this.cache[e] = t;
          }),
          (e.prototype.get = function (e) {
            return this.cache[e];
          }),
          (e.prototype.remove = function (e) {
            delete this.cache[e];
          }),
          (e.prototype.reset = function () {
            this.cache = {};
          }),
          (e.prototype.load = function (e) {
            s(this.cache, e, !0);
          }),
          e
        );
      })(),
      k = new w({});
    function x(e, i, n, o) {
      if (i && i.length > 0)
        throw t(
          (o ? "Native" : "") + "Helper '" + e + "' doesn't accept blocks"
        );
      if (n && n.length > 0)
        throw t(
          (o ? "Native" : "") + "Helper '" + e + "' doesn't accept filters"
        );
    }
    var S = new w({
        each: function (e, t) {
          var i = "",
            n = e.params[0];
          if ((x("each", t, !1), e.async))
            return new Promise(function (t) {
              !(function e(t, i, n, o, r) {
                n(t[i], i).then(function (s) {
                  (o += s), i === t.length - 1 ? r(o) : e(t, i + 1, n, o, r);
                });
              })(n, 0, e.exec, i, t);
            });
          for (var o = 0; o < n.length; o++) i += e.exec(n[o], o);
          return i;
        },
        foreach: function (e, t) {
          var i = e.params[0];
          if ((x("foreach", t, !1), e.async))
            return new Promise(function (t) {
              !(function e(t, i, n, o, r, s) {
                o(i[n], t[i[n]]).then(function (a) {
                  (r += a), n === i.length - 1 ? s(r) : e(t, i, n + 1, o, r, s);
                });
              })(i, Object.keys(i), 0, e.exec, "", t);
            });
          var n = "";
          for (var o in i) r(i, o) && (n += e.exec(o, i[o]));
          return n;
        },
        include: function (e, i, n) {
          x("include", i, !1);
          var o = n.storage.templates.get(e.params[0]);
          if (!o) throw t('Could not fetch template "' + e.params[0] + '"');
          return o(e.params[1], n);
        },
        extends: function (e, i, n) {
          var o = e.params[1] || {};
          o.content = e.exec();
          for (var r = 0; r < i.length; r++) {
            var s = i[r];
            o[s.name] = s.exec();
          }
          var a = n.storage.templates.get(e.params[0]);
          if (!a) throw t('Could not fetch template "' + e.params[0] + '"');
          return a(o, n);
        },
        useScope: function (e, t) {
          return x("useScope", t, !1), e.exec(e.params[0]);
        },
      }),
      C = new w({
        if: function (e, t) {
          x("if", !1, e.f, !0);
          var i = "if(" + e.p + "){" + b(e.d, t) + "}";
          if (e.b)
            for (var n = 0; n < e.b.length; n++) {
              var o = e.b[n];
              "else" === o.n
                ? (i += "else{" + b(o.d, t) + "}")
                : "elif" === o.n &&
                  (i += "else if(" + o.p + "){" + b(o.d, t) + "}");
            }
          return i;
        },
        try: function (e, i) {
          if (
            (x("try", !1, e.f, !0),
            !e.b || 1 !== e.b.length || "catch" !== e.b[0].n)
          )
            throw t("native helper 'try' only accepts 1 block, 'catch'");
          var n = "try{" + b(e.d, i) + "}",
            o = e.b[0];
          return (
            n +
            "catch" +
            (o.res ? "(" + o.res + ")" : "") +
            "{" +
            b(o.d, i) +
            "}"
          );
        },
        block: function (e, t) {
          return (
            x("block", e.b, e.f, !0),
            "if(!" +
              t.varName +
              "[" +
              e.p +
              "]){tR+=(" +
              y(e.d, "", t) +
              ")()}else{tR+=" +
              t.varName +
              "[" +
              e.p +
              "]}"
          );
        },
      }),
      T = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      };
    function $(e) {
      return T[e];
    }
    var _ = new w({
        e: function (e) {
          var t = String(e);
          return /[&<>"']/.test(t) ? t.replace(/[&<>"']/g, $) : t;
        },
      }),
      E = {
        varName: "it",
        autoTrim: [!1, "nl"],
        autoEscape: !0,
        defaultFilter: !1,
        tags: ["{{", "}}"],
        l: function (e, i) {
          if ("H" === e) {
            var n = this.storage.helpers.get(i);
            if (n) return n;
            throw t("Can't find helper '" + i + "'");
          }
          if ("F" === e) {
            var o = this.storage.filters.get(i);
            if (o) return o;
            throw t("Can't find filter '" + i + "'");
          }
        },
        async: !1,
        storage: { helpers: S, nativeHelpers: C, filters: _, templates: k },
        prefixes: { h: "@", b: "#", i: "", r: "*", c: "/", e: "!" },
        cache: !1,
        plugins: [],
        useWith: !1,
      };
    function A(e, t) {
      var i = {};
      return s(i, E), t && s(i, t), e && s(i, e), i.l.bind(i), i;
    }
    function P(e, i) {
      var n = A(i || {}),
        r = Function;
      if (n.async) {
        if (!o) throw t("This environment doesn't support async/await");
        r = o;
      }
      try {
        return new r(n.varName, "c", "cb", f(e, n));
      } catch (i) {
        throw i instanceof SyntaxError
          ? t(
              "Bad template syntax\n\n" +
                i.message +
                "\n" +
                Array(i.message.length + 1).join("=") +
                "\n" +
                f(e, n)
            )
          : i;
      }
    }
    function L(e, t) {
      var i;
      return t.cache && t.name && t.storage.templates.get(t.name)
        ? t.storage.templates.get(t.name)
        : ((i = "function" == typeof e ? e : P(e, t)),
          t.cache && t.name && t.storage.templates.define(t.name, i),
          i);
    }
    E.l.bind(E),
      (e.compile = P),
      (e.compileScope = b),
      (e.compileScopeIntoFunction = y),
      (e.compileToString = f),
      (e.defaultConfig = E),
      (e.filters = _),
      (e.getConfig = A),
      (e.helpers = S),
      (e.nativeHelpers = C),
      (e.parse = h),
      (e.render = function (e, i, o, r) {
        var s = A(o || {});
        if (!s.async) return L(e, s)(i, s);
        if (!r) {
          if ("function" == typeof n)
            return new n(function (t, n) {
              try {
                t(L(e, s)(i, s));
              } catch (e) {
                n(e);
              }
            });
          throw t(
            "Please provide a callback function, this env doesn't support Promises"
          );
        }
        try {
          L(e, s)(i, s, r);
        } catch (e) {
          return r(e);
        }
      }),
      (e.templates = k),
      Object.defineProperty(e, "__esModule", { value: !0 });
  }),
  (function (e, t) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define([], t)
      : "object" == typeof exports
      ? (exports.scrollLock = t())
      : (e.scrollLock = t());
  })(this, function () {
    return (function (e) {
      var t = {};
      function i(n) {
        if (t[n]) return t[n].exports;
        var o = (t[n] = { i: n, l: !1, exports: {} });
        return e[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
      }
      return (
        (i.m = e),
        (i.c = t),
        (i.d = function (e, t, n) {
          i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
        }),
        (i.r = function (e) {
          "undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (i.t = function (e, t) {
          if ((1 & t && (e = i(e)), 8 & t)) return e;
          if (4 & t && "object" == typeof e && e && e.__esModule) return e;
          var n = Object.create(null);
          if (
            (i.r(n),
            Object.defineProperty(n, "default", { enumerable: !0, value: e }),
            2 & t && "string" != typeof e)
          )
            for (var o in e)
              i.d(
                n,
                o,
                function (t) {
                  return e[t];
                }.bind(null, o)
              );
          return n;
        }),
        (i.n = function (e) {
          var t =
            e && e.__esModule
              ? function () {
                  return e.default;
                }
              : function () {
                  return e;
                };
          return i.d(t, "a", t), t;
        }),
        (i.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (i.p = ""),
        i((i.s = 0))
      );
    })([
      function (e, t, i) {
        "use strict";
        i.r(t);
        var n = function (e) {
            return Array.isArray(e) ? e : [e];
          },
          o = function (e) {
            return e instanceof Node;
          },
          r = function (e, t) {
            if (e && t) {
              e = e instanceof NodeList ? e : [e];
              for (var i = 0; i < e.length && !0 !== t(e[i], i, e.length); i++);
            }
          },
          s = function (e) {
            return console.error("[scroll-lock] ".concat(e));
          },
          a = function (e) {
            if (Array.isArray(e)) return e.join(", ");
          },
          l = function (e) {
            var t = [];
            return (
              r(e, function (e) {
                return t.push(e);
              }),
              t
            );
          },
          c = function (e, t) {
            var i =
                !(2 < arguments.length && void 0 !== arguments[2]) ||
                arguments[2],
              n =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : document;
            if (i && -1 !== l(n.querySelectorAll(t)).indexOf(e)) return e;
            for (
              ;
              (e = e.parentElement) &&
              -1 === l(n.querySelectorAll(t)).indexOf(e);

            );
            return e;
          },
          d = function (e, t) {
            var i =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : document;
            return -1 !== l(i.querySelectorAll(t)).indexOf(e);
          },
          u = function (e) {
            if (e) return "hidden" === getComputedStyle(e).overflow;
          },
          p = function (e) {
            if (e) return !!u(e) || e.scrollTop <= 0;
          },
          h = function (e) {
            if (e) {
              if (u(e)) return !0;
              var t = e.scrollTop;
              return e.scrollHeight <= t + e.offsetHeight;
            }
          },
          f = function (e) {
            if (e) return !!u(e) || e.scrollLeft <= 0;
          },
          m = function (e) {
            if (e) {
              if (u(e)) return !0;
              var t = e.scrollLeft;
              return e.scrollWidth <= t + e.offsetWidth;
            }
          };
        i.d(t, "disablePageScroll", function () {
          return y;
        }),
          i.d(t, "enablePageScroll", function () {
            return b;
          }),
          i.d(t, "getScrollState", function () {
            return w;
          }),
          i.d(t, "clearQueueScrollLocks", function () {
            return k;
          }),
          i.d(t, "getTargetScrollBarWidth", function () {
            return x;
          }),
          i.d(t, "getCurrentTargetScrollBarWidth", function () {
            return S;
          }),
          i.d(t, "getPageScrollBarWidth", function () {
            return C;
          }),
          i.d(t, "getCurrentPageScrollBarWidth", function () {
            return T;
          }),
          i.d(t, "addScrollableTarget", function () {
            return $;
          }),
          i.d(t, "removeScrollableTarget", function () {
            return _;
          }),
          i.d(t, "addScrollableSelector", function () {
            return E;
          }),
          i.d(t, "removeScrollableSelector", function () {
            return A;
          }),
          i.d(t, "addLockableTarget", function () {
            return P;
          }),
          i.d(t, "addLockableSelector", function () {
            return L;
          }),
          i.d(t, "setFillGapMethod", function () {
            return j;
          }),
          i.d(t, "addFillGapTarget", function () {
            return I;
          }),
          i.d(t, "removeFillGapTarget", function () {
            return M;
          }),
          i.d(t, "addFillGapSelector", function () {
            return q;
          }),
          i.d(t, "removeFillGapSelector", function () {
            return D;
          }),
          i.d(t, "refillGaps", function () {
            return z;
          });
        var g = ["padding", "margin", "width", "max-width", "none"],
          v = {
            scroll: !0,
            queue: 0,
            scrollableSelectors: ["[data-scroll-lock-scrollable]"],
            lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
            fillGapSelectors: [
              "body",
              "[data-scroll-lock-fill-gap]",
              "[data-scroll-lock-lockable]",
            ],
            fillGapMethod: g[0],
            startTouchY: 0,
            startTouchX: 0,
          },
          y = function (e) {
            v.queue <= 0 && ((v.scroll = !1), F(), R()), $(e), v.queue++;
          },
          b = function (e) {
            0 < v.queue && v.queue--,
              v.queue <= 0 && ((v.scroll = !0), O(), U()),
              _(e);
          },
          w = function () {
            return v.scroll;
          },
          k = function () {
            v.queue = 0;
          },
          x = function (e) {
            var t =
              1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (o(e)) {
              var i = e.style.overflowY;
              t
                ? w() ||
                  (e.style.overflowY = e.getAttribute(
                    "data-scroll-lock-saved-overflow-y-property"
                  ))
                : (e.style.overflowY = "scroll");
              var n = S(e);
              return (e.style.overflowY = i), n;
            }
            return 0;
          },
          S = function (e) {
            if (o(e)) {
              if (e === document.body) {
                var t = document.documentElement.clientWidth;
                return window.innerWidth - t;
              }
              var i = e.style.borderLeftWidth,
                n = e.style.borderRightWidth;
              (e.style.borderLeftWidth = "0px"),
                (e.style.borderRightWidth = "0px");
              var r = e.offsetWidth - e.clientWidth;
              return (
                (e.style.borderLeftWidth = i), (e.style.borderRightWidth = n), r
              );
            }
            return 0;
          },
          C = function () {
            var e =
              0 < arguments.length && void 0 !== arguments[0] && arguments[0];
            return x(document.body, e);
          },
          T = function () {
            return S(document.body);
          },
          $ = function (e) {
            e &&
              n(e).map(function (e) {
                r(e, function (e) {
                  o(e)
                    ? e.setAttribute("data-scroll-lock-scrollable", "")
                    : s('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          _ = function (e) {
            e &&
              n(e).map(function (e) {
                r(e, function (e) {
                  o(e)
                    ? e.removeAttribute("data-scroll-lock-scrollable")
                    : s('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          E = function (e) {
            e &&
              n(e).map(function (e) {
                v.scrollableSelectors.push(e);
              });
          },
          A = function (e) {
            e &&
              n(e).map(function (e) {
                v.scrollableSelectors = v.scrollableSelectors.filter(function (
                  t
                ) {
                  return t !== e;
                });
              });
          },
          P = function (e) {
            e &&
              (n(e).map(function (e) {
                r(e, function (e) {
                  o(e)
                    ? e.setAttribute("data-scroll-lock-lockable", "")
                    : s('"'.concat(e, '" is not a Element.'));
                });
              }),
              w() || F());
          },
          L = function (e) {
            e &&
              (n(e).map(function (e) {
                v.lockableSelectors.push(e);
              }),
              w() || F(),
              q(e));
          },
          j = function (e) {
            if (e)
              if (-1 !== g.indexOf(e)) (v.fillGapMethod = e), z();
              else {
                var t = g.join(", ");
                s(
                  '"'
                    .concat(
                      e,
                      '" method is not available!\nAvailable fill gap methods: '
                    )
                    .concat(t, ".")
                );
              }
          },
          I = function (e) {
            e &&
              n(e).map(function (e) {
                r(e, function (e) {
                  o(e)
                    ? (e.setAttribute("data-scroll-lock-fill-gap", ""),
                      v.scroll || G(e))
                    : s('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          M = function (e) {
            e &&
              n(e).map(function (e) {
                r(e, function (e) {
                  o(e)
                    ? (e.removeAttribute("data-scroll-lock-fill-gap"),
                      v.scroll || Y(e))
                    : s('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          q = function (e) {
            e &&
              n(e).map(function (e) {
                -1 === v.fillGapSelectors.indexOf(e) &&
                  (v.fillGapSelectors.push(e), v.scroll || V(e));
              });
          },
          D = function (e) {
            e &&
              n(e).map(function (e) {
                (v.fillGapSelectors = v.fillGapSelectors.filter(function (t) {
                  return t !== e;
                })),
                  v.scroll || X(e);
              });
          },
          z = function () {
            v.scroll || R();
          },
          F = function () {
            var e = a(v.lockableSelectors);
            N(e);
          },
          O = function () {
            var e = a(v.lockableSelectors);
            B(e);
          },
          N = function (e) {
            var t = document.querySelectorAll(e);
            r(t, function (e) {
              H(e);
            });
          },
          B = function (e) {
            var t = document.querySelectorAll(e);
            r(t, function (e) {
              W(e);
            });
          },
          H = function (e) {
            if (o(e) && "true" !== e.getAttribute("data-scroll-lock-locked")) {
              var t = window.getComputedStyle(e);
              e.setAttribute(
                "data-scroll-lock-saved-overflow-y-property",
                t.overflowY
              ),
                e.setAttribute(
                  "data-scroll-lock-saved-inline-overflow-property",
                  e.style.overflow
                ),
                e.setAttribute(
                  "data-scroll-lock-saved-inline-overflow-y-property",
                  e.style.overflowY
                ),
                (e.style.overflow = "hidden"),
                e.setAttribute("data-scroll-lock-locked", "true");
            }
          },
          W = function (e) {
            o(e) &&
              "true" === e.getAttribute("data-scroll-lock-locked") &&
              ((e.style.overflow = e.getAttribute(
                "data-scroll-lock-saved-inline-overflow-property"
              )),
              (e.style.overflowY = e.getAttribute(
                "data-scroll-lock-saved-inline-overflow-y-property"
              )),
              e.removeAttribute("data-scroll-lock-saved-overflow-property"),
              e.removeAttribute(
                "data-scroll-lock-saved-inline-overflow-property"
              ),
              e.removeAttribute(
                "data-scroll-lock-saved-inline-overflow-y-property"
              ),
              e.removeAttribute("data-scroll-lock-locked"));
          },
          R = function () {
            v.fillGapSelectors.map(function (e) {
              V(e);
            });
          },
          U = function () {
            v.fillGapSelectors.map(function (e) {
              X(e);
            });
          },
          V = function (e) {
            var t = document.querySelectorAll(e),
              i = -1 !== v.lockableSelectors.indexOf(e);
            r(t, function (e) {
              G(e, i);
            });
          },
          G = function (e) {
            var t =
              1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (o(e)) {
              var i;
              if ("" === e.getAttribute("data-scroll-lock-lockable") || t)
                i = x(e, !0);
              else {
                var n = c(e, a(v.lockableSelectors));
                i = x(n, !0);
              }
              "true" === e.getAttribute("data-scroll-lock-filled-gap") && Y(e);
              var r = window.getComputedStyle(e);
              if (
                (e.setAttribute("data-scroll-lock-filled-gap", "true"),
                e.setAttribute(
                  "data-scroll-lock-current-fill-gap-method",
                  v.fillGapMethod
                ),
                "margin" === v.fillGapMethod)
              ) {
                var s = parseFloat(r.marginRight);
                e.style.marginRight = "".concat(s + i, "px");
              } else if ("width" === v.fillGapMethod)
                e.style.width = "calc(100% - ".concat(i, "px)");
              else if ("max-width" === v.fillGapMethod)
                e.style.maxWidth = "calc(100% - ".concat(i, "px)");
              else if ("padding" === v.fillGapMethod) {
                var l = parseFloat(r.paddingRight);
                e.style.paddingRight = "".concat(l + i, "px");
              }
            }
          },
          X = function (e) {
            var t = document.querySelectorAll(e);
            r(t, function (e) {
              Y(e);
            });
          },
          Y = function (e) {
            if (
              o(e) &&
              "true" === e.getAttribute("data-scroll-lock-filled-gap")
            ) {
              var t = e.getAttribute(
                "data-scroll-lock-current-fill-gap-method"
              );
              e.removeAttribute("data-scroll-lock-filled-gap"),
                e.removeAttribute("data-scroll-lock-current-fill-gap-method"),
                "margin" === t
                  ? (e.style.marginRight = "")
                  : "width" === t
                  ? (e.style.width = "")
                  : "max-width" === t
                  ? (e.style.maxWidth = "")
                  : "padding" === t && (e.style.paddingRight = "");
            }
          };
        "undefined" != typeof window &&
          window.addEventListener("resize", function (e) {
            z();
          }),
          "undefined" != typeof document &&
            (document.addEventListener("touchstart", function (e) {
              v.scroll ||
                ((v.startTouchY = e.touches[0].clientY),
                (v.startTouchX = e.touches[0].clientX));
            }),
            document.addEventListener(
              "touchmove",
              function (e) {
                if (!v.scroll) {
                  var t = v.startTouchY,
                    i = v.startTouchX,
                    n = e.touches[0].clientY,
                    o = e.touches[0].clientX;
                  if (e.touches.length < 2) {
                    var r = a(v.scrollableSelectors),
                      s = t < n,
                      l = n < t,
                      u = i < o,
                      g = o < i,
                      y = t + 3 < n,
                      b = n < t - 3,
                      w = i + 3 < o,
                      k = o < i - 3;
                    !(function t(i) {
                      var n =
                        1 < arguments.length &&
                        void 0 !== arguments[1] &&
                        arguments[1];
                      if (i) {
                        var o = c(i, r, !1);
                        if (d(i, 'input[type="range"]')) return !1;
                        if (
                          n ||
                          (d(i, 'textarea, [contenteditable="true"]') &&
                            c(i, r)) ||
                          d(i, r)
                        ) {
                          var a = !1;
                          f(i) && m(i)
                            ? ((s && p(i)) || (l && h(i))) && (a = !0)
                            : p(i) && h(i)
                            ? ((u && f(i)) || (g && m(i))) && (a = !0)
                            : ((y && p(i)) ||
                                (b && h(i)) ||
                                (w && f(i)) ||
                                (k && m(i))) &&
                              (a = !0),
                            a && (o ? t(o, !0) : e.preventDefault());
                        } else t(o);
                      } else e.preventDefault();
                    })(e.target);
                  }
                }
              },
              { passive: !1 }
            ),
            document.addEventListener("touchend", function (e) {
              v.scroll || ((v.startTouchY = 0), (v.startTouchX = 0));
            }));
        var Q = {
            hide: function (e) {
              s(
                '"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'
              ),
                y(e);
            },
            show: function (e) {
              s(
                '"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'
              ),
                b(e);
            },
            toggle: function (e) {
              s('"toggle" is deprecated! Do not use it.'), w() ? y() : b(e);
            },
            getState: function () {
              return (
                s(
                  '"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'
                ),
                w()
              );
            },
            getWidth: function () {
              return (
                s(
                  '"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'
                ),
                C()
              );
            },
            getCurrentWidth: function () {
              return (
                s(
                  '"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'
                ),
                T()
              );
            },
            setScrollableTargets: function (e) {
              s(
                '"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'
              ),
                $(e);
            },
            setFillGapSelectors: function (e) {
              s(
                '"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'
              ),
                q(e);
            },
            setFillGapTargets: function (e) {
              s(
                '"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'
              ),
                I(e);
            },
            clearQueue: function () {
              s(
                '"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'
              ),
                k();
            },
          },
          K = (function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var i = null != arguments[t] ? arguments[t] : {},
                n = Object.keys(i);
              "function" == typeof Object.getOwnPropertySymbols &&
                (n = n.concat(
                  Object.getOwnPropertySymbols(i).filter(function (e) {
                    return Object.getOwnPropertyDescriptor(i, e).enumerable;
                  })
                )),
                n.forEach(function (t) {
                  var n, o, r;
                  (n = e),
                    (r = i[(o = t)]),
                    o in n
                      ? Object.defineProperty(n, o, {
                          value: r,
                          enumerable: !0,
                          configurable: !0,
                          writable: !0,
                        })
                      : (n[o] = r);
                });
            }
            return e;
          })(
            {
              disablePageScroll: y,
              enablePageScroll: b,
              getScrollState: w,
              clearQueueScrollLocks: k,
              getTargetScrollBarWidth: x,
              getCurrentTargetScrollBarWidth: S,
              getPageScrollBarWidth: C,
              getCurrentPageScrollBarWidth: T,
              addScrollableSelector: E,
              removeScrollableSelector: A,
              addScrollableTarget: $,
              removeScrollableTarget: _,
              addLockableSelector: L,
              addLockableTarget: P,
              addFillGapSelector: q,
              removeFillGapSelector: D,
              addFillGapTarget: I,
              removeFillGapTarget: M,
              setFillGapMethod: j,
              refillGaps: z,
              _state: v,
            },
            Q
          );
        t.default = K;
      },
    ]).default;
  }),
  (function (e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define([], e)
      : (("undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : this
        ).enquire = e());
  })(function () {
    return (function e(t, i, n) {
      function o(s, a) {
        if (!i[s]) {
          if (!t[s]) {
            var l = "function" == typeof require && require;
            if (!a && l) return l(s, !0);
            if (r) return r(s, !0);
            var c = new Error("Cannot find module '" + s + "'");
            throw ((c.code = "MODULE_NOT_FOUND"), c);
          }
          var d = (i[s] = { exports: {} });
          t[s][0].call(
            d.exports,
            function (e) {
              return o(t[s][1][e] || e);
            },
            d,
            d.exports,
            e,
            t,
            i,
            n
          );
        }
        return i[s].exports;
      }
      for (
        var r = "function" == typeof require && require, s = 0;
        s < n.length;
        s++
      )
        o(n[s]);
      return o;
    })(
      {
        1: [
          function (e, t, i) {
            function n(e, t) {
              (this.query = e),
                (this.isUnconditional = t),
                (this.handlers = []),
                (this.mql = window.matchMedia(e));
              var i = this;
              (this.listener = function (e) {
                (i.mql = e.currentTarget || e), i.assess();
              }),
                this.mql.addListener(this.listener);
            }
            var o = e(3),
              r = e(4).each;
            (n.prototype = {
              constuctor: n,
              addHandler: function (e) {
                var t = new o(e);
                this.handlers.push(t), this.matches() && t.on();
              },
              removeHandler: function (e) {
                var t = this.handlers;
                r(t, function (i, n) {
                  if (i.equals(e)) return i.destroy(), !t.splice(n, 1);
                });
              },
              matches: function () {
                return this.mql.matches || this.isUnconditional;
              },
              clear: function () {
                r(this.handlers, function (e) {
                  e.destroy();
                }),
                  this.mql.removeListener(this.listener),
                  (this.handlers.length = 0);
              },
              assess: function () {
                var e = this.matches() ? "on" : "off";
                r(this.handlers, function (t) {
                  t[e]();
                });
              },
            }),
              (t.exports = n);
          },
          { 3: 3, 4: 4 },
        ],
        2: [
          function (e, t, i) {
            function n() {
              if (!window.matchMedia)
                throw new Error(
                  "matchMedia not present, legacy browsers require a polyfill"
                );
              (this.queries = {}),
                (this.browserIsIncapable =
                  !window.matchMedia("only all").matches);
            }
            var o = e(1),
              r = e(4),
              s = r.each,
              a = r.isFunction,
              l = r.isArray;
            (n.prototype = {
              constructor: n,
              register: function (e, t, i) {
                var n = this.queries,
                  r = i && this.browserIsIncapable;
                return (
                  n[e] || (n[e] = new o(e, r)),
                  a(t) && (t = { match: t }),
                  l(t) || (t = [t]),
                  s(t, function (t) {
                    a(t) && (t = { match: t }), n[e].addHandler(t);
                  }),
                  this
                );
              },
              unregister: function (e, t) {
                var i = this.queries[e];
                return (
                  i &&
                    (t
                      ? i.removeHandler(t)
                      : (i.clear(), delete this.queries[e])),
                  this
                );
              },
            }),
              (t.exports = n);
          },
          { 1: 1, 4: 4 },
        ],
        3: [
          function (e, t, i) {
            function n(e) {
              (this.options = e), !e.deferSetup && this.setup();
            }
            (n.prototype = {
              constructor: n,
              setup: function () {
                this.options.setup && this.options.setup(),
                  (this.initialised = !0);
              },
              on: function () {
                !this.initialised && this.setup(),
                  this.options.match && this.options.match();
              },
              off: function () {
                this.options.unmatch && this.options.unmatch();
              },
              destroy: function () {
                this.options.destroy ? this.options.destroy() : this.off();
              },
              equals: function (e) {
                return this.options === e || this.options.match === e;
              },
            }),
              (t.exports = n);
          },
          {},
        ],
        4: [
          function (e, t, i) {
            t.exports = {
              isFunction: function (e) {
                return "function" == typeof e;
              },
              isArray: function (e) {
                return "[object Array]" === Object.prototype.toString.apply(e);
              },
              each: function (e, t) {
                for (var i = 0, n = e.length; i < n && !1 !== t(e[i], i); i++);
              },
            };
          },
          {},
        ],
        5: [
          function (e, t, i) {
            var n = e(2);
            t.exports = new n();
          },
          { 2: 2 },
        ],
      },
      {},
      [5]
    )(5);
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("jquery")))
      : (e.jQueryBridget = t(e, e.jQuery));
  })(window, function (e, t) {
    "use strict";
    var i = Array.prototype.slice,
      n = e.console,
      o =
        void 0 === n
          ? function () {}
          : function (e) {
              n.error(e);
            };
    function r(n, r, a) {
      (a = a || t || e.jQuery) &&
        (r.prototype.option ||
          (r.prototype.option = function (e) {
            a.isPlainObject(e) &&
              (this.options = a.extend(!0, this.options, e));
          }),
        (a.fn[n] = function (e) {
          if ("string" != typeof e)
            return (
              (u = e),
              this.each(function (e, t) {
                var i = a.data(t, n);
                i
                  ? (i.option(u), i._init())
                  : ((i = new r(t, u)), a.data(t, n, i));
              }),
              this
            );
          var t,
            s,
            l,
            c,
            d,
            u,
            p = i.call(arguments, 1);
          return (
            (l = p),
            (d = "$()." + n + '("' + (s = e) + '")'),
            (t = this).each(function (e, t) {
              var i = a.data(t, n);
              if (i) {
                var r = i[s];
                if (r && "_" != s.charAt(0)) {
                  var u = r.apply(i, l);
                  c = void 0 === c ? u : c;
                } else o(d + " is not a valid method");
              } else o(n + " not initialized. Cannot call methods, i.e. " + d);
            }),
            void 0 !== c ? c : t
          );
        }),
        s(a));
    }
    function s(e) {
      !e || (e && e.bridget) || (e.bridget = r);
    }
    return s(t || e.jQuery), r;
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.EvEmitter = t());
  })("undefined" != typeof window ? window : this, function () {
    function e() {}
    var t = e.prototype;
    return (
      (t.on = function (e, t) {
        if (e && t) {
          var i = (this._events = this._events || {}),
            n = (i[e] = i[e] || []);
          return -1 == n.indexOf(t) && n.push(t), this;
        }
      }),
      (t.once = function (e, t) {
        if (e && t) {
          this.on(e, t);
          var i = (this._onceEvents = this._onceEvents || {});
          return ((i[e] = i[e] || {})[t] = !0), this;
        }
      }),
      (t.off = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          var n = i.indexOf(t);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (t.emitEvent = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          (i = i.slice(0)), (t = t || []);
          for (
            var n = this._onceEvents && this._onceEvents[e], o = 0;
            o < i.length;
            o++
          ) {
            var r = i[o];
            n && n[r] && (this.off(e, r), delete n[r]), r.apply(this, t);
          }
          return this;
        }
      }),
      (t.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      e
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.getSize = t());
  })(window, function () {
    "use strict";
    function e(e) {
      var t = parseFloat(e);
      return -1 == e.indexOf("%") && !isNaN(t) && t;
    }
    var t =
        "undefined" == typeof console
          ? function () {}
          : function (e) {
              console.error(e);
            },
      i = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      n = i.length;
    function o(e) {
      var i = getComputedStyle(e);
      return (
        i ||
          t(
            "Style returned " +
              i +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
          ),
        i
      );
    }
    var r,
      s = !1;
    return function t(a) {
      if (
        ((function () {
          if (!s) {
            s = !0;
            var i = document.createElement("div");
            (i.style.width = "200px"),
              (i.style.padding = "1px 2px 3px 4px"),
              (i.style.borderStyle = "solid"),
              (i.style.borderWidth = "1px 2px 3px 4px"),
              (i.style.boxSizing = "border-box");
            var n = document.body || document.documentElement;
            n.appendChild(i);
            var a = o(i);
            (r = 200 == Math.round(e(a.width))),
              (t.isBoxSizeOuter = r),
              n.removeChild(i);
          }
        })(),
        "string" == typeof a && (a = document.querySelector(a)),
        a && "object" == typeof a && a.nodeType)
      ) {
        var l = o(a);
        if ("none" == l.display)
          return (function () {
            for (
              var e = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                t = 0;
              t < n;
              t++
            )
              e[i[t]] = 0;
            return e;
          })();
        var c = {};
        (c.width = a.offsetWidth), (c.height = a.offsetHeight);
        for (
          var d = (c.isBorderBox = "border-box" == l.boxSizing), u = 0;
          u < n;
          u++
        ) {
          var p = i[u],
            h = l[p],
            f = parseFloat(h);
          c[p] = isNaN(f) ? 0 : f;
        }
        var m = c.paddingLeft + c.paddingRight,
          g = c.paddingTop + c.paddingBottom,
          v = c.marginLeft + c.marginRight,
          y = c.marginTop + c.marginBottom,
          b = c.borderLeftWidth + c.borderRightWidth,
          w = c.borderTopWidth + c.borderBottomWidth,
          k = d && r,
          x = e(l.width);
        !1 !== x && (c.width = x + (k ? 0 : m + b));
        var S = e(l.height);
        return (
          !1 !== S && (c.height = S + (k ? 0 : g + w)),
          (c.innerWidth = c.width - (m + b)),
          (c.innerHeight = c.height - (g + w)),
          (c.outerWidth = c.width + v),
          (c.outerHeight = c.height + y),
          c
        );
      }
    };
  }),
  (function (e, t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.matchesSelector = t());
  })(window, function () {
    "use strict";
    var e = (function () {
      var e = window.Element.prototype;
      if (e.matches) return "matches";
      if (e.matchesSelector) return "matchesSelector";
      for (var t = ["webkit", "moz", "ms", "o"], i = 0; i < t.length; i++) {
        var n = t[i] + "MatchesSelector";
        if (e[n]) return n;
      }
    })();
    return function (t, i) {
      return t[e](i);
    };
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("desandro-matches-selector")))
      : (e.fizzyUIUtils = t(e, e.matchesSelector));
  })(window, function (e, t) {
    var i = {
        extend: function (e, t) {
          for (var i in t) e[i] = t[i];
          return e;
        },
        modulo: function (e, t) {
          return ((e % t) + t) % t;
        },
      },
      n = Array.prototype.slice;
    (i.makeArray = function (e) {
      return Array.isArray(e)
        ? e
        : null == e
        ? []
        : "object" == typeof e && "number" == typeof e.length
        ? n.call(e)
        : [e];
    }),
      (i.removeFrom = function (e, t) {
        var i = e.indexOf(t);
        -1 != i && e.splice(i, 1);
      }),
      (i.getParent = function (e, i) {
        for (; e.parentNode && e != document.body; )
          if (((e = e.parentNode), t(e, i))) return e;
      }),
      (i.getQueryElement = function (e) {
        return "string" == typeof e ? document.querySelector(e) : e;
      }),
      (i.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (i.filterFindElements = function (e, n) {
        e = i.makeArray(e);
        var o = [];
        return (
          e.forEach(function (e) {
            if (e instanceof HTMLElement)
              if (n) {
                t(e, n) && o.push(e);
                for (var i = e.querySelectorAll(n), r = 0; r < i.length; r++)
                  o.push(i[r]);
              } else o.push(e);
          }),
          o
        );
      }),
      (i.debounceMethod = function (e, t, i) {
        i = i || 100;
        var n = e.prototype[t],
          o = t + "Timeout";
        e.prototype[t] = function () {
          var e = this[o];
          clearTimeout(e);
          var t = arguments,
            r = this;
          this[o] = setTimeout(function () {
            n.apply(r, t), delete r[o];
          }, i);
        };
      }),
      (i.docReady = function (e) {
        var t = document.readyState;
        "complete" == t || "interactive" == t
          ? setTimeout(e)
          : document.addEventListener("DOMContentLoaded", e);
      }),
      (i.toDashed = function (e) {
        return e
          .replace(/(.)([A-Z])/g, function (e, t, i) {
            return t + "-" + i;
          })
          .toLowerCase();
      });
    var o = e.console;
    return (
      (i.htmlInit = function (t, n) {
        i.docReady(function () {
          var r = i.toDashed(n),
            s = "data-" + r,
            a = document.querySelectorAll("[" + s + "]"),
            l = document.querySelectorAll(".js-" + r),
            c = i.makeArray(a).concat(i.makeArray(l)),
            d = s + "-options",
            u = e.jQuery;
          c.forEach(function (e) {
            var i,
              r = e.getAttribute(s) || e.getAttribute(d);
            try {
              i = r && JSON.parse(r);
            } catch (i) {
              return void (
                o &&
                o.error("Error parsing " + s + " on " + e.className + ": " + i)
              );
            }
            var a = new t(e, i);
            u && u.data(e, n, a);
          });
        });
      }),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("flickity/js/cell", ["get-size/get-size"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("get-size")))
      : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = t(e, e.getSize)));
  })(window, function (e, t) {
    function i(e, t) {
      (this.element = e), (this.parent = t), this.create();
    }
    var n = i.prototype;
    return (
      (n.create = function () {
        (this.element.style.position = "absolute"),
          this.element.setAttribute("aria-hidden", "true"),
          (this.x = 0),
          (this.shift = 0);
      }),
      (n.destroy = function () {
        this.unselect(), (this.element.style.position = "");
        var e = this.parent.originSide;
        this.element.style[e] = "";
      }),
      (n.getSize = function () {
        this.size = t(this.element);
      }),
      (n.setPosition = function (e) {
        (this.x = e), this.updateTarget(), this.renderPosition(e);
      }),
      (n.updateTarget = n.setDefaultTarget =
        function () {
          var e =
            "left" == this.parent.originSide ? "marginLeft" : "marginRight";
          this.target =
            this.x + this.size[e] + this.size.width * this.parent.cellAlign;
        }),
      (n.renderPosition = function (e) {
        var t = this.parent.originSide;
        this.element.style[t] = this.parent.getPositionValue(e);
      }),
      (n.select = function () {
        this.element.classList.add("is-selected"),
          this.element.removeAttribute("aria-hidden");
      }),
      (n.unselect = function () {
        this.element.classList.remove("is-selected"),
          this.element.setAttribute("aria-hidden", "true");
      }),
      (n.wrapShift = function (e) {
        (this.shift = e),
          this.renderPosition(this.x + this.parent.slideableWidth * e);
      }),
      (n.remove = function () {
        this.element.parentNode.removeChild(this.element);
      }),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("flickity/js/slide", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = t()));
  })(window, function () {
    "use strict";
    function e(e) {
      (this.parent = e),
        (this.isOriginLeft = "left" == e.originSide),
        (this.cells = []),
        (this.outerWidth = 0),
        (this.height = 0);
    }
    var t = e.prototype;
    return (
      (t.addCell = function (e) {
        if (
          (this.cells.push(e),
          (this.outerWidth += e.size.outerWidth),
          (this.height = Math.max(e.size.outerHeight, this.height)),
          1 == this.cells.length)
        ) {
          this.x = e.x;
          var t = this.isOriginLeft ? "marginLeft" : "marginRight";
          this.firstMargin = e.size[t];
        }
      }),
      (t.updateTarget = function () {
        var e = this.isOriginLeft ? "marginRight" : "marginLeft",
          t = this.getLastCell(),
          i = t ? t.size[e] : 0,
          n = this.outerWidth - (this.firstMargin + i);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
      }),
      (t.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (t.select = function () {
        this.cells.forEach(function (e) {
          e.select();
        });
      }),
      (t.unselect = function () {
        this.cells.forEach(function (e) {
          e.unselect();
        });
      }),
      (t.getCellElements = function () {
        return this.cells.map(function (e) {
          return e.element;
        });
      }),
      e
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("fizzy-ui-utils")))
      : ((e.Flickity = e.Flickity || {}),
        (e.Flickity.animatePrototype = t(e, e.fizzyUIUtils)));
  })(window, function (e, t) {
    return {
      startAnimation: function () {
        this.isAnimating ||
          ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
      },
      animate: function () {
        this.applyDragForce(), this.applySelectedAttraction();
        var e = this.x;
        if (
          (this.integratePhysics(),
          this.positionSlider(),
          this.settle(e),
          this.isAnimating)
        ) {
          var t = this;
          requestAnimationFrame(function () {
            t.animate();
          });
        }
      },
      positionSlider: function () {
        var e = this.x;
        this.options.wrapAround &&
          1 < this.cells.length &&
          ((e = t.modulo(e, this.slideableWidth)),
          (e -= this.slideableWidth),
          this.shiftWrapCells(e)),
          this.setTranslateX(e, this.isAnimating),
          this.dispatchScrollEvent();
      },
      setTranslateX: function (e, t) {
        (e += this.cursorPosition), (e = this.options.rightToLeft ? -e : e);
        var i = this.getPositionValue(e);
        this.slider.style.transform = t
          ? "translate3d(" + i + ",0,0)"
          : "translateX(" + i + ")";
      },
      dispatchScrollEvent: function () {
        var e = this.slides[0];
        if (e) {
          var t = -this.x - e.target,
            i = t / this.slidesWidth;
          this.dispatchEvent("scroll", null, [i, t]);
        }
      },
      positionSliderAtSelected: function () {
        this.cells.length &&
          ((this.x = -this.selectedSlide.target),
          (this.velocity = 0),
          this.positionSlider());
      },
      getPositionValue: function (e) {
        return this.options.percentPosition
          ? 0.01 * Math.round((e / this.size.innerWidth) * 1e4) + "%"
          : Math.round(e) + "px";
      },
      settle: function (e) {
        this.isPointerDown ||
          Math.round(100 * this.x) != Math.round(100 * e) ||
          this.restingFrames++,
          2 < this.restingFrames &&
            ((this.isAnimating = !1),
            delete this.isFreeScrolling,
            this.positionSlider(),
            this.dispatchEvent("settle", null, [this.selectedIndex]));
      },
      shiftWrapCells: function (e) {
        var t = this.cursorPosition + e;
        this._shiftCells(this.beforeShiftCells, t, -1);
        var i =
          this.size.innerWidth -
          (e + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, i, 1);
      },
      _shiftCells: function (e, t, i) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n],
            r = 0 < t ? i : 0;
          o.wrapShift(r), (t -= o.size.outerWidth);
        }
      },
      _unshiftCells: function (e) {
        if (e && e.length) for (var t = 0; t < e.length; t++) e[t].wrapShift(0);
      },
      integratePhysics: function () {
        (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
      },
      applyForce: function (e) {
        this.velocity += e;
      },
      getFrictionFactor: function () {
        return (
          1 -
          this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        );
      },
      getRestingPosition: function () {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      },
      applyDragForce: function () {
        if (this.isDraggable && this.isPointerDown) {
          var e = this.dragX - this.x - this.velocity;
          this.applyForce(e);
        }
      },
      applySelectedAttraction: function () {
        if (
          (!this.isDraggable || !this.isPointerDown) &&
          !this.isFreeScrolling &&
          this.slides.length
        ) {
          var e =
            (-1 * this.selectedSlide.target - this.x) *
            this.options.selectedAttraction;
          this.applyForce(e);
        }
      },
    };
  }),
  (function (e, t) {
    if ("function" == typeof define && define.amd)
      define("flickity/js/flickity", [
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate",
      ], function (i, n, o, r, s, a) {
        return t(e, i, n, o, r, s, a);
      });
    else if ("object" == typeof module && module.exports)
      module.exports = t(
        e,
        require("ev-emitter"),
        require("get-size"),
        require("fizzy-ui-utils"),
        require("./cell"),
        require("./slide"),
        require("./animate")
      );
    else {
      var i = e.Flickity;
      e.Flickity = t(
        e,
        e.EvEmitter,
        e.getSize,
        e.fizzyUIUtils,
        i.Cell,
        i.Slide,
        i.animatePrototype
      );
    }
  })(window, function (e, t, i, n, o, r, s) {
    var a = e.jQuery,
      l = e.getComputedStyle,
      c = e.console;
    function d(e, t) {
      for (e = n.makeArray(e); e.length; ) t.appendChild(e.shift());
    }
    var u = 0,
      p = {};
    function h(e, t) {
      var i = n.getQueryElement(e);
      if (i) {
        if (((this.element = i), this.element.flickityGUID)) {
          var o = p[this.element.flickityGUID];
          return o.option(t), o;
        }
        a && (this.$element = a(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          this.option(t),
          this._create();
      } else c && c.error("Bad element for Flickity: " + (i || e));
    }
    (h.defaults = {
      accessibility: !0,
      cellAlign: "center",
      freeScrollFriction: 0.075,
      friction: 0.28,
      namespaceJQueryEvents: !0,
      percentPosition: !0,
      resize: !0,
      selectedAttraction: 0.025,
      setGallerySize: !0,
    }),
      (h.createMethods = []);
    var f = h.prototype;
    n.extend(f, t.prototype),
      (f._create = function () {
        var t = (this.guid = ++u);
        for (var i in ((this.element.flickityGUID = t),
        ((p[t] = this).selectedIndex = 0),
        (this.restingFrames = 0),
        (this.x = 0),
        (this.velocity = 0),
        (this.originSide = this.options.rightToLeft ? "right" : "left"),
        (this.viewport = document.createElement("div")),
        (this.viewport.className = "flickity-viewport"),
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) &&
          e.addEventListener("resize", this),
        this.options.on)) {
          var n = this.options.on[i];
          this.on(i, n);
        }
        h.createMethods.forEach(function (e) {
          this[e]();
        }, this),
          this.options.watchCSS ? this.watchCSS() : this.activate();
      }),
      (f.option = function (e) {
        n.extend(this.options, e);
      }),
      (f.activate = function () {
        this.isActive ||
          ((this.isActive = !0),
          this.element.classList.add("flickity-enabled"),
          this.options.rightToLeft &&
            this.element.classList.add("flickity-rtl"),
          this.getSize(),
          d(this._filterFindCellElements(this.element.children), this.slider),
          this.viewport.appendChild(this.slider),
          this.element.appendChild(this.viewport),
          this.reloadCells(),
          this.options.accessibility &&
            ((this.element.tabIndex = 0),
            this.element.addEventListener("keydown", this)),
          this.emitEvent("activate"),
          this.selectInitialIndex(),
          (this.isInitActivated = !0),
          this.dispatchEvent("ready"));
      }),
      (f._createSlider = function () {
        var e = document.createElement("div");
        (e.className = "flickity-slider"),
          (e.style[this.originSide] = 0),
          (this.slider = e);
      }),
      (f._filterFindCellElements = function (e) {
        return n.filterFindElements(e, this.options.cellSelector);
      }),
      (f.reloadCells = function () {
        (this.cells = this._makeCells(this.slider.children)),
          this.positionCells(),
          this._getWrapShiftCells(),
          this.setGallerySize();
      }),
      (f._makeCells = function (e) {
        return this._filterFindCellElements(e).map(function (e) {
          return new o(e, this);
        }, this);
      }),
      (f.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (f.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
      }),
      (f.positionCells = function () {
        this._sizeCells(this.cells), this._positionCells(0);
      }),
      (f._positionCells = function (e) {
        (e = e || 0), (this.maxCellHeight = (e && this.maxCellHeight) || 0);
        var t = 0;
        if (0 < e) {
          var i = this.cells[e - 1];
          t = i.x + i.size.outerWidth;
        }
        for (var n = this.cells.length, o = e; o < n; o++) {
          var r = this.cells[o];
          r.setPosition(t),
            (t += r.size.outerWidth),
            (this.maxCellHeight = Math.max(
              r.size.outerHeight,
              this.maxCellHeight
            ));
        }
        (this.slideableWidth = t),
          this.updateSlides(),
          this._containSlides(),
          (this.slidesWidth = n
            ? this.getLastSlide().target - this.slides[0].target
            : 0);
      }),
      (f._sizeCells = function (e) {
        e.forEach(function (e) {
          e.getSize();
        });
      }),
      (f.updateSlides = function () {
        if (((this.slides = []), this.cells.length)) {
          var e = new r(this);
          this.slides.push(e);
          var t = "left" == this.originSide ? "marginRight" : "marginLeft",
            i = this._getCanCellFit();
          this.cells.forEach(function (n, o) {
            if (e.cells.length) {
              var s =
                e.outerWidth - e.firstMargin + (n.size.outerWidth - n.size[t]);
              i.call(this, o, s) ||
                (e.updateTarget(), (e = new r(this)), this.slides.push(e)),
                e.addCell(n);
            } else e.addCell(n);
          }, this),
            e.updateTarget(),
            this.updateSelectedSlide();
        }
      }),
      (f._getCanCellFit = function () {
        var e = this.options.groupCells;
        if (!e)
          return function () {
            return !1;
          };
        if ("number" == typeof e) {
          var t = parseInt(e, 10);
          return function (e) {
            return e % t != 0;
          };
        }
        var i = "string" == typeof e && e.match(/^(\d+)%$/),
          n = i ? parseInt(i[1], 10) / 100 : 1;
        return function (e, t) {
          return t <= (this.size.innerWidth + 1) * n;
        };
      }),
      (f._init = f.reposition =
        function () {
          this.positionCells(), this.positionSliderAtSelected();
        }),
      (f.getSize = function () {
        (this.size = i(this.element)),
          this.setCellAlign(),
          (this.cursorPosition = this.size.innerWidth * this.cellAlign);
      });
    var m = {
      center: { left: 0.5, right: 0.5 },
      left: { left: 0, right: 1 },
      right: { right: 0, left: 1 },
    };
    return (
      (f.setCellAlign = function () {
        var e = m[this.options.cellAlign];
        this.cellAlign = e ? e[this.originSide] : this.options.cellAlign;
      }),
      (f.setGallerySize = function () {
        if (this.options.setGallerySize) {
          var e =
            this.options.adaptiveHeight && this.selectedSlide
              ? this.selectedSlide.height
              : this.maxCellHeight;
          this.viewport.style.height = e + "px";
        }
      }),
      (f._getWrapShiftCells = function () {
        if (this.options.wrapAround) {
          this._unshiftCells(this.beforeShiftCells),
            this._unshiftCells(this.afterShiftCells);
          var e = this.cursorPosition,
            t = this.cells.length - 1;
          (this.beforeShiftCells = this._getGapCells(e, t, -1)),
            (e = this.size.innerWidth - this.cursorPosition),
            (this.afterShiftCells = this._getGapCells(e, 0, 1));
        }
      }),
      (f._getGapCells = function (e, t, i) {
        for (var n = []; 0 < e; ) {
          var o = this.cells[t];
          if (!o) break;
          n.push(o), (t += i), (e -= o.size.outerWidth);
        }
        return n;
      }),
      (f._containSlides = function () {
        if (
          this.options.contain &&
          !this.options.wrapAround &&
          this.cells.length
        ) {
          var e = this.options.rightToLeft,
            t = e ? "marginRight" : "marginLeft",
            i = e ? "marginLeft" : "marginRight",
            n = this.slideableWidth - this.getLastCell().size[i],
            o = n < this.size.innerWidth,
            r = this.cursorPosition + this.cells[0].size[t],
            s = n - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function (e) {
            o
              ? (e.target = n * this.cellAlign)
              : ((e.target = Math.max(e.target, r)),
                (e.target = Math.min(e.target, s)));
          }, this);
        }
      }),
      (f.dispatchEvent = function (e, t, i) {
        var n = t ? [t].concat(i) : i;
        if ((this.emitEvent(e, n), a && this.$element)) {
          var o = (e += this.options.namespaceJQueryEvents ? ".flickity" : "");
          if (t) {
            var r = a.Event(t);
            (r.type = e), (o = r);
          }
          this.$element.trigger(o, i);
        }
      }),
      (f.select = function (e, t, i) {
        if (
          this.isActive &&
          ((e = parseInt(e, 10)),
          this._wrapSelect(e),
          (this.options.wrapAround || t) &&
            (e = n.modulo(e, this.slides.length)),
          this.slides[e])
        ) {
          var o = this.selectedIndex;
          (this.selectedIndex = e),
            this.updateSelectedSlide(),
            i ? this.positionSliderAtSelected() : this.startAnimation(),
            this.options.adaptiveHeight && this.setGallerySize(),
            this.dispatchEvent("select", null, [e]),
            e != o && this.dispatchEvent("change", null, [e]),
            this.dispatchEvent("cellSelect");
        }
      }),
      (f._wrapSelect = function (e) {
        var t = this.slides.length;
        if (!(this.options.wrapAround && 1 < t)) return e;
        var i = n.modulo(e, t),
          o = Math.abs(i - this.selectedIndex),
          r = Math.abs(i + t - this.selectedIndex),
          s = Math.abs(i - t - this.selectedIndex);
        !this.isDragSelect && r < o
          ? (e += t)
          : !this.isDragSelect && s < o && (e -= t),
          e < 0
            ? (this.x -= this.slideableWidth)
            : t <= e && (this.x += this.slideableWidth);
      }),
      (f.previous = function (e, t) {
        this.select(this.selectedIndex - 1, e, t);
      }),
      (f.next = function (e, t) {
        this.select(this.selectedIndex + 1, e, t);
      }),
      (f.updateSelectedSlide = function () {
        var e = this.slides[this.selectedIndex];
        e &&
          (this.unselectSelectedSlide(),
          (this.selectedSlide = e).select(),
          (this.selectedCells = e.cells),
          (this.selectedElements = e.getCellElements()),
          (this.selectedCell = e.cells[0]),
          (this.selectedElement = this.selectedElements[0]));
      }),
      (f.unselectSelectedSlide = function () {
        this.selectedSlide && this.selectedSlide.unselect();
      }),
      (f.selectInitialIndex = function () {
        var e = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
        else {
          if (e && "string" == typeof e && this.queryCell(e))
            return void this.selectCell(e, !1, !0);
          var t = 0;
          e && this.slides[e] && (t = e), this.select(t, !1, !0);
        }
      }),
      (f.selectCell = function (e, t, i) {
        var n = this.queryCell(e);
        if (n) {
          var o = this.getCellSlideIndex(n);
          this.select(o, t, i);
        }
      }),
      (f.getCellSlideIndex = function (e) {
        for (var t = 0; t < this.slides.length; t++)
          if (-1 != this.slides[t].cells.indexOf(e)) return t;
      }),
      (f.getCell = function (e) {
        for (var t = 0; t < this.cells.length; t++) {
          var i = this.cells[t];
          if (i.element == e) return i;
        }
      }),
      (f.getCells = function (e) {
        e = n.makeArray(e);
        var t = [];
        return (
          e.forEach(function (e) {
            var i = this.getCell(e);
            i && t.push(i);
          }, this),
          t
        );
      }),
      (f.getCellElements = function () {
        return this.cells.map(function (e) {
          return e.element;
        });
      }),
      (f.getParentCell = function (e) {
        return (
          this.getCell(e) ||
          ((e = n.getParent(e, ".flickity-slider > *")), this.getCell(e))
        );
      }),
      (f.getAdjacentCellElements = function (e, t) {
        if (!e) return this.selectedSlide.getCellElements();
        t = void 0 === t ? this.selectedIndex : t;
        var i = this.slides.length;
        if (i <= 1 + 2 * e) return this.getCellElements();
        for (var o = [], r = t - e; r <= t + e; r++) {
          var s = this.options.wrapAround ? n.modulo(r, i) : r,
            a = this.slides[s];
          a && (o = o.concat(a.getCellElements()));
        }
        return o;
      }),
      (f.queryCell = function (e) {
        if ("number" == typeof e) return this.cells[e];
        if ("string" == typeof e) {
          if (e.match(/^[#\.]?[\d\/]/)) return;
          e = this.element.querySelector(e);
        }
        return this.getCell(e);
      }),
      (f.uiChange = function () {
        this.emitEvent("uiChange");
      }),
      (f.childUIPointerDown = function (e) {
        "touchstart" != e.type && e.preventDefault(), this.focus();
      }),
      (f.onresize = function () {
        this.watchCSS(), this.resize();
      }),
      n.debounceMethod(h, "onresize", 150),
      (f.resize = function () {
        if (this.isActive) {
          this.getSize(),
            this.options.wrapAround &&
              (this.x = n.modulo(this.x, this.slideableWidth)),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize(),
            this.emitEvent("resize");
          var e = this.selectedElements && this.selectedElements[0];
          this.selectCell(e, !1, !0);
        }
      }),
      (f.watchCSS = function () {
        this.options.watchCSS &&
          (-1 != l(this.element, ":after").content.indexOf("flickity")
            ? this.activate()
            : this.deactivate());
      }),
      (f.onkeydown = function (e) {
        var t =
          document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !t) {
          var i = h.keyboardHandlers[e.keyCode];
          i && i.call(this);
        }
      }),
      (h.keyboardHandlers = {
        37: function () {
          var e = this.options.rightToLeft ? "next" : "previous";
          this.uiChange(), this[e]();
        },
        39: function () {
          var e = this.options.rightToLeft ? "previous" : "next";
          this.uiChange(), this[e]();
        },
      }),
      (f.focus = function () {
        var t = e.pageYOffset;
        this.element.focus({ preventScroll: !0 }),
          e.pageYOffset != t && e.scrollTo(e.pageXOffset, t);
      }),
      (f.deactivate = function () {
        this.isActive &&
          (this.element.classList.remove("flickity-enabled"),
          this.element.classList.remove("flickity-rtl"),
          this.unselectSelectedSlide(),
          this.cells.forEach(function (e) {
            e.destroy();
          }),
          this.element.removeChild(this.viewport),
          d(this.slider.children, this.element),
          this.options.accessibility &&
            (this.element.removeAttribute("tabIndex"),
            this.element.removeEventListener("keydown", this)),
          (this.isActive = !1),
          this.emitEvent("deactivate"));
      }),
      (f.destroy = function () {
        this.deactivate(),
          e.removeEventListener("resize", this),
          this.allOff(),
          this.emitEvent("destroy"),
          a && this.$element && a.removeData(this.element, "flickity"),
          delete this.element.flickityGUID,
          delete p[this.guid];
      }),
      n.extend(f, s),
      (h.data = function (e) {
        var t = (e = n.getQueryElement(e)) && e.flickityGUID;
        return t && p[t];
      }),
      n.htmlInit(h, "flickity"),
      a && a.bridget && a.bridget("flickity", h),
      (h.setJQuery = function (e) {
        a = e;
      }),
      (h.Cell = o),
      (h.Slide = r),
      h
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "unipointer/unipointer",
          ["ev-emitter/ev-emitter"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("ev-emitter")))
      : (e.Unipointer = t(e, e.EvEmitter));
  })(window, function (e, t) {
    function i() {}
    var n = (i.prototype = Object.create(t.prototype));
    (n.bindStartEvent = function (e) {
      this._bindStartEvent(e, !0);
    }),
      (n.unbindStartEvent = function (e) {
        this._bindStartEvent(e, !1);
      }),
      (n._bindStartEvent = function (t, i) {
        var n = (i = void 0 === i || i)
            ? "addEventListener"
            : "removeEventListener",
          o = "mousedown";
        e.PointerEvent
          ? (o = "pointerdown")
          : "ontouchstart" in e && (o = "touchstart"),
          t[n](o, this);
      }),
      (n.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (n.getTouch = function (e) {
        for (var t = 0; t < e.length; t++) {
          var i = e[t];
          if (i.identifier == this.pointerIdentifier) return i;
        }
      }),
      (n.onmousedown = function (e) {
        var t = e.button;
        (t && 0 !== t && 1 !== t) || this._pointerDown(e, e);
      }),
      (n.ontouchstart = function (e) {
        this._pointerDown(e, e.changedTouches[0]);
      }),
      (n.onpointerdown = function (e) {
        this._pointerDown(e, e);
      }),
      (n._pointerDown = function (e, t) {
        e.button ||
          this.isPointerDown ||
          ((this.isPointerDown = !0),
          (this.pointerIdentifier =
            void 0 !== t.pointerId ? t.pointerId : t.identifier),
          this.pointerDown(e, t));
      }),
      (n.pointerDown = function (e, t) {
        this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]);
      });
    var o = {
      mousedown: ["mousemove", "mouseup"],
      touchstart: ["touchmove", "touchend", "touchcancel"],
      pointerdown: ["pointermove", "pointerup", "pointercancel"],
    };
    return (
      (n._bindPostStartEvents = function (t) {
        if (t) {
          var i = o[t.type];
          i.forEach(function (t) {
            e.addEventListener(t, this);
          }, this),
            (this._boundPointerEvents = i);
        }
      }),
      (n._unbindPostStartEvents = function () {
        this._boundPointerEvents &&
          (this._boundPointerEvents.forEach(function (t) {
            e.removeEventListener(t, this);
          }, this),
          delete this._boundPointerEvents);
      }),
      (n.onmousemove = function (e) {
        this._pointerMove(e, e);
      }),
      (n.onpointermove = function (e) {
        e.pointerId == this.pointerIdentifier && this._pointerMove(e, e);
      }),
      (n.ontouchmove = function (e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerMove(e, t);
      }),
      (n._pointerMove = function (e, t) {
        this.pointerMove(e, t);
      }),
      (n.pointerMove = function (e, t) {
        this.emitEvent("pointerMove", [e, t]);
      }),
      (n.onmouseup = function (e) {
        this._pointerUp(e, e);
      }),
      (n.onpointerup = function (e) {
        e.pointerId == this.pointerIdentifier && this._pointerUp(e, e);
      }),
      (n.ontouchend = function (e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerUp(e, t);
      }),
      (n._pointerUp = function (e, t) {
        this._pointerDone(), this.pointerUp(e, t);
      }),
      (n.pointerUp = function (e, t) {
        this.emitEvent("pointerUp", [e, t]);
      }),
      (n._pointerDone = function () {
        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
      }),
      (n._pointerReset = function () {
        (this.isPointerDown = !1), delete this.pointerIdentifier;
      }),
      (n.pointerDone = function () {}),
      (n.onpointercancel = function (e) {
        e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e);
      }),
      (n.ontouchcancel = function (e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerCancel(e, t);
      }),
      (n._pointerCancel = function (e, t) {
        this._pointerDone(), this.pointerCancel(e, t);
      }),
      (n.pointerCancel = function (e, t) {
        this.emitEvent("pointerCancel", [e, t]);
      }),
      (i.getPointerPoint = function (e) {
        return { x: e.pageX, y: e.pageY };
      }),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "unidragger/unidragger",
          ["unipointer/unipointer"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("unipointer")))
      : (e.Unidragger = t(e, e.Unipointer));
  })(window, function (e, t) {
    function i() {}
    var n = (i.prototype = Object.create(t.prototype));
    (n.bindHandles = function () {
      this._bindHandles(!0);
    }),
      (n.unbindHandles = function () {
        this._bindHandles(!1);
      }),
      (n._bindHandles = function (t) {
        for (
          var i = (t = void 0 === t || t)
              ? "addEventListener"
              : "removeEventListener",
            n = t ? this._touchActionValue : "",
            o = 0;
          o < this.handles.length;
          o++
        ) {
          var r = this.handles[o];
          this._bindStartEvent(r, t),
            r[i]("click", this),
            e.PointerEvent && (r.style.touchAction = n);
        }
      }),
      (n._touchActionValue = "none"),
      (n.pointerDown = function (e, t) {
        this.okayPointerDown(e) &&
          ((this.pointerDownPointer = t),
          e.preventDefault(),
          this.pointerDownBlur(),
          this._bindPostStartEvents(e),
          this.emitEvent("pointerDown", [e, t]));
      });
    var o = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
      r = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0,
      };
    return (
      (n.okayPointerDown = function (e) {
        var t = o[e.target.nodeName],
          i = r[e.target.type],
          n = !t || i;
        return n || this._pointerReset(), n;
      }),
      (n.pointerDownBlur = function () {
        var e = document.activeElement;
        e && e.blur && e != document.body && e.blur();
      }),
      (n.pointerMove = function (e, t) {
        var i = this._dragPointerMove(e, t);
        this.emitEvent("pointerMove", [e, t, i]), this._dragMove(e, t, i);
      }),
      (n._dragPointerMove = function (e, t) {
        var i = {
          x: t.pageX - this.pointerDownPointer.pageX,
          y: t.pageY - this.pointerDownPointer.pageY,
        };
        return (
          !this.isDragging && this.hasDragStarted(i) && this._dragStart(e, t), i
        );
      }),
      (n.hasDragStarted = function (e) {
        return 3 < Math.abs(e.x) || 3 < Math.abs(e.y);
      }),
      (n.pointerUp = function (e, t) {
        this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t);
      }),
      (n._dragPointerUp = function (e, t) {
        this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t);
      }),
      (n._dragStart = function (e, t) {
        (this.isDragging = !0),
          (this.isPreventingClicks = !0),
          this.dragStart(e, t);
      }),
      (n.dragStart = function (e, t) {
        this.emitEvent("dragStart", [e, t]);
      }),
      (n._dragMove = function (e, t, i) {
        this.isDragging && this.dragMove(e, t, i);
      }),
      (n.dragMove = function (e, t, i) {
        e.preventDefault(), this.emitEvent("dragMove", [e, t, i]);
      }),
      (n._dragEnd = function (e, t) {
        (this.isDragging = !1),
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          ),
          this.dragEnd(e, t);
      }),
      (n.dragEnd = function (e, t) {
        this.emitEvent("dragEnd", [e, t]);
      }),
      (n.onclick = function (e) {
        this.isPreventingClicks && e.preventDefault();
      }),
      (n._staticClick = function (e, t) {
        (this.isIgnoringMouseUp && "mouseup" == e.type) ||
          (this.staticClick(e, t),
          "mouseup" != e.type &&
            ((this.isIgnoringMouseUp = !0),
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            )));
      }),
      (n.staticClick = function (e, t) {
        this.emitEvent("staticClick", [e, t]);
      }),
      (i.getPointerPoint = t.getPointerPoint),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/drag",
          ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return t(e, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("unidragger"),
          require("fizzy-ui-utils")
        ))
      : (e.Flickity = t(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
  })(window, function (e, t, i, n) {
    n.extend(t.defaults, { draggable: ">1", dragThreshold: 3 }),
      t.createMethods.push("_createDrag");
    var o = t.prototype;
    n.extend(o, i.prototype), (o._touchActionValue = "pan-y");
    var r = "createTouch" in document,
      s = !1;
    (o._createDrag = function () {
      this.on("activate", this.onActivateDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("deactivate", this.onDeactivateDrag),
        this.on("cellChange", this.updateDraggable),
        r && !s && (e.addEventListener("touchmove", function () {}), (s = !0));
    }),
      (o.onActivateDrag = function () {
        (this.handles = [this.viewport]),
          this.bindHandles(),
          this.updateDraggable();
      }),
      (o.onDeactivateDrag = function () {
        this.unbindHandles(), this.element.classList.remove("is-draggable");
      }),
      (o.updateDraggable = function () {
        ">1" == this.options.draggable
          ? (this.isDraggable = 1 < this.slides.length)
          : (this.isDraggable = this.options.draggable),
          this.isDraggable
            ? this.element.classList.add("is-draggable")
            : this.element.classList.remove("is-draggable");
      }),
      (o.bindDrag = function () {
        (this.options.draggable = !0), this.updateDraggable();
      }),
      (o.unbindDrag = function () {
        (this.options.draggable = !1), this.updateDraggable();
      }),
      (o._uiChangeDrag = function () {
        delete this.isFreeScrolling;
      }),
      (o.pointerDown = function (t, i) {
        this.isDraggable
          ? this.okayPointerDown(t) &&
            (this._pointerDownPreventDefault(t),
            this.pointerDownFocus(t),
            document.activeElement != this.element && this.pointerDownBlur(),
            (this.dragX = this.x),
            this.viewport.classList.add("is-pointer-down"),
            (this.pointerDownScroll = l()),
            e.addEventListener("scroll", this),
            this._pointerDownDefault(t, i))
          : this._pointerDownDefault(t, i);
      }),
      (o._pointerDownDefault = function (e, t) {
        (this.pointerDownPointer = { pageX: t.pageX, pageY: t.pageY }),
          this._bindPostStartEvents(e),
          this.dispatchEvent("pointerDown", e, [t]);
      });
    var a = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
    function l() {
      return { x: e.pageXOffset, y: e.pageYOffset };
    }
    return (
      (o.pointerDownFocus = function (e) {
        a[e.target.nodeName] || this.focus();
      }),
      (o._pointerDownPreventDefault = function (e) {
        var t = "touchstart" == e.type,
          i = "touch" == e.pointerType,
          n = a[e.target.nodeName];
        t || i || n || e.preventDefault();
      }),
      (o.hasDragStarted = function (e) {
        return Math.abs(e.x) > this.options.dragThreshold;
      }),
      (o.pointerUp = function (e, t) {
        delete this.isTouchScrolling,
          this.viewport.classList.remove("is-pointer-down"),
          this.dispatchEvent("pointerUp", e, [t]),
          this._dragPointerUp(e, t);
      }),
      (o.pointerDone = function () {
        e.removeEventListener("scroll", this), delete this.pointerDownScroll;
      }),
      (o.dragStart = function (t, i) {
        this.isDraggable &&
          ((this.dragStartPosition = this.x),
          this.startAnimation(),
          e.removeEventListener("scroll", this),
          this.dispatchEvent("dragStart", t, [i]));
      }),
      (o.pointerMove = function (e, t) {
        var i = this._dragPointerMove(e, t);
        this.dispatchEvent("pointerMove", e, [t, i]), this._dragMove(e, t, i);
      }),
      (o.dragMove = function (e, t, i) {
        if (this.isDraggable) {
          e.preventDefault();
          var n = this.options.rightToLeft ? -1 : 1;
          this.options.wrapAround && (i.x = i.x % this.slideableWidth);
          var o = this.dragStartPosition + i.x * n;
          if (!this.options.wrapAround && this.slides.length) {
            var r = Math.max(-this.slides[0].target, this.dragStartPosition);
            o = r < o ? 0.5 * (o + r) : o;
            var s = Math.min(
              -this.getLastSlide().target,
              this.dragStartPosition
            );
            o = o < s ? 0.5 * (o + s) : o;
          }
          this.dragX !== o && (this.previousDragX = this.dragX),
            (this.dragX = o),
            (this.dragMoveTime = new Date()),
            this.dispatchEvent("dragMove", e, [t, i]);
        }
      }),
      (o.dragEnd = function (e, t) {
        if (this.isDraggable) {
          this.options.freeScroll && (this.isFreeScrolling = !0);
          var i = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            var n = this.getRestingPosition();
            this.isFreeScrolling =
              -n > this.slides[0].target && -n < this.getLastSlide().target;
          } else
            this.options.freeScroll ||
              i != this.selectedIndex ||
              (i += this.dragEndBoostSelect());
          delete this.previousDragX,
            (this.isDragSelect = this.options.wrapAround),
            this.select(i),
            delete this.isDragSelect,
            this.dispatchEvent("dragEnd", e, [t]);
        }
      }),
      (o.dragEndRestingSelect = function () {
        var e = this.getRestingPosition(),
          t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
          i = this._getClosestResting(e, t, 1),
          n = this._getClosestResting(e, t, -1);
        return i.distance < n.distance ? i.index : n.index;
      }),
      (o._getClosestResting = function (e, t, i) {
        for (
          var n = this.selectedIndex,
            o = 1 / 0,
            r =
              this.options.contain && !this.options.wrapAround
                ? function (e, t) {
                    return e <= t;
                  }
                : function (e, t) {
                    return e < t;
                  };
          r(t, o) &&
          ((n += i), (o = t), null !== (t = this.getSlideDistance(-e, n)));

        )
          t = Math.abs(t);
        return { distance: o, index: n - i };
      }),
      (o.getSlideDistance = function (e, t) {
        var i = this.slides.length,
          o = this.options.wrapAround && 1 < i,
          r = o ? n.modulo(t, i) : t,
          s = this.slides[r];
        if (!s) return null;
        var a = o ? this.slideableWidth * Math.floor(t / i) : 0;
        return e - (s.target + a);
      }),
      (o.dragEndBoostSelect = function () {
        if (
          void 0 === this.previousDragX ||
          !this.dragMoveTime ||
          100 < new Date() - this.dragMoveTime
        )
          return 0;
        var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
          t = this.previousDragX - this.dragX;
        return 0 < e && 0 < t ? 1 : e < 0 && t < 0 ? -1 : 0;
      }),
      (o.staticClick = function (e, t) {
        var i = this.getParentCell(e.target),
          n = i && i.element,
          o = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", e, [t, n, o]);
      }),
      (o.onscroll = function () {
        var e = l(),
          t = this.pointerDownScroll.x - e.x,
          i = this.pointerDownScroll.y - e.y;
        (3 < Math.abs(t) || 3 < Math.abs(i)) && this._pointerDone();
      }),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/prev-next-button",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return t(e, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
  })(window, function (e, t, i, n) {
    "use strict";
    var o = "http://www.w3.org/2000/svg";
    function r(e, t) {
      (this.direction = e), (this.parent = t), this._create();
    }
    ((r.prototype = Object.create(i.prototype))._create = function () {
      (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
      var e = this.parent.options.rightToLeft ? 1 : -1;
      this.isLeft = this.direction == e;
      var t = (this.element = document.createElement("button"));
      (t.className = "flickity-button flickity-prev-next-button"),
        (t.className += this.isPrevious ? " previous" : " next"),
        t.setAttribute("type", "button"),
        this.disable(),
        t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
      var i = this.createSVG();
      t.appendChild(i),
        this.parent.on("select", this.update.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (r.prototype.activate = function () {
        this.bindStartEvent(this.element),
          this.element.addEventListener("click", this),
          this.parent.element.appendChild(this.element);
      }),
      (r.prototype.deactivate = function () {
        this.parent.element.removeChild(this.element),
          this.unbindStartEvent(this.element),
          this.element.removeEventListener("click", this);
      }),
      (r.prototype.createSVG = function () {
        var e = document.createElementNS(o, "svg");
        e.setAttribute("class", "flickity-button-icon"),
          e.setAttribute("viewBox", "0 0 100 100");
        var t,
          i = document.createElementNS(o, "path"),
          n =
            "string" != typeof (t = this.parent.options.arrowShape)
              ? "M " +
                t.x0 +
                ",50 L " +
                t.x1 +
                "," +
                (t.y1 + 50) +
                " L " +
                t.x2 +
                "," +
                (t.y2 + 50) +
                " L " +
                t.x3 +
                ",50  L " +
                t.x2 +
                "," +
                (50 - t.y2) +
                " L " +
                t.x1 +
                "," +
                (50 - t.y1) +
                " Z"
              : t;
        return (
          i.setAttribute("d", n),
          i.setAttribute("class", "arrow"),
          this.isLeft ||
            i.setAttribute("transform", "translate(100, 100) rotate(180) "),
          e.appendChild(i),
          e
        );
      }),
      (r.prototype.handleEvent = n.handleEvent),
      (r.prototype.onclick = function () {
        if (this.isEnabled) {
          this.parent.uiChange();
          var e = this.isPrevious ? "previous" : "next";
          this.parent[e]();
        }
      }),
      (r.prototype.enable = function () {
        this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
      }),
      (r.prototype.disable = function () {
        this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
      }),
      (r.prototype.update = function () {
        var e = this.parent.slides;
        if (this.parent.options.wrapAround && 1 < e.length) this.enable();
        else {
          var t = e.length ? e.length - 1 : 0,
            i = this.isPrevious ? 0 : t;
          this[this.parent.selectedIndex == i ? "disable" : "enable"]();
        }
      }),
      (r.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      n.extend(t.defaults, {
        prevNextButtons: !0,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
      }),
      t.createMethods.push("_createPrevNextButtons");
    var s = t.prototype;
    return (
      (s._createPrevNextButtons = function () {
        this.options.prevNextButtons &&
          ((this.prevButton = new r(-1, this)),
          (this.nextButton = new r(1, this)),
          this.on("activate", this.activatePrevNextButtons));
      }),
      (s.activatePrevNextButtons = function () {
        this.prevButton.activate(),
          this.nextButton.activate(),
          this.on("deactivate", this.deactivatePrevNextButtons);
      }),
      (s.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate(),
          this.nextButton.deactivate(),
          this.off("deactivate", this.deactivatePrevNextButtons);
      }),
      (t.PrevNextButton = r),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/page-dots",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return t(e, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
  })(window, function (e, t, i, n) {
    function o(e) {
      (this.parent = e), this._create();
    }
    ((o.prototype = Object.create(i.prototype))._create = function () {
      (this.holder = document.createElement("ol")),
        (this.holder.className = "flickity-page-dots"),
        (this.dots = []),
        (this.handleClick = this.onClick.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (o.prototype.activate = function () {
        this.setDots(),
          this.holder.addEventListener("click", this.handleClick),
          this.bindStartEvent(this.holder),
          this.parent.element.appendChild(this.holder);
      }),
      (o.prototype.deactivate = function () {
        this.holder.removeEventListener("click", this.handleClick),
          this.unbindStartEvent(this.holder),
          this.parent.element.removeChild(this.holder);
      }),
      (o.prototype.setDots = function () {
        var e = this.parent.slides.length - this.dots.length;
        0 < e ? this.addDots(e) : e < 0 && this.removeDots(-e);
      }),
      (o.prototype.addDots = function (e) {
        for (
          var t = document.createDocumentFragment(),
            i = [],
            n = this.dots.length,
            o = n + e,
            r = n;
          r < o;
          r++
        ) {
          var s = document.createElement("li");
          (s.className = "dot"),
            s.setAttribute("aria-label", "Page dot " + (r + 1)),
            t.appendChild(s),
            i.push(s);
        }
        this.holder.appendChild(t), (this.dots = this.dots.concat(i));
      }),
      (o.prototype.removeDots = function (e) {
        this.dots.splice(this.dots.length - e, e).forEach(function (e) {
          this.holder.removeChild(e);
        }, this);
      }),
      (o.prototype.updateSelected = function () {
        this.selectedDot &&
          ((this.selectedDot.className = "dot"),
          this.selectedDot.removeAttribute("aria-current")),
          this.dots.length &&
            ((this.selectedDot = this.dots[this.parent.selectedIndex]),
            (this.selectedDot.className = "dot is-selected"),
            this.selectedDot.setAttribute("aria-current", "step"));
      }),
      (o.prototype.onTap = o.prototype.onClick =
        function (e) {
          var t = e.target;
          if ("LI" == t.nodeName) {
            this.parent.uiChange();
            var i = this.dots.indexOf(t);
            this.parent.select(i);
          }
        }),
      (o.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      (t.PageDots = o),
      n.extend(t.defaults, { pageDots: !0 }),
      t.createMethods.push("_createPageDots");
    var r = t.prototype;
    return (
      (r._createPageDots = function () {
        this.options.pageDots &&
          ((this.pageDots = new o(this)),
          this.on("activate", this.activatePageDots),
          this.on("select", this.updateSelectedPageDots),
          this.on("cellChange", this.updatePageDots),
          this.on("resize", this.updatePageDots),
          this.on("deactivate", this.deactivatePageDots));
      }),
      (r.activatePageDots = function () {
        this.pageDots.activate();
      }),
      (r.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
      }),
      (r.updatePageDots = function () {
        this.pageDots.setDots();
      }),
      (r.deactivatePageDots = function () {
        this.pageDots.deactivate();
      }),
      (t.PageDots = o),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/player",
          ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"],
          function (e, i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          require("ev-emitter"),
          require("fizzy-ui-utils"),
          require("./flickity")
        ))
      : t(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
  })(window, function (e, t, i) {
    function n(e) {
      (this.parent = e),
        (this.state = "stopped"),
        (this.onVisibilityChange = this.visibilityChange.bind(this)),
        (this.onVisibilityPlay = this.visibilityPlay.bind(this));
    }
    ((n.prototype = Object.create(e.prototype)).play = function () {
      "playing" != this.state &&
        (document.hidden
          ? document.addEventListener("visibilitychange", this.onVisibilityPlay)
          : ((this.state = "playing"),
            document.addEventListener(
              "visibilitychange",
              this.onVisibilityChange
            ),
            this.tick()));
    }),
      (n.prototype.tick = function () {
        if ("playing" == this.state) {
          var e = this.parent.options.autoPlay;
          e = "number" == typeof e ? e : 3e3;
          var t = this;
          this.clear(),
            (this.timeout = setTimeout(function () {
              t.parent.next(!0), t.tick();
            }, e));
        }
      }),
      (n.prototype.stop = function () {
        (this.state = "stopped"),
          this.clear(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityChange
          );
      }),
      (n.prototype.clear = function () {
        clearTimeout(this.timeout);
      }),
      (n.prototype.pause = function () {
        "playing" == this.state && ((this.state = "paused"), this.clear());
      }),
      (n.prototype.unpause = function () {
        "paused" == this.state && this.play();
      }),
      (n.prototype.visibilityChange = function () {
        this[document.hidden ? "pause" : "unpause"]();
      }),
      (n.prototype.visibilityPlay = function () {
        this.play(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityPlay
          );
      }),
      t.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
      i.createMethods.push("_createPlayer");
    var o = i.prototype;
    return (
      (o._createPlayer = function () {
        (this.player = new n(this)),
          this.on("activate", this.activatePlayer),
          this.on("uiChange", this.stopPlayer),
          this.on("pointerDown", this.stopPlayer),
          this.on("deactivate", this.deactivatePlayer);
      }),
      (o.activatePlayer = function () {
        this.options.autoPlay &&
          (this.player.play(),
          this.element.addEventListener("mouseenter", this));
      }),
      (o.playPlayer = function () {
        this.player.play();
      }),
      (o.stopPlayer = function () {
        this.player.stop();
      }),
      (o.pausePlayer = function () {
        this.player.pause();
      }),
      (o.unpausePlayer = function () {
        this.player.unpause();
      }),
      (o.deactivatePlayer = function () {
        this.player.stop(),
          this.element.removeEventListener("mouseenter", this);
      }),
      (o.onmouseenter = function () {
        this.options.pauseAutoPlayOnHover &&
          (this.player.pause(),
          this.element.addEventListener("mouseleave", this));
      }),
      (o.onmouseleave = function () {
        this.player.unpause(),
          this.element.removeEventListener("mouseleave", this);
      }),
      (i.Player = n),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/add-remove-cell",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.fizzyUIUtils);
  })(window, function (e, t, i) {
    var n = t.prototype;
    return (
      (n.insert = function (e, t) {
        var i = this._makeCells(e);
        if (i && i.length) {
          var n = this.cells.length;
          t = void 0 === t ? n : t;
          var o,
            r,
            s =
              ((o = i),
              (r = document.createDocumentFragment()),
              o.forEach(function (e) {
                r.appendChild(e.element);
              }),
              r),
            a = t == n;
          if (a) this.slider.appendChild(s);
          else {
            var l = this.cells[t].element;
            this.slider.insertBefore(s, l);
          }
          if (0 === t) this.cells = i.concat(this.cells);
          else if (a) this.cells = this.cells.concat(i);
          else {
            var c = this.cells.splice(t, n - t);
            this.cells = this.cells.concat(i).concat(c);
          }
          this._sizeCells(i), this.cellChange(t, !0);
        }
      }),
      (n.append = function (e) {
        this.insert(e, this.cells.length);
      }),
      (n.prepend = function (e) {
        this.insert(e, 0);
      }),
      (n.remove = function (e) {
        var t = this.getCells(e);
        if (t && t.length) {
          var n = this.cells.length - 1;
          t.forEach(function (e) {
            e.remove();
            var t = this.cells.indexOf(e);
            (n = Math.min(t, n)), i.removeFrom(this.cells, e);
          }, this),
            this.cellChange(n, !0);
        }
      }),
      (n.cellSizeChange = function (e) {
        var t = this.getCell(e);
        if (t) {
          t.getSize();
          var i = this.cells.indexOf(t);
          this.cellChange(i);
        }
      }),
      (n.cellChange = function (e, t) {
        var i = this.selectedElement;
        this._positionCells(e),
          this._getWrapShiftCells(),
          this.setGallerySize();
        var n = this.getCell(i);
        n && (this.selectedIndex = this.getCellSlideIndex(n)),
          (this.selectedIndex = Math.min(
            this.slides.length - 1,
            this.selectedIndex
          )),
          this.emitEvent("cellChange", [e]),
          this.select(this.selectedIndex),
          t && this.positionSliderAtSelected();
      }),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/lazyload",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.fizzyUIUtils);
  })(window, function (e, t, i) {
    "use strict";
    t.createMethods.push("_createLazyload");
    var n = t.prototype;
    function o(e, t) {
      (this.img = e), (this.flickity = t), this.load();
    }
    return (
      (n._createLazyload = function () {
        this.on("select", this.lazyLoad);
      }),
      (n.lazyLoad = function () {
        var e = this.options.lazyLoad;
        if (e) {
          var t = "number" == typeof e ? e : 0,
            n = this.getAdjacentCellElements(t),
            r = [];
          n.forEach(function (e) {
            var t = (function (e) {
              if ("IMG" == e.nodeName) {
                var t = e.getAttribute("data-flickity-lazyload"),
                  n = e.getAttribute("data-flickity-lazyload-src"),
                  o = e.getAttribute("data-flickity-lazyload-srcset");
                if (t || n || o) return [e];
              }
              var r = e.querySelectorAll(
                "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]"
              );
              return i.makeArray(r);
            })(e);
            r = r.concat(t);
          }),
            r.forEach(function (e) {
              new o(e, this);
            }, this);
        }
      }),
      (o.prototype.handleEvent = i.handleEvent),
      (o.prototype.load = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this);
        var e =
            this.img.getAttribute("data-flickity-lazyload") ||
            this.img.getAttribute("data-flickity-lazyload-src"),
          t = this.img.getAttribute("data-flickity-lazyload-srcset");
        (this.img.src = e),
          t && this.img.setAttribute("srcset", t),
          this.img.removeAttribute("data-flickity-lazyload"),
          this.img.removeAttribute("data-flickity-lazyload-src"),
          this.img.removeAttribute("data-flickity-lazyload-srcset");
      }),
      (o.prototype.onload = function (e) {
        this.complete(e, "flickity-lazyloaded");
      }),
      (o.prototype.onerror = function (e) {
        this.complete(e, "flickity-lazyerror");
      }),
      (o.prototype.complete = function (e, t) {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
        var i = this.flickity.getParentCell(this.img),
          n = i && i.element;
        this.flickity.cellSizeChange(n),
          this.img.classList.add(t),
          this.flickity.dispatchEvent("lazyLoad", e, n);
      }),
      (t.LazyLoader = o),
      t
    );
  }),
  (function (e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/index",
          [
            "./flickity",
            "./drag",
            "./prev-next-button",
            "./page-dots",
            "./player",
            "./add-remove-cell",
            "./lazyload",
          ],
          e
        )
      : "object" == typeof module &&
        module.exports &&
        (module.exports = e(
          require("./flickity"),
          require("./drag"),
          require("./prev-next-button"),
          require("./page-dots"),
          require("./player"),
          require("./add-remove-cell"),
          require("./lazyload")
        ));
  })(
    (window,
    function (e) {
      return e;
    })
  ),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity-as-nav-for/as-nav-for",
          ["flickity/js/index", "fizzy-ui-utils/utils"],
          t
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(require("flickity"), require("fizzy-ui-utils")))
      : (e.Flickity = t(e.Flickity, e.fizzyUIUtils));
  })(window, function (e, t) {
    e.createMethods.push("_createAsNavFor");
    var i = e.prototype;
    return (
      (i._createAsNavFor = function () {
        this.on("activate", this.activateAsNavFor),
          this.on("deactivate", this.deactivateAsNavFor),
          this.on("destroy", this.destroyAsNavFor);
        var e = this.options.asNavFor;
        if (e) {
          var t = this;
          setTimeout(function () {
            t.setNavCompanion(e);
          });
        }
      }),
      (i.setNavCompanion = function (i) {
        i = t.getQueryElement(i);
        var n = e.data(i);
        if (n && n != this) {
          this.navCompanion = n;
          var o = this;
          (this.onNavCompanionSelect = function () {
            o.navCompanionSelect();
          }),
            n.on("select", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect(!0);
        }
      }),
      (i.navCompanionSelect = function (e) {
        var t = this.navCompanion && this.navCompanion.selectedCells;
        if (t) {
          var i,
            n = t[0],
            o = this.navCompanion.cells.indexOf(n),
            r = o + t.length - 1,
            s = Math.floor((r - (i = o)) * this.navCompanion.cellAlign + i);
          if (
            (this.selectCell(s, !1, e),
            this.removeNavSelectedElements(),
            !(s >= this.cells.length))
          ) {
            var a = this.cells.slice(o, 1 + r);
            (this.navSelectedElements = a.map(function (e) {
              return e.element;
            })),
              this.changeNavSelectedClass("add");
          }
        }
      }),
      (i.changeNavSelectedClass = function (e) {
        this.navSelectedElements.forEach(function (t) {
          t.classList[e]("is-nav-selected");
        });
      }),
      (i.activateAsNavFor = function () {
        this.navCompanionSelect(!0);
      }),
      (i.removeNavSelectedElements = function () {
        this.navSelectedElements &&
          (this.changeNavSelectedClass("remove"),
          delete this.navSelectedElements);
      }),
      (i.onNavStaticClick = function (e, t, i, n) {
        "number" == typeof n && this.navCompanion.selectCell(n);
      }),
      (i.deactivateAsNavFor = function () {
        this.removeNavSelectedElements();
      }),
      (i.destroyAsNavFor = function () {
        this.navCompanion &&
          (this.navCompanion.off("select", this.onNavCompanionSelect),
          this.off("staticClick", this.onNavStaticClick),
          delete this.navCompanion);
      }),
      e
    );
  }),
  (function (e, t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(
          "imagesloaded/imagesloaded",
          ["ev-emitter/ev-emitter"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("ev-emitter")))
      : (e.imagesLoaded = t(e, e.EvEmitter));
  })("undefined" != typeof window ? window : this, function (e, t) {
    var i = e.jQuery,
      n = e.console;
    function o(e, t) {
      for (var i in t) e[i] = t[i];
      return e;
    }
    var r = Array.prototype.slice;
    function s(e, t, a) {
      if (!(this instanceof s)) return new s(e, t, a);
      var l,
        c = e;
      "string" == typeof e && (c = document.querySelectorAll(e)),
        c
          ? ((this.elements =
              ((l = c),
              Array.isArray(l)
                ? l
                : "object" == typeof l && "number" == typeof l.length
                ? r.call(l)
                : [l])),
            (this.options = o({}, this.options)),
            "function" == typeof t ? (a = t) : o(this.options, t),
            a && this.on("always", a),
            this.getImages(),
            i && (this.jqDeferred = new i.Deferred()),
            setTimeout(this.check.bind(this)))
          : n.error("Bad element for imagesLoaded " + (c || e));
    }
    ((s.prototype = Object.create(t.prototype)).options = {}),
      (s.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      }),
      (s.prototype.addElementImages = function (e) {
        "IMG" == e.nodeName && this.addImage(e),
          !0 === this.options.background && this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && a[t]) {
          for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
            var o = i[n];
            this.addImage(o);
          }
          if ("string" == typeof this.options.background) {
            var r = e.querySelectorAll(this.options.background);
            for (n = 0; n < r.length; n++) {
              var s = r[n];
              this.addElementBackgroundImages(s);
            }
          }
        }
      });
    var a = { 1: !0, 9: !0, 11: !0 };
    function l(e) {
      this.img = e;
    }
    function c(e, t) {
      (this.url = e), (this.element = t), (this.img = new Image());
    }
    return (
      (s.prototype.addElementBackgroundImages = function (e) {
        var t = getComputedStyle(e);
        if (t)
          for (
            var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage);
            null !== n;

          ) {
            var o = n && n[2];
            o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
          }
      }),
      (s.prototype.addImage = function (e) {
        var t = new l(e);
        this.images.push(t);
      }),
      (s.prototype.addBackground = function (e, t) {
        var i = new c(e, t);
        this.images.push(i);
      }),
      (s.prototype.check = function () {
        var e = this;
        function t(t, i, n) {
          setTimeout(function () {
            e.progress(t, i, n);
          });
        }
        (this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? this.images.forEach(function (e) {
                e.once("progress", t), e.check();
              })
            : this.complete();
      }),
      (s.prototype.progress = function (e, t, i) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
          this.emitEvent("progress", [this, e, t]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, e),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && n && n.log("progress: " + i, e, t);
      }),
      (s.prototype.complete = function () {
        var e = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(e, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          var t = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[t](this);
        }
      }),
      ((l.prototype = Object.create(t.prototype)).check = function () {
        this.getIsImageComplete()
          ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            (this.proxyImage.src = this.img.src));
      }),
      (l.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
      }),
      (l.prototype.confirm = function (e, t) {
        (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
      }),
      (l.prototype.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (l.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (l.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (l.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      ((c.prototype = Object.create(l.prototype)).check = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url),
          this.getIsImageComplete() &&
            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents());
      }),
      (c.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (c.prototype.confirm = function (e, t) {
        (this.isLoaded = e),
          this.emitEvent("progress", [this, this.element, t]);
      }),
      (s.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery) &&
          ((i = t).fn.imagesLoaded = function (e, t) {
            return new s(this, e, t).jqDeferred.promise(i(this));
          });
      })(),
      s
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          ["flickity/js/index", "imagesloaded/imagesloaded"],
          function (i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("flickity"), require("imagesloaded")))
      : (e.Flickity = t(e, e.Flickity, e.imagesLoaded));
  })(window, function (e, t, i) {
    "use strict";
    t.createMethods.push("_createImagesLoaded");
    var n = t.prototype;
    return (
      (n._createImagesLoaded = function () {
        this.on("activate", this.imagesLoaded);
      }),
      (n.imagesLoaded = function () {
        if (this.options.imagesLoaded) {
          var e = this;
          i(this.slider).on("progress", function (t, i) {
            var n = e.getParentCell(i.img);
            e.cellSizeChange(n && n.element),
              e.options.freeScroll || e.positionSliderAtSelected();
          });
        }
      }),
      t
    );
  }),
  (function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (e) {
    "use strict";
    var t = window.Slick || {};
    ((t = (function () {
      var t = 0;
      return function (i, n) {
        var o,
          r = this;
        (r.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: e(i),
          appendDots: e(i),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next" type="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (t, i) {
            return e('<button type="button" />').text(i + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          focusOnChange: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (r.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          e.extend(r, r.initials),
          (r.activeBreakpoint = null),
          (r.animType = null),
          (r.animProp = null),
          (r.breakpoints = []),
          (r.breakpointSettings = []),
          (r.cssTransitions = !1),
          (r.focussed = !1),
          (r.interrupted = !1),
          (r.hidden = "hidden"),
          (r.paused = !0),
          (r.positionProp = null),
          (r.respondTo = null),
          (r.rowCount = 1),
          (r.shouldClick = !0),
          (r.$slider = e(i)),
          (r.$slidesCache = null),
          (r.transformType = null),
          (r.transitionType = null),
          (r.visibilityChange = "visibilitychange"),
          (r.windowWidth = 0),
          (r.windowTimer = null),
          (o = e(i).data("slick") || {}),
          (r.options = e.extend({}, r.defaults, n, o)),
          (r.currentSlide = r.options.initialSlide),
          (r.originalSettings = r.options),
          void 0 !== document.mozHidden
            ? ((r.hidden = "mozHidden"),
              (r.visibilityChange = "mozvisibilitychange"))
            : void 0 !== document.webkitHidden &&
              ((r.hidden = "webkitHidden"),
              (r.visibilityChange = "webkitvisibilitychange")),
          (r.autoPlay = e.proxy(r.autoPlay, r)),
          (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
          (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
          (r.changeSlide = e.proxy(r.changeSlide, r)),
          (r.clickHandler = e.proxy(r.clickHandler, r)),
          (r.selectHandler = e.proxy(r.selectHandler, r)),
          (r.setPosition = e.proxy(r.setPosition, r)),
          (r.swipeHandler = e.proxy(r.swipeHandler, r)),
          (r.dragHandler = e.proxy(r.dragHandler, r)),
          (r.keyHandler = e.proxy(r.keyHandler, r)),
          (r.instanceUid = t++),
          (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          r.registerBreakpoints(),
          r.init(!0);
      };
    })()).prototype.activateADA = function () {
      this.$slideTrack
        .find(".slick-active")
        .attr({ "aria-hidden": "false" })
        .find("a, input, button, select")
        .attr({ tabindex: "0" });
    }),
      (t.prototype.addSlide = t.prototype.slickAdd =
        function (t, i, n) {
          var o = this;
          if ("boolean" == typeof i) (n = i), (i = null);
          else if (i < 0 || i >= o.slideCount) return !1;
          o.unload(),
            "number" == typeof i
              ? 0 === i && 0 === o.$slides.length
                ? e(t).appendTo(o.$slideTrack)
                : n
                ? e(t).insertBefore(o.$slides.eq(i))
                : e(t).insertAfter(o.$slides.eq(i))
              : !0 === n
              ? e(t).prependTo(o.$slideTrack)
              : e(t).appendTo(o.$slideTrack),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            o.$slides.each(function (t, i) {
              e(i).attr("data-slick-index", t);
            }),
            (o.$slidesCache = o.$slides),
            o.reinit();
        }),
      (t.prototype.animateHeight = function () {
        var e = this;
        if (
          1 === e.options.slidesToShow &&
          !0 === e.options.adaptiveHeight &&
          !1 === e.options.vertical
        ) {
          var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
          e.$list.animate({ height: t }, e.options.speed);
        }
      }),
      (t.prototype.animateSlide = function (t, i) {
        var n = {},
          o = this;
        o.animateHeight(),
          !0 === o.options.rtl && !1 === o.options.vertical && (t = -t),
          !1 === o.transformsEnabled
            ? !1 === o.options.vertical
              ? o.$slideTrack.animate(
                  { left: t },
                  o.options.speed,
                  o.options.easing,
                  i
                )
              : o.$slideTrack.animate(
                  { top: t },
                  o.options.speed,
                  o.options.easing,
                  i
                )
            : !1 === o.cssTransitions
            ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft),
              e({ animStart: o.currentLeft }).animate(
                { animStart: t },
                {
                  duration: o.options.speed,
                  easing: o.options.easing,
                  step: function (e) {
                    (e = Math.ceil(e)),
                      !1 === o.options.vertical
                        ? ((n[o.animType] = "translate(" + e + "px, 0px)"),
                          o.$slideTrack.css(n))
                        : ((n[o.animType] = "translate(0px," + e + "px)"),
                          o.$slideTrack.css(n));
                  },
                  complete: function () {
                    i && i.call();
                  },
                }
              ))
            : (o.applyTransition(),
              (t = Math.ceil(t)),
              !1 === o.options.vertical
                ? (n[o.animType] = "translate3d(" + t + "px, 0px, 0px)")
                : (n[o.animType] = "translate3d(0px," + t + "px, 0px)"),
              o.$slideTrack.css(n),
              i &&
                setTimeout(function () {
                  o.disableTransition(), i.call();
                }, o.options.speed));
      }),
      (t.prototype.getNavTarget = function () {
        var t = this.options.asNavFor;
        return t && null !== t && (t = e(t).not(this.$slider)), t;
      }),
      (t.prototype.asNavFor = function (t) {
        var i = this.getNavTarget();
        null !== i &&
          "object" == typeof i &&
          i.each(function () {
            var i = e(this).slick("getSlick");
            i.unslicked || i.slideHandler(t, !0);
          });
      }),
      (t.prototype.applyTransition = function (e) {
        var t = this,
          i = {};
        !1 === t.options.fade
          ? (i[t.transitionType] =
              t.transformType +
              " " +
              t.options.speed +
              "ms " +
              t.options.cssEase)
          : (i[t.transitionType] =
              "opacity " + t.options.speed + "ms " + t.options.cssEase),
          !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
      }),
      (t.prototype.autoPlay = function () {
        var e = this;
        e.autoPlayClear(),
          e.slideCount > e.options.slidesToShow &&
            (e.autoPlayTimer = setInterval(
              e.autoPlayIterator,
              e.options.autoplaySpeed
            ));
      }),
      (t.prototype.autoPlayClear = function () {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
      }),
      (t.prototype.autoPlayIterator = function () {
        var e = this,
          t = e.currentSlide + e.options.slidesToScroll;
        e.paused ||
          e.interrupted ||
          e.focussed ||
          (!1 === e.options.infinite &&
            (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
              ? (e.direction = 0)
              : 0 === e.direction &&
                ((t = e.currentSlide - e.options.slidesToScroll),
                e.currentSlide - 1 == 0 && (e.direction = 1))),
          e.slideHandler(t));
      }),
      (t.prototype.buildArrows = function () {
        var t = this;
        !0 === t.options.arrows &&
          ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
          (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
          t.slideCount > t.options.slidesToShow
            ? (t.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.htmlExpr.test(t.options.prevArrow) &&
                t.$prevArrow.prependTo(t.options.appendArrows),
              t.htmlExpr.test(t.options.nextArrow) &&
                t.$nextArrow.appendTo(t.options.appendArrows),
              !0 !== t.options.infinite &&
                t.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : t.$prevArrow
                .add(t.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (t.prototype.buildDots = function () {
        var t,
          i,
          n = this;
        if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
          for (
            n.$slider.addClass("slick-dotted"),
              i = e("<ul />").addClass(n.options.dotsClass),
              t = 0;
            t <= n.getDotCount();
            t += 1
          )
            i.append(
              e("<li />").append(n.options.customPaging.call(this, n, t))
            );
          (n.$dots = i.appendTo(n.options.appendDots)),
            n.$dots.find("li").first().addClass("slick-active");
        }
      }),
      (t.prototype.buildOut = function () {
        var t = this;
        (t.$slides = t.$slider
          .children(t.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.$slides.each(function (t, i) {
            e(i)
              .attr("data-slick-index", t)
              .data("originalStyling", e(i).attr("style") || "");
          }),
          t.$slider.addClass("slick-slider"),
          (t.$slideTrack =
            0 === t.slideCount
              ? e('<div class="slick-track"/>').appendTo(t.$slider)
              : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent()),
          t.$slideTrack.css("opacity", 0),
          (!0 !== t.options.centerMode && !0 !== t.options.swipeToSlide) ||
            (t.options.slidesToScroll = 1),
          e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
          t.setupInfinite(),
          t.buildArrows(),
          t.buildDots(),
          t.updateDots(),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          !0 === t.options.draggable && t.$list.addClass("draggable");
      }),
      (t.prototype.buildRows = function () {
        var e,
          t,
          i,
          n,
          o,
          r,
          s,
          a = this;
        if (
          ((n = document.createDocumentFragment()),
          (r = a.$slider.children()),
          a.options.rows > 0)
        ) {
          for (
            s = a.options.slidesPerRow * a.options.rows,
              o = Math.ceil(r.length / s),
              e = 0;
            e < o;
            e++
          ) {
            var l = document.createElement("div");
            for (t = 0; t < a.options.rows; t++) {
              var c = document.createElement("div");
              for (i = 0; i < a.options.slidesPerRow; i++) {
                var d = e * s + (t * a.options.slidesPerRow + i);
                r.get(d) && c.appendChild(r.get(d));
              }
              l.appendChild(c);
            }
            n.appendChild(l);
          }
          a.$slider.empty().append(n),
            a.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (t.prototype.checkResponsive = function (t, i) {
        var n,
          o,
          r,
          s = this,
          a = !1,
          l = s.$slider.width(),
          c = window.innerWidth || e(window).width();
        if (
          ("window" === s.respondTo
            ? (r = c)
            : "slider" === s.respondTo
            ? (r = l)
            : "min" === s.respondTo && (r = Math.min(c, l)),
          s.options.responsive &&
            s.options.responsive.length &&
            null !== s.options.responsive)
        ) {
          for (n in ((o = null), s.breakpoints))
            s.breakpoints.hasOwnProperty(n) &&
              (!1 === s.originalSettings.mobileFirst
                ? r < s.breakpoints[n] && (o = s.breakpoints[n])
                : r > s.breakpoints[n] && (o = s.breakpoints[n]));
          null !== o
            ? null !== s.activeBreakpoint
              ? (o !== s.activeBreakpoint || i) &&
                ((s.activeBreakpoint = o),
                "unslick" === s.breakpointSettings[o]
                  ? s.unslick(o)
                  : ((s.options = e.extend(
                      {},
                      s.originalSettings,
                      s.breakpointSettings[o]
                    )),
                    !0 === t && (s.currentSlide = s.options.initialSlide),
                    s.refresh(t)),
                (a = o))
              : ((s.activeBreakpoint = o),
                "unslick" === s.breakpointSettings[o]
                  ? s.unslick(o)
                  : ((s.options = e.extend(
                      {},
                      s.originalSettings,
                      s.breakpointSettings[o]
                    )),
                    !0 === t && (s.currentSlide = s.options.initialSlide),
                    s.refresh(t)),
                (a = o))
            : null !== s.activeBreakpoint &&
              ((s.activeBreakpoint = null),
              (s.options = s.originalSettings),
              !0 === t && (s.currentSlide = s.options.initialSlide),
              s.refresh(t),
              (a = o)),
            t || !1 === a || s.$slider.trigger("breakpoint", [s, a]);
        }
      }),
      (t.prototype.changeSlide = function (t, i) {
        var n,
          o,
          r = this,
          s = e(t.currentTarget);
        switch (
          (s.is("a") && t.preventDefault(),
          s.is("li") || (s = s.closest("li")),
          (n =
            r.slideCount % r.options.slidesToScroll != 0
              ? 0
              : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
          t.data.message)
        ) {
          case "previous":
            (o =
              0 === n ? r.options.slidesToScroll : r.options.slidesToShow - n),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide - o, !1, i);
            break;
          case "next":
            (o = 0 === n ? r.options.slidesToScroll : n),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide + o, !1, i);
            break;
          case "index":
            var a =
              0 === t.data.index
                ? 0
                : t.data.index || s.index() * r.options.slidesToScroll;
            r.slideHandler(r.checkNavigable(a), !1, i),
              s.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (t.prototype.checkNavigable = function (e) {
        var t, i;
        if (((i = 0), e > (t = this.getNavigableIndexes())[t.length - 1]))
          e = t[t.length - 1];
        else
          for (var n in t) {
            if (e < t[n]) {
              e = i;
              break;
            }
            i = t[n];
          }
        return e;
      }),
      (t.prototype.cleanUpEvents = function () {
        var t = this;
        t.options.dots &&
          null !== t.$dots &&
          (e("li", t.$dots)
            .off("click.slick", t.changeSlide)
            .off("mouseenter.slick", e.proxy(t.interrupt, t, !0))
            .off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
          !0 === t.options.accessibility &&
            t.$dots.off("keydown.slick", t.keyHandler)),
          t.$slider.off("focus.slick blur.slick"),
          !0 === t.options.arrows &&
            t.slideCount > t.options.slidesToShow &&
            (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
            t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide),
            !0 === t.options.accessibility &&
              (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler),
              t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))),
          t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
          t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
          t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
          t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
          t.$list.off("click.slick", t.clickHandler),
          e(document).off(t.visibilityChange, t.visibility),
          t.cleanUpSlideEvents(),
          !0 === t.options.accessibility &&
            t.$list.off("keydown.slick", t.keyHandler),
          !0 === t.options.focusOnSelect &&
            e(t.$slideTrack).children().off("click.slick", t.selectHandler),
          e(window).off(
            "orientationchange.slick.slick-" + t.instanceUid,
            t.orientationChange
          ),
          e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
          e("[draggable!=true]", t.$slideTrack).off(
            "dragstart",
            t.preventDefault
          ),
          e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition);
      }),
      (t.prototype.cleanUpSlideEvents = function () {
        var t = this;
        t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.cleanUpRows = function () {
        var e,
          t = this;
        t.options.rows > 0 &&
          ((e = t.$slides.children().children()).removeAttr("style"),
          t.$slider.empty().append(e));
      }),
      (t.prototype.clickHandler = function (e) {
        !1 === this.shouldClick &&
          (e.stopImmediatePropagation(),
          e.stopPropagation(),
          e.preventDefault());
      }),
      (t.prototype.destroy = function (t) {
        var i = this;
        i.autoPlayClear(),
          (i.touchObject = {}),
          i.cleanUpEvents(),
          e(".slick-cloned", i.$slider).detach(),
          i.$dots && i.$dots.remove(),
          i.$prevArrow &&
            i.$prevArrow.length &&
            (i.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()),
          i.$nextArrow &&
            i.$nextArrow.length &&
            (i.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()),
          i.$slides &&
            (i.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                e(this).attr("style", e(this).data("originalStyling"));
              }),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slideTrack.detach(),
            i.$list.detach(),
            i.$slider.append(i.$slides)),
          i.cleanUpRows(),
          i.$slider.removeClass("slick-slider"),
          i.$slider.removeClass("slick-initialized"),
          i.$slider.removeClass("slick-dotted"),
          (i.unslicked = !0),
          t || i.$slider.trigger("destroy", [i]);
      }),
      (t.prototype.disableTransition = function (e) {
        var t = this,
          i = {};
        (i[t.transitionType] = ""),
          !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
      }),
      (t.prototype.fadeSlide = function (e, t) {
        var i = this;
        !1 === i.cssTransitions
          ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
            i.$slides
              .eq(e)
              .animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
          : (i.applyTransition(e),
            i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
            t &&
              setTimeout(function () {
                i.disableTransition(e), t.call();
              }, i.options.speed));
      }),
      (t.prototype.fadeSlideOut = function (e) {
        var t = this;
        !1 === t.cssTransitions
          ? t.$slides
              .eq(e)
              .animate(
                { opacity: 0, zIndex: t.options.zIndex - 2 },
                t.options.speed,
                t.options.easing
              )
          : (t.applyTransition(e),
            t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
      }),
      (t.prototype.filterSlides = t.prototype.slickFilter =
        function (e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
      (t.prototype.focusHandler = function () {
        var t = this;
        t.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick", "*", function (i) {
            var n = e(this);
            setTimeout(function () {
              t.options.pauseOnFocus &&
                n.is(":focus") &&
                ((t.focussed = !0), t.autoPlay());
            }, 0);
          })
          .on("blur.slick", "*", function (i) {
            e(this),
              t.options.pauseOnFocus && ((t.focussed = !1), t.autoPlay());
          });
      }),
      (t.prototype.getCurrent = t.prototype.slickCurrentSlide =
        function () {
          return this.currentSlide;
        }),
      (t.prototype.getDotCount = function () {
        var e = this,
          t = 0,
          i = 0,
          n = 0;
        if (!0 === e.options.infinite)
          if (e.slideCount <= e.options.slidesToShow) ++n;
          else
            for (; t < e.slideCount; )
              ++n,
                (t = i + e.options.slidesToScroll),
                (i +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
        else if (!0 === e.options.centerMode) n = e.slideCount;
        else if (e.options.asNavFor)
          for (; t < e.slideCount; )
            ++n,
              (t = i + e.options.slidesToScroll),
              (i +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
        else
          n =
            1 +
            Math.ceil(
              (e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll
            );
        return n - 1;
      }),
      (t.prototype.getLeft = function (e) {
        var t,
          i,
          n,
          o,
          r = this,
          s = 0;
        return (
          (r.slideOffset = 0),
          (i = r.$slides.first().outerHeight(!0)),
          !0 === r.options.infinite
            ? (r.slideCount > r.options.slidesToShow &&
                ((r.slideOffset = r.slideWidth * r.options.slidesToShow * -1),
                (o = -1),
                !0 === r.options.vertical &&
                  !0 === r.options.centerMode &&
                  (2 === r.options.slidesToShow
                    ? (o = -1.5)
                    : 1 === r.options.slidesToShow && (o = -2)),
                (s = i * r.options.slidesToShow * o)),
              r.slideCount % r.options.slidesToScroll != 0 &&
                e + r.options.slidesToScroll > r.slideCount &&
                r.slideCount > r.options.slidesToShow &&
                (e > r.slideCount
                  ? ((r.slideOffset =
                      (r.options.slidesToShow - (e - r.slideCount)) *
                      r.slideWidth *
                      -1),
                    (s =
                      (r.options.slidesToShow - (e - r.slideCount)) * i * -1))
                  : ((r.slideOffset =
                      (r.slideCount % r.options.slidesToScroll) *
                      r.slideWidth *
                      -1),
                    (s = (r.slideCount % r.options.slidesToScroll) * i * -1))))
            : e + r.options.slidesToShow > r.slideCount &&
              ((r.slideOffset =
                (e + r.options.slidesToShow - r.slideCount) * r.slideWidth),
              (s = (e + r.options.slidesToShow - r.slideCount) * i)),
          r.slideCount <= r.options.slidesToShow &&
            ((r.slideOffset = 0), (s = 0)),
          !0 === r.options.centerMode && r.slideCount <= r.options.slidesToShow
            ? (r.slideOffset =
                (r.slideWidth * Math.floor(r.options.slidesToShow)) / 2 -
                (r.slideWidth * r.slideCount) / 2)
            : !0 === r.options.centerMode && !0 === r.options.infinite
            ? (r.slideOffset +=
                r.slideWidth * Math.floor(r.options.slidesToShow / 2) -
                r.slideWidth)
            : !0 === r.options.centerMode &&
              ((r.slideOffset = 0),
              (r.slideOffset +=
                r.slideWidth * Math.floor(r.options.slidesToShow / 2))),
          (t =
            !1 === r.options.vertical
              ? e * r.slideWidth * -1 + r.slideOffset
              : e * i * -1 + s),
          !0 === r.options.variableWidth &&
            ((n =
              r.slideCount <= r.options.slidesToShow ||
              !1 === r.options.infinite
                ? r.$slideTrack.children(".slick-slide").eq(e)
                : r.$slideTrack
                    .children(".slick-slide")
                    .eq(e + r.options.slidesToShow)),
            (t =
              !0 === r.options.rtl
                ? n[0]
                  ? -1 * (r.$slideTrack.width() - n[0].offsetLeft - n.width())
                  : 0
                : n[0]
                ? -1 * n[0].offsetLeft
                : 0),
            !0 === r.options.centerMode &&
              ((n =
                r.slideCount <= r.options.slidesToShow ||
                !1 === r.options.infinite
                  ? r.$slideTrack.children(".slick-slide").eq(e)
                  : r.$slideTrack
                      .children(".slick-slide")
                      .eq(e + r.options.slidesToShow + 1)),
              (t =
                !0 === r.options.rtl
                  ? n[0]
                    ? -1 * (r.$slideTrack.width() - n[0].offsetLeft - n.width())
                    : 0
                  : n[0]
                  ? -1 * n[0].offsetLeft
                  : 0),
              (t += (r.$list.width() - n.outerWidth()) / 2))),
          t
        );
      }),
      (t.prototype.getOption = t.prototype.slickGetOption =
        function (e) {
          return this.options[e];
        }),
      (t.prototype.getNavigableIndexes = function () {
        var e,
          t = this,
          i = 0,
          n = 0,
          o = [];
        for (
          !1 === t.options.infinite
            ? (e = t.slideCount)
            : ((i = -1 * t.options.slidesToScroll),
              (n = -1 * t.options.slidesToScroll),
              (e = 2 * t.slideCount));
          i < e;

        )
          o.push(i),
            (i = n + t.options.slidesToScroll),
            (n +=
              t.options.slidesToScroll <= t.options.slidesToShow
                ? t.options.slidesToScroll
                : t.options.slidesToShow);
        return o;
      }),
      (t.prototype.getSlick = function () {
        return this;
      }),
      (t.prototype.getSlideCount = function () {
        var t,
          i,
          n,
          o = this;
        return (
          (n =
            !0 === o.options.centerMode ? Math.floor(o.$list.width() / 2) : 0),
          (i = -1 * o.swipeLeft + n),
          !0 === o.options.swipeToSlide
            ? (o.$slideTrack.find(".slick-slide").each(function (n, r) {
                var s, a;
                if (
                  ((s = e(r).outerWidth()),
                  (a = r.offsetLeft),
                  !0 !== o.options.centerMode && (a += s / 2),
                  i < a + s)
                )
                  return (t = r), !1;
              }),
              Math.abs(e(t).attr("data-slick-index") - o.currentSlide) || 1)
            : o.options.slidesToScroll
        );
      }),
      (t.prototype.goTo = t.prototype.slickGoTo =
        function (e, t) {
          this.changeSlide(
            { data: { message: "index", index: parseInt(e) } },
            t
          );
        }),
      (t.prototype.init = function (t) {
        var i = this;
        e(i.$slider).hasClass("slick-initialized") ||
          (e(i.$slider).addClass("slick-initialized"),
          i.buildRows(),
          i.buildOut(),
          i.setProps(),
          i.startLoad(),
          i.loadSlider(),
          i.initializeEvents(),
          i.updateArrows(),
          i.updateDots(),
          i.checkResponsive(!0),
          i.focusHandler()),
          t && i.$slider.trigger("init", [i]),
          !0 === i.options.accessibility && i.initADA(),
          i.options.autoplay && ((i.paused = !1), i.autoPlay());
      }),
      (t.prototype.initADA = function () {
        var t = this,
          i = Math.ceil(t.slideCount / t.options.slidesToShow),
          n = t.getNavigableIndexes().filter(function (e) {
            return e >= 0 && e < t.slideCount;
          });
        t.$slides
          .add(t.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          null !== t.$dots &&
            (t.$slides
              .not(t.$slideTrack.find(".slick-cloned"))
              .each(function (i) {
                var o = n.indexOf(i);
                if (
                  (e(this).attr({
                    role: "tabpanel",
                    id: "slick-slide" + t.instanceUid + i,
                    tabindex: -1,
                  }),
                  -1 !== o)
                ) {
                  var r = "slick-slide-control" + t.instanceUid + o;
                  e("#" + r).length && e(this).attr({ "aria-describedby": r });
                }
              }),
            t.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (o) {
                var r = n[o];
                e(this).attr({ role: "presentation" }),
                  e(this)
                    .find("button")
                    .first()
                    .attr({
                      role: "tab",
                      id: "slick-slide-control" + t.instanceUid + o,
                      "aria-controls": "slick-slide" + t.instanceUid + r,
                      "aria-label": o + 1 + " of " + i,
                      "aria-selected": null,
                      tabindex: "-1",
                    });
              })
              .eq(t.currentSlide)
              .find("button")
              .attr({ "aria-selected": "true", tabindex: "0" })
              .end());
        for (var o = t.currentSlide, r = o + t.options.slidesToShow; o < r; o++)
          t.options.focusOnChange
            ? t.$slides.eq(o).attr({ tabindex: "0" })
            : t.$slides.eq(o).removeAttr("tabindex");
        t.activateADA();
      }),
      (t.prototype.initArrowEvents = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, e.changeSlide),
          e.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, e.changeSlide),
          !0 === e.options.accessibility &&
            (e.$prevArrow.on("keydown.slick", e.keyHandler),
            e.$nextArrow.on("keydown.slick", e.keyHandler)));
      }),
      (t.prototype.initDotEvents = function () {
        var t = this;
        !0 === t.options.dots &&
          t.slideCount > t.options.slidesToShow &&
          (e("li", t.$dots).on(
            "click.slick",
            { message: "index" },
            t.changeSlide
          ),
          !0 === t.options.accessibility &&
            t.$dots.on("keydown.slick", t.keyHandler)),
          !0 === t.options.dots &&
            !0 === t.options.pauseOnDotsHover &&
            t.slideCount > t.options.slidesToShow &&
            e("li", t.$dots)
              .on("mouseenter.slick", e.proxy(t.interrupt, t, !0))
              .on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.initSlideEvents = function () {
        var t = this;
        t.options.pauseOnHover &&
          (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
      }),
      (t.prototype.initializeEvents = function () {
        var t = this;
        t.initArrowEvents(),
          t.initDotEvents(),
          t.initSlideEvents(),
          t.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on("click.slick", t.clickHandler),
          e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
          !0 === t.options.accessibility &&
            t.$list.on("keydown.slick", t.keyHandler),
          !0 === t.options.focusOnSelect &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          e(window).on(
            "orientationchange.slick.slick-" + t.instanceUid,
            e.proxy(t.orientationChange, t)
          ),
          e(window).on(
            "resize.slick.slick-" + t.instanceUid,
            e.proxy(t.resize, t)
          ),
          e("[draggable!=true]", t.$slideTrack).on(
            "dragstart",
            t.preventDefault
          ),
          e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
          e(t.setPosition);
      }),
      (t.prototype.initUI = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.show(), e.$nextArrow.show()),
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.show();
      }),
      (t.prototype.keyHandler = function (e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === e.keyCode && !0 === t.options.accessibility
            ? t.changeSlide({
                data: { message: !0 === t.options.rtl ? "next" : "previous" },
              })
            : 39 === e.keyCode &&
              !0 === t.options.accessibility &&
              t.changeSlide({
                data: { message: !0 === t.options.rtl ? "previous" : "next" },
              }));
      }),
      (t.prototype.lazyLoad = function () {
        function t(t) {
          e("img[data-lazy]", t).each(function () {
            var t = e(this),
              i = e(this).attr("data-lazy"),
              n = e(this).attr("data-srcset"),
              o = e(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
              s = document.createElement("img");
            (s.onload = function () {
              t.animate({ opacity: 0 }, 100, function () {
                n && (t.attr("srcset", n), o && t.attr("sizes", o)),
                  t.attr("src", i).animate({ opacity: 1 }, 200, function () {
                    t.removeAttr(
                      "data-lazy data-srcset data-sizes"
                    ).removeClass("slick-loading");
                  }),
                  r.$slider.trigger("lazyLoaded", [r, t, i]);
              });
            }),
              (s.onerror = function () {
                t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  r.$slider.trigger("lazyLoadError", [r, t, i]);
              }),
              (s.src = i);
          });
        }
        var i,
          n,
          o,
          r = this;
        if (
          (!0 === r.options.centerMode
            ? !0 === r.options.infinite
              ? (o =
                  (n = r.currentSlide + (r.options.slidesToShow / 2 + 1)) +
                  r.options.slidesToShow +
                  2)
              : ((n = Math.max(
                  0,
                  r.currentSlide - (r.options.slidesToShow / 2 + 1)
                )),
                (o = r.options.slidesToShow / 2 + 1 + 2 + r.currentSlide))
            : ((n = r.options.infinite
                ? r.options.slidesToShow + r.currentSlide
                : r.currentSlide),
              (o = Math.ceil(n + r.options.slidesToShow)),
              !0 === r.options.fade &&
                (n > 0 && n--, o <= r.slideCount && o++)),
          (i = r.$slider.find(".slick-slide").slice(n, o)),
          "anticipated" === r.options.lazyLoad)
        )
          for (
            var s = n - 1, a = o, l = r.$slider.find(".slick-slide"), c = 0;
            c < r.options.slidesToScroll;
            c++
          )
            s < 0 && (s = r.slideCount - 1),
              (i = (i = i.add(l.eq(s))).add(l.eq(a))),
              s--,
              a++;
        t(i),
          r.slideCount <= r.options.slidesToShow
            ? t(r.$slider.find(".slick-slide"))
            : r.currentSlide >= r.slideCount - r.options.slidesToShow
            ? t(
                r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)
              )
            : 0 === r.currentSlide &&
              t(
                r.$slider
                  .find(".slick-cloned")
                  .slice(-1 * r.options.slidesToShow)
              );
      }),
      (t.prototype.loadSlider = function () {
        var e = this;
        e.setPosition(),
          e.$slideTrack.css({ opacity: 1 }),
          e.$slider.removeClass("slick-loading"),
          e.initUI(),
          "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
      }),
      (t.prototype.next = t.prototype.slickNext =
        function () {
          this.changeSlide({ data: { message: "next" } });
        }),
      (t.prototype.orientationChange = function () {
        this.checkResponsive(), this.setPosition();
      }),
      (t.prototype.pause = t.prototype.slickPause =
        function () {
          this.autoPlayClear(), (this.paused = !0);
        }),
      (t.prototype.play = t.prototype.slickPlay =
        function () {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
      (t.prototype.postSlide = function (t) {
        var i = this;
        !i.unslicked &&
          (i.$slider.trigger("afterChange", [i, t]),
          (i.animating = !1),
          i.slideCount > i.options.slidesToShow && i.setPosition(),
          (i.swipeLeft = null),
          i.options.autoplay && i.autoPlay(),
          !0 === i.options.accessibility &&
            (i.initADA(), i.options.focusOnChange)) &&
          e(i.$slides.get(i.currentSlide)).attr("tabindex", 0).focus();
      }),
      (t.prototype.prev = t.prototype.slickPrev =
        function () {
          this.changeSlide({ data: { message: "previous" } });
        }),
      (t.prototype.preventDefault = function (e) {
        e.preventDefault();
      }),
      (t.prototype.progressiveLazyLoad = function (t) {
        t = t || 1;
        var i,
          n,
          o,
          r,
          s,
          a = this,
          l = e("img[data-lazy]", a.$slider);
        l.length
          ? ((i = l.first()),
            (n = i.attr("data-lazy")),
            (o = i.attr("data-srcset")),
            (r = i.attr("data-sizes") || a.$slider.attr("data-sizes")),
            ((s = document.createElement("img")).onload = function () {
              o && (i.attr("srcset", o), r && i.attr("sizes", r)),
                i
                  .attr("src", n)
                  .removeAttr("data-lazy data-srcset data-sizes")
                  .removeClass("slick-loading"),
                !0 === a.options.adaptiveHeight && a.setPosition(),
                a.$slider.trigger("lazyLoaded", [a, i, n]),
                a.progressiveLazyLoad();
            }),
            (s.onerror = function () {
              t < 3
                ? setTimeout(function () {
                    a.progressiveLazyLoad(t + 1);
                  }, 500)
                : (i
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  a.$slider.trigger("lazyLoadError", [a, i, n]),
                  a.progressiveLazyLoad());
            }),
            (s.src = n))
          : a.$slider.trigger("allImagesLoaded", [a]);
      }),
      (t.prototype.refresh = function (t) {
        var i,
          n,
          o = this;
        (n = o.slideCount - o.options.slidesToShow),
          !o.options.infinite && o.currentSlide > n && (o.currentSlide = n),
          o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
          (i = o.currentSlide),
          o.destroy(!0),
          e.extend(o, o.initials, { currentSlide: i }),
          o.init(),
          t || o.changeSlide({ data: { message: "index", index: i } }, !1);
      }),
      (t.prototype.registerBreakpoints = function () {
        var t,
          i,
          n,
          o = this,
          r = o.options.responsive || null;
        if ("array" === e.type(r) && r.length) {
          for (t in ((o.respondTo = o.options.respondTo || "window"), r))
            if (((n = o.breakpoints.length - 1), r.hasOwnProperty(t))) {
              for (i = r[t].breakpoint; n >= 0; )
                o.breakpoints[n] &&
                  o.breakpoints[n] === i &&
                  o.breakpoints.splice(n, 1),
                  n--;
              o.breakpoints.push(i), (o.breakpointSettings[i] = r[t].settings);
            }
          o.breakpoints.sort(function (e, t) {
            return o.options.mobileFirst ? e - t : t - e;
          });
        }
      }),
      (t.prototype.reinit = function () {
        var t = this;
        (t.$slides = t.$slideTrack
          .children(t.options.slide)
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.currentSlide >= t.slideCount &&
            0 !== t.currentSlide &&
            (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          t.registerBreakpoints(),
          t.setProps(),
          t.setupInfinite(),
          t.buildArrows(),
          t.updateArrows(),
          t.initArrowEvents(),
          t.buildDots(),
          t.updateDots(),
          t.initDotEvents(),
          t.cleanUpSlideEvents(),
          t.initSlideEvents(),
          t.checkResponsive(!1, !0),
          !0 === t.options.focusOnSelect &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.setPosition(),
          t.focusHandler(),
          (t.paused = !t.options.autoplay),
          t.autoPlay(),
          t.$slider.trigger("reInit", [t]);
      }),
      (t.prototype.resize = function () {
        var t = this;
        e(window).width() !== t.windowWidth &&
          (clearTimeout(t.windowDelay),
          (t.windowDelay = window.setTimeout(function () {
            (t.windowWidth = e(window).width()),
              t.checkResponsive(),
              t.unslicked || t.setPosition();
          }, 50)));
      }),
      (t.prototype.removeSlide = t.prototype.slickRemove =
        function (e, t, i) {
          var n = this;
          return (
            (e =
              "boolean" == typeof e
                ? !0 === (t = e)
                  ? 0
                  : n.slideCount - 1
                : !0 === t
                ? --e
                : e),
            !(n.slideCount < 1 || e < 0 || e > n.slideCount - 1) &&
              (n.unload(),
              !0 === i
                ? n.$slideTrack.children().remove()
                : n.$slideTrack.children(this.options.slide).eq(e).remove(),
              (n.$slides = n.$slideTrack.children(this.options.slide)),
              n.$slideTrack.children(this.options.slide).detach(),
              n.$slideTrack.append(n.$slides),
              (n.$slidesCache = n.$slides),
              void n.reinit())
          );
        }),
      (t.prototype.setCSS = function (e) {
        var t,
          i,
          n = this,
          o = {};
        !0 === n.options.rtl && (e = -e),
          (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (o[n.positionProp] = e),
          !1 === n.transformsEnabled
            ? n.$slideTrack.css(o)
            : ((o = {}),
              !1 === n.cssTransitions
                ? ((o[n.animType] = "translate(" + t + ", " + i + ")"),
                  n.$slideTrack.css(o))
                : ((o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)"),
                  n.$slideTrack.css(o)));
      }),
      (t.prototype.setDimensions = function () {
        var e = this;
        !1 === e.options.vertical
          ? !0 === e.options.centerMode &&
            e.$list.css({ padding: "0px " + e.options.centerPadding })
          : (e.$list.height(
              e.$slides.first().outerHeight(!0) * e.options.slidesToShow
            ),
            !0 === e.options.centerMode &&
              e.$list.css({ padding: e.options.centerPadding + " 0px" })),
          (e.listWidth = e.$list.width()),
          (e.listHeight = e.$list.height()),
          !1 === e.options.vertical && !1 === e.options.variableWidth
            ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
              e.$slideTrack.width(
                Math.ceil(
                  e.slideWidth * e.$slideTrack.children(".slick-slide").length
                )
              ))
            : !0 === e.options.variableWidth
            ? e.$slideTrack.width(5e3 * e.slideCount)
            : ((e.slideWidth = Math.ceil(e.listWidth)),
              e.$slideTrack.height(
                Math.ceil(
                  e.$slides.first().outerHeight(!0) *
                    e.$slideTrack.children(".slick-slide").length
                )
              ));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        !1 === e.options.variableWidth &&
          e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
      }),
      (t.prototype.setFade = function () {
        var t,
          i = this;
        i.$slides.each(function (n, o) {
          (t = i.slideWidth * n * -1),
            !0 === i.options.rtl
              ? e(o).css({
                  position: "relative",
                  right: t,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                })
              : e(o).css({
                  position: "relative",
                  left: t,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          i.$slides
            .eq(i.currentSlide)
            .css({ zIndex: i.options.zIndex - 1, opacity: 1 });
      }),
      (t.prototype.setHeight = function () {
        var e = this;
        if (
          1 === e.options.slidesToShow &&
          !0 === e.options.adaptiveHeight &&
          !1 === e.options.vertical
        ) {
          var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
          e.$list.css("height", t);
        }
      }),
      (t.prototype.setOption = t.prototype.slickSetOption =
        function () {
          var t,
            i,
            n,
            o,
            r,
            s = this,
            a = !1;
          if (
            ("object" === e.type(arguments[0])
              ? ((n = arguments[0]), (a = arguments[1]), (r = "multiple"))
              : "string" === e.type(arguments[0]) &&
                ((n = arguments[0]),
                (o = arguments[1]),
                (a = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === e.type(arguments[1])
                  ? (r = "responsive")
                  : void 0 !== arguments[1] && (r = "single")),
            "single" === r)
          )
            s.options[n] = o;
          else if ("multiple" === r)
            e.each(n, function (e, t) {
              s.options[e] = t;
            });
          else if ("responsive" === r)
            for (i in o)
              if ("array" !== e.type(s.options.responsive))
                s.options.responsive = [o[i]];
              else {
                for (t = s.options.responsive.length - 1; t >= 0; )
                  s.options.responsive[t].breakpoint === o[i].breakpoint &&
                    s.options.responsive.splice(t, 1),
                    t--;
                s.options.responsive.push(o[i]);
              }
          a && (s.unload(), s.reinit());
        }),
      (t.prototype.setPosition = function () {
        var e = this;
        e.setDimensions(),
          e.setHeight(),
          !1 === e.options.fade
            ? e.setCSS(e.getLeft(e.currentSlide))
            : e.setFade(),
          e.$slider.trigger("setPosition", [e]);
      }),
      (t.prototype.setProps = function () {
        var e = this,
          t = document.body.style;
        (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
          "top" === e.positionProp
            ? e.$slider.addClass("slick-vertical")
            : e.$slider.removeClass("slick-vertical"),
          (void 0 === t.WebkitTransition &&
            void 0 === t.MozTransition &&
            void 0 === t.msTransition) ||
            (!0 === e.options.useCSS && (e.cssTransitions = !0)),
          e.options.fade &&
            ("number" == typeof e.options.zIndex
              ? e.options.zIndex < 3 && (e.options.zIndex = 3)
              : (e.options.zIndex = e.defaults.zIndex)),
          void 0 !== t.OTransform &&
            ((e.animType = "OTransform"),
            (e.transformType = "-o-transform"),
            (e.transitionType = "OTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.MozTransform &&
            ((e.animType = "MozTransform"),
            (e.transformType = "-moz-transform"),
            (e.transitionType = "MozTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.MozPerspective &&
              (e.animType = !1)),
          void 0 !== t.webkitTransform &&
            ((e.animType = "webkitTransform"),
            (e.transformType = "-webkit-transform"),
            (e.transitionType = "webkitTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.msTransform &&
            ((e.animType = "msTransform"),
            (e.transformType = "-ms-transform"),
            (e.transitionType = "msTransition"),
            void 0 === t.msTransform && (e.animType = !1)),
          void 0 !== t.transform &&
            !1 !== e.animType &&
            ((e.animType = "transform"),
            (e.transformType = "transform"),
            (e.transitionType = "transition")),
          (e.transformsEnabled =
            e.options.useTransform && null !== e.animType && !1 !== e.animType);
      }),
      (t.prototype.setSlideClasses = function (e) {
        var t,
          i,
          n,
          o,
          r = this;
        if (
          ((i = r.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true")),
          r.$slides.eq(e).addClass("slick-current"),
          !0 === r.options.centerMode)
        ) {
          var s = r.options.slidesToShow % 2 == 0 ? 1 : 0;
          (t = Math.floor(r.options.slidesToShow / 2)),
            !0 === r.options.infinite &&
              (e >= t && e <= r.slideCount - 1 - t
                ? r.$slides
                    .slice(e - t + s, e + t + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((n = r.options.slidesToShow + e),
                  i
                    .slice(n - t + 1 + s, n + t + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === e
                ? i
                    .eq(i.length - 1 - r.options.slidesToShow)
                    .addClass("slick-center")
                : e === r.slideCount - 1 &&
                  i.eq(r.options.slidesToShow).addClass("slick-center")),
            r.$slides.eq(e).addClass("slick-center");
        } else
          e >= 0 && e <= r.slideCount - r.options.slidesToShow
            ? r.$slides
                .slice(e, e + r.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : i.length <= r.options.slidesToShow
            ? i.addClass("slick-active").attr("aria-hidden", "false")
            : ((o = r.slideCount % r.options.slidesToShow),
              (n = !0 === r.options.infinite ? r.options.slidesToShow + e : e),
              r.options.slidesToShow == r.options.slidesToScroll &&
              r.slideCount - e < r.options.slidesToShow
                ? i
                    .slice(n - (r.options.slidesToShow - o), n + o)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : i
                    .slice(n, n + r.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false"));
        ("ondemand" !== r.options.lazyLoad &&
          "anticipated" !== r.options.lazyLoad) ||
          r.lazyLoad();
      }),
      (t.prototype.setupInfinite = function () {
        var t,
          i,
          n,
          o = this;
        if (
          (!0 === o.options.fade && (o.options.centerMode = !1),
          !0 === o.options.infinite &&
            !1 === o.options.fade &&
            ((i = null), o.slideCount > o.options.slidesToShow))
        ) {
          for (
            n =
              !0 === o.options.centerMode
                ? o.options.slidesToShow + 1
                : o.options.slidesToShow,
              t = o.slideCount;
            t > o.slideCount - n;
            t -= 1
          )
            (i = t - 1),
              e(o.$slides[i])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", i - o.slideCount)
                .prependTo(o.$slideTrack)
                .addClass("slick-cloned");
          for (t = 0; t < n + o.slideCount; t += 1)
            (i = t),
              e(o.$slides[i])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", i + o.slideCount)
                .appendTo(o.$slideTrack)
                .addClass("slick-cloned");
          o.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              e(this).attr("id", "");
            });
        }
      }),
      (t.prototype.interrupt = function (e) {
        e || this.autoPlay(), (this.interrupted = e);
      }),
      (t.prototype.selectHandler = function (t) {
        var i = this,
          n = e(t.target).is(".slick-slide")
            ? e(t.target)
            : e(t.target).parents(".slick-slide"),
          o = parseInt(n.attr("data-slick-index"));
        return (
          o || (o = 0),
          i.slideCount <= i.options.slidesToShow
            ? void i.slideHandler(o, !1, !0)
            : void i.slideHandler(o)
        );
      }),
      (t.prototype.slideHandler = function (e, t, i) {
        var n,
          o,
          r,
          s,
          a,
          l = null,
          c = this;
        if (
          ((t = t || !1),
          !(
            (!0 === c.animating && !0 === c.options.waitForAnimate) ||
            (!0 === c.options.fade && c.currentSlide === e)
          ))
        )
          return (
            !1 === t && c.asNavFor(e),
            (n = e),
            (l = c.getLeft(n)),
            (s = c.getLeft(c.currentSlide)),
            (c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft),
            (!1 === c.options.infinite &&
              !1 === c.options.centerMode &&
              (e < 0 || e > c.getDotCount() * c.options.slidesToScroll)) ||
            (!1 === c.options.infinite &&
              !0 === c.options.centerMode &&
              (e < 0 || e > c.slideCount - c.options.slidesToScroll))
              ? void (
                  !1 === c.options.fade &&
                  ((n = c.currentSlide),
                  !0 !== i && c.slideCount > c.options.slidesToShow
                    ? c.animateSlide(s, function () {
                        c.postSlide(n);
                      })
                    : c.postSlide(n))
                )
              : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                (o =
                  n < 0
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                      : c.slideCount + n
                    : n >= c.slideCount
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? 0
                      : n - c.slideCount
                    : n),
                (c.animating = !0),
                c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                (r = c.currentSlide),
                (c.currentSlide = o),
                c.setSlideClasses(c.currentSlide),
                c.options.asNavFor &&
                  (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <=
                    a.options.slidesToShow &&
                  a.setSlideClasses(c.currentSlide),
                c.updateDots(),
                c.updateArrows(),
                !0 === c.options.fade
                  ? (!0 !== i
                      ? (c.fadeSlideOut(r),
                        c.fadeSlide(o, function () {
                          c.postSlide(o);
                        }))
                      : c.postSlide(o),
                    void c.animateHeight())
                  : void (!0 !== i && c.slideCount > c.options.slidesToShow
                      ? c.animateSlide(l, function () {
                          c.postSlide(o);
                        })
                      : c.postSlide(o)))
          );
      }),
      (t.prototype.startLoad = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.hide(), e.$nextArrow.hide()),
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.hide(),
          e.$slider.addClass("slick-loading");
      }),
      (t.prototype.swipeDirection = function () {
        var e,
          t,
          i,
          n,
          o = this;
        return (
          (e = o.touchObject.startX - o.touchObject.curX),
          (t = o.touchObject.startY - o.touchObject.curY),
          (i = Math.atan2(t, e)),
          (n = Math.round((180 * i) / Math.PI)) < 0 && (n = 360 - Math.abs(n)),
          (n <= 45 && n >= 0) || (n <= 360 && n >= 315)
            ? !1 === o.options.rtl
              ? "left"
              : "right"
            : n >= 135 && n <= 225
            ? !1 === o.options.rtl
              ? "right"
              : "left"
            : !0 === o.options.verticalSwiping
            ? n >= 35 && n <= 135
              ? "down"
              : "up"
            : "vertical"
        );
      }),
      (t.prototype.swipeEnd = function (e) {
        var t,
          i,
          n = this;
        if (((n.dragging = !1), (n.swiping = !1), n.scrolling))
          return (n.scrolling = !1), !1;
        if (
          ((n.interrupted = !1),
          (n.shouldClick = !(n.touchObject.swipeLength > 10)),
          void 0 === n.touchObject.curX)
        )
          return !1;
        if (
          (!0 === n.touchObject.edgeHit &&
            n.$slider.trigger("edge", [n, n.swipeDirection()]),
          n.touchObject.swipeLength >= n.touchObject.minSwipe)
        ) {
          switch ((i = n.swipeDirection())) {
            case "left":
            case "down":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                : n.currentSlide + n.getSlideCount()),
                (n.currentDirection = 0);
              break;
            case "right":
            case "up":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                : n.currentSlide - n.getSlideCount()),
                (n.currentDirection = 1);
          }
          "vertical" != i &&
            (n.slideHandler(t),
            (n.touchObject = {}),
            n.$slider.trigger("swipe", [n, i]));
        } else
          n.touchObject.startX !== n.touchObject.curX &&
            (n.slideHandler(n.currentSlide), (n.touchObject = {}));
      }),
      (t.prototype.swipeHandler = function (e) {
        var t = this;
        if (
          !(
            !1 === t.options.swipe ||
            ("ontouchend" in document && !1 === t.options.swipe) ||
            (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
          )
        )
          switch (
            ((t.touchObject.fingerCount =
              e.originalEvent && void 0 !== e.originalEvent.touches
                ? e.originalEvent.touches.length
                : 1),
            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
            !0 === t.options.verticalSwiping &&
              (t.touchObject.minSwipe =
                t.listHeight / t.options.touchThreshold),
            e.data.action)
          ) {
            case "start":
              t.swipeStart(e);
              break;
            case "move":
              t.swipeMove(e);
              break;
            case "end":
              t.swipeEnd(e);
          }
      }),
      (t.prototype.swipeMove = function (e) {
        var t,
          i,
          n,
          o,
          r,
          s,
          a = this;
        return (
          (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
          !(!a.dragging || a.scrolling || (r && 1 !== r.length)) &&
            ((t = a.getLeft(a.currentSlide)),
            (a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
            (a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
            (a.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))
            )),
            (s = Math.round(
              Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))
            )),
            !a.options.verticalSwiping && !a.swiping && s > 4
              ? ((a.scrolling = !0), !1)
              : (!0 === a.options.verticalSwiping &&
                  (a.touchObject.swipeLength = s),
                (i = a.swipeDirection()),
                void 0 !== e.originalEvent &&
                  a.touchObject.swipeLength > 4 &&
                  ((a.swiping = !0), e.preventDefault()),
                (o =
                  (!1 === a.options.rtl ? 1 : -1) *
                  (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
                !0 === a.options.verticalSwiping &&
                  (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
                (n = a.touchObject.swipeLength),
                (a.touchObject.edgeHit = !1),
                !1 === a.options.infinite &&
                  ((0 === a.currentSlide && "right" === i) ||
                    (a.currentSlide >= a.getDotCount() && "left" === i)) &&
                  ((n = a.touchObject.swipeLength * a.options.edgeFriction),
                  (a.touchObject.edgeHit = !0)),
                !1 === a.options.vertical
                  ? (a.swipeLeft = t + n * o)
                  : (a.swipeLeft =
                      t + n * (a.$list.height() / a.listWidth) * o),
                !0 === a.options.verticalSwiping && (a.swipeLeft = t + n * o),
                !0 !== a.options.fade &&
                  !1 !== a.options.touchMove &&
                  (!0 === a.animating
                    ? ((a.swipeLeft = null), !1)
                    : void a.setCSS(a.swipeLeft))))
        );
      }),
      (t.prototype.swipeStart = function (e) {
        var t,
          i = this;
        return (
          (i.interrupted = !0),
          1 !== i.touchObject.fingerCount ||
          i.slideCount <= i.options.slidesToShow
            ? ((i.touchObject = {}), !1)
            : (void 0 !== e.originalEvent &&
                void 0 !== e.originalEvent.touches &&
                (t = e.originalEvent.touches[0]),
              (i.touchObject.startX = i.touchObject.curX =
                void 0 !== t ? t.pageX : e.clientX),
              (i.touchObject.startY = i.touchObject.curY =
                void 0 !== t ? t.pageY : e.clientY),
              void (i.dragging = !0))
        );
      }),
      (t.prototype.unfilterSlides = t.prototype.slickUnfilter =
        function () {
          var e = this;
          null !== e.$slidesCache &&
            (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit());
        }),
      (t.prototype.unload = function () {
        var t = this;
        e(".slick-cloned", t.$slider).remove(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.htmlExpr.test(t.options.prevArrow) &&
            t.$prevArrow.remove(),
          t.$nextArrow &&
            t.htmlExpr.test(t.options.nextArrow) &&
            t.$nextArrow.remove(),
          t.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (t.prototype.unslick = function (e) {
        var t = this;
        t.$slider.trigger("unslick", [t, e]), t.destroy();
      }),
      (t.prototype.updateArrows = function () {
        var e = this;
        Math.floor(e.options.slidesToShow / 2),
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            !e.options.infinite &&
            (e.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            e.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            0 === e.currentSlide
              ? (e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : ((e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                  !1 === e.options.centerMode) ||
                  (e.currentSlide >= e.slideCount - 1 &&
                    !0 === e.options.centerMode)) &&
                (e.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (t.prototype.updateDots = function () {
        var e = this;
        null !== e.$dots &&
          (e.$dots.find("li").removeClass("slick-active").end(),
          e.$dots
            .find("li")
            .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
            .addClass("slick-active"));
      }),
      (t.prototype.visibility = function () {
        var e = this;
        e.options.autoplay &&
          (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
      }),
      (e.fn.slick = function () {
        var e,
          i,
          n = this,
          o = arguments[0],
          r = Array.prototype.slice.call(arguments, 1),
          s = n.length;
        for (e = 0; e < s; e++)
          if (
            ("object" == typeof o || void 0 === o
              ? (n[e].slick = new t(n[e], o))
              : (i = n[e].slick[o].apply(n[e].slick, r)),
            void 0 !== i)
          )
            return i;
        return n;
      });
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "object" == typeof module && module.exports
      ? t(require("jquery"))
      : t(e.jQuery);
  })(this, function (e) {
    var t,
      i,
      n = "left",
      o = "right",
      r = "auto";
    function s(t) {
      (this.$element = e(t)),
        (this.original_text = e.trim(this.$element.html())),
        (this.settings = e.extend({}, e.fn.trunk8.defaults));
    }
    function a(e) {
      var t = document.createElement("DIV");
      return (
        (t.innerHTML = e),
        void 0 !== t.textContent ? t.textContent : t.innerText
      );
    }
    function l(t, i, n) {
      t = t.replace(n, "");
      var o = function (i, r) {
          var s,
            a,
            l,
            c,
            d = "";
          for (c = 0; c < i.length; c++)
            (s = i[c]),
              (l = e.trim(t).split(" ").length),
              e.trim(t).length &&
                ("string" == typeof s
                  ? (/<br\s*\/?>/i.test(s) ||
                      (1 === l && e.trim(t).length <= s.length
                        ? ((s = t),
                          ("p" !== r && "div" !== r) || (s += n),
                          (t = ""))
                        : (t = t.replace(s, ""))),
                    (d +=
                      e.trim(s) + (c === i.length - 1 || l <= 1 ? "" : " ")))
                  : ((a = o(s.content, s.tag)),
                    s.after && (t = t.replace(s.after, "")),
                    a &&
                      (s.after || (s.after = " "),
                      (d +=
                        "<" +
                        s.tag +
                        s.attribs +
                        ">" +
                        a +
                        "</" +
                        s.tag +
                        ">" +
                        s.after))));
          return d;
        },
        r = o(i);
      return r.slice(r.length - n.length) !== n && (r += n), r;
    }
    function c() {
      var t,
        n,
        o,
        s,
        c,
        d,
        u = this.data("trunk8"),
        p = u.settings,
        h = p.width,
        f = p.side,
        m = p.fill,
        g = p.parseHTML,
        v = i.getLineHeight(this) * p.lines,
        y = u.original_text,
        b = y.length,
        w = "";
      if (
        (this.html(y),
        (c = this.text()),
        g &&
          a(y) !== y &&
          ((d = (function e(t) {
            if (a(t) === t) return t.split(/\s/g);
            for (
              var i,
                n,
                o = [],
                r =
                  /<([a-z]+)([^<]*)(?:>([\S\s]*?(?!<\1>))<\/\1>|\s+\/>)(['.?!,]*)|((?:[^<>\s])+['.?!,]*\w?|<br\s?\/?>)/gi,
                s = r.exec(t);
              s && i !== r.lastIndex;

            )
              (i = r.lastIndex),
                s[5]
                  ? o.push(s[5])
                  : s[1] &&
                    o.push({
                      tag: s[1],
                      attribs: s[2],
                      content: s[3],
                      after: s[4],
                    }),
                (s = r.exec(t));
            for (n = 0; n < o.length; n++)
              "string" != typeof o[n] &&
                o[n].content &&
                (o[n].content = e(o[n].content));
            return o;
          })(y)),
          (b = (y = a(y)).length)),
        h === r)
      ) {
        if (this.height() <= v) return;
        for (t = 0, n = b - 1; t <= n; )
          (o = t + ((n - t) >> 1)),
            (s = i.eatStr(y, f, b - o, m)),
            g && d && (s = l(s, d, m)),
            this.html(s),
            this.height() > v
              ? (n = o - 1)
              : ((t = o + 1), (w = w.length > s.length ? w : s));
        this.html(""), this.html(w), p.tooltip && this.attr("title", c);
      } else {
        if (isNaN(h)) return void e.error('Invalid width "' + h + '".');
        (o = b - h),
          (s = i.eatStr(y, f, o, m)),
          this.html(s),
          p.tooltip && this.attr("title", y);
      }
      p.onTruncate();
    }
    (s.prototype.updateSettings = function (t) {
      this.settings = e.extend(this.settings, t);
    }),
      (t = {
        init: function (t) {
          return this.each(function () {
            var i = e(this),
              n = i.data("trunk8");
            n || i.data("trunk8", (n = new s(this))),
              n.updateSettings(t),
              c.call(i);
          });
        },
        update: function (t) {
          return this.each(function () {
            var i = e(this);
            t && (i.data("trunk8").original_text = t), c.call(i);
          });
        },
        revert: function () {
          return this.each(function () {
            var t = e(this).data("trunk8").original_text;
            e(this).html(t);
          });
        },
        getSettings: function () {
          return e(this.get(0)).data("trunk8").settings;
        },
      }),
      ((i = {
        eatStr: function (t, r, s, a) {
          var l,
            c,
            d = t.length,
            u = i.eatStr.generateKey.apply(null, arguments);
          if (i.eatStr.cache[u]) return i.eatStr.cache[u];
          if (
            (("string" == typeof t && 0 !== d) ||
              e.error('Invalid source string "' + t + '".'),
            s < 0 || s > d)
          )
            e.error('Invalid bite size "' + s + '".');
          else if (0 === s) return t;
          switch (
            ("string" != typeof (a + "") &&
              e.error("Fill unable to be converted to a string."),
            r)
          ) {
            case o:
              return (i.eatStr.cache[u] = e.trim(t.substr(0, d - s)) + a);
            case n:
              return (i.eatStr.cache[u] = a + e.trim(t.substr(s)));
            case "center":
              return (
                (l = d >> 1),
                (c = s >> 1),
                (i.eatStr.cache[u] =
                  e.trim(i.eatStr(t.substr(0, d - l), o, s - c, "")) +
                  a +
                  e.trim(i.eatStr(t.substr(d - l), n, c, "")))
              );
            default:
              e.error('Invalid side "' + r + '".');
          }
        },
        getLineHeight: function (t) {
          var i = e(t).css("float");
          "none" !== i && e(t).css("float", "none");
          var n = e(t).css("position");
          "absolute" === n && e(t).css("position", "static");
          var o,
            r = e(t).html(),
            s = "line-height-test";
          return (
            e(t)
              .html("i")
              .wrap('<div id="' + s + '" />'),
            (o = e("#" + s).innerHeight()),
            e(t).html(r).css({ float: i, position: n }).unwrap(),
            o
          );
        },
      }).eatStr.cache = {}),
      (i.eatStr.generateKey = function () {
        return Array.prototype.join.call(arguments, "");
      }),
      (e.fn.trunk8 = function (i) {
        return t[i]
          ? t[i].apply(this, Array.prototype.slice.call(arguments, 1))
          : "object" != typeof i && i
          ? void e.error("Method " + i + " does not exist on jQuery.trunk8")
          : t.init.apply(this, arguments);
      }),
      (e.fn.trunk8.defaults = {
        fill: "&hellip;",
        lines: 1,
        side: o,
        tooltip: !0,
        width: r,
        parseHTML: !1,
        onTruncate: function () {},
      });
  }),
  (function (e) {
    var t = e(window);
    e.fn.visible = function (e, i, n) {
      if (!(this.length < 1)) {
        var o = this.length > 1 ? this.eq(0) : this,
          r = o.get(0),
          s = t.width(),
          a = t.height(),
          l = ((n = n || "both"), !0 !== i || r.offsetWidth * r.offsetHeight);
        if ("function" == typeof r.getBoundingClientRect) {
          var c = r.getBoundingClientRect(),
            d = c.top >= 0 && c.top < a,
            u = c.bottom > 0 && c.bottom <= a,
            p = c.left >= 0 && c.left < s,
            h = c.right > 0 && c.right <= s,
            f = e ? d || u : d && u,
            m = e ? p || h : p && h;
          if ("both" === n) return l && f && m;
          if ("vertical" === n) return l && f;
          if ("horizontal" === n) return l && m;
        } else {
          var g = t.scrollTop(),
            v = g + a,
            y = t.scrollLeft(),
            b = y + s,
            w = o.offset(),
            k = w.top,
            x = k + o.height(),
            S = w.left,
            C = S + o.width(),
            T = !0 === e ? x : k,
            $ = !0 === e ? k : x,
            _ = !0 === e ? C : S,
            E = !0 === e ? S : C;
          if ("both" === n) return !!l && v >= $ && T >= g && b >= E && _ >= y;
          if ("vertical" === n) return !!l && v >= $ && T >= g;
          if ("horizontal" === n) return !!l && b >= E && _ >= y;
        }
      }
    };
  })(jQuery),
  (ajaxify = function (e) {
    var t = (e = e || {}).linkParent || ".pagination",
      i = e.parentContainer || "#MainContent",
      n = e.endlessScrollContainer || ".EndlessScroll",
      o = e.endlessClickContainer || ".EndlessClick",
      r = e.endlessOffset || 0,
      s = e.ajaxinateContainer || ".Ajaxinate",
      a = e.ajaxinateLink || ".page a",
      l =
        $(n).closest("[data-section-id]").data("section-id") ||
        $(o).closest("[data-section-id]").data("section-id") ||
        $(s).closest("[data-section-id]").data("section-id") ||
        "",
      c = e.fade || "fast",
      d = e.textChange || "Loading";
    const u = e.callback || !1;
    var p, h, f, m, g, v;
    ($.loadMore = function () {
      v.length
        ? $.ajax({
            type: "GET",
            dataType: "html",
            url: v,
            success: function (e) {
              "ajax" == m
                ? ($(s)
                    .not('[data-page="' + f + '"]')
                    .hide(),
                  history.pushState({}, f, v))
                : $(p).fadeOut(c);
              var t = $(e).find(h).html();
              $(h)
                .find(".visually-hidden")
                .removeClass("visually-hidden")
                .end()
                .find(".gridSpacer, .pagination")
                .remove()
                .end()
                .append(t),
                "endlessScroll" == m
                  ? $.endlessScroll()
                  : "ajax" == m
                  ? $.ajaxinationClick()
                  : "endlessClick" == m && $.endlessClick(),
                $(document).trigger("ajaxify:updated", [e]),
                u && "function" == typeof u && u(e),
                window?.swatch_hover_func();
            },
          })
        : ($(h).find(".visually-hidden").removeClass("visually-hidden"),
          $(document).trigger("ajaxify:updated"));
    }),
      ($.endlessScroll = function () {
        (g = "scroll.endlessScroll--" + l + " load resize.endlessScroll--" + l),
          $(window).on(g, function () {
            if (
              ((h = n),
              (v = $(h + ":last-of-type " + p).attr("href")),
              (m = "endlessScroll"),
              $(p).text(d),
              $(h + ":last-of-type " + p).length)
            ) {
              var e = $(i).outerHeight();
              $(document).scrollTop() + $(window).height() + r > e &&
                ($(window).off(g), $.loadMore());
            }
          });
      }),
      ($.endlessClick = function () {
        $(p).on("click", function (e) {
          e.preventDefault(),
            (g = "click"),
            (h = o),
            (v = $(this).attr("href")),
            (m = "endlessClick"),
            $(p).text(d),
            $(p).off(g),
            $(p).on("click", function (e) {
              e.preventDefault();
            }),
            $.loadMore();
        });
      }),
      ($.ajaxinationClick = function () {
        $(p).on("click", function (e) {
          e.preventDefault(),
            (g = "click"),
            (h = s),
            (v = $(this).attr("href")),
            (f = $(this).attr("data-number")),
            (m = "ajax"),
            $(h + '[data-page="' + f + '"]').length
              ? ($(h)
                  .not('[data-page="' + f + '"]')
                  .hide(),
                $(h + '[data-page="' + f + '"]').fadeIn(c),
                history.pushState({}, f, v))
              : ($(p).off(g), $.loadMore()),
            $("html, body").animate({ scrollTop: $(i).offset().top }, 300);
        });
      }),
      $(o).length && ((p = t + " a"), $.endlessClick()),
      $(s).length && ((p = a), $.ajaxinationClick()),
      $(n).length && ((p = t + " a"), $.endlessScroll());
  });
var LibraryLoader = (function () {
  var e = "link",
    t = "script",
    i = "requested",
    n = "loaded",
    o = "https://cdn.shopify.com/shopifycloud/",
    r = {
      youtubeSdk: {
        tagId: "youtube-sdk",
        src: "https://www.youtube.com/iframe_api",
        type: t,
      },
      plyrShopifyStyles: {
        tagId: "plyr-shopify-styles",
        src: o + "shopify-plyr/v1.0/shopify-plyr.css",
        type: e,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: o + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: e,
      },
    };
  return {
    load: function (o, s) {
      var a = r[o];
      if (a && a.status !== i)
        if (((s = s || function () {}), a.status !== n)) {
          var l;
          switch (((a.status = i), a.type)) {
            case t:
              l = (function (e, t) {
                var i = document.createElement("script");
                return (
                  (i.src = e.src),
                  i.addEventListener("load", function () {
                    (e.status = n), t();
                  }),
                  i
                );
              })(a, s);
              break;
            case e:
              l = (function (e, t) {
                var i = document.createElement("link");
                return (
                  (i.href = e.src),
                  (i.rel = "stylesheet"),
                  (i.type = "text/css"),
                  i.addEventListener("load", function () {
                    (e.status = n), t();
                  }),
                  i
                );
              })(a, s);
          }
          (l.id = a.tagId), (a.element = l);
          var c = document.getElementsByTagName(a.type)[0];
          c.parentNode.insertBefore(l, c);
        } else s();
    },
  };
})();
jQuery(function (e) {
  var t,
    i = {
      init: function () {
        e(document)
          .on("shopify:section:load", this._onSectionLoad)
          .on("shopify:section:unload", this._onSectionUnload)
          .on("shopify:section:select", this._onSectionSelect)
          .on("shopify:section:deselect", this._onSectionDeselect)
          .on("shopify:block:select", this._onBlockSelect)
          .on("shopify:block:deselect", this._onBlockDeselect);
      },
      _onSectionLoad: function (t) {
        var i,
          n,
          o =
            e(t.target).children("[data-section-type]").data("section-type") ||
            !1;
        switch ((Site.animations.init(), o)) {
          case "header":
            t.target,
              Site.header.resetHeader(),
              Site.nav.hide(),
              Site.nav.init(),
              Site.header.init(),
              Search.init(),
              e(".template-cart").length || Cart.init(),
              setTimeout(function () {
                e(window).scroll();
              }, 100);
            break;
          case "footer":
            t.target, Site.footer();
            break;
          case "product":
            (i = t.target),
              (n = e(i).find("[data-section-id]").data("section-id")),
              Product.init(!0, n),
              Site.video(),
              Site.initReviews();
            break;
          case "gallery":
            !(function (t) {
              var i = e(t).find(".js-slider"),
                n = i.data("autoplay"),
                o = JSON.parse(i.data("slick").replace(/'/g, '"'));
              (o = e.extend({}, o, {
                autoplay: n,
                prevArrow:
                  '<button class="slick-prev slick-arrow" aria-label="' +
                  window.theme.translations.previous +
                  '" type="button">' +
                  window.theme.icons.arrowSlider +
                  "</button>",
                nextArrow:
                  '<button class="slick-next slick-arrow" aria-label="' +
                  window.theme.translations.next +
                  '" type="button">' +
                  window.theme.icons.arrowSlider +
                  "</button>",
              })),
                i.on("init", function () {
                  e(this).removeClass("gallery-slider--is-loading");
                }),
                i.slick(o);
            })(t.target);
            break;
          case "mosaic":
            !(function (t) {
              var i = e(t),
                n = e(t).find(".js-mosaic__blocks"),
                o = e(t).children().first().data("section-id"),
                r = window.innerWidth || document.documentElement.clientWidth;
              Site.sliders.initMobileSlider(n),
                Site.sliders.truncateMosaicText(i),
                Site.video(),
                e(window)
                  .on("load", Site.sliders.truncateMosaicText(i))
                  .on(
                    "resize." + o,
                    Reqs.debounce(function () {
                      var e =
                        window.innerWidth ||
                        document.documentElement.clientWidth;
                      r != e && Site.sliders.initMobileSlider(n),
                        (r = e),
                        Site.sliders.truncateMosaicText(i);
                    }, 250)
                  );
            })(t.target);
          case "map":
            t.target, Gmap.init();
            break;
          case "slideshow":
            !(function (t) {
              var i = e(t).find(".js-hero-slider"),
                n = i.data("autoplay"),
                o = JSON.parse(i.data("slick").replace(/'/g, '"')),
                r = e(t).find(".js-scroll-down");
              (o = e.extend({}, o, {
                autoplay: n,
                prevArrow:
                  '<button class="slick-prev slick-arrow" aria-label="' +
                  window.theme.translations.previous +
                  '" type="button">' +
                  window.theme.icons.arrowSlider +
                  "</button>",
                nextArrow:
                  '<button class="slick-next slick-arrow" aria-label="' +
                  window.theme.translations.next +
                  '" type="button">' +
                  window.theme.icons.arrowSlider +
                  "</button>",
              })),
                i.on("init", function () {
                  var t = e(this)
                    .find('.js-slide[data-slick-index="1"]')
                    .data("style");
                  e(this).attr("data-current-style", t),
                    e(this).removeClass("hero--is-loading");
                }),
                i.on("beforeChange", function (t, i, n, o) {
                  var r = parseInt(o + 1),
                    s = e(this)
                      .find('.js-slide[data-slick-index="' + r + '"]')
                      .data("style");
                  e(this).attr("data-current-style", s);
                }),
                i.slick(o),
                e(window).on(
                  "scroll.slideshow resize.slideshow",
                  Reqs.throttle(function () {
                    var t = e(window).height(),
                      o = e(window).scrollTop(),
                      r = i.height(),
                      s = i.offset().top;
                    s + r >= o && s - t <= o && n
                      ? i.slick("slickPlay")
                      : i.slick("slickPause");
                  }, 100)
                ),
                r.on("click", function (t) {
                  t.preventDefault();
                  var n = parseInt(i.offset().top + i.outerHeight() - 59);
                  e("html, body").stop(!0, !1).animate({ scrollTop: n }, 500);
                }),
                Site.header.resetHeader(),
                Site.header.init();
            })(t.target);
            break;
          case "collection-template":
            t.target,
              Collection.init(),
              Site.sliders.collection(),
              Site.initReviews();
            break;
          case "featured-collection":
            !(function (t) {
              var i = e(t).find(".js-collectionGrid"),
                n = i.data("section-id");
              Collection.init(),
                Site.initReviews(),
                Site.sliders.collection(),
                Site.sliders.setCarouselState(i),
                e(window).on(
                  "resize." + n,
                  Reqs.debounce(function () {
                    Site.sliders.setCarouselState(i);
                  }, 250)
                );
            })(t.target);
            break;
          case "collection-grid":
            !(function (t) {
              var i = e(t).find(".collectionList"),
                n = i.data("section-id");
              ListCollections.truncateBlockText(i),
                e(window).on(
                  "resize." + n,
                  Reqs.throttle(function () {
                    ListCollections.truncateBlockText(i);
                  }, 50)
                ),
                e(document).on("ajaxify:updated", function () {
                  ListCollections.truncateBlockText(i);
                });
            })(t.target);
            break;
          case "related-products":
            t.target, RelatedProducts.init();
            break;
          case "blog-template":
            t.target, ajaxify(), Blog.init();
            break;
          case "featured-blog":
            t.target, Blog.init();
            break;
          case "featured-video":
            t.target, Site.video();
            break;
          case "logos-list":
            !(function (t) {
              var i, n;
              (i = e(t).find(".js-logos-slider")),
                (n = {
                  infinite: !0,
                  autoplay: !1,
                  speed: 300,
                  slidesToShow: 8,
                  centerPadding: "80px",
                  arrows: !0,
                  dots: !1,
                  prevArrow:
                    '<button class="slick-prev slick-arrow" aria-label="' +
                    window.theme.translations.previous +
                    '" type="button">' +
                    window.theme.icons.arrowSlider +
                    "</button>",
                  nextArrow:
                    '<button class="slick-next slick-arrow" aria-label="' +
                    window.theme.translations.next +
                    '" type="button">' +
                    window.theme.icons.arrowSlider +
                    "</button>",
                  responsive: [
                    {
                      breakpoint: 1440,
                      settings: { centerPadding: "40px", slidesToShow: 6 },
                    },
                    {
                      breakpoint: 1024,
                      settings: { centerPadding: "30px", slidesToShow: 5 },
                    },
                    {
                      breakpoint: 992,
                      settings: { centerPadding: "25px", slidesToShow: 4 },
                    },
                    {
                      breakpoint: 768,
                      settings: { centerPadding: "20px", slidesToShow: 3 },
                    },
                    {
                      breakpoint: 640,
                      settings: { centerPadding: "15px", slidesToShow: 2 },
                    },
                    {
                      breakpoint: 375,
                      settings: { centerPadding: "10px", slidesToShow: 1 },
                    },
                  ],
                }),
                i.slick(n);
            })(t.target);
            break;
          case "about-template":
            t.target, Site.header.init();
            break;
          case "faq-template":
          case "faq-section":
            !(function (t) {
              e(t)
                .find(".faq-list")
                .on("click", ".faq-list__item-question", function (t) {
                  t.preventDefault(),
                    e(this).parent().toggleClass("is-expanded");
                });
            })(t.target);
        }
      },
      _onSectionUnload: function (t) {
        var i;
        switch (t.target.children[0].getAttribute("data-section-type") || !1) {
          case "header":
            t.target, e(window).off("scroll.header resize.header");
            break;
          case "gallery":
            (i = t.target),
              e(i).find(".js-slider").slick("unslick"),
              e(window).off("scroll.gallery");
            break;
          case "slideshow":
            !(function (t) {
              e(t).find(".js-hero-slider").slick("unslick"),
                e(window).off("scroll.slideshow resize.slideshow");
            })(t.target);
            break;
          case "logos-list":
            !(function (t) {
              e(t).find(".js-logos-slider").slick("unslick");
            })(t.target);
            break;
          case "mosaic":
            !(function (t) {
              var i = e(t).find(".js-mosaic__blocks"),
                n = i.hasClass("slick-initialized"),
                o = (o = e(t).children().first().data("section-id"));
              n && i.slick("unslick"), e(window).off("resize." + o);
            })(t.target);
            break;
          case "popup":
            t.target, Popup.hide();
            break;
          case "product":
            !(function (t) {
              var i = e(t).children().first(),
                n = i.data("section-id"),
                o = ".product" + n;
              e("#shop-bar").remove(),
                ProductVideo.removeSectionVideos(n),
                ProductModel.removeSectionModels(n),
                e(window).off("resize.product"),
                e(window).off("scroll.product"),
                i.off(o);
            })(t.target);
            break;
          case "collection-grid":
            !(function (t) {
              var i = e(t).children().first().data("section-id"),
                n =
                  "scroll.endlessScroll--" +
                  i +
                  " load resize.endlessScroll--" +
                  i +
                  " resize." +
                  i;
              e(window).off(n);
            })(t.target);
            break;
          case "collection-template":
          case "featured-collection":
          case "related-products":
            !(function (t) {
              var i = e(t).children().first().data("section-id"),
                n =
                  "resize." +
                  i +
                  " scroll.endlessScroll--" +
                  i +
                  " load resize.endlessScroll--" +
                  i;
              e(window).off(n), e(window).off("resize.collection");
            })(t.target);
            break;
          case "blog-template":
            !(function (t) {
              var i = e(t).children().first().data("section-id"),
                n =
                  "scroll.endlessScroll--" +
                  i +
                  " load resize.endlessScroll--" +
                  i;
              e(window).off(n);
            })(t.target);
        }
      },
      _onSectionSelect: function (e) {
        switch (
          e.target.children[0].getAttribute("data-section-type") ||
          e.target.children[1].getAttribute("data-section-type") ||
          e.target.children[2].getAttribute("data-section-type") ||
          !1
        ) {
          case "header":
            e.target,
              Site.header.resetHeader(),
              Site.nav.hide(),
              Site.header.init();
            break;
          case "blog-template":
            e.target, Blog.init();
            break;
          case "popup":
            e.target, Popup.init();
        }
      },
      _onSectionDeselect: function (e) {
        if (
          "header" ===
          (e.target.children[0].getAttribute("data-section-type") || !1)
        )
          e.target, Site.nav.hide();
      },
      _onBlockSelect: function (t) {
        var i, n, o;
        switch (t.target.getAttribute("data-block") || !1) {
          case "slide":
            (i = t.target),
              (n = e(i).parents(".slick-slider")),
              (o = e(i)
                .parents(".slick-slide:not(.slick-cloned)")
                .attr("data-slick-index")),
              n.slick("slickGoTo", o),
              n.slick("slickPause");
            break;
          case "mosaic":
            !(function (t) {
              var i,
                n = e(t).parents(".section-mosaic"),
                o = e(t).parents(".js-mosaic__blocks");
              o.hasClass("slick-initialized") &&
                ((i = e(t)
                  .parents(".slick-slide:not(.slick-cloned)")
                  .attr("data-slick-index")),
                o.slick("slickGoTo", i),
                o.slick("slickPause")),
                Site.sliders.truncateMosaicText(n),
                Site.video();
            })(t.target);
            break;
          case "testimonial":
            _selectBlockTestimonial(t.target);
            break;
          case "item_logo":
            !(function (t) {
              var i = e(t).parents(".js-logos-slider"),
                n = e(t)
                  .parents(".slick-slide:not(.slick-cloned)")
                  .attr("data-slick-index");
              i.slick("slickGoTo", n);
            })(t.target);
        }
      },
      _onBlockDeselect: function (t) {
        var i, n;
        switch (t.target.getAttribute("data-block") || !1) {
          case "slide":
            (i = t.target),
              (n = e(i).parents(".slick-slider")).data("autoplay") &&
                n.slick("slickPlay");
            break;
          case "item_logo":
            !(function (t) {
              e(t).parents(".js-logos-slider").slick("slickPlay");
            })(t.target);
        }
      },
    };
  (window.Site = {
    settings: { b: e("body"), w: e(window), d: e(document) },
    init: function () {
      (t = this.settings),
        this.general(),
        this.setScrollbarWidth(),
        this.header.init(),
        this.footer(),
        this.nav.init(),
        this.sliders.init(),
        this.addresses.init(),
        this.keyboardAccessible(),
        this.video(),
        this.faq(),
        this.checkReviewsApp(),
        "true" == this.getQueryParameter("customer_posted") &&
          (e("body").addClass("signUp-posted"),
          t.d.scrollTop(t.d.height() - t.w.height()));
    },
    general: function () {
      t.b.on("click", ".share-link", function (t) {
        t.preventDefault();
        var i = e(this),
          n = i.attr("data-network"),
          o = i.attr("href"),
          r = 400;
        if ("twitter" === n) r = 300;
        window.open(o, n, "width=700, height=" + r);
      }),
        t.b.on("click", "[data-anchor-link]", function (t) {
          var i = e(this).attr("href");
          if (e(i).length) {
            var n = e(i).offset().top - 60;
            e("html, body").stop().animate({ scrollTop: n }),
              t.preventDefault();
          }
        });
    },
    setScrollbarWidth: function () {
      var e = document.documentElement,
        t = scrollLock.getPageScrollBarWidth() + "px";
      e.style.setProperty("--scrollbar-width", t);
    },
    getQueryParameter: function (e) {
      e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var t = new RegExp("[\\?&]" + e + "=([^&#]*)").exec(location.search);
      return null === t ? "" : decodeURIComponent(t[1].replace(/\+/g, " "));
    },
    keyboardAccessible: function () {
      t.w.mousedown(function (e) {
        t.b.addClass("no-outline");
      }),
        t.w.keyup(function (e) {
          9 === e.keyCode && t.b.removeClass("no-outline");
        });
    },
    header: {
      init: function () {
        var t = e(".site-header"),
          i = e("#shopify-section-header"),
          n = e(".bodyWrap"),
          o = window.innerWidth || document.documentElement.clientWidth;
        function r() {
          var i = t.hasClass("header--standard"),
            n = document.querySelector(".nav-search-scroller");
          if (i) {
            var o = (function () {
              t.addClass("header--is-standard").removeClass(
                "header--is-hamburger"
              );
              var i,
                n = e(".site-header .container > .row").width(),
                o =
                  ((i = 0),
                  e(".nav-standard .menu > li").each(function () {
                    i += e(this).outerWidth(!0);
                  }),
                  i),
                r = !1,
                s =
                  t.hasClass("header--logo_center_links_center") ||
                  t.hasClass("header--logo_left_links_center"),
                a =
                  t.hasClass("header--logo_center_links_left") ||
                  t.hasClass("header--logo_left_links_left"),
                l = e(".header-icons").outerWidth(),
                c = (function () {
                  var t = 0,
                    i = e(".logo__image-link"),
                    n = e(".logo__text");
                  return (
                    i.length && (t = i.data("width")),
                    n.length && (t += n.outerWidth()),
                    t
                  );
                })();
              return (
                s && ((c = c < l ? l : c), (c *= 2), (l = 0)),
                (r = parseInt(n) < parseInt(o + c + l + 40)),
                a && (r = parseInt((n - c) / 2) < parseInt(o)),
                r
              );
            })();
            e(window).width() >= 1024 && !o
              ? Site.nav.hide()
              : (t
                  .removeClass("header--is-standard header--search-visible")
                  .addClass("header--is-hamburger"),
                scrollLock.enablePageScroll(n));
          }
          s(),
            e(document).one("shopify:section:unload", function () {
              setTimeout(s, 100);
            });
        }
        function s() {
          Site.isHeroEnabled()
            ? (t.addClass("header--no-bg"), n.removeAttr("data-spacer"))
            : (t.removeClass("header--no-bg"),
              n.attr("data-spacer", "default"),
              t.hasClass("header--is-hamburger")
                ? n.attr("data-spacer", "small")
                : t.hasClass("header--logo_center_links_center") &&
                  n.attr("data-spacer", "large"));
        }
        r(),
          e(window)
            .off(".header")
            .on("load", r)
            .on(
              "scroll.header",
              Reqs.throttle(function () {
                e(window).scrollTop() > n.offset().top
                  ? (i.addClass("shopify-section-header--fixed"),
                    t.addClass("header--has-scrolled"))
                  : (i.removeClass("shopify-section-header--fixed"),
                    t.removeClass("header--has-scrolled"));
              }, 50)
            )
            .on("resize.header", Reqs.throttle(Site.setCartClosePosition, 50))
            .on(
              "resize.header",
              Reqs.debounce(function () {
                var e =
                  window.innerWidth || document.documentElement.clientWidth;
                o != e && r(), (o = e);
              }, 250)
            );
      },
      resetHeader: function () {
        var t = e("body"),
          i = e(".bodyWrap"),
          n = e("#hamburger-menu"),
          o = e(".site-header, .siteAlert, .bodyWrap, .shop-bar"),
          r = document.querySelector(".nav-inner");
        t.removeClass("nav--is-visible"),
          i.removeAttr("style"),
          o.css("transform", "none"),
          n.removeClass("open"),
          scrollLock.enablePageScroll(r),
          t.hasClass("cart--is-visible") &&
            e(".js-cartToggle").eq(0).trigger("click");
      },
    },
    isHeroEnabled: function () {
      var t = e(".site-header").data("transparent");
      return (
        (e(".main-content")
          .children()
          .first(".shopify-section")
          .hasClass("header--full") ||
          e(".main-content")
            .children()
            .first(".shopify-section")
            .find('[data-header-style="index"]').length) &&
        t
      );
    },
    setCartClosePosition: function () {
      if (e("#cartTotal").length) {
        var t = e(".cart-drawer .js-cartToggle"),
          i = e(window).scrollTop(),
          n = e("#cartTotal").offset().top - i - 40;
        t.css("top", n);
      }
    },
    footer: function () {
      var t = e(".js-product-template"),
        i = e(".site-footer"),
        n = e("[data-disclosure-locale]", i),
        o = e("[data-disclosure-currency]", i);
      n.length && new Disclosure(n),
        o.length && new Disclosure(o),
        e(window).on(
          "scroll",
          Reqs.throttle(function () {
            var n = e(window).scrollTop(),
              o = e("#shop-bar");
            if (t.length && o.length) {
              var r = t.offset().top;
              n > r
                ? (o.addClass("shop-bar--is-visible"),
                  i.addClass("site-footer--push"))
                : n < r - 60 &&
                  (o.removeClass("shop-bar--is-visible"),
                  i.removeClass("site-footer--push"));
            }
          }, 100)
        );
    },
    video: function () {
      Reqs.lightbox(),
        e(".js-video").each(function () {
          e(this).magnificPopup({
            closeMarkup:
              '<button title="%title%" type="button" class="mfp-close">' +
              window.theme.icons.close +
              "</button>",
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: !1,
            autoFocusLast: !1,
            fixedContentPos: !1,
            iframe: {
              markup:
                '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay, fullscreen"></iframe></div>',
              patterns: {
                youtube: {
                  index: "youtube.com/",
                  id: "v=",
                  src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0modestbranding=0",
                },
                youtube_short: {
                  index: "youtu.be/",
                  id: "youtu.be/",
                  src: "//www.youtube.com/embed/%id%?autoplay=1&autohide=0&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&quality=hd720&rel=0&showinfo=0&wmode=opaque",
                },
              },
              srcAction: "iframe_src",
            },
          });
        });
    },
    faq: function () {
      e(".faq-list__item-question").on("click", function (t) {
        t.preventDefault(), e(this).parent().toggleClass("is-expanded");
      });
    },
    sliders: {
      init: function () {
        this.hero(),
          this.carousel(),
          this.collection(),
          this.gallery(),
          this.mosaic(),
          this.logosList();
      },
      hero: function () {
        var t = e(".js-hero-slider"),
          i = e(".js-scroll-down");
        t.each(function () {
          var i = e(this),
            n = i.data("autoplay"),
            o = JSON.parse(i.data("slick").replace(/'/g, '"'));
          (o = e.extend({}, o, {
            autoplay: !1,
            dots: !0,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="' +
              window.theme.translations.previous +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="' +
              window.theme.translations.next +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
          })),
            i.on("init", function () {
              var t = e(this)
                .find('.js-slide[data-slick-index="1"]')
                .data("style");
              e(this)
                .attr("data-current-style", t)
                .removeClass("hero--is-loading");
            }),
            i.on("beforeChange", function (t, i, n, o) {
              var r = parseInt(o + 1),
                s = e(this)
                  .find('.js-slide[data-slick-index="' + r + '"]')
                  .data("style");
              e(this).attr("data-current-style", s);
            }),
            i.slick(o),
            e(window).on(
              "scroll.slideshow resize.slideshow",
              Reqs.throttle(function () {
                var e = i.visible(!0);
                i.hasClass("slick-initialized") &&
                  (e && n ? i.slick("slickPlay") : i.slick("slickPause"));
              }, 100)
            ),
            e(window).on("load", function () {
              n && t.slick("slickPlay");
            });
        }),
          e(".slick-list").attr("tabindex", "-1"),
          i.on("click", function (i) {
            i.preventDefault();
            var n = parseInt(t.offset().top + t.outerHeight() - 59);
            e("html, body").stop(!0, !1).animate({ scrollTop: n }, 500);
          });
      },
      carousel: function () {
        var t = e(".js-carousel-slider");
        null == t.data("flickity") &&
          t.flickity({
            cellSelector: ".js-slide",
            cellAlign: "center",
            watchCSS: !0,
            prevNextButtons: !1,
            pageDots: !1,
          });
      },
      collection: function () {
        var t = e(".js-collection-grid"),
          i = e(".js-collection-slider");
        function n() {
          var e = i.find(".slick-slide--quickView");
          if (
            (e.length ||
              (e = i.find(".quickView--is-visible").closest(".slick-slide")),
            i.length && e.length)
          ) {
            var t = e.find(".quickView-wrap"),
              n =
                i.find(".slick-slide.slick-current").position().left -
                e.position().left;
            t.css("left", n);
          }
        }
        e(".quickView-button", i).on("click", function () {
          e(this).closest(".slick-slide").addClass("slick-slide--quickView");
        }),
          e("html, body").on("quickView:show", function () {
            n(),
              i
                .find(".slick-slide--quickView")
                .removeClass("slick-slide--quickView");
          }),
          e("html, body").on("quickView:ajax", n),
          t.each(function () {
            Site.sliders.setCarouselState(e(this));
          }),
          i.each(function () {
            Site.removeAnimationClass(e(this));
          }),
          e(window).on(
            "resize",
            Reqs.debounce(function () {
              n(),
                t.each(function () {
                  Site.sliders.setCarouselState(e(this));
                });
            }, 250)
          );
      },
      setCarouselState: function (t) {
        if (void 0 !== t) {
          var i = t.find(".js-collection-slider");
          if (i.length) {
            Site.removeAnimationClass(t);
            var n = i.hasClass("slick-initialized"),
              o = parseInt(t.data("slides-per-row")),
              r =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth,
              s = {
                slidesPerRow: o,
                infinite: !1,
                dots: !1,
                prevArrow: document.querySelector("button.custom_prev"),
                nextArrow: document.querySelector("button.custom_next"),
                responsive: [
                  { breakpoint: 1024, settings: { slidesPerRow: 2 } },
                ],
              };
            r >= 120
              ? n ||
                (i.on("init", a),
                i.slick(s).on("beforeChange", function () {
                  e(".quickView--is-visible").length && QuickView.hide();
                }))
              : n && i.slick("unslick"),
              a();
          }
        }
        function a() {
          var e = i.find(".slick-arrow"),
            t = i.find(".collectionBlock-image").outerHeight() / 2;
          e.css("top", t);
        }
      },
      gallery: function () {
        e(".js-slider").each(function () {
          var t = e(this),
            i = t.data("autoplay"),
            n = JSON.parse(t.data("slick").replace(/'/g, '"'));
          (n = e.extend({}, n, {
            autoplay: !1,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="' +
              window.theme.translations.previous +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="' +
              window.theme.translations.next +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
          })),
            t.on("init", function () {
              e(this).removeClass("gallery-slider--is-loading");
            }),
            t.slick(n),
            e(window)
              .on(
                "scroll.gallery",
                Reqs.debounce(function () {
                  (function (e) {
                    const t = e.getBoundingClientRect(),
                      i =
                        window.innerHeight ||
                        document.documentElement.clientHeight,
                      n =
                        window.innerWidth ||
                        document.documentElement.clientWidth,
                      o = t.top <= i && t.top + t.height >= 0,
                      r = t.left <= n && t.left + t.width >= 0;
                    return o && r;
                  })(t.get(0)) && i
                    ? t.slick("slickPlay")
                    : t.slick("slickPause");
                }, 150)
              )
              .on("load", function () {
                i && t.slick("slickPlay");
              });
        });
      },
      mosaic: function () {
        var t = this;
        e(".js-mosaic__blocks").each(function () {
          var i = e(this),
            n = e(this).closest(".section-mosaic"),
            o = e(this).closest("[data-section-id]").data("section-id"),
            r = window.innerWidth || document.documentElement.clientWidth;
          t.initMobileSlider(i),
            e(window)
              .on("load", t.truncateMosaicText(n))
              .on(
                "resize." + o,
                Reqs.debounce(function () {
                  var e =
                    window.innerWidth || document.documentElement.clientWidth;
                  r != e && t.initMobileSlider(i),
                    (r = e),
                    t.truncateMosaicText(n);
                }, 250)
              );
        });
      },
      truncateMosaicText: function (t) {
        e(t).find(".mosaic__heading, .mosaic__subheading").trunk8({ lines: 1 }),
          e(t).find(".mosaic__block-text-title").trunk8({ lines: 3 }),
          e(t).find(".mosaic__image-text > p").trunk8({ lines: 8 });
      },
      initMobileSlider: function (t) {
        var i = e(window).width() < 768,
          n = t.hasClass("slick-initialized"),
          o = {
            infinite: !0,
            autoplay: !1,
            speed: 300,
            slidesToShow: 1,
            arrows: !0,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="' +
              window.theme.translations.previous +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="' +
              window.theme.translations.next +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
            dots: !1,
          };
        i && !n ? t.slick(o) : !i && n && t.slick("unslick");
      },
      logosList: function () {
        var t = e(".js-logos-slider"),
          i = {
            infinite: !0,
            autoplay: !1,
            speed: 300,
            slidesToShow: 8,
            centerPadding: "80px",
            arrows: !0,
            dots: !1,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="' +
              window.theme.translations.previous +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="' +
              window.theme.translations.next +
              '" type="button">' +
              window.theme.icons.arrowSlider +
              "</button>",
            responsive: [
              {
                breakpoint: 1440,
                settings: { centerPadding: "40px", slidesToShow: 6 },
              },
              {
                breakpoint: 1024,
                settings: { centerPadding: "30px", slidesToShow: 5 },
              },
              {
                breakpoint: 992,
                settings: { centerPadding: "25px", slidesToShow: 4 },
              },
              {
                breakpoint: 768,
                settings: { centerPadding: "20px", slidesToShow: 3 },
              },
              {
                breakpoint: 640,
                settings: { centerPadding: "15px", slidesToShow: 2 },
              },
              {
                breakpoint: 375,
                settings: { centerPadding: "10px", slidesToShow: 1 },
              },
            ],
          };
        t.each(function () {
          e(this).slick(i);
        });
      },
      checkThumbnailsOverflow: function (e) {
        var t = e.find(".js-slide").outerWidth(),
          i = e.find(".js-slide").length,
          n = parseInt(t * i);
        return e.width() < n;
      },
    },
    nav: {
      getWidth: function () {
        var t = e(window).outerWidth();
        return t >= 1280 ? t / 3 : t >= 768 ? (2 * t) / 3 : t;
      },
      init: function () {
        Site.nav.bindings(), Site.nav.activeLinks();
      },
      bindings: function () {
        var t = e("body"),
          i = e(".site-header");
        e(".js-menuToggle").on("click", function (t) {
          t.preventDefault(),
            e("body").hasClass("nav--is-visible")
              ? Site.nav.hide()
              : Site.nav.show();
        }),
          e(".nav-standard .has-submenu").on("mouseover", function () {
            e(this)
              .addClass("is-expanded")
              .find("a[aria-expanded]")
              .attr("aria-expanded", !0),
              e(this)
                .siblings()
                .removeClass("is-expanded")
                .find("a[aria-expanded]")
                .attr("aria-expanded", !1);
          }),
          e(".nav-standard .menu-item--dropdown").on("mouseleave", function () {
            e(this)
              .removeClass("is-expanded")
              .find("a[aria-expanded]")
              .attr("aria-expanded", !1);
          }),
          e(".nav-standard .menu-item--meganav")
            .on("mouseover", function () {
              e(".site-header").addClass("header--megamenu-visible"),
                e(this).find(".visible-nav-link").removeAttr("tabindex");
            })
            .on("mouseleave", function () {
              e(this)
                .removeClass("is-expanded")
                .find("a[aria-expanded]")
                .attr("aria-expanded", !1),
                e(".site-header").removeClass("header--megamenu-visible"),
                e(".visible-nav-link").attr("tabindex", "-1");
            }),
          e(".nav-standard .toggle-submenu").on("click", function (t) {
            var i = e(this);
            i.parent().hasClass("is-expanded")
              ? Site.nav.submenuStandard.close()
              : Site.nav.submenuStandard.open(i);
          }),
          t.on("keyup", function (t) {
            if (
              t.keyCode === slate.utils.keyboardKeys.TAB ||
              t.keyCode === slate.utils.keyboardKeys.ESCAPE
            ) {
              var i = e(t.target),
                n = i.parents(".submenu").length,
                o = i.parents(".nav-hamburger").length,
                r =
                  i.parents(".nav-search").length ||
                  !i.is(".js-searchToggle--open");
              t.keyCode === slate.utils.keyboardKeys.TAB
                ? (n || Site.nav.submenuStandard.close(),
                  o || Site.nav.hide(),
                  r || (Site.nav.search.close(), Search.close()))
                : t.keyCode === slate.utils.keyboardKeys.ESCAPE &&
                  (Site.nav.submenuStandard.close(),
                  Site.nav.search.close(),
                  Search.close(),
                  Site.nav.hide());
            }
          }),
          e(".main-content")
            .children()
            .first()
            .on("click", function () {
              Site.nav.hide();
            }),
          e(".nav-hamburger .has-submenu .dropdown-arrow").on(
            "click",
            function (t) {
              e(this).parent().hasClass("is-expanded")
                ? Site.nav.submenu.close(e(this).parent())
                : Site.nav.submenu.open(e(this).parent());
            }
          ),
          e(".js-searchToggle").on("click", function (t) {
            if ((t.preventDefault(), i.hasClass("header--search-visible")))
              Site.nav.search.close(), Search.close();
            else {
              var n = e(this).data("search-nav");
              Site.nav.search.open(n);
            }
          }),
          e(document).on("click", function (t) {
            e(t.target).is(
              ".nav-search-overlay, .nav-search-overlay *, .js-searchToggle, .js-searchToggle *"
            ) ||
              (i.hasClass("header--search-visible") &&
                (Site.nav.search.close(), Search.close()));
          }),
          t.on("click", function (t) {
            e(t.target).is(".js-menuToggle, .js-menuToggle *, .nav-main *") ||
              Site.nav.hide();
          });
      },
      show: function () {
        var t = e(".nav-hamburger").width() + "px",
          i = e("body"),
          n = e("#hamburger-menu"),
          o = e(".site-header, .siteAlert, .bodyWrap, .shop-bar"),
          r = document.querySelector(".nav-inner");
        n.addClass("open"),
          i.addClass("nav--is-visible"),
          scrollLock.disablePageScroll(r),
          e(".header-icons a:not(.js-menuToggle)").attr("tabindex", "-1"),
          e(".nav-hamburger").find("button, a").removeAttr("tabindex"),
          o.css({ transform: "translateX(" + t + ")" }),
          e(window).on(
            "resize.siteNav",
            Reqs.debounce(function () {
              e(".site-header").hasClass("header--is-hamburger") &&
                ((t = e(".nav-hamburger").width() + "px"),
                o.css({ transform: "translateX(" + t + ")" }));
            }, 100)
          );
      },
      hide: function () {
        var t = e("body"),
          i = e("#hamburger-menu"),
          n = e(".site-header, .siteAlert, .bodyWrap, .shop-bar"),
          o = document.querySelector(".nav-inner");
        t.hasClass("nav--is-visible") &&
          (i.removeClass("open"),
          t.addClass("nav--is-hiding").removeClass("nav--is-visible"),
          n.css({ transform: "none" }),
          scrollLock.enablePageScroll(o),
          e(window).off("resize.siteNav"),
          setTimeout(function () {
            t.removeClass("nav--is-hiding");
          }, 300),
          e(".header-icons a").removeAttr("tabindex"),
          e(".nav-hamburger").find("button, a").attr("tabindex", "-1"));
      },
      activeLinks: function () {
        var t = e(".menu-item"),
          i = e(".submenu-item");
        t.each(function () {
          e(this).find("> a").attr("href") === window.location.pathname
            ? e(this).addClass("is-active")
            : i.each(function () {
                e(this).find("> a").attr("href") === window.location.pathname &&
                  (e(this).addClass("is-active"),
                  e(this)
                    .closest(".menu-item.has-submenu")
                    .addClass("is-active"));
              });
        });
      },
      submenuStandard: {
        open: function (t) {
          t
            .parent()
            .siblings(".menu-item--meganav")
            .removeClass("is-expanded")
            .find("a[aria-expanded]")
            .attr("aria-expanded", !1),
            t
              .parent()
              .siblings(".menu-item--meganav")
              .find(".visible-nav-link")
              .attr("tabindex", "-1"),
            t.attr("aria-expanded", !0).parent().addClass("is-expanded"),
            t.parent().find(".visible-nav-link").removeAttr("tabindex"),
            t.parents(".menu-item--meganav").length &&
              e(".site-header").addClass("header--megamenu-visible");
        },
        close: function () {
          e(".visible-nav-link").attr("tabindex", "-1"),
            e(".nav-standard .menu li")
              .removeClass("is-expanded")
              .find("a[aria-expanded]")
              .attr("aria-expanded", !1),
            e(".site-header").removeClass("header--megamenu-visible");
        },
      },
      submenu: {
        open: function (t) {
          var i = e(t);
          i
            .addClass("is-expanded")
            .find("> .submenu")
            .stop(!0)
            .slideDown("fast"),
            i.find(".visible-nav-link").removeAttr("tabindex");
        },
        close: function (t) {
          var i = e(t);
          i
            .removeClass("is-expanded")
            .find("> .submenu")
            .stop(!0)
            .slideUp("fast"),
            i.find(".visible-nav-link").attr("tabindex", "-1");
        },
      },
      search: {
        open: function (t) {
          var i = e(".site-header"),
            n = e(".js-searchToggle"),
            o = e(t).find(".nav-search-input"),
            r = e(t).find(
              ".nav-search-input, .nav-search-submit, .js-searchToggle--close"
            ),
            s = document.querySelector(".nav-search-scroller");
          i.addClass("header--search-visible"),
            n.attr("aria-expanded", !0),
            r.removeAttr("tabindex"),
            o.focus().select(),
            scrollLock.disablePageScroll(s);
        },
        close: function () {
          var t = e(".site-header"),
            i = e(".js-searchToggle"),
            n = e(".js-searchToggle--open"),
            o = e(
              ".nav-search-input, .nav-search-submit, .js-searchToggle--close"
            ),
            r = document.querySelector(".nav-search-scroller"),
            s = t.hasClass("header--search-visible");
          o.attr("tabindex", "-1"),
            i.attr("aria-expanded", !1),
            s &&
              (t
                .addClass("header--search-hiding")
                .removeClass("header--search-visible"),
              n.focus(),
              setTimeout(function () {
                t.removeClass("header--search-hiding"),
                  scrollLock.enablePageScroll(r);
              }, 300));
        },
      },
    },
    addresses: {
      addAddressForm: e(".js-addAddress > form"),
      editAddressForm: e(".js-editAddress > form"),
      init: function () {
        ($addAddressForm = this.addAddressForm),
          ($editAddressForm = this.editAddressForm),
          Site.addresses.validating();
      },
      validating: function () {
        $addAddressForm.add($editAddressForm).submit(function (t) {
          var i = !0;
          if (
            (e(this)
              .find("input")
              .not(".optional")
              .each(function () {
                e(this).val()
                  ? e(this).next().removeClass("validation--showup")
                  : e(this).next().addClass("validation--showup");
              }),
            e(this)
              .find("input")
              .not(".optional")
              .each(function () {
                e(this).val() || (i = !1);
              }),
            !i)
          )
            return !1;
        });
      },
    },
    checkReviewsApp: function () {
      var t = window.theme.settings.showReviews,
        i = window.theme.settings.enableYotpo,
        n = window.theme.settings.yotpoId;
      if (t && i && n) {
        var o = setInterval(function () {
          ("function" == typeof window.SPR && t) ||
          ("object" == typeof yotpo && i && n)
            ? (e("body").removeAttr("data-app-reviews"), clearInterval(o))
            : e("body").attr("data-app-reviews", "not-installed");
        }, 1e3);
        setTimeout(function () {
          clearInterval(o);
        }, 2e4);
      }
    },
    animations: {
      init: function () {
        var t = window.theme.settings.enableTextAnimations,
          i = window.theme.settings.enableGridItemsAnimations;
        e("body").removeClass("is-page-loading"),
          (t || i) &&
            (i && e("body").addClass("allow-grid-items-animations"),
            this.animateAll(),
            e(document).on("ajaxify:updated", this.animateAll),
            e(window)
              .on("load", this.animateAll)
              .on("scroll", Reqs.throttle(this.animateAll, 100)));
      },
      animateAll: function (t) {
        e(".will-animate").each(function () {
          var t = e(this),
            i = "animated " + t.data("animation"),
            n = 1e3 + (t.data("animation-delay") || 0);
          t.visible(!0) &&
            (t.addClass(i).removeClass("will-animate"),
            setTimeout(function () {
              t.removeClass(i);
            }, n));
        });
      },
    },
    initReviews: function () {
      var t = window.theme.settings.showReviews,
        i = window.theme.settings.enableYotpo,
        n = window.theme.settings.yotpoId;
      i && "" != n && "undefined" != typeof yotpo
        ? (yotpo.initialized ? yotpo.refreshWidgets() : yotpo.initWidgets(),
          e(".star-clickable").removeAttr("tabindex"))
        : t &&
          "function" == typeof window.SPR &&
          (window.SPR.initDomEls(),
          window.SPR.loadBadges(),
          window.SPR.loadProducts());
    },
    removeAnimationClass: function (t) {
      e(".will-animate", t).removeClass("will-animate");
    },
  }),
    Site.init(),
    Cart.init(),
    Collection.init(),
    ListCollections.init(),
    Blog.init(),
    Site.animations.init(),
    e(document).ready(function () {
      Gmap.init();
    }),
    i.init(),
    Popup.init(),
    Search.init(),
    e(".template-product").length && (Product.init(), RelatedProducts.init()),
    e(".featured-product").length && Product.init(),
    e(".template-password").length && Password.init(),
    e(".template-customers-login").length && Login.init(),
    e(".template-customers-addresses").length && Addresses.init(),
    e(".template-search").length && SearchTemplate.init(),
    window.theme.settings.showQuickView && QuickView.init(),
    slate.a11y.pageLinkFocus(e(window.location.hash)),
    e(".in-page-link").on("click", function (t) {
      slate.a11y.pageLinkFocus(e(t.currentTarget.hash));
    }),
    e(document).on("shopify:section:reorder", Site.header.init),
    e(document).on("shopify:section:unload", Site.header.init);
}),
  (Cart = {
    popoverTimer: 0,
    init: function () {
      var e = $("#Cart"),
        t = $("body"),
        i = $("#CartPopoverCont"),
        n = window.theme.settings.enableAjaxCart;
      if (
        (this.counter(),
        this.initTermsAcceptance(),
        $(window).on("resize", Reqs.throttle(Site.setCartClosePosition, 10)),
        e.on("click", ".js-continueShopping", function (e) {
          e.preventDefault();
          var t = document.referrer,
            i = window.location.origin + "/";
          $(window).width() < 768 || window.location.href.indexOf("/cart") > -1
            ? t === i
              ? (window.location.href = window.theme.routes.root_url)
              : history.back(1)
            : $(".js-cartToggle-close").eq(0).trigger("click");
        }),
        !n)
      )
        return !1;
      $(document).off("click", ".js-cartToggle"),
        $(document).on("click", ".js-cartToggle", function (n) {
          var o = $(this),
            r = $("body").hasClass("template-cart"),
            s =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth,
            a = document.querySelector(".scroll");
          if (r) return !1;
          s > 768
            ? (n.preventDefault(),
              Site.setCartClosePosition(),
              t.toggleClass("cart--is-visible"),
              t.hasClass("cart--is-visible")
                ? (e.removeClass("close"),
                  e.addClass("open"),
                  $("#cartTotal").attr("aria-expanded", !0),
                  scrollLock.disablePageScroll(a))
                : (e.removeClass("open"),
                  e.addClass("close"),
                  $("#cartTotal").attr("aria-expanded", !1),
                  Cart.popover.hide(i),
                  scrollLock.enablePageScroll(a)),
              $(".js-continueShopping").attr("tabindex", "0"))
            : (o.hasClass("js-cartToggle-close") &&
                (n.preventDefault(),
                $("html").css("overflow", "initial"),
                t.removeClass("cart--is-visible"),
                e.removeClass("open"),
                e.addClass("close"),
                $("#cartTotal").attr("aria-expanded", !1),
                Cart.popover.hide(i)),
              $(".js-continueShopping").attr("tabindex", "-1"));
        }),
        $("body").on("click", "[data-add-to-cart]", function (e) {
          var t = $(this).closest("form.productForm");
          if (n) {
            /* 2026-07-04 FAZ2: eski kontrol formda file input VARSA (boş olsa bile)
            preventDefault+return yapıp butonu öldürüyordu. Yeni kural: dosya SEÇİLİYSE
            preventDefault YAPMADAN çık -> native form POST dosyayı taşır (AJAX taşıyamaz).
            Dosya seçili değilse normal AJAX akışı. */
                    var lpFiles = t.find('input[type="file"]').filter(function () {
                      return this.files && this.files.length > 0;
                    });
                    if (lpFiles.length) return;
                    e.preventDefault();
                    Cart.submit($(this));
          }
        }),
        $(window).on("keyup", function (n) {
          "Escape" === n.key &&
            (t.removeClass("cart--is-visible"),
            e.removeClass("open"),
            e.addClass("close"),
            ($scrollableElement = document.querySelector(".scroll")),
            $("#cartTotal").attr("aria-expanded", !1),
            Cart.popover.hide(i),
            scrollLock.enablePageScroll($scrollableElement));
        });
    },
    submit: function (e) {
      var t = this,
        i = e.closest("form.productForm"),
        n = e.attr("data-handle"),
        o = i.find('[name="id"]').val(),
        r = i.serializeArray(),
        s = e,
        a = e.find("[data-add-to-cart-text]"),
        l = {};
      $.map(r, function (e, t) {
        l[e.name] = e.value;
      }),
        s.attr("disabled", !0),
        s.find("span").html(""),
        s.addClass("loading"),
        $.ajax({
          method: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: l,
          success: function (e) {
            /* 2026-07-04 FAZ2: localStorage tabanlı fee ekleme kaldırıldı.
            Fee artık personalization-cart-sync scripti tarafından, sepetteki
            _Personalization Fee Type property'lerine göre ekleniyor/eşitleniyor
            (redirect zaten /cart'a gidiyor; sync orada çalışıyor). */
              s.removeClass("loading"),
              s.attr("disabled", !1),
              a.html("Added to cart"),
              (location.href = "/cart"),
              setTimeout(
                () => a.html(window.theme.translations.form_submit),
                1e3
              ),
              Cart.getCart(Cart.buildCart),
              $(window).width() >= 550 && Cart.popover.show(e);
          },
          error: function (e) {
            $.ajax({
              method: "GET",
              url: "/products/" + n + ".js",
              dataType: "json",
              success: function (e) {
                var i = e.variants,
                  n =
                    ($.each(i, function (e, t) {
                      if (t.id == o)
                        return (variant_quantity = t.inventory_quantity);
                    }),
                    $("#CartPopoverCont")),
                  r = window.theme.translations.form_submit_error_details,
                  s = r;
                1 == new RegExp("[[i]]").test(r) &&
                  (s = r.replace("[[i]]", variant_quantity)),
                  a.html(window.theme.translations.form_submit_error),
                  setTimeout(function () {
                    a.html(window.theme.translations.form_submit);
                  }, 1e3),
                  clearTimeout(t.popoverTimer),
                  n
                    .empty()
                    .append('<div class="popover-error">' + s + "</div>")
                    .addClass("is-visible")
                    .css({ "pointer-events": "none" }),
                  (t.popoverTimer = setTimeout(function () {
                    n.removeClass("is-visible").css({
                      "pointer-events": "auto",
                    });
                  }, 5e3));
              },
              error: function () {
                console.log(
                  "Error: product is out of stock. If you're seeing this, Cart.submit.error() must have failed."
                );
              },
            });
          },
        });
    },
    popover: {
      show: function (e) {
        var t,
          i = $("#CartPopoverCont"),
          n = $("#CartPopover").text(),
          o = this.getTruncatedTitle(e.product_title),
          r = slate.Currency.formatMoney(e.final_price, window.moneyFormat),
          s = "";
        if (
          (e.unit_price_measurement &&
            ((s =
              slate.Currency.formatMoney(e.unit_price, window.moneyFormat) +
              " "),
            1 != e.unit_price_measurement.reference_value &&
              (s += e.unit_price_measurement.reference_value),
            (s += e.unit_price_measurement.reference_unit)),
          null != e.image)
        )
          var a = e.image.replace(/(\.[^.]*)$/, "_150x$1").replace("http:", "");
        else
          a =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        t = {
          item_count: e.quantity,
          img: a,
          product_title: o,
          variation: "Default Title" != e.variant_title && e.variant_title,
          price: e.price,
          price_formatted: r,
          unit_price: s,
        };
        var l = Sqrl.render(n, t);
        i.empty().append(l),
          i.addClass("is-visible"),
          clearTimeout(this.popoverTimer),
          (this.popoverTimer = setTimeout(function () {
            Cart.popover.hide(i);
          }, 5e3));
      },
      hide: function (e) {
        e.removeClass("is-visible"),
          setTimeout(function () {
            e.empty();
          }, 300);
      },
      getTruncatedTitle: function (e) {
        return e.length > 20 && (e = e.substring(0, 20) + " ..."), e;
      },
    },
    getCart: function (e) {
      $.getJSON("/cart.js", function (t, i) {
        "function" == typeof e ? e(t) : ShopifyAPI?.onCartUpdate(t);
      });
    },
    buildCart: function (e) {
      var t = $("#Cart"),
        i = $("body"),
        n = !!t.attr("data-acceptance-checked") || !1;
      if (
        (t.empty(),
        i.hasClass("template-cart") ||
          t.append(
            '<div class="js-cartToggle js-cartToggle-close cart-close">' +
              window.theme.icons.close +
              "</div>"
          ),
        0 === e.item_count)
      )
        return (
          t.append(
            '<div class="cart-title cart-title--empty">\t\t\t\t\t\t\t<h1>' +
              window.theme.translations.cart_title +
              "</h1>\t\t\t\t\t\t\t<p>" +
              window.theme.translations.cart_empty +
              '</p>\t\t\t\t\t\t\t<a tabindex="-1" class="js-continueShopping js-continueShopping--empty js-go-back button">' +
              window.theme.translations.continue_shopping +
              "</a>\t\t\t\t\t\t</div>"
          ),
          this.updateCartTotal(),
          void Site.setCartClosePosition()
        );
      var o,
        r = [],
        s = {},
        a = $("#CartTemplate").html();
      $.each(e.items, function (e, t) {
        var i = t.quantity,
          n = t.variant_id,
          o = t.discounts,
          a = "",
          l = "",
          c = "",
          d = "";
        if (
          (t.original_price > t.final_price &&
            (l +=
              "<s>" +
              slate.Currency.formatMoney(t.original_price, window.moneyFormat) +
              "</s> "),
          (l +=
            "<span>" +
            slate.Currency.formatMoney(t.final_price, window.moneyFormat) +
            "</span>"),
          t.original_line_price > t.final_line_price &&
            (c +=
              "<s>" +
              slate.Currency.formatMoney(
                t.original_line_price,
                window.moneyFormat
              ) +
              "</s> "),
          (c += slate.Currency.formatMoney(
            t.final_line_price,
            window.moneyFormat
          )),
          o.length)
        ) {
          a += '<div class="cart-product__discounts">';
          for (var u = 0; u < o.length; u++)
            a +=
              "<p>" +
              o[u].title +
              " (-" +
              slate.Currency.formatMoney(o[u].amount, window.moneyFormat) +
              ")</p>";
          a += "</div>";
        }
        if (
          (t.unit_price_measurement &&
            ((d =
              slate.Currency.formatMoney(t.unit_price, window.moneyFormat) +
              " "),
            (d +=
              '<span aria-hidden="true">/</span><span class="visually-hidden">' +
              window.theme.translations.unit_price_separator +
              "</span>&nbsp;"),
            1 != t.unit_price_measurement.reference_value &&
              (d += t.unit_price_measurement.reference_value),
            (d += t.unit_price_measurement.reference_unit)),
          null != t.image)
        )
          var p = t.image.replace(/(\.[^.]*)$/, "_300x$1").replace("http:", "");
        else
          p =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        var h = t.product_title,
          f = t.variant_title;
        "Default Title" == f && (f = !1),
          (s = {
            id: t.variant_id,
            url: t.url,
            img: p,
            name: h,
            variation: f,
            itemQty: i,
            itemVariantId: n,
            properties: t.properties,
            price: t.price,
            priceFormatted: l,
            unitPrice: d,
            linePriceFormatted: c,
            discounts: a,
            vendor: t.vendor,
            iconPlus: window.theme.icons.plus,
            iconMinus: window.theme.icons.minus,
          }),
          r.push(s);
      });
      var l = "",
        c = e.cart_level_discount_applications;
      if (c.length) {
        l += '<p class="cart-discounts">';
        for (var d = 0; d < c.length; d++)
          (l += "<span>" + c[d].title + ":</span>"),
            (l +=
              "<span>-" +
              slate.Currency.formatMoney(
                c[d].total_allocated_amount,
                window.moneyFormat
              ) +
              "</span>");
        l += "</p>";
      }
      (o = {
        item_count: e.item_count,
        items: r,
        properties: r.properties,
        note: e.note,
        totalDiscounts: l,
        totalPrice: slate.Currency.formatMoney(
          e.total_price,
          window.moneyFormat
        ),
        acceptanceChecked: n,
      }),
        console.log("proptesting");
      var u = Sqrl.render(a, o);
      t.append(u),
        Cart.updateCartTotal(),
        Cart.initTermsAcceptance(),
        Site.setCartClosePosition(),
        window.Shopify &&
          Shopify.StorefrontExpressButtons &&
          Shopify.StorefrontExpressButtons.initialize();
    },
    counter: function () {
      var e = this;
      $("#Cart")
        .off(".cart")
        .on("change.cart", ".inputCounter", function () {
          var t = $(this),
            i = $(this).val();
          e.inputCounter(t, i);
        })
        .on("click.cart", ".inputCounter__btn--down", function (t) {
          var i = $(this),
            n = i.siblings(".inputCounter"),
            o = parseInt(n.val()) - 1;
          e.inputCounter(i, o);
        })
        .on("click.cart", ".inputCounter__btn--up", function (t) {
          var i = $(this),
            n = i.siblings(".inputCounter"),
            o = parseInt(n.val()) + 1;
          e.inputCounter(i, o);
        })
        .on("click.cart", ".cart-product__remove", function () {
          var t = $(this);
          e.inputCounter(t, 0);
        });
    },
    inputCounter: function (e, t) {
      var i = this,
        n = e.closest(".line-item").find(".inputCounter");
      0 == t
        ? n.closest(".line-item").fadeOut(function () {
            $(this).remove();
          })
        : t < 0 && (t = 0);
      var o = t,
        r = parseInt(n.closest(".line-item").index() + 1);
      $.ajax({
        type: "post",
        url: "/cart/change.js",
        dataType: "json",
        data: { quantity: o, line: r },
        success: function (e) {
          Cart.buildCart(e);
        },
      }),
        0 == o &&
          $(this)
            .closest(".line-item")
            .fadeOut(function () {
              $(this).remove(), i.updateCartTotal();
            });
    },
    updateCartTotal: function () {
      $.getJSON("/cart.js", function (e) {
        $("#CartToggleItemCount").html(e.item_count),
          e.item_count
            ? $(".js-cartToggle").removeClass("cartToggle--empty")
            : $(".js-cartToggle").addClass("cartToggle--empty");
      });
    },
    initTermsAcceptance: function () {
      var e = {
        cartAcceptance: "[data-cart-acceptance]",
        cartButtons: "[data-cart-buttons]",
        cartButtonsFieldset: "[data-cart-buttons-fieldset]",
        cartContainer: ".cart-container",
        cartFormError: "[data-cart-error]",
      };
      if ($(e.cartAcceptance).length) {
        var t =
            '<div class="errors" data-cart-error>' +
            window.theme.translations.cart_acceptance_error +
            "</div>",
          i = function (i) {
            if ($(e.cartAcceptance).is(":checked"))
              $(e.cartFormError)
                .stop()
                .slideUp("fast", function () {
                  $(this).remove();
                }),
                $(e.cartButtonsFieldset).removeAttr("disabled"),
                $(e.cartContainer).attr("data-acceptance-checked", "checked");
            else {
              if ((i.preventDefault(), $(e.cartFormError).length)) return;
              $(e.cartButtonsFieldset).attr("disabled", !0),
                $(e.cartButtons).before(t),
                $(e.cartFormError).slideDown(),
                $(e.cartContainer).removeAttr("data-acceptance-checked");
            }
          };
        $(e.cartAcceptance).is(":checked") ||
          $(e.cartButtonsFieldset).attr("disabled", !0),
          $(e.cartContainer)
            .on("click.cart", e.cartButtons, i)
            .on("submit.cart", e.cartForm, i)
            .on("submit.cart", e.cartFormDynamicCheckout, i)
            .on("change.cart", e.cartAcceptance, i);
      }
    },
  });
var Collection = {
    selectors: {
      body: "body",
      collectionWrapper: "[data-collection-wrapper]",
      collectionBannerImage: "[data-collection-banner-image]",
      collectionBannerContent: "[data-collection-banner-content]",
      collectionProductsWrapper: "[data-collection-products-wrapper]",
      collectionProducts: "[data-collection-products]",
      collectionFilters: "[data-collection-filters]",
      collectionFiltersResetButton: "[data-collection-filters-reset-button]",
      collectionFilter: "[data-collection-filter]",
      collectionFilterTag: "[data-collection-filter-tag]",
      collectionFilterTagButton: "[data-collection-filter-tag-button]",
      collectionFilterTitle: "[data-collection-filter-title]",
      collectionPagination: "[data-collection-pagination]",
      collectionSort: "[data-collection-sort]",
      collectionBlockImage: ".collectionBlock-image",
      collectionFeaturedImage: ".featured-block",
      productsFoundLabel: "[data-products-found-label]",
      loadMoreButton: "[data-load-more]",
      loadMoreIcon: "[data-icon-load-more]",
      gridSpacer: ".gridSpacer",
    },
    classes: {
      loading: "loading",
      isActive: "is-active",
      isVisible: "is-visible",
      isExpanded: "is-expanded",
      isLoading: "is-loading",
      ajaxSorting: "ajax-sorting",
      hasTagsExpanded: "has-tags-expanded",
      collectionFiltersTop: "collection__filters--top",
      collectionFiltersHasTagsSelected:
        "collection__filters--has-tags-selected",
      collectionFiltersResetButtonFullwidth:
        "collection__filters-reset--fullwidth",
      collectionFilterAccordionExpanded:
        "collection__filter--accordion-expanded",
    },
    init: function () {
      var e = this;
      (this.filterProductsRequest = null),
        $(this.selectors.collectionSort).length &&
          $(this.selectors.collectionSort).on("change", function () {
            document.location.href =
              "?sort_by=" + this.options[this.selectedIndex].value;
          }),
        $(this.selectors.collectionProducts).each(function () {
          var t = $(this),
            i = $(this).data("section-id");
          if ("contain" == window.theme.settings.imageBackgroundSize) {
            var n = $(e.selectors.collectionBlockImage, t);
            Collection.setBadgePosition(n),
              $(window).on(
                "resize." + i,
                Reqs.debounce(e.setBadgePosition.bind(e, n), 50)
              );
          }
          e.initFilters(t);
        }),
        ajaxify(),
        Product.qtyAdjust(),
        $(document).on("ajaxify:updated", function () {
          Site.initReviews();
        }),
        this.truncateFeaturedImageText(),
        $(window).on(
          "resize.collection",
          Reqs.throttle(e.truncateFeaturedImageText.bind(e), 50)
        );
    },
    ajaxSort: function (e) {
      var t = this,
        i = $(this.selectors.loadMoreIcon);
      i.show(),
        $(this.selectors.collectionProducts).hide().next(".row").hide(),
        $.ajax({
          type: "GET",
          dataType: "html",
          url: e,
          success: function (e) {
            var n = $(e).find(t.selectors.collectionProducts)[0].outerHTML,
              o = $(e).find(t.selectors.collectionProducts).next(".row")[0]
                ? $(e).find(t.selectors.collectionProducts).next(".row")[0]
                    .outerHTML
                : "";
            $(t.selectors.collectionProducts).replaceWith(n),
              $(t.selectors.collectionProducts).next(".row").replaceWith(o),
              i.hide(),
              $(t.selectors.collectionSort).removeClass(t.classes.loading),
              $(t.selectors.body).removeClass(t.classes.ajaxSorting);
          },
        });
    },
    initLoadMore: function () {
      var e = this;
      $(this.selectors.body).on(
        "click",
        e.selectors.loadMoreButton,
        function (t) {
          if (!$(this).hasClass(e.classes.isLoading)) {
            QuickView.hide();
            var i = $(t.target),
              n = i.attr("href");
            t.preventDefault(),
              i.addClass(e.classes.loading),
              e.ajaxLoadMore(n);
          }
        }
      );
    },
    ajaxLoadMore: function (e) {
      var t = this;
      $.ajax({
        type: "GET",
        dataType: "html",
        url: e,
        success: function (e) {
          var i = $(e).find(t.selectors.collectionProducts).html(),
            n = $(e).find(t.selectors.loadMoreButton).attr("href");
          $(t.selectors.collectionProducts)
            .find(t.selectors.gridSpacer)
            .remove(),
            $(i).appendTo(t.selectors.collectionProducts),
            void 0 !== n
              ? $(t.selectors.loadMoreButton)
                  .attr("href", n)
                  .removeClass(t.classes.loading)
              : $(t.selectors.loadMoreButton).remove(),
            (collectionBlocks = $(".js-collectionBlock"));
        },
      });
    },
    setBadgePosition: function (e) {
      $(e).each(function () {
        var e = $(this),
          t = e.find(".product-status-flag");
        if (t.length) {
          var i = e.data("aspectratio"),
            n = e.outerWidth(),
            o = e.outerHeight(),
            r = 0,
            s = 0;
          i < n / o ? (s = (n - o * i) / 2) : (r = (o - n / i) / 2),
            t.css({ top: r, left: s });
        }
      });
    },
    initFilters: function (e) {
      var t = this,
        i = $(e),
        n = $(this.selectors.collectionFilters);
      if (n.length) {
        var o = $(e).data("section-id"),
          r = i.data("collection"),
          s = i.data("sort");
        (this.tags = i.data("tags")),
          this.preventBannerContentOverflow(),
          this.checkFiltersPosition(),
          $(window).on(
            "resize." + o,
            Reqs.debounce(function () {
              t.preventBannerContentOverflow(t), t.checkFiltersPosition(t);
            }, 50)
          ),
          n.on("click", this.selectors.collectionFilterTitle, function () {
            var e =
                (window.innerWidth ||
                  document.documentElement.clientWidth ||
                  document.body.clientWidth) < 1280 ||
                $(".collection__filters--top").length,
              i = !(
                $(this).parent().hasClass(t.classes.isExpanded) ||
                $(this)
                  .parent()
                  .hasClass(t.classes.collectionFilterAccordionExpanded)
              );
            e
              ? ($(this)
                  .parent()
                  .toggleClass(t.classes.isExpanded)
                  .attr("aria-expanded", i)
                  .siblings()
                  .removeClass(t.classes.isExpanded)
                  .attr("aria-expanded", !1),
                n.find(".collection__filter.is-expanded").length
                  ? n.addClass(t.classes.hasTagsExpanded)
                  : n.removeClass(t.classes.hasTagsExpanded))
              : $(this)
                  .parent()
                  .toggleClass(t.classes.collectionFilterAccordionExpanded)
                  .attr("aria-expanded", i)
                  .siblings()
                  .removeClass(t.classes.isExpanded)
                  .attr("aria-expanded", !1);
          }),
          $(document).on("click", function (e) {
            $(e.target).is(".collection__filters *") ||
              n
                .find(t.selectors.collectionFilter)
                .removeClass(t.classes.isExpanded)
                .attr("aria-expanded", !1)
                .end()
                .removeClass(t.classes.hasTagsExpanded);
          }),
          n.on("click", this.selectors.collectionFilterTagButton, function (o) {
            var a = $(this).parent(),
              l = $(this).data("tag");
            a.hasClass(t.classes.isActive),
              a.addClass(t.classes.isActive),
              t.tags.length > 0 && t.tags.pop(),
              t.tags.push(l),
              i.attr("data-tags", t.tags),
              n
                .find(t.selectors.collectionFilter)
                .removeClass(t.classes.isExpanded)
                .attr("aria-expanded", !1)
                .end()
                .removeClass(t.classes.hasTagsExpanded);
            var c = r + "/" + t.tags.join("+") + "?sort_by=" + s;
            t.requestFilteredProducts(t, e, c), o.preventDefault();
          }),
          this.bindResetButton(e);
      }
    },
    requestFilteredProducts: function (e, t, i) {
      var n = e,
        o = $(t),
        r = $(t).data("section-id"),
        s = parseInt(
          Math.ceil($(n.selectors.collectionWrapper).offset().top) - 60
        ),
        a = "scroll.endlessScroll--" + r + " resize.endlessScroll--" + r;
      $(window).off(a),
        null != n.filterProductsRequest && n.filterProductsRequest.abort(),
        n.tags.length ||
          ($(n.selectors.collectionFiltersResetButton)
            .removeClass(n.classes.isVisible)
            .slideUp(300),
          $(n.selectors.collectionFilters).removeClass(
            n.classes.collectionFiltersHasTagsSelected
          )),
        $(n.selectors.collectionWrapper).addClass(n.classes.isLoading),
        $("html, body").stop(!0).animate({ scrollTop: s }, 300),
        (n.filterProductsRequest = $.ajax({
          method: "GET",
          url: i,
          dataType: "html",
        })
          .done(function (e) {
            var r = $(e).find(n.selectors.collectionProducts).html(),
              s = $(e).find(n.selectors.productsFoundLabel).html(),
              a = $(e).find(n.selectors.collectionPagination);
            if (
              (o.html(r),
              $(n.selectors.productsFoundLabel).html(s),
              a.length
                ? $(n.selectors.collectionPagination, t).html(a.html())
                : $(n.selectors.collectionPagination, t).empty(),
              n.bindResetButton(t),
              Site.animations.animateAll(),
              Site.initReviews(),
              ajaxify(),
              "contain" == window.theme.settings.imageBackgroundSize)
            ) {
              var l = $(n.selectors.collectionBlockImage, t);
              n.setBadgePosition(l),
                $(window)
                  .off("resize.products")
                  .on(
                    "resize.products",
                    Reqs.debounce(Collection.setBadgePosition.bind(this, l), 50)
                  );
            }
            n.tags.length &&
              ($(n.selectors.collectionFiltersResetButton)
                .addClass(n.classes.isVisible)
                .slideDown(300),
              $(n.selectors.collectionFilters).addClass(
                n.classes.collectionFiltersHasTagsSelected
              )),
              setTimeout(function () {
                $(n.selectors.collectionWrapper).removeClass(
                  n.classes.isLoading
                );
              }, 450),
              history.replaceState &&
                window.history.pushState({ path: i }, "", i);
          })
          .fail(function (e, t, i) {
            $(n.selectors.collectionWrapper).removeClass(n.classes.isLoading);
          }));
    },
    checkFiltersPosition: function () {
      var e = $(this.selectors.collectionFilters).hasClass(
          this.classes.collectionFiltersTop
        ),
        t = window.innerWidth || document.documentElement.clientWidth,
        i = $(this.selectors.collectionFilters).children().first().width(),
        n = $(this.selectors.collectionFiltersResetButton),
        o = $(this.selectors.collectionFilter),
        r = n.outerWidth(!0),
        s = 0;
      (e || t < 1280) &&
        (o.each(function () {
          s += $(this).outerWidth(!0);
        }),
        i - s - 60 < r
          ? n
              .parent()
              .addClass(this.classes.collectionFiltersResetButtonFullwidth)
          : n
              .parent()
              .removeClass(this.classes.collectionFiltersResetButtonFullwidth));
    },
    preventBannerContentOverflow: function () {
      var e = $(this.selectors.collectionBannerImage),
        t = $(this.selectors.collectionBannerContent).outerHeight();
      e.css("min-height", t);
    },
    bindResetButton: function (e) {
      var t = this,
        i = $(t.selectors.collectionFilters),
        n = $(e).data("collection") + "/?sort_by=" + $(e).data("sort");
      $(this.selectors.collectionFiltersResetButton).on("click", function (o) {
        i.find(t.selectors.collectionFilter).removeClass(t.classes.isExpanded),
          i
            .find(t.selectors.collectionFilterTag)
            .removeClass(t.classes.isActive),
          i.removeClass(t.classes.hasTagsExpanded),
          (t.tags = []),
          $(e).attr("data-tags", !1),
          t.requestFilteredProducts(t, e, n),
          o.preventDefault();
      });
    },
    truncateFeaturedImageText: function () {
      var e = $("h2", this.selectors.collectionFeaturedImage),
        t = $("p", this.selectors.collectionFeaturedImage),
        i = 4,
        n = window.theme.settings.imageAspectRatio,
        o = window.innerWidth || document.documentElement.clientWidth;
      (n < 1 || o < 768) && (i = 2),
        e.trunk8({ lines: 2 }),
        t.trunk8({ lines: i });
    },
  },
  ListCollections = {
    selectors: {
      listCollectionsContainer: ".collectionList",
      collectionBlock: ".collectionBlock",
      collectionBlockTitle: ".collectionBlock-info h2",
      collectionBlockText: ".collectionBlock-info h4",
    },
    classes: { isLoading: "is-loading", gridLargeOneQuarter: "lg_s14" },
    init: function () {
      var e = this;
      $(this.selectors.listCollectionsContainer).each(function () {
        var t = $(this),
          i = t.data("section-id");
        e.truncateBlockText(t),
          $(window).on(
            "resize." + i,
            Reqs.throttle(e.truncateBlockText.bind(e, t), 50)
          ),
          $(document).on("ajaxify:updated", function () {
            e.truncateBlockText(t);
          });
      });
    },
    truncateBlockText: function (e) {
      var t = e
        .find(this.selectors.collectionBlock)
        .hasClass(this.classes.gridLargeOneQuarter)
        ? 2
        : 3;
      $(this.selectors.collectionBlockText, e).trunk8({ lines: t }),
        $(this.selectors.collectionBlockTitle, e).trunk8({ lines: 2 }),
        $(this.selectors.collectionBlock, e).removeClass(
          this.classes.isLoading
        );
    },
  },
  QuickView = {
    selectors: {
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      section: "[data-section-id]",
      quickViewButton: ".js-quickView-button",
      closeButton: ".js-quickView-close",
      collectionGrid: ".js-collectionGrid",
      productMedia: "[data-product-single-media-group]",
      productMediaSlider: "[data-product-single-media-slider]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productMediaThumbs: "[data-product-single-media-thumbs]",
      productMediaTypeVideo: "[data-product-media-type-video]",
      productMediaTypeModel: "[data-product-media-type-model]",
      productTitle: "[data-product-title]",
      productPrice: "[data-product-price]",
      comparePrice: "[data-compare-price]",
      unitPrice: "[data-unit-price]",
      unitBase: "[data-unit-base]",
      unitWrapper: "[data-unit-wrapper]",
      originalSelectorId: "[data-product-select]",
      singleOptionSelector: "[data-single-option-selector]",
      priceWrapper: "[data-price-wrapper]",
      productForm: "[data-product-form]",
      productFormWrapper: "[data-product-form-wrapper]",
      productFormBlock: ".productForm-block",
      productFormSelectWrapper: ".selector-wrapper",
      productDescription: "[data-product-description]",
      collectionBlock: "[data-collection-block]",
    },
    init: function () {
      var e = this,
        t = (this.isQuickViewLoading = !1);
      $(document).on("click", this.selectors.quickViewButton, function (i) {
        var n = $(this),
          o = $(this).closest(e.selectors.collectionBlock),
          r = $(this).attr("href"),
          s = n.closest(e.selectors.section).data("section-id");
        t ||
          ((e.isQuickViewLoading = !0),
          o.addClass("quickView--is-loading"),
          o.hasClass("is-loaded") && o.hasClass("quickView--is-visible")
            ? e.hide(e)
            : !o.hasClass("is-loaded") ||
              o.hasClass("quickView--is-visible") ||
              $(".quickView--is-visible").length
            ? o.hasClass("is-loaded") &&
              !o.hasClass("quickView--is-visible") &&
              $(".quickView--is-visible").length
              ? (e.hide(e),
                setTimeout(function () {
                  e.show(o);
                }, 200))
              : $(".quickView--is-visible").length
              ? (e.hide(e),
                setTimeout(function () {
                  e.ajaxSearch(o, r, s);
                }, 200))
              : e.ajaxSearch(o, r, s)
            : e.show(o)),
          i.preventDefault();
      });
    },
    show: function (e) {
      var t = this,
        i = ($(window).height() - 680) / 2,
        n = e.children(".quickView").offset().top - i - 60,
        o = !$("body").hasClass("no-outline");
      e.addClass("quickView--is-active"),
        e.removeClass("quickView--is-loading"),
        $("html, body")
          .stop(!0, !0)
          .animate({ scrollTop: n }, 300, function () {
            Site.initReviews(),
              e.hasClass("is-loaded")
                ? e.addClass("quickView--is-visible")
                : e.addClass("quickView--is-visible is-loaded"),
              (t.isQuickViewLoading = !1);
          }),
        $("html, body").trigger("quickView:show"),
        o && e.find(this.selectors.closeButton).focus();
    },
    hide: function () {
      var e = $(this.selectors.collectionBlock);
      e.hasClass("quickView--is-visible") &&
        e.removeClass(
          "quickView--is-visible quickView--is-active quickView--is-loading"
        ),
        e
          .find(".product-image.is-selected")
          .trigger("mediaHidden")
          .addClass("media--hidden"),
        setTimeout(function () {
          Site.animations.animateAll();
        }, 300),
        $("html, body").trigger("quickView:hide");
    },
    ajaxSearch: function (e, t, i) {
      var n = this,
        o = window.theme.settings.showProductDescription;
      e.addClass("quickView--is-loading"),
        $.ajax({ url: t, cache: !1, dataType: "html" }).done(function (r) {
          var s,
            a = $(r).find("#ProductJson--product-template").text(),
            l = $(r).find("#ModelJson-product-template").html(),
            c = JSON.parse(a),
            d = n.modifyProductMediaSettings(
              $(r).find(n.selectors.productMediaSlider),
              n.settings
            ),
            u = $(r).find(n.selectors.productMediaThumbs).html(),
            p = n.addProductTitleLink($(r).find(n.selectors.productTitle), t),
            h = n.modifyProductFormIds(
              $(r).find(n.selectors.productForm),
              c.id
            ),
            f = o ? $(r).find(n.selectors.productDescription).html() : "",
            m = 1 == $(r).find(".js-productImgContainer > .js-slide").length,
            g = $("#ProductQuickViewTemplate--" + i).html();
          s = {
            productMediaSlider: d,
            productMediaThumbs: u,
            productTitle: p,
            productForm: h,
            productDescription: f,
            productMediaJson: l,
            isProductMediaSingle: m,
          };
          var v = Sqrl.render(g, s);
          e.append(v),
            e.attr("data-section-id", "product-template"),
            e.on("click", n.selectors.closeButton, function (e) {
              e.preventDefault(), n.hide(n);
            }),
            n.initProductMediaSlider(e),
            n.initProductVideo(e),
            n.initMediaSwitch(e),
            n.initModelViewerLibraries(e),
            n.initShopifyXrLaunch(e),
            n.initVariants(e, c),
            n.initPaymentButton(e),
            n.show(e),
            $("html, body").trigger("quickView:ajax");
        });
    },
    initProductMediaSlider: function (e) {
      var t = this,
        i = $(e),
        n = i.find(".js-productImgSlider"),
        o = i.find(".js-productImgSlider-nav"),
        r = n.data("arrows"),
        s = !(
          n.find(".product-single__media--video").length ||
          n.find(".product-single__media--model").length
        ),
        a = n.find(".is-selected-product").index(),
        l = window.innerWidth || document.documentElement.clientWidth;
      if (((a = -1 == a ? 0 : a), n.find(".js-slide").length > 1)) {
        function c() {
          var e = o.data("flickity"),
            t = Site.sliders.checkThumbnailsOverflow(o);
          null != e && o.flickity("destroy"),
            o.flickity({
              cellSelector: ".js-slide",
              asNavFor: n[0],
              initialIndex: a,
              pageDots: !1,
              prevNextButtons: t,
              arrowShape: window.theme.icons.arrowNavSlider,
              contain: !0,
              wrapAround: t,
            });
        }
        n
          .on("ready.flickity", function () {
            n.attr("tabindex", "-1"),
              n.find(".js-slide").attr("tabindex", "-1");
          })
          .on("change.flickity", function (e, t) {
            var i = n
              .find(".js-slide")
              .eq(t)
              .find(".product-single__media--image");
            i.hasClass("lazyloaded") || i.addClass("lazyload");
          })
          .on("settle.flickity", function (i, o) {
            var r = n.find(".js-slide").eq(o).data("media-id");
            t.switchMedia(e, r);
          }),
          n.flickity({
            cellSelector: ".js-slide",
            prevNextButtons: r,
            arrowShape: window.theme.icons.arrowNavSlider,
            pageDots: !1,
            initialIndex: a,
            draggable: s,
            adaptiveHeight: !0,
            contain: !0,
            wrapAround: !0,
          }),
          o.on("ready.flickity", function () {
            o.attr("tabindex", "-1");
          }),
          c(),
          $(window).on(
            "resize.product",
            Reqs.debounce(function () {
              var e = window.innerWidth || document.documentElement.clientWidth;
              l != e && c(), (l = e);
            }, 250)
          );
      }
    },
    handleMediaFocus: function (e) {
      if (13 === e.keyCode || 9 === e.keyCode) {
        var t = $(e.currentTarget).closest(this.selectors.collectionBlock),
          i = $(e.currentTarget).data("thumbnail-id"),
          n = $(
            this.selectors.productMediaWrapper + '[data-media-id="' + i + '"]',
            t
          ).index(),
          o = $(this.selectors.productMediaSlider, t).data("flickity");
        (flickNav = $(this.selectors.productMediaThumbs, t).data("flickity")),
          o && o.isActive && n > -1 && 13 === e.keyCode && o.select(n),
          flickNav && flickNav.isActive && n > -1 && flickNav.select(n);
      }
    },
    switchMedia: function (e, t) {
      var i = $(e),
        n = $(this.selectors.productMediaWrapper + ":not(.media--hidden)", i),
        o = $(
          this.selectors.productMediaWrapper + '[data-media-id="' + t + '"]',
          i
        ),
        r = $(
          this.selectors.productMediaWrapper +
            ':not([data-media-id="' +
            t +
            '"])',
          i
        );
      !$("body").hasClass("no-outline") && o.focus(),
        n.trigger("mediaHidden"),
        o.removeClass("media--hidden").trigger("mediaVisible"),
        r.addClass("media--hidden");
    },
    initMediaSwitch: function (e) {
      var t = $(e),
        i = $("[data-thumbnail-id]", t);
      i.length &&
        i
          .on("click", function (e) {
            e.preventDefault();
          })
          .on("keyup", this.handleMediaFocus.bind(this));
    },
    initProductVideo: function (e) {
      var t = $(e).data("section-id");
      $(this.selectors.productMediaTypeVideo, e).each(function () {
        var e = $(this);
        ProductVideo.init(e, t);
      });
    },
    initModelViewerLibraries: function (e) {
      var t = $(e).data("section-id"),
        i = $(this.selectors.productMediaTypeModel, e);
      i.length < 1 || ProductModel.init(i, t);
    },
    initShopifyXrLaunch: function (e) {
      var t = this;
      $(document).on("shopify_xr_launch", function () {
        $(t.selectors.productMediaWrapper + ":not(.media--hidden)", e).trigger(
          "xrLaunch"
        );
      });
    },
    initVariants: function (e, t) {
      var i = $(e),
        n = ".product" + $(e).data("section-id"),
        o = {
          $container: i,
          enableHistoryState: !1,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: t,
        };
      (this.$container = $(e)),
        (this.variants = new slate.Variants(o)),
        i.on("variantChange" + n, this.updateAddToCartState.bind(this)),
        i.on("variantChange" + n, this.updateColorName.bind(this)),
        i.on("variantPriceChange" + n, this.updateProductPrices.bind(this)),
        i.on("variantUnitChange" + n, this.updateProductUnits.bind(this)),
        i.on("variantImageChange" + n, this.updateProductImage.bind(this));
    },
    updateAddToCartState: function (e) {
      var t = e.variant;
      t
        ? t.available
          ? ($(this.selectors.addToCart, this.$container).prop("disabled", !1),
            $(this.selectors.addToCartText, this.$container).html(
              window.theme.translations.add_to_cart
            ),
            $(this.selectors.notificationForm, this.$container).addClass(
              "visually-hidden"
            ))
          : ($(this.selectors.addToCart, this.$container).prop("disabled", !0),
            $(this.selectors.addToCartText, this.$container).html(
              window.theme.translations.sold_out
            ),
            $(this.selectors.notificationForm, this.$container).removeClass(
              "visually-hidden"
            ))
        : ($(this.selectors.addToCart, this.$container).prop("disabled", !0),
          $(this.selectors.addToCartText, this.$container).html(
            window.theme.translations.unavailable
          ),
          $(this.selectors.notificationForm, this.$container).removeClass(
            "visually-hidden"
          ));
    },
    updateColorName: function (e) {
      debugger;
      var t = $(this.selectors.colorSwatch, this.$container)
        .filter(":checked")
        .val();
      $(this.selectors.colorLabel).text(t);
      console.log(t);
    },
    updateProductPrices: function (e) {
      var t = e.variant,
        i = $(this.selectors.comparePrice, this.$container);
      $(this.selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(t.price, window.moneyFormat)
      ),
        t.compare_at_price > t.price
          ? i
              .html(
                slate.Currency.formatMoney(
                  t.compare_at_price,
                  window.moneyFormat
                )
              )
              .removeClass("visually-hidden")
          : i.html("").addClass("visually-hidden");
    },
    updateProductUnits: function (e) {
      var t = e.variant;
      if (void 0 !== t.unit_price) {
        var i = slate.Currency.formatMoney(t.unit_price, window.moneyFormat),
          n = this.getBaseUnit(t);
        $(this.selectors.unitPrice, this.$container).html(i),
          $(this.selectors.unitBase, this.$container).html(n),
          $(this.selectors.unitWrapper, this.$container).show();
      } else $(this.selectors.unitWrapper, this.$container).hide();
    },
    getBaseUnit: function (e) {
      return 1 === e.unit_price_measurement.reference_value
        ? e.unit_price_measurement.reference_unit
        : e.unit_price_measurement.reference_value +
            e.unit_price_measurement.reference_unit;
    },
    updateProductImage: function (e) {
      var t = e.variant,
        i = t.featured_media ? t.featured_media.id : "",
        n = $(this.selectors.productMediaSlider, this.$container),
        o = n.data("flickity");
      if (o && o.isActive) {
        var r = n.find('[data-id="' + i + '"]');
        -1 != r.index() && o.select(r.index());
      }
    },
    initPaymentButton: function (e) {
      var t = window.theme.settings.enablePaymentButton,
        i = window.theme.settings.enableAcceptTerms,
        n = $(this.selectors.addToCart, e);
      t && !i
        ? (n.addClass("button--alt"),
          Shopify.PaymentButton && Shopify.PaymentButton.init())
        : n.removeClass("button--alt");
    },
    modifyProductMediaSettings: function (e) {
      return (
        e.find(".product-image").each(function () {
          $(this)
            .attr(
              "data-enable-video-looping",
              window.theme.settings.enableVideoLooping
            )
            .attr("data-show_quantity", window.theme.settings.showQuantity)
            .attr("tabindex", "-1");
        }),
        e.html()
      );
    },
    modifyProductFormIds: function (e, t) {
      return (
        e.find("[id]").each(function () {
          var e = $(this).attr("id") + "--" + t + "-quickView";
          $(this).attr("id", e);
        }),
        e.find("[for]").each(function () {
          var e = $(this).attr("for") + "--" + t + "-quickView";
          $(this).attr("for", e);
        }),
        e.html()
      );
    },
    addProductTitleLink: function (e, t) {
      var i = e.find(".product-title").text();
      return (
        e.find(".product-title").html('<a href="' + t + '">' + i + "</a>"),
        e.html()
      );
    },
  },
  Product = {
    selectors: {
      body: "body",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      productPrice: "[data-product-price]",
      comparePrice: "[data-compare-price]",
      unitPrice: "[data-unit-price]",
      unitBase: "[data-unit-base]",
      unitWrapper: "[data-unit-wrapper]",
      priceWrapper: "[data-price-wrapper]",
      notificationForm: "[data-notification-form]",
      originalSelectorId: "[data-product-select]",
      singleOptionSelector: "[data-single-option-selector]",
      productSection: '[data-section-type="product"]',
      productSectionContainer: ".js-product-template",
      productSliderContainer: ".js-productImgContainer",
      productSlider: "[data-product-single-media-slider]",
      productSliderNav: ".js-productImgSlider-nav",
      productSlide: ".js-slide",
      productScroller: ".js-productImgScroller",
      productScrollerNav: ".js-productImgScroller-nav",
      productSelected: ".is-selected-product",
      productMediaSlider: "[data-product-single-media-slider]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productMediaTypeVideo: "[data-product-media-type-video]",
      productMediaTypeModel: "[data-product-media-type-model]",
      productMediaVideo: ".product-single__media--video",
      productMediaModel: ".product-single__media--model",
      productMediaImage: ".product-single__media--image",
      productMediaThumb: ".product-single__media-thumb",
      productThumbnail: ".js-product-single__thumbnail",
      productImageLightboxLink: "[data-lightbox-link]",
      productLayoutScrollable: ".product-layout--scrollable",
      productTabs: ".js-product-tabs",
      productTabsNav: ".product-tabs-nav",
      productTabsContents: ".product-tabs-contents",
      productTabTitle: ".product-tab-title",
      productTabContent: ".product-tab-content",
      productForm: ".productForm",
      productFormBlock: ".productForm-block",
      productFormSelectWrapper: ".selector-wrapper",
      storeAvailabilityContainer: "[data-store-availability-container]",
      cartStatus: "[data-cart-status]",
      colorSwatch: "[data-color-swatch]",
      colorLabel: "[data-color-label]",
      shopBar: ".shop-bar",
      zoomContainer: ".zoom-container",
    },
    classes: { visibilityHidden: "visibility-hidden" },
    init: function (e, t) {
      var i = this;
      if ((e = void 0 !== e && e)) {
        var n = document.querySelector('[data-section-id="' + t + '"]');
        this.initSingleProduct(n, e);
      } else
        document
          .querySelectorAll(this.selectors.productSection)
          .forEach((t) => {
            i.initSingleProduct(t, e);
          });
    },
    initSingleProduct: function (e, t) {
      var i = this,
        n = $(this.selectors.shopBar, e).length,
        o = $(this.selectors.productLayoutScrollable, e).length,
        r = $(e).hasClass("onboarding-product"),
        s = !$(e).hasClass("featured-product");
      r
        ? (this.qtyAdjust(),
          $(this.selectors.colorSwatch, e).on("change", function () {
            var t = $(i.selectors.colorSwatch, e).filter(":checked").val();
            $(i.selectors.colorLabel, e).text(t);
          }))
        : (s
            ? ((this.mfpOpen = !0),
              (this.storeAvailabilityContainer = e.querySelector(
                this.selectors.storeAvailabilityContainer
              )),
              this.storeAvailabilityContainer &&
                (this.storeAvailability = new theme.StoreAvailability(
                  this.storeAvailabilityContainer
                )),
              this.initProductTabs(e),
              this.initImageGallery(e),
              this.qtyAdjust(),
              o ? this.initScroller(e, t) : this.initProductMediaSlider(e),
              n && this.initShopBar(e))
            : this.initProductMediaSlider(e),
          this.initProductVideo(e),
          this.initMediaSwitch(e),
          this.initModelViewerLibraries(e),
          this.initShopifyXrLaunch(e),
          this.initVariants(e),
          Site.initReviews());
    },
    initVariants: function (e) {
      var t = $(e),
        i = $(e).data("section-id"),
        n = ".product" + i,
        o = JSON.parse(document.getElementById("ProductJson--" + i).innerHTML),
        r = {
          $container: t,
          enableHistoryState: !$(e).hasClass("featured-product"),
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: o,
        };
      (this.variants = new slate.Variants(r)),
        (this.productSingleObject = o),
        this.storeAvailability &&
          this.storeAvailability.updateContent(
            this.variants.currentVariant.id,
            r.product.title
          ),
        t.on("variantChange" + n, this.updateAddToCartState.bind(this)),
        t.on("variantChange" + n, this.updateColorName.bind(this)),
        t.on("variantChange" + n, this.updateAvailability.bind(this)),
        t.on("variantPriceChange" + n, this.updateProductPrices.bind(this)),
        t.on("variantUnitChange" + n, this.updateProductUnits.bind(this)),
        t.on("variantImageChange" + n, this.updateProductImage.bind(this));
    },
    updateAddToCartState: function (e) {
      var t = e.target,
        i = e.variant,
        n = $(this.selectors.shopBar);
      i
        ? i.available
          ? ($(this.selectors.addToCart, t).prop("disabled", !1),
            $(this.selectors.addToCartText, t).html(
              window.theme.translations.add_to_cart
            ),
            $(this.selectors.notificationForm, t).addClass("visually-hidden"))
          : ($(this.selectors.addToCart, t).prop("disabled", !0),
            $(this.selectors.addToCartText, t).html(
              window.theme.translations.sold_out
            ),
            $(this.selectors.notificationForm, t).removeClass(
              "visually-hidden"
            ))
        : ($(this.selectors.addToCart, t).prop("disabled", !0),
          $(this.selectors.addToCartText, t).html(
            window.theme.translations.unavailable
          ),
          $(this.selectors.notificationForm, t).removeClass("visually-hidden")),
        n.length &&
          (i
            ? i.available
              ? ($(this.selectors.addToCart, n).prop("disabled", !1),
                $(this.selectors.addToCartText, n).html(
                  window.theme.translations.add_to_cart
                ))
              : ($(this.selectors.addToCart, n).prop("disabled", !0),
                $(this.selectors.addToCartText, n).html(
                  window.theme.translations.sold_out
                ))
            : ($(this.selectors.addToCart, n).prop("disabled", !0),
              $(this.selectors.addToCartText, n).html(
                window.theme.translations.unavailable
              )));
    },
    updateColorName: function (e) {
      var t = e.target,
        i = $(this.selectors.colorSwatch, t).filter(":checked").val();
      $(this.selectors.colorLabel, t).text(i);
    },
    updateProductPrices: function (e) {
      var t = e.target,
        i = e.variant,
        n = $(this.selectors.comparePrice, t).add(
          $(this.selectors.comparePrice, this.selectors.shopBar)
        );
      $(this.selectors.productPrice, t)
        .add($(this.selectors.productPrice, this.selectors.shopBar))
        .html(slate.Currency.formatMoney(i.price, window.moneyFormat)),
        i.compare_at_price > i.price
          ? n
              .html(
                slate.Currency.formatMoney(
                  i.compare_at_price,
                  window.moneyFormat
                )
              )
              .removeClass("visually-hidden")
          : n.html("").addClass("visually-hidden");
    },
    updateProductUnits: function (e) {
      var t = e.target,
        i = e.variant;
      if (void 0 !== i.unit_price) {
        var n = slate.Currency.formatMoney(i.unit_price, window.moneyFormat),
          o = this.getBaseUnit(i);
        $(this.selectors.unitPrice, t).html(n),
          $(this.selectors.unitBase, t).html(o),
          $(this.selectors.unitWrapper, t).show();
      } else $(this.selectors.unitWrapper, t).hide();
    },
    getBaseUnit: function (e) {
      return 1 === e.unit_price_measurement.reference_value
        ? e.unit_price_measurement.reference_unit
        : e.unit_price_measurement.reference_value +
            e.unit_price_measurement.reference_unit;
    },
    updateAvailability: function (e) {
      this.updateStoreAvailabilityContent(e);
    },
    updateStoreAvailabilityContent: function (e) {
      if (this.storeAvailability) {
        var t = e.variant;
        t
          ? this.storeAvailability.updateContent(
              t.id,
              this.productSingleObject.title
            )
          : this.storeAvailability.clearContent();
      }
    },
    updateProductImage: function (e) {
      var t = e.target,
        i = e.variant,
        n = i.featured_media ? i.featured_media.id : "",
        o = $(this.selectors.productLayoutScrollable, t).length,
        r = $(this.selectors.productSlider, t),
        s = r.data("flickity");
      if (s && s.isActive) {
        var a = r.find('[data-id="' + n + '"]');
        -1 != a.index() && s.select(a.index());
      }
      if (
        o &&
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) >= 768
      ) {
        var l = $(this.selectors.productMediaWrapper + '[data-id="' + n + '"]');
        if (l.length) {
          var c = l.data("media-id");
          $("html, body")
            .stop(!0, !1)
            .animate({ scrollTop: l.offset().top - 59 - 40 }, 500, function () {
              Product.switchMedia(t, c);
            });
        }
      }
    },
    initProductMediaSlider: function (e) {
      var t = this,
        i = $(this.selectors.productSlider, e),
        n = $(this.selectors.productSliderNav, e),
        o = i.data("arrows"),
        r = i.data("dots"),
        s = !(
          $(this.selectors.productMediaVideo, i).length ||
          $(this.selectors.productMediaModel, i).length
        ),
        a = $(this.selectors.productSelected, i).index(),
        l = $(this.selectors.productSlide, i).length > 1,
        c = window.innerWidth || document.documentElement.clientWidth;
      if (((a = -1 == a ? 0 : a), l)) {
        function d() {
          var e = n.data("flickity"),
            t = Site.sliders.checkThumbnailsOverflow(n);
          null != e && n.flickity("destroy"),
            n.flickity({
              cellSelector: ".js-slide",
              asNavFor: i[0],
              initialIndex: a,
              pageDots: !1,
              prevNextButtons: t,
              arrowShape: window.theme.icons.arrowNavSlider,
              contain: !0,
              wrapAround: t,
            });
        }
        i
          .on("ready.flickity", function () {
            i.attr("tabindex", "-1"),
              $(t.selectors.productSlide, i).attr("tabindex", "-1");
          })
          .on("change.flickity", function (e, n) {
            var o = $(t.selectors.productSlide, i).eq(n),
              r = $(t.selectors.productMediaImage, o);
            r.hasClass("lazyloaded") || r.addClass("lazyload"),
              setTimeout(function () {
                t.mfpOpen = !0;
              }, 10);
          })
          .on("dragStart.flickity", function (e, i) {
            t.mfpOpen = !1;
          })
          .on("settle.flickity", function (n, o) {
            var r = $(t.selectors.productSlide, i).eq(o).data("media-id");
            t.switchMedia(e, r);
          }),
          i.flickity({
            cellSelector: t.selectors.productSlide,
            prevNextButtons: o,
            arrowShape: window.theme.icons.arrowNavSlider,
            pageDots: r,
            initialIndex: a,
            draggable: s,
            adaptiveHeight: !0,
            contain: !0,
            wrapAround: !0,
          }),
          n.on("ready.flickity", function () {
            n.attr("tabindex", "-1");
          }),
          d(),
          $(window).on(
            "resize.product",
            Reqs.debounce(function () {
              var e = window.innerWidth || document.documentElement.clientWidth;
              c != e && d(), (c = e);
            }, 250)
          );
      }
    },
    initImageGallery: function (e) {
      var t = this,
        i = $(t.selectors.productSliderContainer, e);
      i.data("lightbox") &&
        (Reqs.lightbox(),
        Reqs.zoom(),
        $(t.selectors.productImageLightboxLink, i).magnificPopup({
          mainClass: "mfp-fade-in-up",
          type: "image",
          removalDelay: 300,
          fixedContentPos: !0,
          closeOnContentClick: !1,
          closeOnBgClick: !1,
          closeBtnInside: !0,
          gallery: {
            enabled: !0,
            preload: 0,
            tCounter: '<div class="mfp-counter-text">%curr% / %total%</div>',
            arrowMarkup:
              '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%">' +
              window.theme.icons.arrowSlider +
              "</button>",
          },
          tLoading: '<span class="icon-loader"></span>',
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close">' +
            window.theme.icons.close +
            "</button>",
          disableOn: function () {
            return t.mfpOpen;
          },
          callbacks: {
            open: function () {
              var e = $(this.currItem.el).attr("href"),
                i = $(this.contentContainer);
              t.initZoom(e, i);
            },
            change: function () {
              var e = $(this.currItem.el).attr("href"),
                i = $(this.contentContainer);
              t.initZoom(e, i);
            },
          },
        }));
    },
    initZoom: function (e, t) {
      $(this.selectors.zoomContainer, t).length ||
        t.append('<span class="zoom-container"></span>'),
        t
          .find(this.selectors.zoomContainer)
          .removeClass("zoom-container--loaded is-zoomed")
          .trigger("zoom.destroy")
          .empty()
          .zoom({
            on: "click",
            url: e,
            magnify: 1.5,
            duration: 500,
            callback: function () {
              $(this)
                .parent()
                .removeClass("is-zoomed")
                .addClass("zoom-container--loaded");
            },
            onZoomIn: function () {
              $(this).parent().addClass("is-zoomed");
            },
            onZoomOut: function () {
              $(this).parent().removeClass("is-zoomed");
            },
          });
    },
    initProductTabs: function (e) {
      var t = this,
        i = $(this.selectors.productTabs, e);
      enquire.register("screen and (min-width: 768px)", function () {
        var e = $(t.selectors.productTabsNav, i),
          n = $(t.selectors.productTabsContents, i);
        $(t.selectors.productTabTitle, i).remove().appendTo(e),
          $(t.selectors.productTabContent, i).remove().appendTo(n);
      }),
        enquire.register("screen and (max-width: 767px)", function () {
          for (
            var e = $(t.selectors.productTabTitle, i),
              n = $(t.selectors.productTabContent, i),
              o = 0;
            o < e.length;
            o++
          )
            e.eq(o).remove().appendTo(i), n.eq(o).remove().appendTo(i);
        }),
        i.on("click", t.selectors.productTabTitle, function () {
          var e = $(this).index(),
            n = $(this).hasClass("is-active"),
            o = $(this).siblings(t.selectors.productTabTitle).length + 1,
            r =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth;
          (1 == o && r >= 768) ||
            (i.find(t.selectors.productTabTitle).removeClass("is-active"),
            i.find(t.selectors.productTabContent).removeClass("is-active"),
            n
              ? (e++,
                i.find(t.selectors.productTabTitle).eq(e).length || (e = 0),
                r >= 768
                  ? (i
                      .find(t.selectors.productTabTitle)
                      .eq(e)
                      .addClass("is-active")
                      .siblings()
                      .removeClass("is-active"),
                    i
                      .find(t.selectors.productTabContent)
                      .eq(e)
                      .addClass("is-active")
                      .siblings()
                      .removeClass("is-active"))
                  : $(this).next().next(t.selectors.productTabTitle).length
                  ? $(this)
                      .next()
                      .next(t.selectors.productTabTitle)
                      .addClass("is-active")
                      .next(t.selectors.productTabContent)
                      .addClass("is-active")
                  : 1 == o
                  ? $(this)
                      .removeClass("is-active")
                      .next(t.selectors.productTabContent)
                      .removeClass("is-active")
                  : $(this)
                      .parent()
                      .find(t.selectors.productTabTitle)
                      .eq(0)
                      .addClass("is-active")
                      .next(t.selectors.productTabContent)
                      .addClass("is-active"))
              : r >= 768
              ? (i
                  .find(t.selectors.productTabTitle)
                  .eq(e)
                  .addClass("is-active")
                  .siblings()
                  .removeClass("is-active"),
                i
                  .find(t.selectors.productTabContent)
                  .eq(e)
                  .addClass("is-active")
                  .siblings()
                  .removeClass("is-active"))
              : $(this)
                  .addClass("is-active")
                  .next(t.selectors.productTabContent)
                  .addClass("is-active"),
            r < 768 &&
              i.find(t.selectors.productTabTitle + ".is-active").length &&
              setTimeout(function () {
                var e =
                  i.find(t.selectors.productTabTitle + ".is-active").offset()
                    .top - 61;
                $("html, body").stop(!0, !0).animate({ scrollTop: e });
              }, 300));
        });
    },
    initScroller: function (e, t) {
      var i = this;
      if ($(this.selectors.productMediaWrapper, e).length > 1) {
        var n = !1,
          o = $(this.selectors.productLayoutScrollable, e),
          r = $(this.selectors.productMediaWrapper, e),
          s = $(this.selectors.productScrollerNav, e);
        function a() {
          var t =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth,
            n = $(i.selectors.productSlide, o).length > 1;
          t < 768 && n
            ? (function () {
                var t = $(i.selectors.productScroller, e),
                  n = $(i.selectors.productScrollerNav, e),
                  o = $(i.selectors.productSlide, e).length > 1,
                  r = t.data("arrows"),
                  s = t.data("dots"),
                  a = Site.sliders.checkThumbnailsOverflow(n),
                  l = !(
                    $(i.selectors.productMediaVideo, t).length ||
                    $(i.selectors.productMediaModel, t).length
                  ),
                  c = $(i.selectors.productSelected, t).index();
                c = -1 == c ? 0 : c;
                var d = t.data("flickity"),
                  u = n.data("flickity");
                o &&
                  (null == d &&
                    (t
                      .on("change.flickity", function (e, n) {
                        var o = $(i.selectors.productSlide, t).eq(n);
                        o.hasClass("lazyloaded") || o.addClass("lazyload"),
                          setTimeout(function () {
                            i.mfpOpen = !0;
                          }, 10);
                      })
                      .on("dragStart.flickity", function (e, t) {
                        i.mfpOpen = !1;
                      }),
                    t.flickity({
                      cellSelector: ".js-slide",
                      prevNextButtons: r,
                      arrowShape: window.theme.icons.arrowNavSlider,
                      pageDots: s,
                      initialIndex: c,
                      draggable: l,
                      selectedAttraction: 0.08,
                      friction: 0.8,
                      adaptiveHeight: !0,
                      draggable: !0,
                      contain: !0,
                      wrapAround: !0,
                    })),
                  null == u &&
                    n.flickity({
                      cellSelector: ".js-slide",
                      asNavFor: t[0],
                      initialIndex: c,
                      pageDots: !1,
                      prevNextButtons: a,
                      arrowShape: window.theme.icons.arrowNavSlider,
                      contain: !0,
                      wrapAround: a,
                    }));
              })()
            : (function () {
                var t = $(i.selectors.productScroller, e),
                  n = $(i.selectors.productScrollerNav, e),
                  o = t.data("flickity"),
                  r = n.data("flickity");
                o && o.isActive && t.flickity("destroy"),
                  r && r.isActive && n.flickity("destroy");
              })();
        }
        function l() {
          if (
            (window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth) >= 768
          )
            for (
              var e = $(window).scrollTop(), t = (o.offset().top, r.length - 1);
              t >= 0;
              t--
            ) {
              var n = $(i.selectors.productMediaWrapper).eq(t),
                a = n.data("id");
              if (e >= parseInt(n.offset().top - 100)) {
                s.find(i.selectors.productMediaThumb + '[data-id="' + a + '"]')
                  .addClass("active")
                  .siblings()
                  .removeClass("active");
                break;
              }
            }
        }
        t && l(),
          $(window)
            .on("scroll.product", Reqs.throttle(l, 10))
            .on("load", function () {
              n = !0;
            }),
          s.on("click", this.selectors.productThumbnail, function (o) {
            if (
              (o.preventDefault(),
              (window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth) >= 768)
            ) {
              var r = $(this).parent().data("id"),
                s = $(
                  i.selectors.productMediaWrapper + '[data-id="' + r + '"]'
                );
              if (s.length) {
                var a = s.data("media-id");
                (n || t) &&
                  $("html, body")
                    .stop(!0, !1)
                    .animate(
                      { scrollTop: s.offset().top - 59 - 40 },
                      500,
                      function () {
                        Product.switchMedia(e, a);
                      }
                    );
              }
            }
          }),
          $(window).on("resize.product", Reqs.throttle(a, 250)),
          a();
      }
    },
    handleMediaFocus: function (e, t) {
      if (13 === e.keyCode || 9 === e.keyCode) {
        var i = $(e.currentTarget).data("thumbnail-id"),
          n = $(
            this.selectors.productSlide + '[data-media-id="' + i + '"]',
            t
          ).index(),
          o = $(this.selectors.productSliderContainer, t).data("flickity"),
          r = $(this.selectors.productSliderNav, t).data("flickity");
        o && o.isActive && n > -1 && 13 === e.keyCode && o.select(n),
          r && r.isActive && n > -1 && r.select(n);
      }
    },
    switchMedia: function (e, t) {
      var i = $(this.selectors.productMediaWrapper + ":not(.media--hidden)", e),
        n = $(
          this.selectors.productMediaWrapper + '[data-media-id="' + t + '"]',
          e
        ),
        o = $(
          this.selectors.productMediaWrapper +
            ':not([data-media-id="' +
            t +
            '"])',
          e
        );
      !$(this.selectors.body).hasClass("no-outline") && n.focus(),
        i.trigger("mediaHidden"),
        n.removeClass("media--hidden").trigger("mediaVisible"),
        o.addClass("media--hidden");
    },
    pauseOtherMedia: function (e, t) {
      var i = $(
          this.selectors.productMediaWrapper + '[data-media-id="' + e + '"]'
        ),
        n = $(
          this.selectors.productMediaWrapper +
            ':not([data-media-id="' +
            e +
            '"])'
        );
      i.removeClass("media--hidden"),
        n.trigger("mediaHidden").addClass("media--hidden");
    },
    initMediaSwitch: function (e) {
      var t = $(this.selectors.productThumbnail, e);
      t.length &&
        t
          .on("click", function (e) {
            e.preventDefault();
          })
          .on("keyup", this.handleMediaFocus.bind(this));
    },
    initProductVideo: function (e) {
      var t = $(e).data("section-id");
      $(this.selectors.productMediaTypeVideo, e).each(function () {
        var e = $(this);
        ProductVideo.init(e, t);
      });
    },
    initModelViewerLibraries: function (e) {
      var t = $(e).data("section-id"),
        i = $(this.selectors.productMediaTypeModel, e);
      i.length < 1 || ProductModel.init(i, t);
    },
    initShopifyXrLaunch: function (e) {
      var t = this;
      $(document).on("shopify_xr_launch", function () {
        $(t.selectors.productMediaWrapper + ":not(.media--hidden)", e).trigger(
          "xrLaunch"
        );
      });
    },
    initShopBar: function (e) {
      var t = this,
        i = $(e).data("section-id"),
        n = ".product" + i,
        o = JSON.parse(document.getElementById("ProductJson--" + i).innerHTML),
        r = $(this.selectors.body),
        s = $(this.selectors.shopBar, e),
        a = $(this.selectors.productSectionContainer, e),
        l = $(".site-footer");
      (enableHistoryState = !1), s.remove().appendTo(r);
      var c = {
        $container: s,
        enableHistoryState: enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: o,
      };
      (this.variants = new slate.Variants(c)),
        s.on("variantChange" + n, this.updateAddToCartState.bind(this)),
        s.on("variantPriceChange" + n, this.updateProductPrices.bind(this)),
        s.on("variantImageChange" + n, this.updateProductImage.bind(this)),
        s.on("change", "select", function (i) {
          var n = $(this).val(),
            o = $(this).data("index"),
            r = $(t.selectors.singleOptionSelector, e).filter(
              '[data-index="' + o + '"]'
            );
          r.is("select")
            ? r.val(n).triggerHandler("change")
            : r
                .filter('[value="' + n + '"]')
                .prop("checked", !0)
                .triggerHandler("change");
        }),
        $(this.selectors.singleOptionSelector, e).on("change", function (e) {
          var t = $(this).data("index"),
            i = $(this).val();
          s.find('[data-index="' + t + '"]')
            .val(i)
            .triggerHandler("change");
        }),
        $(window)
          .on(
            "scroll.product",
            Reqs.throttle(function () {
              var e = $(window).scrollTop();
              if (a.length && s.length) {
                var t = a.offset().top;
                e > t
                  ? (s.addClass("shop-bar--is-visible"),
                    l.addClass("site-footer--push"))
                  : e < t - 60 &&
                    (s.removeClass("shop-bar--is-visible"),
                    l.removeClass("site-footer--push"));
              }
            }, 100)
          )
          .trigger("scroll.product");
    },
    showVariantImage: function (e, t) {
      var i = e.featured_media ? e.featured_media.id : "",
        n = t.find(".product-image"),
        o = t.find(".js-productImgContainer"),
        r = t.find(".productImgScroller-nav"),
        s = o.data("flickity");
      if (s && s.isActive) {
        var a = o.find('[data-id="' + i + '"]');
        -1 != a.index() && s.select(a.index()),
          n.removeClass("is-selected-product"),
          a.addClass("is-selected-product");
      } else {
        var l = r.find('[data-id="' + i + '"] .js-product-single__thumbnail');
        l.length && l.trigger("click");
      }
    },
    qtyAdjust: function () {
      var e = $("body");
      e.off("click", ".js-qty__adjust-btn"),
        e.on("click", ".js-qty__adjust-btn", function (e) {
          e.preventDefault();
          var t = $(this),
            i = $(this).siblings(".qty__adjust-input");
          (qty = (function (e) {
            return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), e;
          })(parseInt(i.val().replace(/\D/g, "")))),
            t.hasClass("increase")
              ? (qty += 1)
              : ((qty -= 1), qty < 1 && (qty = 1)),
            i.val(qty);
        }),
        e.off("focusout", ".qty__adjust > input"),
        e.on("focusout", ".qty__adjust > input", function (e) {
          $(this).val() || $(this).prop("value", 1);
        }),
        e.off("keydown", ".qty__adjust > input"),
        e.on("keydown", ".qty__adjust > input", function (e) {
          var t = $(this).val();
          13 !== e.keyCode || t || $(this).prop("value", 1);
        });
    },
  };
function onYouTubeIframeAPIReady() {
  ProductVideo.loadVideos(ProductVideo.hosts.youtube),
    (window.isYoutubeAPILoaded = !0);
}
window.isYoutubeAPILoaded = !1;
var ProductVideo = (function () {
    var e = {},
      t = { html5: "html5", youtube: "youtube" };
    function i(i) {
      i
        ? (function () {
            for (var i in e)
              if (e.hasOwnProperty(i)) {
                var n = e[i];
                if (n.nativeVideo) continue;
                n.host === t.html5 &&
                  (n.element.setAttribute("controls", "controls"),
                  (n.nativeVideo = !0));
              }
          })()
        : o(t.html5);
    }
    function n(e) {
      return "VIDEO" === e.tagName
        ? t.html5
        : "IFRAME" === e.tagName &&
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            e.src
          )
        ? t.youtube
        : null;
    }
    function o(t) {
      for (var i in e)
        if (e.hasOwnProperty(i)) {
          var n = e[i];
          n.host === t && n.ready();
        }
    }
    return {
      init: function (o, r) {
        if (o.length) {
          var s = o.find("iframe, video")[0],
            a = o.data("mediaId");
          if (s)
            switch (
              ((e[a] = {
                mediaId: a,
                sectionId: r,
                host: n(s),
                container: o,
                element: s,
                ready: function () {
                  !(function (e) {
                    if (!e.player) {
                      var i = e.container,
                        n = i.data("enable-video-looping"),
                        o = i.data("media-id");
                      switch (e.host) {
                        case t.html5:
                          (e.player = new Shopify.Plyr(e.element, {
                            loop: { active: n },
                            focusOnPlay: !0,
                          })),
                            e.player.on("play", function () {
                              Product.pauseOtherMedia(o);
                            });
                          break;
                        case t.youtube:
                          var r = i.data("video-id");
                          e.player = new YT.Player(e.element, {
                            videoId: r,
                            events: {
                              onStateChange: function (e) {
                                0 === e.data && n && e.target.seekTo(0),
                                  1 === e.data && Product.pauseOtherMedia(o);
                              },
                            },
                          });
                      }
                      i.on("mediaHidden xrLaunch", function (i) {
                        e.player &&
                          (e.host === t.html5 && e.player.pause(),
                          e.host === t.youtube &&
                            e.player.pauseVideo &&
                            e.player.pauseVideo());
                      }),
                        i.on("mediaVisible", function (i) {
                          window.theme.isTouch ||
                            (e.player &&
                              (e.host === t.html5 && e.player.play(),
                              e.host === t.youtube &&
                                e.player.playVideo &&
                                e.player.playVideo()));
                        });
                    }
                  })(this);
                },
              }),
              e[a].host)
            ) {
              case t.html5:
                window.Shopify.loadFeatures([
                  { name: "video-ui", version: "1.0", onLoad: i },
                ]),
                  LibraryLoader.load("plyrShopifyStyles");
                break;
              case t.youtube:
                window.isYoutubeAPILoaded
                  ? ProductVideo.loadVideos(ProductVideo.hosts.youtube)
                  : LibraryLoader.load("youtubeSdk");
            }
        }
      },
      hosts: t,
      loadVideos: o,
      removeSectionVideos: function (t) {
        for (var i in e)
          if (e.hasOwnProperty(i)) {
            var n = e[i];
            n.sectionId === t && (n.player && n.player.destroy(), delete e[i]);
          }
      },
    };
  })(),
  ProductModel = (function () {
    var e = {},
      t = {},
      i = {};
    function n(t) {
      if (!t)
        if (window.ShopifyXR) {
          for (var i in e)
            if (e.hasOwnProperty(i)) {
              var o = e[i];
              if (o.loaded) continue;
              var r = $("#ModelJson-" + i);
              window.ShopifyXR.addModels(JSON.parse(r.html())), (o.loaded = !0);
            }
          window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener("shopify_xr_initialized", function () {
            n();
          });
    }
    function o(e) {
      if (!e)
        for (var i in t)
          if (t.hasOwnProperty(i)) {
            var n = t[i];
            n.modelViewerUi ||
              (n.modelViewerUi = new Shopify.ModelViewerUI(n.$element)),
              r(n);
          }
    }
    function r(e) {
      var t = i[e.sectionId];
      e.$container.on("mediaVisible", function () {
        t.$element.attr("data-shopify-model3d-id", e.modelId),
          Product.pauseOtherMedia(e.mediaId),
          window.theme.isTouch || e.modelViewerUi.play();
      }),
        e.$container
          .on("mediaHidden", function () {
            t.$element.attr("data-shopify-model3d-id", t.defaultId),
              e.modelViewerUi.pause();
          })
          .on("xrLaunch", function () {
            e.modelViewerUi.pause();
          }),
        e.$element.on("shopify_model_viewer_ui_toggle_play", function () {
          Product.pauseOtherMedia(e.mediaId);
        });
    }
    return {
      init: function (r, s) {
        (e[s] = { loaded: !1 }),
          r.each(function (e) {
            var n = $(this),
              o = n.data("media-id"),
              r = $(n.find("model-viewer")[0]),
              a = r.data("model-id");
            if (0 === e) {
              var l = n
                .closest("[data-product-single-media-group]")
                .find("[data-shopify-xr]");
              i[s] = { $element: l, defaultId: a };
            }
            t[o] = {
              modelId: a,
              mediaId: o,
              sectionId: s,
              $container: n,
              $element: r,
            };
          }),
          window.Shopify.loadFeatures([
            { name: "shopify-xr", version: "1.0", onLoad: n },
            { name: "model-viewer-ui", version: "1.0", onLoad: o },
          ]),
          LibraryLoader.load("modelViewerUiStyles");
      },
      removeSectionModels: function (i) {
        for (var n in t)
          t.hasOwnProperty(n) &&
            t[n].sectionId === i &&
            (t[n].modelViewerUi.destroy(), delete t[n]);
        delete e[i];
      },
    };
  })(),
  RelatedProducts = {
    init: function () {
      var e = $('[data-section-type="related-products"]'),
        t = e.attr("data-section-id"),
        i = e.data("product-id"),
        n = e.data("limit"),
        o =
          window.theme.routes.product_recommendations_url +
          "?section_id=" +
          t +
          "&limit=" +
          n +
          "&product_id=" +
          i;
      $.get(o).done(function (t) {
        var i = $(t).find('[data-section-type="related-products"]').html();
        e.hide().html(i).slideDown("slow");
        var n = e.find(".collectionBlock-image");
        Site.animations.animateAll(),
          Site.initReviews(),
          "contain" == window.theme.settings.imageBackgroundSize &&
            (Collection.setBadgePosition(n),
            $(window)
              .off("resize.products")
              .on(
                "resize.products",
                Reqs.debounce(Collection.setBadgePosition.bind(this, n), 50)
              ));
      });
    },
  },
  Blog = {
    selectors: {
      blogContainer: "[data-blog-container]",
      blogPosts: "[data-blog-posts]",
      blogPost: "[data-blog-post]",
      blogPostContent: "[data-post-title], [data-post-excerpt]",
    },
    classes: { blogPostHasImage: "blogModule-posts__post--has-image" },
    init: function () {
      this.truncateText(),
        this.removeAnimations(),
        $(window)
          .off(".blog")
          .on("load", this.truncateText.bind(this))
          .on("resize.blog", Reqs.debounce(this.truncateText.bind(this), 250))
          .on(
            "resize.blog",
            Reqs.debounce(this.removeAnimations.bind(this), 250)
          ),
        $(document).on("ajaxify:updated", this.truncateText.bind(this));
    },
    removeAnimations: function () {
      (window.innerWidth || document.decumentElement.clientWidth) < 768 &&
        $(this.selectors.blogContainer).each(function () {
          Site.removeAnimationClass($(this));
        });
    },
    truncateText: function () {
      var e = this,
        t = $(this.selectors.blogPost);
      t.length &&
        t.each(function () {
          var t = $(this).find(e.selectors.blogPostContent),
            i = $(this).hasClass(e.classes.blogPostHasImage) ? 2 : 4;
          t.trunk8({ lines: i });
        });
    },
  },
  Reqs = {
    throttle: function (e, t, i) {
      var n, o;
      return (
        t || (t = 250),
        function () {
          var r = i || this,
            s = +new Date(),
            a = arguments;
          n && s < n + t
            ? (clearTimeout(o),
              (o = setTimeout(function () {
                (n = s), e.apply(r, a);
              }, t)))
            : ((n = s), e.apply(r, a));
        }
      );
    },
    debounce: function (e, t, i) {
      var n;
      return function () {
        var o = this,
          r = arguments,
          s = i && !n;
        clearTimeout(n),
          (n = setTimeout(function () {
            (n = null), i || e.apply(o, r);
          }, t)),
          s && e.apply(o, r);
      };
    },
    lightbox: function () {
      var e;
      (e = function (e) {
        var t,
          i,
          n,
          o,
          r,
          s,
          a = "Close",
          l = "BeforeClose",
          c = "MarkupParse",
          d = "Open",
          u = "Change",
          p = "mfp",
          h = "." + p,
          f = "mfp-ready",
          m = "mfp-removing",
          g = "mfp-prevent-close",
          v = function () {},
          y = !!window.jQuery,
          b = e(window),
          w = function (e, i) {
            t.ev.on(p + e + h, i);
          },
          k = function (t, i, n, o) {
            var r = document.createElement("div");
            return (
              (r.className = "mfp-" + t),
              n && (r.innerHTML = n),
              o ? i && i.appendChild(r) : ((r = e(r)), i && r.appendTo(i)),
              r
            );
          },
          x = function (i, n) {
            t.ev.triggerHandler(p + i, n),
              t.st.callbacks &&
                ((i = i.charAt(0).toLowerCase() + i.slice(1)),
                t.st.callbacks[i] &&
                  t.st.callbacks[i].apply(t, e.isArray(n) ? n : [n]));
          },
          S = function (i) {
            return (
              (i === s && t.currTemplate.closeBtn) ||
                ((t.currTemplate.closeBtn = e(
                  t.st.closeMarkup.replace("%title%", t.st.tClose)
                )),
                (s = i)),
              t.currTemplate.closeBtn
            );
          },
          C = function () {
            e.magnificPopup.instance ||
              ((t = new v()).init(), (e.magnificPopup.instance = t));
          };
        (v.prototype = {
          constructor: v,
          init: function () {
            var i = navigator.appVersion;
            (t.isLowIE = t.isIE8 = document.all && !document.addEventListener),
              (t.isAndroid = /android/gi.test(i)),
              (t.isIOS = /iphone|ipad|ipod/gi.test(i)),
              (t.supportsTransition = (function () {
                var e = document.createElement("p").style,
                  t = ["ms", "O", "Moz", "Webkit"];
                if (void 0 !== e.transition) return !0;
                for (; t.length; ) if (t.pop() + "Transition" in e) return !0;
                return !1;
              })()),
              (t.probablyMobile =
                t.isAndroid ||
                t.isIOS ||
                /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
                  navigator.userAgent
                )),
              (n = e(document)),
              (t.popupsCache = {});
          },
          open: function (i) {
            var o;
            if (!1 === i.isObj) {
              (t.items = i.items.toArray()), (t.index = 0);
              var s,
                a = i.items;
              for (o = 0; o < a.length; o++)
                if (((s = a[o]).parsed && (s = s.el[0]), s === i.el[0])) {
                  t.index = o;
                  break;
                }
            } else
              (t.items = e.isArray(i.items) ? i.items : [i.items]),
                (t.index = i.index || 0);
            if (!t.isOpen) {
              (t.types = []),
                (r = ""),
                i.mainEl && i.mainEl.length
                  ? (t.ev = i.mainEl.eq(0))
                  : (t.ev = n),
                i.key
                  ? (t.popupsCache[i.key] || (t.popupsCache[i.key] = {}),
                    (t.currTemplate = t.popupsCache[i.key]))
                  : (t.currTemplate = {}),
                (t.st = e.extend(!0, {}, e.magnificPopup.defaults, i)),
                (t.fixedContentPos =
                  "auto" === t.st.fixedContentPos
                    ? !t.probablyMobile
                    : t.st.fixedContentPos),
                t.st.modal &&
                  ((t.st.closeOnContentClick = !1),
                  (t.st.closeOnBgClick = !1),
                  (t.st.showCloseBtn = !1),
                  (t.st.enableEscapeKey = !1)),
                t.bgOverlay ||
                  ((t.bgOverlay = k("bg").on("click" + h, function () {
                    t.close();
                  })),
                  (t.wrap = k("wrap")
                    .attr("tabindex", -1)
                    .on("click" + h, function (e) {
                      t._checkIfClose(e.target) && t.close();
                    })),
                  (t.container = k("container", t.wrap))),
                (t.contentContainer = k("content")),
                t.st.preloader &&
                  (t.preloader = k("preloader", t.container, t.st.tLoading));
              var l = e.magnificPopup.modules;
              for (o = 0; o < l.length; o++) {
                var u = l[o];
                (u = u.charAt(0).toUpperCase() + u.slice(1)),
                  t["init" + u].call(t);
              }
              x("BeforeOpen"),
                t.st.showCloseBtn &&
                  (t.st.closeBtnInside
                    ? (w(c, function (e, t, i, n) {
                        i.close_replaceWith = S(n.type);
                      }),
                      (r += " mfp-close-btn-in"))
                    : t.wrap.append(S())),
                t.st.alignTop && (r += " mfp-align-top"),
                t.fixedContentPos
                  ? t.wrap.css({
                      overflow: t.st.overflowY,
                      overflowX: "hidden",
                      overflowY: t.st.overflowY,
                    })
                  : t.wrap.css({ top: b.scrollTop(), position: "absolute" }),
                (!1 === t.st.fixedBgPos ||
                  ("auto" === t.st.fixedBgPos && !t.fixedContentPos)) &&
                  t.bgOverlay.css({ height: n.height(), position: "absolute" }),
                t.st.enableEscapeKey &&
                  n.on("keyup" + h, function (e) {
                    27 === e.keyCode && t.close();
                  }),
                b.on("resize" + h, function () {
                  t.updateSize();
                }),
                t.st.closeOnContentClick || (r += " mfp-auto-cursor"),
                r && t.wrap.addClass(r);
              var p = (t.wH = b.height()),
                m = {};
              if (t.fixedContentPos && t._hasScrollBar(p)) {
                var g = t._getScrollbarSize();
                g && (m.marginRight = g);
              }
              t.fixedContentPos &&
                (t.isIE7
                  ? e("body, html").css("overflow", "hidden")
                  : (m.overflow = "hidden"));
              var v = t.st.mainClass;
              return (
                t.isIE7 && (v += " mfp-ie7"),
                v && t._addClassToMFP(v),
                t.updateItemHTML(),
                x("BuildControls"),
                e("html").css(m),
                t.bgOverlay
                  .add(t.wrap)
                  .prependTo(t.st.prependTo || e(document.body)),
                (t._lastFocusedEl = document.activeElement),
                setTimeout(function () {
                  t.content
                    ? (t._addClassToMFP(f), t._setFocus())
                    : t.bgOverlay.addClass(f),
                    n.on("focusin" + h, t._onFocusIn);
                }, 16),
                (t.isOpen = !0),
                t.updateSize(p),
                x(d),
                i
              );
            }
            t.updateItemHTML();
          },
          close: function () {
            t.isOpen &&
              (x(l),
              (t.isOpen = !1),
              t.st.removalDelay && !t.isLowIE && t.supportsTransition
                ? (t._addClassToMFP(m),
                  setTimeout(function () {
                    t._close();
                  }, t.st.removalDelay))
                : t._close());
          },
          _close: function () {
            x(a);
            var i = m + " " + f + " ";
            if (
              (t.bgOverlay.detach(),
              t.wrap.detach(),
              t.container.empty(),
              t.st.mainClass && (i += t.st.mainClass + " "),
              t._removeClassFromMFP(i),
              t.fixedContentPos)
            ) {
              var o = { marginRight: "" };
              t.isIE7 ? e("body, html").css("overflow", "") : (o.overflow = ""),
                e("html").css(o);
            }
            n.off("keyup.mfp focusin" + h),
              t.ev.off(h),
              t.wrap.attr("class", "mfp-wrap").removeAttr("style"),
              t.bgOverlay.attr("class", "mfp-bg"),
              t.container.attr("class", "mfp-container"),
              !t.st.showCloseBtn ||
                (t.st.closeBtnInside &&
                  !0 !== t.currTemplate[t.currItem.type]) ||
                (t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach()),
              t.st.autoFocusLast &&
                t._lastFocusedEl &&
                e(t._lastFocusedEl).focus(),
              (t.currItem = null),
              (t.content = null),
              (t.currTemplate = null),
              (t.prevHeight = 0),
              x("AfterClose");
          },
          updateSize: function (e) {
            if (t.isIOS) {
              var i = document.documentElement.clientWidth / window.innerWidth,
                n = window.innerHeight * i;
              t.wrap.css("height", n), (t.wH = n);
            } else t.wH = e || b.height();
            t.fixedContentPos || t.wrap.css("height", t.wH), x("Resize");
          },
          updateItemHTML: function () {
            var i = t.items[t.index];
            t.contentContainer.detach(),
              t.content && t.content.detach(),
              i.parsed || (i = t.parseEl(t.index));
            var n = i.type;
            if (
              (x("BeforeChange", [t.currItem ? t.currItem.type : "", n]),
              (t.currItem = i),
              !t.currTemplate[n])
            ) {
              var r = !!t.st[n] && t.st[n].markup;
              x("FirstMarkupParse", r), (t.currTemplate[n] = !r || e(r));
            }
            o &&
              o !== i.type &&
              t.container.removeClass("mfp-" + o + "-holder");
            var s = t["get" + n.charAt(0).toUpperCase() + n.slice(1)](
              i,
              t.currTemplate[n]
            );
            t.appendContent(s, n),
              (i.preloaded = !0),
              x(u, i),
              (o = i.type),
              t.container.prepend(t.contentContainer),
              x("AfterChange");
          },
          appendContent: function (e, i) {
            (t.content = e),
              e
                ? t.st.showCloseBtn &&
                  t.st.closeBtnInside &&
                  !0 === t.currTemplate[i]
                  ? t.content.find(".mfp-close").length || t.content.append(S())
                  : (t.content = e)
                : (t.content = ""),
              x("BeforeAppend"),
              t.container.addClass("mfp-" + i + "-holder"),
              t.contentContainer.append(t.content);
          },
          parseEl: function (i) {
            var n,
              o = t.items[i];
            if (
              (o.tagName
                ? (o = { el: e(o) })
                : ((n = o.type), (o = { data: o, src: o.src })),
              o.el)
            ) {
              for (var r = t.types, s = 0; s < r.length; s++)
                if (o.el.hasClass("mfp-" + r[s])) {
                  n = r[s];
                  break;
                }
              (o.src = o.el.attr("data-mfp-src")),
                o.src || (o.src = o.el.attr("href"));
            }
            return (
              (o.type = n || t.st.type || "inline"),
              (o.index = i),
              (o.parsed = !0),
              (t.items[i] = o),
              x("ElementParse", o),
              t.items[i]
            );
          },
          addGroup: function (e, i) {
            var n = function (n) {
              (n.mfpEl = this), t._openClick(n, e, i);
            };
            i || (i = {});
            var o = "click.magnificPopup";
            (i.mainEl = e),
              i.items
                ? ((i.isObj = !0), e.off(o).on(o, n))
                : ((i.isObj = !1),
                  i.delegate
                    ? e.off(o).on(o, i.delegate, n)
                    : ((i.items = e), e.off(o).on(o, n)));
          },
          _openClick: function (i, n, o) {
            if (
              (void 0 !== o.midClick
                ? o.midClick
                : e.magnificPopup.defaults.midClick) ||
              !(
                2 === i.which ||
                i.ctrlKey ||
                i.metaKey ||
                i.altKey ||
                i.shiftKey
              )
            ) {
              var r =
                void 0 !== o.disableOn
                  ? o.disableOn
                  : e.magnificPopup.defaults.disableOn;
              if (r)
                if (e.isFunction(r)) {
                  if (!r.call(t)) return !0;
                } else if (b.width() < r) return !0;
              i.type && (i.preventDefault(), t.isOpen && i.stopPropagation()),
                (o.el = e(i.mfpEl)),
                o.delegate && (o.items = n.find(o.delegate)),
                t.open(o);
            }
          },
          updateStatus: function (e, n) {
            if (t.preloader) {
              i !== e && t.container.removeClass("mfp-s-" + i),
                n || "loading" !== e || (n = t.st.tLoading);
              var o = { status: e, text: n };
              x("UpdateStatus", o),
                (e = o.status),
                (n = o.text),
                t.preloader.html(n),
                t.preloader.find("a").on("click", function (e) {
                  e.stopImmediatePropagation();
                }),
                t.container.addClass("mfp-s-" + e),
                (i = e);
            }
          },
          _checkIfClose: function (i) {
            if (!e(i).hasClass(g)) {
              var n = t.st.closeOnContentClick,
                o = t.st.closeOnBgClick;
              if (n && o) return !0;
              if (
                !t.content ||
                e(i).hasClass("mfp-close") ||
                (t.preloader && i === t.preloader[0])
              )
                return !0;
              if (i === t.content[0] || e.contains(t.content[0], i)) {
                if (n) return !0;
              } else if (o && e.contains(document, i)) return !0;
              return !1;
            }
          },
          _addClassToMFP: function (e) {
            t.bgOverlay.addClass(e), t.wrap.addClass(e);
          },
          _removeClassFromMFP: function (e) {
            this.bgOverlay.removeClass(e), t.wrap.removeClass(e);
          },
          _hasScrollBar: function (e) {
            return (
              (t.isIE7 ? n.height() : document.body.scrollHeight) >
              (e || b.height())
            );
          },
          _setFocus: function () {
            (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus();
          },
          _onFocusIn: function (i) {
            return i.target === t.wrap[0] || e.contains(t.wrap[0], i.target)
              ? void 0
              : (t._setFocus(), !1);
          },
          _parseMarkup: function (t, i, n) {
            var o;
            n.data && (i = e.extend(n.data, i)),
              x(c, [t, i, n]),
              e.each(i, function (i, n) {
                if (void 0 === n || !1 === n) return !0;
                if ((o = i.split("_")).length > 1) {
                  var r = t.find(h + "-" + o[0]);
                  if (r.length > 0) {
                    var s = o[1];
                    "replaceWith" === s
                      ? r[0] !== n[0] && r.replaceWith(n)
                      : "img" === s
                      ? r.is("img")
                        ? r.attr("src", n)
                        : r.replaceWith(
                            e("<img>")
                              .attr("src", n)
                              .attr("class", r.attr("class"))
                          )
                      : r.attr(o[1], n);
                  }
                } else t.find(h + "-" + i).html(n);
              });
          },
          _getScrollbarSize: function () {
            if (void 0 === t.scrollbarSize) {
              var e = document.createElement("div");
              (e.style.cssText =
                "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
                document.body.appendChild(e),
                (t.scrollbarSize = e.offsetWidth - e.clientWidth),
                document.body.removeChild(e);
            }
            return t.scrollbarSize;
          },
        }),
          (e.magnificPopup = {
            instance: null,
            proto: v.prototype,
            modules: [],
            open: function (t, i) {
              return (
                C(),
                ((t = t ? e.extend(!0, {}, t) : {}).isObj = !0),
                (t.index = i || 0),
                this.instance.open(t)
              );
            },
            close: function () {
              return (
                e.magnificPopup.instance && e.magnificPopup.instance.close()
              );
            },
            registerModule: function (t, i) {
              i.options && (e.magnificPopup.defaults[t] = i.options),
                e.extend(this.proto, i.proto),
                this.modules.push(t);
            },
            defaults: {
              disableOn: 0,
              key: null,
              midClick: !1,
              mainClass: "",
              preloader: !0,
              focus: "",
              closeOnContentClick: !1,
              closeOnBgClick: !0,
              closeBtnInside: !0,
              showCloseBtn: !0,
              enableEscapeKey: !0,
              modal: !1,
              alignTop: !1,
              removalDelay: 0,
              prependTo: null,
              fixedContentPos: "auto",
              fixedBgPos: "auto",
              overflowY: "auto",
              closeMarkup:
                '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
              tClose: "Close (Esc)",
              tLoading: "Loading...",
              autoFocusLast: !0,
            },
          }),
          (e.fn.magnificPopup = function (i) {
            C();
            var n = e(this);
            if ("string" == typeof i)
              if ("open" === i) {
                var o,
                  r = y ? n.data("magnificPopup") : n[0].magnificPopup,
                  s = parseInt(arguments[1], 10) || 0;
                r.items
                  ? (o = r.items[s])
                  : ((o = n),
                    r.delegate && (o = o.find(r.delegate)),
                    (o = o.eq(s))),
                  t._openClick({ mfpEl: o }, n, r);
              } else
                t.isOpen &&
                  t[i].apply(t, Array.prototype.slice.call(arguments, 1));
            else
              (i = e.extend(!0, {}, i)),
                y ? n.data("magnificPopup", i) : (n[0].magnificPopup = i),
                t.addGroup(n, i);
            return n;
          });
        var T,
          $,
          _,
          E = "inline",
          A = function () {
            _ && ($.after(_.addClass(T)).detach(), (_ = null));
          };
        e.magnificPopup.registerModule(E, {
          options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found",
          },
          proto: {
            initInline: function () {
              t.types.push(E),
                w(a + "." + E, function () {
                  A();
                });
            },
            getInline: function (i, n) {
              if ((A(), i.src)) {
                var o = t.st.inline,
                  r = e(i.src);
                if (r.length) {
                  var s = r[0].parentNode;
                  s &&
                    s.tagName &&
                    ($ || ((T = o.hiddenClass), ($ = k(T)), (T = "mfp-" + T)),
                    (_ = r.after($).detach().removeClass(T))),
                    t.updateStatus("ready");
                } else t.updateStatus("error", o.tNotFound), (r = e("<div>"));
                return (i.inlineElement = r), r;
              }
              return t.updateStatus("ready"), t._parseMarkup(n, {}, i), n;
            },
          },
        });
        var P,
          L = "ajax",
          j = function () {
            P && e(document.body).removeClass(P);
          },
          I = function () {
            j(), t.req && t.req.abort();
          };
        e.magnificPopup.registerModule(L, {
          options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.',
          },
          proto: {
            initAjax: function () {
              t.types.push(L),
                (P = t.st.ajax.cursor),
                w(a + "." + L, I),
                w("BeforeChange." + L, I);
            },
            getAjax: function (i) {
              P && e(document.body).addClass(P), t.updateStatus("loading");
              var n = e.extend(
                {
                  url: i.src,
                  success: function (n, o, r) {
                    var s = { data: n, xhr: r };
                    x("ParseAjax", s),
                      t.appendContent(e(s.data), L),
                      (i.finished = !0),
                      j(),
                      t._setFocus(),
                      setTimeout(function () {
                        t.wrap.addClass(f);
                      }, 16),
                      t.updateStatus("ready"),
                      x("AjaxContentAdded");
                  },
                  error: function () {
                    j(),
                      (i.finished = i.loadError = !0),
                      t.updateStatus(
                        "error",
                        t.st.ajax.tError.replace("%url%", i.src)
                      );
                  },
                },
                t.st.ajax.settings
              );
              return (t.req = e.ajax(n)), "";
            },
          },
        });
        var M,
          q,
          D = function (i) {
            if (i.data && void 0 !== i.data.title) return i.data.title;
            var n = t.st.image.titleSrc;
            if (n) {
              if (e.isFunction(n)) return n.call(t, i);
              if (i.el) return i.el.attr(n) || "";
            }
            return "";
          };
        e.magnificPopup.registerModule("image", {
          options: {
            markup:
              '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.',
          },
          proto: {
            initImage: function () {
              var i = t.st.image,
                n = ".image";
              t.types.push("image"),
                w(d + n, function () {
                  "image" === t.currItem.type &&
                    i.cursor &&
                    e(document.body).addClass(i.cursor);
                }),
                w(a + n, function () {
                  i.cursor && e(document.body).removeClass(i.cursor),
                    b.off("resize" + h);
                }),
                w("Resize" + n, t.resizeImage),
                t.isLowIE && w("AfterChange", t.resizeImage);
            },
            resizeImage: function () {
              var e = t.currItem;
              if (e && e.img && t.st.image.verticalFit) {
                var i = 0;
                t.isLowIE &&
                  (i =
                    parseInt(e.img.css("padding-top"), 10) +
                    parseInt(e.img.css("padding-bottom"), 10)),
                  e.img.css("max-height", t.wH - i);
              }
            },
            _onImageHasSize: function (e) {
              e.img &&
                ((e.hasSize = !0),
                M && clearInterval(M),
                (e.isCheckingImgSize = !1),
                x("ImageHasSize", e),
                e.imgHidden &&
                  (t.content && t.content.removeClass("mfp-loading"),
                  (e.imgHidden = !1)));
            },
            findImageSize: function (e) {
              var i = 0,
                n = e.img[0],
                o = function (r) {
                  M && clearInterval(M),
                    (M = setInterval(function () {
                      return n.naturalWidth > 0
                        ? void t._onImageHasSize(e)
                        : (i > 200 && clearInterval(M),
                          void (3 == ++i
                            ? o(10)
                            : 40 === i
                            ? o(50)
                            : 100 === i && o(500)));
                    }, r));
                };
              o(1);
            },
            getImage: function (i, n) {
              var o = 0,
                r = function () {
                  i &&
                    (i.img[0].complete
                      ? (i.img.off(".mfploader"),
                        i === t.currItem &&
                          (t._onImageHasSize(i), t.updateStatus("ready")),
                        (i.hasSize = !0),
                        (i.loaded = !0),
                        x("ImageLoadComplete"))
                      : 200 > ++o
                      ? setTimeout(r, 100)
                      : s());
                },
                s = function () {
                  i &&
                    (i.img.off(".mfploader"),
                    i === t.currItem &&
                      (t._onImageHasSize(i),
                      t.updateStatus(
                        "error",
                        a.tError.replace("%url%", i.src)
                      )),
                    (i.hasSize = !0),
                    (i.loaded = !0),
                    (i.loadError = !0));
                },
                a = t.st.image,
                l = n.find(".mfp-img");
              if (l.length) {
                var c = document.createElement("img");
                (c.className = "mfp-img"),
                  i.el &&
                    i.el.find("img").length &&
                    (c.alt = i.el.find("img").attr("alt")),
                  (i.img = e(c)
                    .on("load.mfploader", r)
                    .on("error.mfploader", s)),
                  (c.src = i.src),
                  l.is("img") && (i.img = i.img.clone()),
                  (c = i.img[0]).naturalWidth > 0
                    ? (i.hasSize = !0)
                    : c.width || (i.hasSize = !1);
              }
              return (
                t._parseMarkup(n, { title: D(i), img_replaceWith: i.img }, i),
                t.resizeImage(),
                i.hasSize
                  ? (M && clearInterval(M),
                    i.loadError
                      ? (n.addClass("mfp-loading"),
                        t.updateStatus(
                          "error",
                          a.tError.replace("%url%", i.src)
                        ))
                      : (n.removeClass("mfp-loading"), t.updateStatus("ready")),
                    n)
                  : (t.updateStatus("loading"),
                    (i.loading = !0),
                    i.hasSize ||
                      ((i.imgHidden = !0),
                      n.addClass("mfp-loading"),
                      t.findImageSize(i)),
                    n)
              );
            },
          },
        }),
          e.magnificPopup.registerModule("zoom", {
            options: {
              enabled: !1,
              easing: "ease-in-out",
              duration: 300,
              opener: function (e) {
                return e.is("img") ? e : e.find("img");
              },
            },
            proto: {
              initZoom: function () {
                var e,
                  i = t.st.zoom,
                  n = ".zoom";
                if (i.enabled && t.supportsTransition) {
                  var o,
                    r,
                    s = i.duration,
                    c = function (e) {
                      var t = e
                          .clone()
                          .removeAttr("style")
                          .removeAttr("class")
                          .addClass("mfp-animated-image"),
                        n = "all " + i.duration / 1e3 + "s " + i.easing,
                        o = {
                          position: "fixed",
                          zIndex: 9999,
                          left: 0,
                          top: 0,
                          "-webkit-backface-visibility": "hidden",
                        },
                        r = "transition";
                      return (
                        (o["-webkit-" + r] =
                          o["-moz-" + r] =
                          o["-o-" + r] =
                          o[r] =
                            n),
                        t.css(o),
                        t
                      );
                    },
                    d = function () {
                      t.content.css("visibility", "visible");
                    };
                  w("BuildControls" + n, function () {
                    if (t._allowZoom()) {
                      if (
                        (clearTimeout(o),
                        t.content.css("visibility", "hidden"),
                        !(e = t._getItemToZoom()))
                      )
                        return void d();
                      (r = c(e)).css(t._getOffset()),
                        t.wrap.append(r),
                        (o = setTimeout(function () {
                          r.css(t._getOffset(!0)),
                            (o = setTimeout(function () {
                              d(),
                                setTimeout(function () {
                                  r.remove(),
                                    (e = r = null),
                                    x("ZoomAnimationEnded");
                                }, 16);
                            }, s));
                        }, 16));
                    }
                  }),
                    w(l + n, function () {
                      if (t._allowZoom()) {
                        if ((clearTimeout(o), (t.st.removalDelay = s), !e)) {
                          if (!(e = t._getItemToZoom())) return;
                          r = c(e);
                        }
                        r.css(t._getOffset(!0)),
                          t.wrap.append(r),
                          t.content.css("visibility", "hidden"),
                          setTimeout(function () {
                            r.css(t._getOffset());
                          }, 16);
                      }
                    }),
                    w(a + n, function () {
                      t._allowZoom() && (d(), r && r.remove(), (e = null));
                    });
                }
              },
              _allowZoom: function () {
                return "image" === t.currItem.type;
              },
              _getItemToZoom: function () {
                return !!t.currItem.hasSize && t.currItem.img;
              },
              _getOffset: function (i) {
                var n,
                  o = (n = i
                    ? t.currItem.img
                    : t.st.zoom.opener(t.currItem.el || t.currItem)).offset(),
                  r = parseInt(n.css("padding-top"), 10),
                  s = parseInt(n.css("padding-bottom"), 10);
                o.top -= e(window).scrollTop() - r;
                var a = {
                  width: n.width(),
                  height: (y ? n.innerHeight() : n[0].offsetHeight) - s - r,
                };
                return (
                  void 0 === q &&
                    (q =
                      void 0 !==
                      document.createElement("p").style.MozTransform),
                  q
                    ? (a["-moz-transform"] = a.transform =
                        "translate(" + o.left + "px," + o.top + "px)")
                    : ((a.left = o.left), (a.top = o.top)),
                  a
                );
              },
            },
          });
        var z = "iframe",
          F = function (e) {
            if (t.currTemplate[z]) {
              var i = t.currTemplate[z].find("iframe");
              i.length &&
                (e || (i[0].src = "//about:blank"),
                t.isIE8 && i.css("display", e ? "block" : "none"));
            }
          };
        e.magnificPopup.registerModule(z, {
          options: {
            markup:
              '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
              youtube: {
                index: "youtube.com",
                id: "v=",
                src: "//www.youtube.com/embed/%id%?autoplay=1",
              },
              vimeo: {
                index: "vimeo.com/",
                id: "/",
                src: "//player.vimeo.com/video/%id%?autoplay=1",
              },
              gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
            },
          },
          proto: {
            initIframe: function () {
              t.types.push(z),
                w("BeforeChange", function (e, t, i) {
                  t !== i && (t === z ? F() : i === z && F(!0));
                }),
                w(a + "." + z, function () {
                  F();
                });
            },
            getIframe: function (i, n) {
              var o = i.src,
                r = t.st.iframe;
              e.each(r.patterns, function () {
                return o.indexOf(this.index) > -1
                  ? (this.id &&
                      (o =
                        "string" == typeof this.id
                          ? o.substr(
                              o.lastIndexOf(this.id) + this.id.length,
                              o.length
                            )
                          : this.id.call(this, o)),
                    (o = this.src.replace("%id%", o)),
                    !1)
                  : void 0;
              });
              var s = {};
              return (
                r.srcAction && (s[r.srcAction] = o),
                t._parseMarkup(n, s, i),
                t.updateStatus("ready"),
                n
              );
            },
          },
        });
        var O = function (e) {
            var i = t.items.length;
            return e > i - 1 ? e - i : 0 > e ? i + e : e;
          },
          N = function (e, t, i) {
            return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, i);
          };
        e.magnificPopup.registerModule("gallery", {
          options: {
            enabled: !1,
            arrowMarkup:
              '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%",
          },
          proto: {
            initGallery: function () {
              var i = t.st.gallery,
                o = ".mfp-gallery";
              return (
                (t.direction = !0),
                !(!i || !i.enabled) &&
                  ((r += " mfp-gallery"),
                  w(d + o, function () {
                    i.navigateByImgClick &&
                      t.wrap.on("click" + o, ".mfp-img", function () {
                        return t.items.length > 1 ? (t.next(), !1) : void 0;
                      }),
                      n.on("keydown" + o, function (e) {
                        37 === e.keyCode
                          ? t.prev()
                          : 39 === e.keyCode && t.next();
                      });
                  }),
                  w("UpdateStatus" + o, function (e, i) {
                    i.text &&
                      (i.text = N(i.text, t.currItem.index, t.items.length));
                  }),
                  w(c + o, function (e, n, o, r) {
                    var s = t.items.length;
                    o.counter = s > 1 ? N(i.tCounter, r.index, s) : "";
                  }),
                  w("BuildControls" + o, function () {
                    if (t.items.length > 1 && i.arrows && !t.arrowLeft) {
                      var n = i.arrowMarkup,
                        o = (t.arrowLeft = e(
                          n
                            .replace(/%title%/gi, i.tPrev)
                            .replace(/%dir%/gi, "left")
                        ).addClass(g)),
                        r = (t.arrowRight = e(
                          n
                            .replace(/%title%/gi, i.tNext)
                            .replace(/%dir%/gi, "right")
                        ).addClass(g));
                      o.click(function () {
                        t.prev();
                      }),
                        r.click(function () {
                          t.next();
                        }),
                        t.container.append(o.add(r));
                    }
                  }),
                  w(u + o, function () {
                    t._preloadTimeout && clearTimeout(t._preloadTimeout),
                      (t._preloadTimeout = setTimeout(function () {
                        t.preloadNearbyImages(), (t._preloadTimeout = null);
                      }, 16));
                  }),
                  void w(a + o, function () {
                    n.off(o),
                      t.wrap.off("click" + o),
                      (t.arrowRight = t.arrowLeft = null);
                  }))
              );
            },
            next: function () {
              (t.direction = !0),
                (t.index = O(t.index + 1)),
                t.updateItemHTML();
            },
            prev: function () {
              (t.direction = !1),
                (t.index = O(t.index - 1)),
                t.updateItemHTML();
            },
            goTo: function (e) {
              (t.direction = e >= t.index), (t.index = e), t.updateItemHTML();
            },
            preloadNearbyImages: function () {
              var e,
                i = t.st.gallery.preload,
                n = Math.min(i[0], t.items.length),
                o = Math.min(i[1], t.items.length);
              for (e = 1; e <= (t.direction ? o : n); e++)
                t._preloadItem(t.index + e);
              for (e = 1; e <= (t.direction ? n : o); e++)
                t._preloadItem(t.index - e);
            },
            _preloadItem: function (i) {
              if (((i = O(i)), !t.items[i].preloaded)) {
                var n = t.items[i];
                n.parsed || (n = t.parseEl(i)),
                  x("LazyLoad", n),
                  "image" === n.type &&
                    (n.img = e('<img class="mfp-img" />')
                      .on("load.mfploader", function () {
                        n.hasSize = !0;
                      })
                      .on("error.mfploader", function () {
                        (n.hasSize = !0),
                          (n.loadError = !0),
                          x("LazyLoadError", n);
                      })
                      .attr("src", n.src)),
                  (n.preloaded = !0);
              }
            },
          },
        });
        var B = "retina";
        e.magnificPopup.registerModule(B, {
          options: {
            replaceSrc: function (e) {
              return e.src.replace(/\.\w+$/, function (e) {
                return "@2x" + e;
              });
            },
            ratio: 1,
          },
          proto: {
            initRetina: function () {
              if (window.devicePixelRatio > 1) {
                var e = t.st.retina,
                  i = e.ratio;
                (i = isNaN(i) ? i() : i) > 1 &&
                  (w("ImageHasSize." + B, function (e, t) {
                    t.img.css({
                      "max-width": t.img[0].naturalWidth / i,
                      width: "100%",
                    });
                  }),
                  w("ElementParse." + B, function (t, n) {
                    n.src = e.replaceSrc(n, i);
                  }));
              }
            },
          },
        }),
          C();
      }),
        "function" == typeof define && define.amd
          ? define(["jquery"], e)
          : e(
              "object" == typeof exports
                ? require("jquery")
                : window.jQuery || window.Zepto
            );
    },
    zoom: function () {
      var e, t;
      (e = window.jQuery),
        (t = {
          url: !1,
          callback: !1,
          target: !1,
          duration: 120,
          on: "mouseover",
          touch: !0,
          onZoomIn: !1,
          onZoomOut: !1,
          magnify: 1,
        }),
        (e.zoom = function (t, i, n, o) {
          var r,
            s,
            a,
            l,
            c,
            d,
            u,
            p = e(t),
            h = p.css("position"),
            f = e(i);
          return (
            (t.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
            (t.style.overflow = "hidden"),
            (n.style.width = n.style.height = ""),
            e(n)
              .addClass("zoomImg")
              .css({
                position: "absolute",
                top: 0,
                left: 0,
                opacity: 0,
                width: n.width * o,
                height: n.height * o,
                border: "none",
                maxWidth: "none",
                maxHeight: "none",
              })
              .appendTo(t),
            {
              init: function () {
                (s = p.outerWidth()),
                  (r = p.outerHeight()),
                  i === t
                    ? ((l = s), (a = r))
                    : ((l = f.outerWidth()), (a = f.outerHeight())),
                  (c = (n.width - s) / l),
                  (d = (n.height - r) / a),
                  (u = f.offset());
              },
              move: function (e) {
                var t = e.pageX - u.left,
                  i = e.pageY - u.top;
                (i = Math.max(Math.min(i, a), 0)),
                  (t = Math.max(Math.min(t, l), 0)),
                  (n.style.left = t * -c + "px"),
                  (n.style.top = i * -d + "px");
              },
            }
          );
        }),
        (e.fn.zoom = function (i) {
          return this.each(function () {
            var n = e.extend({}, t, i || {}),
              o = (n.target && e(n.target)[0]) || this,
              r = this,
              s = e(r),
              a = document.createElement("img"),
              l = e(a),
              c = "mousemove.zoom",
              d = !1,
              u = !1;
            if (!n.url) {
              var p = r.querySelector("img");
              if (
                (p &&
                  (n.url = p.getAttribute("data-src") || p.currentSrc || p.src),
                !n.url)
              )
                return;
            }
            s.one(
              "zoom.destroy",
              function (e, t) {
                s.off(".zoom"),
                  (o.style.position = e),
                  (o.style.overflow = t),
                  (a.onload = null),
                  l.remove();
              }.bind(this, o.style.position, o.style.overflow)
            ),
              (a.onload = function () {
                function t(t) {
                  p.init(),
                    p.move(t),
                    l
                      .stop()
                      .fadeTo(
                        e.support.opacity ? n.duration : 0,
                        1,
                        !!e.isFunction(n.onZoomIn) && n.onZoomIn.call(a)
                      );
                }
                function i() {
                  l.stop().fadeTo(
                    n.duration,
                    0,
                    !!e.isFunction(n.onZoomOut) && n.onZoomOut.call(a)
                  );
                }
                var p = e.zoom(o, r, a, n.magnify);
                "grab" === n.on
                  ? s.on("mousedown.zoom", function (n) {
                      1 === n.which &&
                        (e(document).one("mouseup.zoom", function () {
                          i(), e(document).off(c, p.move);
                        }),
                        t(n),
                        e(document).on(c, p.move),
                        n.preventDefault());
                    })
                  : "click" === n.on
                  ? s.on("click.zoom", function (n) {
                      return d
                        ? void 0
                        : ((d = !0),
                          t(n),
                          e(document).on(c, p.move),
                          e(document).one("click.zoom", function () {
                            i(), (d = !1), e(document).off(c, p.move);
                          }),
                          !1);
                    })
                  : "toggle" === n.on
                  ? s.on("click.zoom", function (e) {
                      d ? i() : t(e), (d = !d);
                    })
                  : "mouseover" === n.on &&
                    (p.init(),
                    s
                      .on("mouseenter.zoom", t)
                      .on("mouseleave.zoom", i)
                      .on(c, p.move)),
                  n.touch &&
                    s
                      .on("touchstart.zoom", function (e) {
                        e.preventDefault(),
                          u
                            ? ((u = !1), i())
                            : ((u = !0),
                              t(
                                e.originalEvent.touches[0] ||
                                  e.originalEvent.changedTouches[0]
                              ));
                      })
                      .on("touchmove.zoom", function (e) {
                        e.preventDefault(),
                          p.move(
                            e.originalEvent.touches[0] ||
                              e.originalEvent.changedTouches[0]
                          );
                      })
                      .on("touchend.zoom", function (e) {
                        e.preventDefault(), u && ((u = !1), i());
                      }),
                  e.isFunction(n.callback) && n.callback.call(a);
              }),
              a.setAttribute("role", "presentation"),
              (a.alt = ""),
              (a.src = n.url);
          });
        }),
        (e.fn.zoom.defaults = t);
    },
    cookie: function () {
      !(function (e) {
        if ("function" == typeof define && define.amd) define(e);
        else if ("object" == typeof exports) module.exports = e();
        else {
          var t = window.Cookies,
            i = (window.Cookies = e());
          i.noConflict = function () {
            return (window.Cookies = t), i;
          };
        }
      })(function () {
        function e() {
          for (var e = 0, t = {}; e < arguments.length; e++) {
            var i = arguments[e];
            for (var n in i) t[n] = i[n];
          }
          return t;
        }
        return (function t(i) {
          function n(t, o, r) {
            var s;
            if (arguments.length > 1) {
              if (
                "number" == typeof (r = e({ path: "/" }, n.defaults, r)).expires
              ) {
                var a = new Date();
                a.setMilliseconds(a.getMilliseconds() + 864e5 * r.expires),
                  (r.expires = a);
              }
              try {
                (s = JSON.stringify(o)), /^[\{\[]/.test(s) && (o = s);
              } catch (e) {}
              return (
                (o = i.write
                  ? i.write(o, t)
                  : encodeURIComponent(String(o)).replace(
                      /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                      decodeURIComponent
                    )),
                (t = (t = (t = encodeURIComponent(String(t))).replace(
                  /%(23|24|26|2B|5E|60|7C)/g,
                  decodeURIComponent
                )).replace(/[\(\)]/g, escape)),
                (document.cookie = [
                  t,
                  "=",
                  o,
                  r.expires && "; expires=" + r.expires.toUTCString(),
                  r.path && "; path=" + r.path,
                  r.domain && "; domain=" + r.domain,
                  r.secure ? "; secure" : "",
                ].join(""))
              );
            }
            t || (s = {});
            for (
              var l = document.cookie ? document.cookie.split("; ") : [],
                c = /(%[0-9A-Z]{2})+/g,
                d = 0;
              d < l.length;
              d++
            ) {
              var u = l[d].split("="),
                p = u[0].replace(c, decodeURIComponent),
                h = u.slice(1).join("=");
              '"' === h.charAt(0) && (h = h.slice(1, -1));
              try {
                if (
                  ((h = i.read
                    ? i.read(h, p)
                    : i(h, p) || h.replace(c, decodeURIComponent)),
                  this.json)
                )
                  try {
                    h = JSON.parse(h);
                  } catch (e) {}
                if (t === p) {
                  s = h;
                  break;
                }
                t || (s[p] = h);
              } catch (e) {}
            }
            return s;
          }
          return (
            (n.get = n.set = n),
            (n.getJSON = function () {
              return n.apply({ json: !0 }, [].slice.call(arguments));
            }),
            (n.defaults = {}),
            (n.remove = function (t, i) {
              n(t, "", e(i, { expires: -1 }));
            }),
            (n.withConverter = t),
            n
          );
        })(function () {});
      });
    },
  },
  apiStatus = null,
  Gmap = {
    selectors: { map: '[data-section-type="map"]' },
    init: function () {
      var e = this,
        t = [];
      $(this.selectors.map).each(function () {
        var i = this,
          n = $(i).data("api-key");
        "string" == typeof n &&
          "" !== n &&
          ("loaded" === apiStatus
            ? 0 === $('script[src*="' + n + '&"]').length
              ? $.getScript(
                  "https://maps.googleapis.com/maps/api/js?key=" + n
                ).then(function () {
                  (apiStatus = "loaded"), e.createMap(i);
                })
              : e.createMap(i)
            : (t.push(this),
              "loading" !== apiStatus &&
                ((apiStatus = "loading"),
                void 0 === window.google &&
                  $.getScript(
                    "https://maps.googleapis.com/maps/api/js?key=" + n
                  ).then(function () {
                    (apiStatus = "loaded"),
                      $.each(t, function (t, i) {
                        e.createMap(i);
                      });
                  }))));
      });
    },
    geolocate: function (e) {
      var t = $.Deferred(),
        i = new google.maps.Geocoder(),
        n =
          e.closest(this.selectors.map).data("address") ||
          "37.4439064, -122.1639733";
      return (
        i.geocode({ address: n }, function (e, i) {
          i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
        }),
        t
      );
    },
    createMap: function (e) {
      var t,
        i = $(e).data("style"),
        n = $(e).data("zoom"),
        o = $(e).data("section-id"),
        r = $(".map--" + o);
      return (
        (t =
          "standard" == i
            ? []
            : "silver" == i
            ? [
                { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                {
                  elementType: "labels.icon",
                  stylers: [{ visibility: "off" }],
                },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#f5f5f5" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#bdbdbd" }],
                },
                {
                  featureType: "poi",
                  elementType: "geometry",
                  stylers: [{ color: "#eeeeee" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry",
                  stylers: [{ color: "#e5e5e5" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#ffffff" }],
                },
                {
                  featureType: "road.arterial",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#dadada" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  featureType: "road.local",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "geometry",
                  stylers: [{ color: "#e5e5e5" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "geometry",
                  stylers: [{ color: "#eeeeee" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#c9c9c9" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
              ]
            : "retro" == i
            ? [
                { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#523735" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#f5f1e6" }],
                },
                {
                  featureType: "administrative",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#c9b2a6" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#dcd2be" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#ae9e90" }],
                },
                {
                  featureType: "landscape.natural",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "poi",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#93817c" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#a5b076" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#447530" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#f5f1e6" }],
                },
                {
                  featureType: "road.arterial",
                  elementType: "geometry",
                  stylers: [{ color: "#fdfcf8" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#f8c967" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#e9bc62" }],
                },
                {
                  featureType: "road.highway.controlled_access",
                  elementType: "geometry",
                  stylers: [{ color: "#e98d58" }],
                },
                {
                  featureType: "road.highway.controlled_access",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#db8555" }],
                },
                {
                  featureType: "road.local",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#806b63" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#8f7d77" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#ebe3cd" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#b9d3c2" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#92998d" }],
                },
              ]
            : "dark" == i
            ? [
                { elementType: "geometry", stylers: [{ color: "#212121" }] },
                {
                  elementType: "labels.icon",
                  stylers: [{ visibility: "off" }],
                },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#212121" }],
                },
                {
                  featureType: "administrative",
                  elementType: "geometry",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "administrative.country",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  stylers: [{ visibility: "off" }],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#bdbdbd" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry",
                  stylers: [{ color: "#181818" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1b1b1b" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#2c2c2c" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#8a8a8a" }],
                },
                {
                  featureType: "road.arterial",
                  elementType: "geometry",
                  stylers: [{ color: "#373737" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#3c3c3c" }],
                },
                {
                  featureType: "road.highway.controlled_access",
                  elementType: "geometry",
                  stylers: [{ color: "#4e4e4e" }],
                },
                {
                  featureType: "road.local",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  featureType: "transit",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#000000" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#3d3d3d" }],
                },
              ]
            : "night" == i
            ? [
                { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#746855" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#242f3e" }],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#d59563" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#d59563" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry",
                  stylers: [{ color: "#263c3f" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#6b9a76" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#38414e" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#212a37" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9ca5b3" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#746855" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#1f2835" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#f3d19c" }],
                },
                {
                  featureType: "transit",
                  elementType: "geometry",
                  stylers: [{ color: "#2f3948" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#d59563" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#17263c" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#515c6d" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#17263c" }],
                },
              ]
            : [
                { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#8ec3b9" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1a3646" }],
                },
                {
                  featureType: "administrative.country",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#4b6878" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#64779e" }],
                },
                {
                  featureType: "administrative.province",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#4b6878" }],
                },
                {
                  featureType: "landscape.man_made",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#334e87" }],
                },
                {
                  featureType: "landscape.natural",
                  elementType: "geometry",
                  stylers: [{ color: "#023e58" }],
                },
                {
                  featureType: "poi",
                  elementType: "geometry",
                  stylers: [{ color: "#283d6a" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#6f9ba5" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1d2c4d" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#023e58" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#3C7680" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#304a7d" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#98a5be" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1d2c4d" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#2c6675" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#255763" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#b0d5ce" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#023e58" }],
                },
                {
                  featureType: "transit",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#98a5be" }],
                },
                {
                  featureType: "transit",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1d2c4d" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#283d6a" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "geometry",
                  stylers: [{ color: "#3a4762" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#0e1626" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#4e6d70" }],
                },
              ]),
        this.geolocate(r).then(
          function (e) {
            var i = {
                styles: t,
                center: e[0].geometry.location,
                clickableIcons: !1,
                scrollwheel: !1,
                zoomControl: !0,
                disableDefaultUI: !0,
                navigationControl: !1,
                mapTypeControl: !1,
                scaleControl: !1,
                draggable: !1,
                zoom: n,
              },
              o = new google.maps.Map(r[0], i),
              s = o.getCenter();
            new google.maps.Marker({ map: o, position: s }),
              google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(o, "resize"), o.setCenter(s);
              });
          }.bind(this)
        )
      );
    },
  },
  Popup = {
    init: function () {
      var e = this,
        t = (this.$popup = $("#popup")),
        i = t.find(".popup__close"),
        n = t.data("enabled");
      if (((this.popupTimeout = 0), n)) {
        var o = t.data("testmode"),
          r = 1e3 * parseInt(t.data("delay")),
          s = 1e3 * parseInt(t.data("reappear_time"));
        enquire.register("screen and (min-width:768px)", function () {
          Reqs.cookie(),
            o
              ? e.show(t, r, o)
              : (void 0 !== Cookies.get("newsletter_delay") && 0 != s) ||
                (e.show(t, r, o), e.createCookie(s));
        }),
          $(window).on(
            "resize",
            Reqs.debounce(function () {
              var i = window.innerWidth || document.documentElement.clientWidth,
                n = t.hasClass("popup--visible");
              i < 768 && n && e.hide();
            }, 100)
          ),
          i.on("click", function () {
            t.removeClass("popup--visible"),
              $("[data-section-id=popup]").removeClass("is--visible");
          });
      }
    },
    show: function (e, t, i) {
      if ("shown" != sessionStorage.name) {
        if (
          ((this.popupTimeout = setTimeout(function () {
            e.addClass("popup--visible"),
              e.find(".popup__close").focus(),
              $("[data-section-id=popup]").addClass("is--visible");
          }, t)),
          "object" == typeof localStorage)
        )
          try {
            localStorage.setItem("localStorage", 1),
              localStorage.removeItem("localStorage"),
              (sessionStorage.name = "shown");
          } catch (e) {
            (Storage.prototype._setItem = Storage.prototype.setItem),
              (Storage.prototype.setItem = function () {});
          }
      } else
        i &&
          (this.popupTimeout = setTimeout(function () {
            e.addClass("popup--visible"),
              e.find(".popup__close").focus(),
              $("[data-section-id=popup]").addClass("is--visible");
          }, t));
    },
    hide: function () {
      clearTimeout(this.popupTimeout),
        this.$popup.removeClass("popup--visible"),
        $("[data-section-id=popup]").removeClass("is--visible");
    },
    createCookie: function (e) {
      0 != e && Cookies.set("newsletter_delay", "value", { expires: e });
    },
  },
  SearchTemplate = {
    init: function () {
      var e = $(".collectionBlock-image");
      "contain" == window.theme.settings.imageBackgroundSize &&
        (Collection.setBadgePosition(e),
        $(window).on(
          "resize.search",
          Reqs.debounce(Collection.setBadgePosition.bind(this, e), 50)
        ));
    },
  },
  Search = {
    init: function () {
      var e = this;
      window.theme.settings.enableSearch &&
        ((this.searchForm = $(".nav-search .search-form")),
        (this.searchContainer = $(".nav-search-container")),
        (this.searchScroller = $(".nav-search-scroller")),
        (this.searchResultsContainer = $("#search-results")),
        (this.searchType = window.theme.settings.searchType),
        (this.searchOptionsPrefix = this.searchForm
          .find('input[name="options[prefix]"]')
          .val()),
        (this.searchRequest = null),
        this.searchForm.on("keyup", ".nav-search-input", function (t) {
          t.keyCode === slate.utils.keyboardKeys.ESCAPE &&
            (e.close(), Site.nav.search.close()),
            t.keyCode === slate.utils.keyboardKeys.ENTER && t.preventDefault();
          var i = $(this).val();
          i.length ? e.request(i) : e.close();
        }));
    },
    close: function () {
      this.searchResultsContainer.empty(),
        this.searchContainer.removeClass("is-searching");
    },
    request: function (e) {
      var t = this;
      null != this.searchRequest && this.searchRequest.abort(),
        this.searchResultsContainer.empty(),
        this.searchContainer.addClass("is-searching"),
        (this.searchRequest = $.ajax({
          method: "GET",
          url: window.theme.routes.search_url + "?view=json",
          dataType: "json",
          data: {
            q: e,
            type: t.searchType,
            options: { prefix: t.searchOptionsPrefix },
          },
        })
          .done(function (e) {
            t.displaySearchResults(e);
          })
          .fail(function (e, i, n, o) {
            t.displaySearchResults(e);
          }));
    },
    displaySearchResults: function (e) {
      var t = this.getResultsContent(e);
      this.searchResultsContainer.html(t),
        this.searchContainer.removeClass("is-searching");
      var i = $(".result__image", this.searchResultsContainer);
      "contain" == window.theme.settings.imageBackgroundSize &&
        (Collection.setBadgePosition(i),
        $(window).on(
          "resize.search",
          Reqs.debounce(Collection.setBadgePosition.bind(this, i), 50)
        ));
    },
    getResultsContent: function (e) {
      var t,
        i = "",
        n = "",
        o = "",
        r = "",
        s = 0,
        a = 0,
        l = 0,
        c = $(".nav-search-input").val(),
        d = $(".nav-search-options").val(),
        u = window.theme.settings.searchType;
      if (e.results)
        for (var p = 0; p < e.results.length; p++)
          if (
            !(
              e.results[p]?.title?.toLowerCase().includes("b2b") ||
              e.results[p].url.includes("b2b") ||
              e.results[p].url.includes("wholesale")
            )
          ) {
            var h = e.results[p].title,
              f = e.results[p].url,
              m = slate.Currency.formatMoney(e.results[p].price),
              g = e.results[p].featured_image,
              v = e.results[p].image_aspectratio || 1,
              y = window.theme.icons.blank,
              b = e.results[p].object_type,
              w = !e.results[p].available,
              k = e.results[p].on_sale,
              x = "",
              S = "",
              C =
                " product-status-flag--" +
                window.theme.settings.productBadgeStyle,
              T = window.theme.settings.productBadgeStyle,
              _ = "result__item";
            "center" == window.theme.settings.productTitlePosition &&
              (_ += " result__item--center"),
              "product" == b
                ? ((k || w) &&
                    ((C += k ? " is-sale" : ""),
                    (x =
                      '<span class="product-status-flag' +
                      (C += w ? " is-sold-out" : "") +
                      '">'),
                    w
                      ? (S = window.theme.translations.sold_out)
                      : k
                      ? (S = window.theme.translations.on_sale)
                      : k && w && (S = window.theme.translations.sold_out),
                    "circle" == T && (S = S.replace(" ", "<br>")),
                    (x += S),
                    (x += "</span>")),
                  s < 4 &&
                    (n +=
                      '<li class="' +
                      _ +
                      '"><div class="result__image" data-aspectratio="' +
                      v +
                      '"><a href="' +
                      f +
                      '"><img class="lazyload" alt="' +
                      h +
                      '"src="' +
                      y +
                      '"data-src="' +
                      g.replace("_1x1.", "_{width}x.") +
                      '"data-widths="[295,394,590,700,800,1000,1200,1500,1800,2000,2400]"data-aspectratio="' +
                      v +
                      '"data-sizes="auto" />' +
                      x +
                      '</a></div><p class="result__price">' +
                      m +
                      '</p><h3 class="result__title"><a href="' +
                      f +
                      '">' +
                      h +
                      "</a></h3></li>"),
                  s++)
                : "page" == b
                ? (a < 10 &&
                    (o +=
                      '<li class="result__item"><h3 class="result__title"><a href="' +
                      f +
                      '">' +
                      h +
                      "</a></h3></li>"),
                  a++)
                : "article" == b &&
                  (l < 10 &&
                    (r +=
                      '<li class="result__item"><h3 class="result__title"><a href="' +
                      f +
                      '">' +
                      h +
                      "</a></h3></li>"),
                  l++);
          }
      return (
        (n = s
          ? n
          : '<li class="result__item"><p class="result__title">' +
            window.theme.translations.no_results +
            "</p></li>"),
        (o = a
          ? o
          : '<li class="result__item"><p class="result__title">' +
            window.theme.translations.no_results +
            "</p></li>"),
        (r = l
          ? r
          : '<li class="result__item"><p class="result__title">' +
            window.theme.translations.no_results +
            "</p></li>"),
        (t = s
          ? '<a href="' +
            window.theme.routes.search_url +
            "?type=product&q=" +
            c +
            "&options[prefix]=" +
            d +
            '" class="view-all" title="' +
            window.theme.translations.view_all +
            '">' +
            window.theme.icons.arrowLong +
            "</a>"
          : ""),
        (i +=
          '<div class="results__column results__column--products"><div class="results__heading"><span>' +
          window.theme.translations.results_products +
          " (" +
          s +
          ")</span>" +
          t +
          '</div><ul class="results__list">' +
          n +
          "</ul></div>"),
        u.indexOf("page") > -1 &&
          (i +=
            '<div class="results__column results__column--pages"><div class="results__heading"><span>' +
            window.theme.translations.results_pages +
            " (" +
            a +
            ')</span></div><ul class="results__list">' +
            o +
            "</ul></div>"),
        u.indexOf("article") > -1 &&
          (i +=
            '<div class="results__column results__column--articles"><div class="results__heading"><span>' +
            window.theme.translations.results_articles +
            " (" +
            l +
            ')</span></div><ul class="results__list">' +
            r +
            "</ul></div>"),
        i
      );
    },
  },
  Password = {
    init: function () {
      $(".password-signup, .password-login").each(function () {
        var e = $(this);
        e.find("div.errors").length &&
          e.find("input.password, input.email").select();
      });
    },
  },
  Login = {
    init: function () {
      this.bind(),
        "#recover" == window.location.hash
          ? this.recover.show()
          : this.recover.hide();
    },
    bind: function () {
      $(".js-recoverToggle").on("click", Login.recover.show),
        $(".js-recoverCancel").on("click", Login.recover.hide);
    },
    recover: {
      show: function (e) {
        return (
          $(".js-loginForm").hide(),
          $(".js-recoverForm").show(),
          (window.location.hash = "#recover"),
          !1
        );
      },
      hide: function (e) {
        return (
          $(".js-loginForm").show(),
          $(".js-recoverForm").hide(),
          (window.location.hash = ""),
          !1
        );
      },
    },
  },
  Addresses = {
    init: function () {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(
          "AddressCountryNew",
          "AddressProvinceNew",
          { hideElement: "AddressProvinceContainerNew" }
        ),
        $(".address-country-option").each(function () {
          var e = $(this).data("form-id"),
            t = "AddressCountry_" + e,
            i = "AddressProvince_" + e,
            n = "AddressProvinceContainer_" + e;
          new Shopify.CountryProvinceSelector(t, i, { hideElement: n });
        }),
        (Shopify.CustomerAddress = {
          toggleForm: function (e) {
            var t = document.getElementById("EditAddress_" + e);
            return (
              (t.style.display = "none" == t.style.display ? "" : "none"), !1
            );
          },
          toggleNewForm: function () {
            var e = document.getElementById("AddAddress"),
              t = document.getElementById("js-addAddress");
            return (
              (e.style.display = "none" == e.style.display ? "" : "none"),
              (t.style.display =
                "inline-block" == t.style.display ? "none" : "inline-block"),
              !1
            );
          },
          destroy: function (e, t) {
            confirm(t || "Are you sure you wish to delete this address?") &&
              Shopify.postLink("/account/addresses/" + e, {
                parameters: { _method: "delete" },
              });
          },
        });
    },
  };
(slate.utils = {
  getParameterByName: function (e, t) {
    t || (t = window.location.href), (e = e.replace(/[[\]]/g, "\\$&"));
    var i = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
    return i
      ? i[2]
        ? decodeURIComponent(i[2].replace(/\+/g, " "))
        : ""
      : null;
  },
  findInstance: function (e, t, i) {
    for (var n = 0; n < e.length; n++) if (e[n][t] === i) return e[n];
  },
  removeInstance: function (e, t, i) {
    for (var n = e.length; n--; )
      if (e[n][t] === i) {
        e.splice(n, 1);
        break;
      }
    return e;
  },
  compact: function (e) {
    for (var t = -1, i = null == e ? 0 : e.length, n = 0, o = []; ++t < i; ) {
      var r = e[t];
      r && (o[n++] = r);
    }
    return o;
  },
  defaultTo: function (e, t) {
    return null == e || e != e ? t : e;
  },
  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
}),
  (slate.a11y = {
    pageLinkFocus: function (e) {
      var t = "js-focus-hidden";
      e.first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(t)
        .one("blur", function () {
          e.first().removeClass(t).removeAttr("tabindex");
        });
    },
    focusHash: function () {
      var e = window.location.hash;
      e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (e) {
          this.pageLinkFocus($(e.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (e) {
      var t = {
          focusin: e.namespace ? "focusin." + e.namespace : "focusin",
          focusout: e.namespace ? "focusout." + e.namespace : "focusout",
          keydown: e.namespace
            ? "keydown." + e.namespace
            : "keydown.handleFocus",
        },
        i = e.$container.find(
          $(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
          ).filter(":visible")
        ),
        n = i[0],
        o = i[i.length - 1];
      e.$elementToFocus || (e.$elementToFocus = e.$container),
        e.$container.attr("tabindex", "-1"),
        e.$elementToFocus.focus(),
        $(document).off("focusin"),
        $(document).on(t.focusout, function () {
          $(document).off(t.keydown);
        }),
        $(document).on(t.focusin, function (e) {
          (e.target !== o && e.target !== n) ||
            $(document).on(t.keydown, function (e) {
              !(function (e) {
                e.keyCode === slate.utils.keyboardKeys.TAB &&
                  (e.target !== o ||
                    e.shiftKey ||
                    (e.preventDefault(), n.focus()),
                  e.target === n &&
                    e.shiftKey &&
                    (e.preventDefault(), o.focus()));
              })(e);
            });
        });
    },
    removeTrapFocus: function (e) {
      var t = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$container &&
        e.$container.length &&
        e.$container.removeAttr("tabindex"),
        $(document).off(t);
    },
    accessibleLinks: function (e) {
      var t = document.querySelector("body"),
        i = {
          newWindow: "a11y-new-window-message",
          external: "a11y-external-message",
          newWindowExternal: "a11y-new-window-external-message",
        };
      (void 0 !== e.$links && e.$links.jquery) ||
        (e.$links = $("a[href]:not([aria-describedby])")),
        $.each(e.$links, function () {
          var e = $(this),
            t = e.attr("target"),
            n = e.attr("rel"),
            o = (function (e) {
              var t = window.location.hostname;
              return e[0].hostname !== t;
            })(e),
            r = "_blank" === t;
          o && e.attr("aria-describedby", i.external),
            r &&
              ((void 0 !== n && -1 !== n.indexOf("noopener")) ||
                e.attr("rel", function (e, t) {
                  return (void 0 === t ? "" : t + " ") + "noopener";
                }),
              e.attr("aria-describedby", i.newWindow)),
            o && r && e.attr("aria-describedby", i.newWindowExternal);
        }),
        (function (e) {
          "object" != typeof e && (e = {});
          var n = $.extend(
              {
                newWindow: "Opens in a new window.",
                external: "Opens external website.",
                newWindowExternal: "Opens external website in a new window.",
              },
              e
            ),
            o = document.createElement("ul"),
            r = "";
          for (var s in n) r += "<li id=" + i[s] + ">" + n[s] + "</li>";
          o.setAttribute("hidden", !0), (o.innerHTML = r), t.appendChild(o);
        })(e.messages);
    },
  }),
  (slate.Variants = (function () {
    function e(e) {
      (this.$container = e.$container),
        (this.product = e.product),
        (this.singleOptionSelector = e.singleOptionSelector),
        (this.originalSelectorId = e.originalSelectorId),
        (this.enableHistoryState = e.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this)
        );
    }
    return (
      (e.prototype = $.extend({}, e.prototype, {
        _getCurrentOptions: function () {
          var e = $.map(
            $(this.singleOptionSelector, this.$container),
            function (e) {
              var t = $(e),
                i = t.attr("type"),
                n = {};
              return "radio" === i || "checkbox" === i
                ? !!t[0].checked &&
                    ((n.value = t.val()), (n.index = t.data("index")), n)
                : ((n.value = t.val()), (n.index = t.data("index")), n);
            }
          );
          return slate.utils.compact(e);
        },
        _getVariantFromOptions: function () {
          var e = this._getCurrentOptions(),
            t = this.product.variants,
            i = !1;
          return (
            t.forEach(function (t) {
              var n = !0;
              e.forEach(function (e) {
                n && (n = e.value === t[e.index]);
              }),
                n && (i = t);
            }),
            i || null
          );
        },
        _onSelectChange: function () {
          var e = this._getVariantFromOptions();
          this.$container.trigger({ type: "variantChange", variant: e }),
            e &&
              (this._updateMasterSelect(e),
              this._updateImages(e),
              this._updatePrice(e),
              this._updateUnits(e),
              (this.currentVariant = e),
              this.enableHistoryState && this._updateHistoryState(e));
        },
        _updateImages: function (e) {
          var t = e.featured_image || {},
            i = this.currentVariant.featured_image || {};
          e.featured_image &&
            t.src !== i.src &&
            this.$container.trigger({ type: "variantImageChange", variant: e });
        },
        _updatePrice: function (e) {
          (e.price === this.currentVariant.price &&
            e.compare_at_price === this.currentVariant.compare_at_price) ||
            this.$container.trigger({ type: "variantPriceChange", variant: e });
        },
        _updateUnits: function (e) {
          this.$container.trigger({ type: "variantUnitChange", variant: e });
        },
        _updateHistoryState: function (e) {
          if (history.replaceState && e) {
            var t =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              e.id;
            window.history.replaceState({ path: t }, "", t);
          }
        },
        _updateMasterSelect: function (e) {
          $(this.originalSelectorId, this.$container)[0].value = e.id;
        },
      })),
      e
    );
  })()),
  (slate.Currency = {
    formatMoney: function (e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var i = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        o = t || "${{amount}}";
      function r(e, t, i, n) {
        if (((i = i || ","), (n = n || "."), isNaN(e) || null === e)) return 0;
        var o = (e = (e / 100).toFixed(t)).split(".");
        return (
          o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (o[1] ? n + o[1] : "")
        );
      }
      switch (o.match(n)[1]) {
        case "amount":
          i = r(e, 2);
          break;
        case "amount_no_decimals":
          i = r(e, 0);
          break;
        case "amount_with_comma_separator":
          i = r(e, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          i = r(e, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          i = r(e, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          i = r(e, 2, "'");
      }
      return o.replace(n, i);
    },
  });
var Disclosure = (function () {
  var e = "disclosure-list--visible";
  function t(e) {
    (this.$container = e),
      (this.cache = {}),
      this._cacheSelectors(),
      this._connectOptions(),
      this._connectToggle(),
      this._onFocusOut();
  }
  return (
    (t.prototype = $.extend({}, t.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          $disclosureList: this.$container.find("[data-disclosure-list]"),
          $disclosureToggle: this.$container.find("[data-disclosure-toggle]"),
          $disclosureInput: this.$container.find("[data-disclosure-input]"),
          $disclosureOptions: this.$container.find("[data-disclosure-option]"),
        };
      },
      _connectToggle: function () {
        this.cache.$disclosureToggle.on(
          "click",
          function (t) {
            var i = "true" === $(t.currentTarget).attr("aria-expanded");
            $(t.currentTarget).attr("aria-expanded", !i),
              this.cache.$disclosureList.toggleClass(e),
              t.preventDefault();
          }.bind(this)
        );
      },
      _connectOptions: function () {
        this.cache.$disclosureOptions.on(
          "click",
          function (e) {
            this._submitForm($(e.currentTarget).data("value")),
              e.preventDefault();
          }.bind(this)
        );
      },
      _onFocusOut: function () {
        this.cache.$disclosureToggle.on(
          "focusout",
          function (e) {
            0 === this.$container.has(e.relatedTarget).length &&
              this._hideList();
          }.bind(this)
        ),
          this.cache.$disclosureList.on(
            "focusout",
            function (t) {
              var i = $(t.currentTarget).has(t.relatedTarget).length > 0;
              this.cache.$disclosureList.hasClass(e) && !i && this._hideList();
            }.bind(this)
          ),
          this.$container.on(
            "keyup",
            function (e) {
              e.which === slate.utils.keyboardKeys.ESCAPE &&
                (this._hideList(), this.cache.$disclosureToggle.focus());
            }.bind(this)
          ),
          (this.bodyOnClick = function (t) {
            var i = this.$container.has(t.target).length > 0;
            this.cache.$disclosureList.hasClass(e) && !i && this._hideList();
          }.bind(this)),
          $("body").on("click", this.bodyOnClick);
      },
      _submitForm: function (e) {
        this.cache.$disclosureInput.val(e),
          this.$container.parents("form").submit();
      },
      _hideList: function () {
        this.cache.$disclosureList.removeClass(e),
          this.cache.$disclosureToggle.attr("aria-expanded", !1);
      },
      unload: function () {
        $("body").off("click", this.bodyOnClick),
          this.cache.$disclosureOptions.off(),
          this.cache.$disclosureToggle.off(),
          this.cache.$disclosureList.off(),
          this.$container.off();
      },
    })),
    t
  );
})();
(theme.StoreAvailability = (function () {
  var e = "[data-store-availability-modal]";
  function t(e) {
    this.container = e;
  }
  return (
    (t.prototype = Object.assign({}, t.prototype, {
      updateContent: function (e, t) {
        var i = this;
        navigator.geolocation
          ? navigator.geolocation.getCurrentPosition(
              function (n) {
                i._useGeolocation(n, e, t);
              },
              function () {
                i._fetchStoreAvailabilities(e, t);
              },
              { maximumAge: 36e5, timeout: 5e3 }
            )
          : this._fetchStoreAvailabilities(e, t);
      },
      clearContent: function () {
        this.container.innerHTML = "";
      },
      _initModal: function () {
        return new theme.Modals(
          "StoreAvailabilityModal",
          "store-availability-modal",
          {
            close: ".js-modal-close-store-availability-modal",
            closeModalOnClick: !0,
            openClass: "store-availabilities-modal--active",
            scrollIntoView: !0,
          }
        );
      },
      _useGeolocation: function (e, t, i) {
        var n = e.coords,
          o = n.latitude,
          r = n.longitude;
        if (theme.Helpers.cookiesEnabled()) {
          var s = theme.Helpers.getCookie("latitude"),
            a = theme.Helpers.getCookie("longitude");
          s && a && parseFloat(s) === o && parseFloat(a) === r
            ? this._fetchStoreAvailabilities(t, i, o, r)
            : (theme.Helpers.setCookie("latitude", o, 1 / 24),
              theme.Helpers.setCookie("longitude", r, 1 / 24),
              this._setBuyerLocation(o, r, t, i));
        } else this._fetchStoreAvailabilities(t, i);
      },
      _setBuyerLocation: function (e, t, i, n) {
        var o = this;
        fetch("/localization.json", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ latitude: e, longitude: t }),
        }).then(function () {
          o._fetchStoreAvailabilities(i, n, e, t);
        });
      },
      _fetchStoreAvailabilities: function (t, i, n, o) {
        var r = "/variants/" + t + "/?section_id=store-availability";
        this.clearContent();
        var s = this;
        fetch(r)
          .then(function (e) {
            return e.text();
          })
          .then(function (t) {
            if ("" !== t.trim()) {
              var r,
                a = document.querySelector("body");
              (r = a.querySelector(e)) && r.remove(),
                (s.container.innerHTML = t),
                (s.container.innerHTML =
                  s.container.firstElementChild.innerHTML),
                s.container.querySelector(
                  "[data-store-availability-modal-open]"
                ) &&
                  ((s.modal = s._initModal()),
                  s._updateProductTitle(i),
                  n && o
                    ? s._updateLocationDistances(n, o)
                    : s._hideDistanceUnits(),
                  (r = s.container.querySelector(e)) && a.appendChild(r));
            }
          });
      },
      _updateProductTitle: function (e) {
        this.container.querySelector(
          "[data-store-availability-modal-product-title]"
        ).textContent = e;
      },
      _calculateDistance: function (e, t, i, n, o) {
        var r = Math.PI / 180,
          s = "metric" === o ? 6378.14 : 3959,
          a = e * r,
          l = i * r,
          c = t * r - n * r,
          d = a - l,
          u =
            Math.pow(Math.sin(d / 2), 2) +
            Math.cos(a) * Math.cos(l) * Math.pow(Math.sin(c / 2), 2);
        return s * (2 * Math.atan2(Math.sqrt(u), Math.sqrt(1 - u)));
      },
      _updateLocationDistances: function (e, t) {
        var i = document.querySelector("[data-unit-system]").dataset.unitSystem,
          n = document.querySelectorAll("[data-distance]"),
          o = Array.from(n),
          r = this;
        o.forEach(function (n) {
          var o = r
            ._calculateDistance(
              e,
              t,
              parseFloat(n.dataset.latitude),
              parseFloat(n.dataset.longitude),
              i
            )
            .toFixed(1);
          n.innerHTML = o;
        });
      },
      _hideDistanceUnits: function () {
        var e = document.querySelectorAll("[data-distance-unit]");
        e &&
          Array.from(e).forEach(function (e) {
            e.classList.add("visually-hidden");
          });
      },
    })),
    t
  );
})()),
  (theme.Modals = (function () {
    function e(e, t, i) {
      var n = {
        close: ".js-modal-close",
        open: ".js-modal-open-" + t,
        openClass: "modal--is-active",
        openBodyClass: "modal--is-visible",
        closeModalOnClick: !1,
        scrollIntoView: !1,
      };
      if (((this.modal = document.getElementById(e)), !this.modal)) return !1;
      (this.nodes = {
        parents: [document.querySelector("html"), document.body],
      }),
        (this.config = Object.assign(n, i)),
        (this.modalIsOpen = !1),
        (this.focusOnOpen = this.config.focusOnOpen
          ? document.getElementById(this.config.focusOnOpen)
          : this.modal),
        (this.openElement = document.querySelector(this.config.open)),
        this.init();
    }
    return (
      (e.prototype.init = function () {
        this.openElement.addEventListener("click", this.open.bind(this)),
          this.modal
            .querySelector(this.config.close)
            .addEventListener("click", this.closeModal.bind(this));
      }),
      (e.prototype.open = function (e) {
        var t = this,
          i = !1;
        if (!this.modalIsOpen) {
          e ? e.preventDefault() : (i = !0),
            e && e.stopPropagation && e.stopPropagation(),
            this.modalIsOpen && !i && this.closeModal(),
            this.modal.classList.add(this.config.openClass),
            this.nodes.parents.forEach(function (e) {
              e.classList.add(t.config.openBodyClass);
            }),
            (this.modalIsOpen = !0);
          var n = document.querySelector(".store-availabilities-list");
          scrollLock.disablePageScroll(n),
            slate.a11y.trapFocus({
              $container: $(this.modal),
              $elementToFocus: $(this.focusOnOpen),
            }),
            this.config.scrollIntoView && this.scrollIntoView(),
            this.bindEvents();
        }
      }),
      (e.prototype.closeModal = function () {
        if (this.modalIsOpen) {
          document.activeElement.blur(),
            this.modal.classList.remove(this.config.openClass);
          var e = this,
            t = document.querySelector(".store-availabilities-list");
          scrollLock.enablePageScroll(t),
            this.nodes.parents.forEach(function (t) {
              t.classList.remove(e.config.openBodyClass);
            }),
            (this.modalIsOpen = !1),
            slate.a11y.removeTrapFocus({ $container: $(this.modal) }),
            this.openElement.focus(),
            this.unbindEvents();
        }
      }),
      (e.prototype.bindEvents = function () {
        (this.keyupHandler = this.keyupHandler.bind(this)),
          (this.clickHandler = this.clickHandler.bind(this)),
          document.body.addEventListener("keyup", this.keyupHandler),
          document.body.addEventListener("click", this.clickHandler);
      }),
      (e.prototype.unbindEvents = function () {
        document.body.removeEventListener("keyup", this.keyupHandler),
          document.body.removeEventListener("click", this.clickHandler);
      }),
      (e.prototype.keyupHandler = function (e) {
        27 === e.keyCode && this.closeModal();
      }),
      (e.prototype.clickHandler = function (e) {
        this.config.closeModalOnClick &&
          !this.modal.contains(e.target) &&
          this.closeModal();
      }),
      (e.prototype.scrollIntoView = function () {
        this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
      }),
      e
    );
  })()),
  (theme.Helpers = {
    cookiesEnabled: function () {
      var e = navigator.cookieEnabled;
      return (
        e ||
          ((document.cookie = "testcookie"),
          (e = -1 !== document.cookie.indexOf("testcookie"))),
        e
      );
    },
    setCookie: function (e, t, i) {
      var n = "";
      if (i) {
        var o = new Date();
        o.setTime(o.getTime() + 24 * i * 60 * 60 * 1e3),
          (n = "; expires=" + o.toUTCString());
      }
      document.cookie = e + "=" + (t || "") + n + "; path=/";
    },
    getCookie: function (e) {
      var t = document.cookie.split("; ").find(function (t) {
        return t.startsWith(e);
      });
      return t ? t.split("=")[1] : null;
    },
  }),
  $(".row--mosaic.row--6-blocks").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: !0,
    dots: !0,
    infinite: !1,
    autoplaySpeed: 2e3,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style="" aria-disabled=""><svg class="" viewBox="0 0 100 100" style=" transform: scale(.5) scaleX(-1); "><path d="M 15,50 L 65,100 L 65,90 L 25,50  L 65,10 L 65,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled=""><svg class="" viewBox="0 0 100 100" style=" transform: scale(.5); "><path d="M 15,50 L 65,100 L 65,90 L 25,50  L 65,10 L 65,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  }),
  $(".row--mosaic.row--5-blocks").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: !0,
    infinite: !1,
    autoplaySpeed: 2e3,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style="" aria-disabled=""><svg class="" viewBox="0 0 100 100" style=" transform: scale(.5) scaleX(-1); "><path d="M 15,50 L 65,100 L 65,90 L 25,50  L 65,10 L 65,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled=""><svg class="" viewBox="0 0 100 100" style=" transform: scale(.5); "><path d="M 15,50 L 65,100 L 65,90 L 25,50  L 65,10 L 65,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  }),
  $(".popup--center.popup--visible+.popup-bg").click(function () {
    $(
      "#shopify-section-popup div[data-section-id=popup].is--visible"
    ).removeClass("is--visible"),
      $(".popup--center.popup--visible").removeClass("is--visible");
  });
var changeShopText = document.querySelector(
  ".product-title__wrapper p.product-vendor.subheading-text"
);
function engraveActions() {
  if (
    ($(".personalize_inputForm").val(localStorage.EngraveLocal),
    // 2026-04-27 FIX: Eski input yerine yeni personalization textarea kontrol ediliyor
    // ESKİ HALİ: $(".panel_text input[type='text']") &&
    $(".panel_text textarea.underHeader_Personalize_desc").length &&
      location.pathname.includes("products"))
  ) {
    // 2026-04-27 FIX: Eski input yerine yeni personalization textarea değeri okunuyor
    // ESKİ HALİ: var e = $(".panel_text input[type='text']").val();
    var e = $(".panel_text textarea.underHeader_Personalize_desc").val();
    $(".tab_panel .counter .counterNumber").html(`${e?.length}/20`),
      localStorage.EngraveLocal &&
        (localStorage.EngraveLocal.length > 0
          ? ($(".personalize_button-js").addClass("hide"),
            $(".isPersonalized").removeClass("hide"))
          : ($(".personalize_button-js").removeClass("hide"),
            $(".isPersonalized").addClass("hide"))),
      $(".pop-up_engrave-text").html(localStorage.EngraveLocal),
      $(".isPersonalized span").html(localStorage.EngraveLocal),
      // 2026-04-27 FIX: Save button kontrolü yeni textarea üzerinden yapılıyor
      // ESKİ HALİ: $(".panel_text input[type='text']").val()?.length < 1
      $(".panel_text textarea.underHeader_Personalize_desc").val()?.length < 1
        ? $(".personalize_saveButton").prop("disabled", !0)
        : $(".personalize_saveButton").prop("disabled", !1);
  }
}
changeShopText &&
  (changeShopText.innerText = changeShopText.innerText.replace("SHOP", "CASE")),
  document.querySelector(".line-item-property__field select") &&
    document
      .querySelector(".line-item-property__field select")
      .addEventListener("click", function () {
        document
          .querySelector(".personalization_switch")
          .setAttribute("style", "height:auto;overflow:auto");
      }),
  $("a.lightbox").click(function (e) {
    e.preventDefault(),
      $(".lightboximgcart").toggleClass("asd"),
      $(window).click(function (e) {
        e.preventDefault(), $(".lightboximgcart").toggleClass("asd");
      });
  }),
  $(".lightboximgcart span").click(function (e) {
    e.preventDefault(), $(".lightboximgcart").toggleClass("asd");
  }),
  $("#personalizeTextCustominputf").on("input", function () {
    0 == $(this).val().length || "" == $(this).val()
      ? $(".personalizetextCustom").removeClass("fade")
      : $(".personalizetextCustom").addClass("fade"),
      $(".personalizetextCustom").text($(this).val());
  }),
  $(".swatch--square .swatch__colorc").removeAttr("onclick"),
  $(".swatch--square .swatch__colorc").click(function () {
    var e = $(this).css("background-image");
    (e = e.replace("url(", "").replace(")", "").replace(/\"/gi, "")),
      $(".addkartlÄ±k").attr("src", e),
      $(".addkartlÄ±k").fadeIn(500);
  }),
  $(".swatch--square .swatch__color").removeAttr("onclick"),
  $(".swatch--square .swatch__color").click(function () {
    var e = $(this).css("background-image");
    (e = e.replace("url(", "").replace(")", "").replace(/\"/gi, "")),
      $("#img1 > image").attr("href", e);
  }),
  $(".swatch--square .swatch__colorr").click(function () {
    var e = $(this).css("background-color");
    $(".personalizetextCustom").css("color", e);
  }),
  $(".swatch__color").click(function () {
    $("#svg_3").css("mix-blend-mode", "color");
  }),
  $(".swatch__color.overlay").click(function () {
    $("#svg_3").css("mix-blend-mode", "overlay");
  }),
  $(".personalize_button").click(() => {
    $(".popup_personalize").toggleClass("open"),
      $(".popup_personalize").hasClass("open")
        ? $("body").css("overflow", "hidden")
        : $("body").css("overflow", "auto");
  }),
  $("body .popup_personalize .close").click(() => {
    $(".popup_personalize").toggleClass("open"),
      $(".popup_personalize").hasClass("open")
        ? $("body").css("overflow", "hidden")
        : $("body").css("overflow", "auto");
  }),
  $(".product_actions ul li").click(function (e, t) {
    $(".product_actions ul li").removeClass("active"),
      $(this).addClass("active"),
      $(".tab_panel > div").css("display", "none"),
      $(".tab_panel > div").eq($(this).index()).css("display", "block");
  }),
  $(".color-flex .color").click(function () {
    $(".color-flex .color").removeClass("active"),
      $(this).addClass("active"),
      $(".pop-up_engrave-text").css("color", $(this).css("background-color"));
  }),
  $(".close_btn_span").click(function () {
    $(".popup_personalize.open").removeClass("open"),
      $(".popup_personalize").hasClass("open")
        ? $("body").css("overflow", "hidden")
        : $("body").css("overflow", "auto");
  }),
  $(".panel_icon label img").click(function () {
    $(".pop-up_engrave-text").html(
      '<img style=" width: 80px; mix-blend-mode: color-burn; " src=' +
        $(this).attr("src") +
        ">"
    ),
      engraveActions();
  }),
  $(".counter .addHeart").click(function () {
    $(".panel_text input[type='text']").val().length > 4
      ? alert("5 harfi geçemez")
      : ($(".panel_text input[type='text']").val(
          $(".panel_text input").val() + "â™¡"
        ),
        (localStorage.EngraveLocal = $(".panel_text input").val()),
        $(".panel_text input[type='text']").val(localStorage.EngraveLocal),
        engraveActions());
  }),
  $(".popup_personalize .product_actions ul li:nth-child(1)").click(() => {
    $(".panel_text input[type='text']").val(""),
      $(".pop-up_engrave-text").text($(".panel_text input[type='text']").val());
    var e =
      $(".panel_text input[type='text']").attr("maxlength") -
      $(".panel_text input[type='text']").val().length;
    $(".tab_panel .counter .counterNumber").html(`${e}/20`);
  }),
  $(".panel_text textarea.underHeader_Personalize_desc").on("input", function () {
    $(this).val().length < 1
      ? $(".personalize_saveButton").prop("disabled", !0)
      : $(".personalize_saveButton").prop("disabled", !1),
      $(".personalize_inputForm").val($(this).val()),
      (localStorage.EngraveLocalicon = ""),
      $(".panel_icon input[type='text']").prop("checked", !1),
      (localStorage.EngraveLocal = $(this).val()),
      localStorage.EngraveLocal.length > 0
        ? ($(".personalize_button-js").addClass("hide"),
          $(".isPersonalized").removeClass("hide"))
        : ($(".personalize_button-js").removeClass("hide"),
          $(".isPersonalized").addClass("hide")),
      engraveActions();
  }),
  $(".personalize_saveButton").click(() => {
    $(".productForm-submit span").text("Personalization Saving ..."),
      $(".productForm-submit").attr("disabled", !0),
      $(".productForm-submit span").text("Saved & Add To Cart"),
      $(".productForm-submit").attr("disabled", !1),
      $("body").css("overflow", "auto"),
      $(".popup_personalize.open").removeClass("open");
  }),
  $(".panel_icon label img").click(function () {
    (localStorage.EngraveLocal = ""),
      (localStorage.EngraveLocalicon =
        "`<img style='width: 80px; mix-blend-mode: color-burn;' width='50' src=${$(this).attr('src')}>`"),
      engraveActions();
  }),
  $(function () {
    $(
      "#collection-module-gift-list-collection > div.collectionList__wrapper.custom-width > div > div > div.collectionBlock.js-collectionBlock.collection--has-image.aa.test-gifts-list-collections.block.s1.lg_s10.med_s12 > div.collectionBlock-info.text-position--bottom_left > div > h3"
    ).text("Watch Bands Set");
  }),
  $(window).on("load", function () {
    let e = function () {
      $(".fleximagespopup img").click(function () {
        var e = $(this).data("img");
        $(
          ".product_image .product-single__media.product-single__media--image.lazyloaded"
        ).css("background-image", "url(" + e + ")");
      }),
        $(".swatch__link").on("mouseenter", function () {
          var e = $(this).data("id");
          $(".collectionBlock-hover__image").each((t, i) => {
            var n = $(i).data("id");
            (i.style.display = "none"),
              $(".collectionBlock-hover").hover(),
              n === e &&
                ($(i).closest(".collectionBlock-hover").css("opacity", "1"),
                (i.style.display = "block"));
          });
        }),
        $(".swatch__link").on("mouseleave", function () {
          $(".collectionBlock-hover__image").each((e, t) => {
            $(t).closest(".collectionBlock-hover").css("opacity", "0");
          });
        }),
        document.querySelectorAll(".collectionBlock__title a").forEach((e) => {
          e.innerText = e.innerText.replace("fo ", "for");
        });
    };
    e(), (window.swatch_hover_func = e);
  }),
  engraveActions(),
  $(function () {
    $(".swatch__input").on("change", function () {
      var e = $(
        ".productImgSlider .getScreenShot.is-selected > div:nth-child(1)"
      ).attr("data-custom-yasin");
      $(
        ".popup_personalize .product_image .product-image div:nth-child(1)"
      ).css("background-image", "url(https:" + e + ")");
    });
  }),
  $(".underHeader_Personalize_desc").on("input", function () {
    $(".form_Personalize_desc").val($(this).val()),
      $(document).keyup(function (e) {
        "Escape" === e.key && $(".popup_personalize.open").removeClass("open");
      });
  }),
  $(".color-item").click(function () {
    $(".color-item").removeClass("active"),
      $(this).addClass("active"),
      document.querySelector(".filtered_products_wrapper") &&
        (document.querySelector(".filtered_products_wrapper").innerHTML = "");
  }),
  $(".product-tab-title").click(function () {
    $(".product-tab-content").removeClass("is-active"),
      $(".product-tab-title").removeClass("is-active"),
      $(this).addClass("is-active"),
      $(".product-tab-content:eq(" + $(this).index() + ")").addClass(
        "is-active"
      );
  }),
  $("form#inviteFriendForm").submit(function (e) {
    $("form#inviteFriendForm button").val(""),
      (document.querySelector("form#inviteFriendForm button").innerHTML =
        "Sending..."),
      e.preventDefault(),
      $.ajax({
        url: "https://delfiwatchbands.com/sendmail",
        type: "GET",
        crossDomain: !0,
        dataType: "jsonp",
        data:
          "name=" +
          $("form#inviteFriendForm input#name").val() +
          "&mail=" +
          $("form#inviteFriendForm input#mail").val(),
        success: function (e) {},
      }),
      (document.querySelector("form#inviteFriendForm input#name").value = ""),
      (document.querySelector("form#inviteFriendForm input#mail").value = "");
    const t = document.createElement("p");
    (t.innerHTML =
      "Discount Code Sended :) <small>Don't forget to check your spam box</small>"),
      t.setAttribute("style", "padding: 10px 0; background: #8bc34a52;"),
      (document.querySelector("form#inviteFriendForm button").innerHTML =
        "Invite"),
      document
        .querySelector("form#inviteFriendForm button")
        .parentElement.append(t);
  }),
  $(".color-items").click(function () {
    $(".color-items").removeClass("active"), $(this).addClass("active");
  });



                    $(()=>{
                      $("[data-collection-filter-tag-button]").click(function(){
$(this).parent().parent().find(".is-active").removeClass("is-active");
    
})
                    })

                   